export const adminData = {
    reload: {
      "status": "success",
      "message": "The Dashboard Stats have been queued for reload."
    },
    data: {
      "data": {
        "date": "Mon, Jul 15, 2024 1:52 AM (PST)",
        "stats": {
          "total_donations_made_in_last_30_days": "592",
          "total_donations_ever": "84618",
          "number_of_donations_in_last_30_days": 20,
          "number_of_active_programs": 9,
          "total_number_of_commitments": 391,
          "total_credit_card_commitments": 188,
          "total_commitments_today": 0,
          "new_commitments_in_last_7_days": 0,
          "new_commitments_in_last_30_days": 13
        },
        "commitments_by_program": {
          "929": {
            "Education": {
              "total": 207,
              "amount": 6629
            }
          },
          "3507": {
            "Kupe": {
              "total": 97,
              "amount": 2910
            }
          },
          "3518": {
            "Masaka BoreHole": {
              "total": 2,
              "amount": 367.5
            }
          },
          "3521": {
            "Sustainable Living expo": {
              "total": 1,
              "amount": 52.94
            }
          },
          "3494": {
            "Youth mentorship program": {
              "total": 1,
              "amount": 35
            }
          },
          "1221": {
            "Sponsored": {
              "total": 1,
              "amount": 32
            }
          }
        },
        "remainders_by_program": {
          "929": {
            "name": "Education",
            "remaining": 624
          },
          "1221": {
            "name": "Sponsored",
            "remaining": 3
          },
          "3437": {
            "name": "Medical",
            "remaining": 12
          },
          "3494": {
            "name": "Youth mentorship program",
            "remaining": 1
          },
          "3506": {
            "name": "Kupenda",
            "remaining": 400
          },
          "3510": {
            "name": "us2uganda",
            "remaining": 652
          }
        },
        "commitment_graph_data": [],
        "donation_graph_data": [],
        "funding_by_program": [],
        "org": {
          "id": 207,
          "organization": "Giving Hands Ministry",
          "website": "https://helpyousponsor.com",
          "ein": null,
          "stripe_cust_id": "stripe_cust_id",
          "arb_enabled": "",
          "stripe_card_id": "stripe_card_id",
          "email": "dev@helpyousponsor.com",
          "logo": "https://i.ytimg.com/vi/uZ_fkDj-bqQ/0.jpg",
          "status": "active",
          "plan": "max",
          "logout": "false",
          "box_client_id": null,
          "box_client_secret": null,
          "box_access_token": "",
          "box_refresh_token": "",
          "created_at": "2017-02-22T17:40:21.000000Z",
          "updated_at": "2024-04-08T18:55:12.000000Z",
          "__hevo__database_name": "apphys_new",
          "__hevo__ingested_at": 1679725251508,
          "__hevo__marked_deleted": 0,
          "__hevo__source_modified_at": null,
          "new_user": 0,
          "stripe_connect_id": null,
          "completed_stripe_onboarding": 0,
          "subaccount_id": null
        },
        "reloaded": null,
        "plan": "max",
        "amount": 208.5,
        "last_payment_date": "2023-10-19T18:30:27.000000Z",
        "last_payment_amount": 20,
        "client_status": "active"
      },
    "stripe_msg": "No Stripe  Publishable Key Setup",
    "status": "success"
    },
    donations_graph: {
      "donation_graph_data": [
        {
          "dates": "2021-12-31",
          "totals": "0"
        },
        {
          "dates": "2022-01-01",
          "totals": "0"
        },
        {
          "dates": "2022-01-02",
          "totals": "0"
        },
        {
          "dates": "2022-01-03",
          "totals": "0"
        },
        {
          "dates": "2022-01-04",
          "totals": "0"
        },
        {
          "dates": "2022-01-05",
          "totals": "0"
        },
        {
          "dates": "2022-01-06",
          "totals": "0"
        },
        {
          "dates": "2022-01-07",
          "totals": "0"
        },
        {
          "dates": "2022-01-08",
          "totals": "0"
        },
        {
          "dates": "2022-01-09",
          "totals": "32"
        },
        {
          "dates": "2022-01-10",
          "totals": "0"
        },
        {
          "dates": "2022-01-11",
          "totals": "0"
        },
        {
          "dates": "2022-01-12",
          "totals": "0"
        },
        {
          "dates": "2022-01-13",
          "totals": "0"
        },
        {
          "dates": "2022-01-14",
          "totals": "0"
        },
        {
          "dates": "2022-01-15",
          "totals": "0"
        },
        {
          "dates": "2022-01-16",
          "totals": "32"
        },
        {
          "dates": "2022-01-17",
          "totals": "0"
        },
        {
          "dates": "2022-01-18",
          "totals": "0"
        },
        {
          "dates": "2022-01-19",
          "totals": "160"
        },
        {
          "dates": "2022-01-20",
          "totals": "32"
        },
        {
          "dates": "2022-01-21",
          "totals": "0"
        },
        {
          "dates": "2022-01-22",
          "totals": "0"
        },
        {
          "dates": "2022-01-23",
          "totals": "0"
        },
        {
          "dates": "2022-01-24",
          "totals": "0"
        },
        {
          "dates": "2022-01-25",
          "totals": "0"
        },
        {
          "dates": "2022-01-26",
          "totals": "96"
        },
        {
          "dates": "2022-01-27",
          "totals": "0"
        },
        {
          "dates": "2022-01-28",
          "totals": "32"
        },
        {
          "dates": "2022-01-29",
          "totals": "0"
        },
        {
          "dates": "2022-01-30",
          "totals": "0"
        },
        {
          "dates": "2022-01-31",
          "totals": "0"
        },
        {
          "dates": "2022-02-01",
          "totals": "0"
        },
        {
          "dates": "2022-02-02",
          "totals": "0"
        },
        {
          "dates": "2022-02-03",
          "totals": "0"
        },
        {
          "dates": "2022-02-04",
          "totals": "0"
        },
        {
          "dates": "2022-02-05",
          "totals": "0"
        },
        {
          "dates": "2022-02-06",
          "totals": "0"
        },
        {
          "dates": "2022-02-07",
          "totals": "0"
        },
        {
          "dates": "2022-02-08",
          "totals": "0"
        },
        {
          "dates": "2022-02-09",
          "totals": "0"
        },
        {
          "dates": "2022-02-10",
          "totals": "0"
        },
        {
          "dates": "2022-02-11",
          "totals": "0"
        },
        {
          "dates": "2022-02-12",
          "totals": "0"
        },
        {
          "dates": "2022-02-13",
          "totals": "0"
        },
        {
          "dates": "2022-02-14",
          "totals": "0"
        },
        {
          "dates": "2022-02-15",
          "totals": "0"
        },
        {
          "dates": "2022-02-16",
          "totals": "0"
        },
        {
          "dates": "2022-02-17",
          "totals": "0"
        },
        {
          "dates": "2022-02-18",
          "totals": "0"
        },
        {
          "dates": "2022-02-19",
          "totals": "0"
        },
        {
          "dates": "2022-02-20",
          "totals": "0"
        },
        {
          "dates": "2022-02-21",
          "totals": "0"
        },
        {
          "dates": "2022-02-22",
          "totals": "0"
        },
        {
          "dates": "2022-02-23",
          "totals": "0"
        },
        {
          "dates": "2022-02-24",
          "totals": "0"
        },
        {
          "dates": "2022-02-25",
          "totals": "0"
        },
        {
          "dates": "2022-02-26",
          "totals": "0"
        },
        {
          "dates": "2022-02-27",
          "totals": "0"
        },
        {
          "dates": "2022-02-28",
          "totals": "0"
        },
        {
          "dates": "2022-03-01",
          "totals": "0"
        },
        {
          "dates": "2022-03-02",
          "totals": "0"
        },
        {
          "dates": "2022-03-03",
          "totals": "0"
        },
        {
          "dates": "2022-03-04",
          "totals": "0"
        },
        {
          "dates": "2022-03-05",
          "totals": "0"
        },
        {
          "dates": "2022-03-06",
          "totals": "0"
        },
        {
          "dates": "2022-03-07",
          "totals": "0"
        },
        {
          "dates": "2022-03-08",
          "totals": "0"
        },
        {
          "dates": "2022-03-09",
          "totals": "0"
        },
        {
          "dates": "2022-03-10",
          "totals": "0"
        },
        {
          "dates": "2022-03-11",
          "totals": "0"
        },
        {
          "dates": "2022-03-12",
          "totals": "0"
        },
        {
          "dates": "2022-03-13",
          "totals": "0"
        },
        {
          "dates": "2022-03-14",
          "totals": "0"
        },
        {
          "dates": "2022-03-15",
          "totals": "0"
        },
        {
          "dates": "2022-03-16",
          "totals": "0"
        },
        {
          "dates": "2022-03-17",
          "totals": "0"
        },
        {
          "dates": "2022-03-18",
          "totals": "0"
        },
        {
          "dates": "2022-03-19",
          "totals": "0"
        },
        {
          "dates": "2022-03-20",
          "totals": "0"
        },
        {
          "dates": "2022-03-21",
          "totals": "0"
        },
        {
          "dates": "2022-03-22",
          "totals": "0"
        },
        {
          "dates": "2022-03-23",
          "totals": "0"
        },
        {
          "dates": "2022-03-24",
          "totals": "0"
        },
        {
          "dates": "2022-03-25",
          "totals": "0"
        },
        {
          "dates": "2022-03-26",
          "totals": "0"
        },
        {
          "dates": "2022-03-27",
          "totals": "0"
        },
        {
          "dates": "2022-03-28",
          "totals": "0"
        },
        {
          "dates": "2022-03-29",
          "totals": "0"
        },
        {
          "dates": "2022-03-30",
          "totals": "0"
        },
        {
          "dates": "2022-03-31",
          "totals": "0"
        },
        {
          "dates": "2022-04-01",
          "totals": "0"
        },
        {
          "dates": "2022-04-02",
          "totals": "0"
        },
        {
          "dates": "2022-04-03",
          "totals": "0"
        },
        {
          "dates": "2022-04-04",
          "totals": "0"
        },
        {
          "dates": "2022-04-05",
          "totals": "0"
        },
        {
          "dates": "2022-04-06",
          "totals": "0"
        },
        {
          "dates": "2022-04-07",
          "totals": "0"
        },
        {
          "dates": "2022-04-08",
          "totals": "0"
        },
        {
          "dates": "2022-04-09",
          "totals": "0"
        },
        {
          "dates": "2022-04-10",
          "totals": "0"
        },
        {
          "dates": "2022-04-11",
          "totals": "0"
        },
        {
          "dates": "2022-04-12",
          "totals": "0"
        },
        {
          "dates": "2022-04-13",
          "totals": "0"
        },
        {
          "dates": "2022-04-14",
          "totals": "0"
        },
        {
          "dates": "2022-04-15",
          "totals": "0"
        },
        {
          "dates": "2022-04-16",
          "totals": "0"
        },
        {
          "dates": "2022-04-17",
          "totals": "0"
        },
        {
          "dates": "2022-04-18",
          "totals": "0"
        },
        {
          "dates": "2022-04-19",
          "totals": "0"
        },
        {
          "dates": "2022-04-20",
          "totals": "0"
        },
        {
          "dates": "2022-04-21",
          "totals": "0"
        },
        {
          "dates": "2022-04-22",
          "totals": "0"
        },
        {
          "dates": "2022-04-23",
          "totals": "0"
        },
        {
          "dates": "2022-04-24",
          "totals": "0"
        },
        {
          "dates": "2022-04-25",
          "totals": "0"
        },
        {
          "dates": "2022-04-26",
          "totals": "0"
        },
        {
          "dates": "2022-04-27",
          "totals": "0"
        },
        {
          "dates": "2022-04-28",
          "totals": "0"
        },
        {
          "dates": "2022-04-29",
          "totals": "0"
        },
        {
          "dates": "2022-04-30",
          "totals": "0"
        },
        {
          "dates": "2022-05-01",
          "totals": "0"
        },
        {
          "dates": "2022-05-02",
          "totals": "0"
        },
        {
          "dates": "2022-05-03",
          "totals": "0"
        },
        {
          "dates": "2022-05-04",
          "totals": "0"
        },
        {
          "dates": "2022-05-05",
          "totals": "0"
        },
        {
          "dates": "2022-05-06",
          "totals": "0"
        },
        {
          "dates": "2022-05-07",
          "totals": "0"
        },
        {
          "dates": "2022-05-08",
          "totals": "0"
        },
        {
          "dates": "2022-05-09",
          "totals": "0"
        },
        {
          "dates": "2022-05-10",
          "totals": "0"
        },
        {
          "dates": "2022-05-11",
          "totals": "0"
        },
        {
          "dates": "2022-05-12",
          "totals": "0"
        },
        {
          "dates": "2022-05-13",
          "totals": "0"
        },
        {
          "dates": "2022-05-14",
          "totals": "0"
        },
        {
          "dates": "2022-05-15",
          "totals": "0"
        },
        {
          "dates": "2022-05-16",
          "totals": "0"
        },
        {
          "dates": "2022-05-17",
          "totals": "0"
        },
        {
          "dates": "2022-05-18",
          "totals": "0"
        },
        {
          "dates": "2022-05-19",
          "totals": "0"
        },
        {
          "dates": "2022-05-20",
          "totals": "0"
        },
        {
          "dates": "2022-05-21",
          "totals": "0"
        },
        {
          "dates": "2022-05-22",
          "totals": "0"
        },
        {
          "dates": "2022-05-23",
          "totals": "0"
        },
        {
          "dates": "2022-05-24",
          "totals": "0"
        },
        {
          "dates": "2022-05-25",
          "totals": "0"
        },
        {
          "dates": "2022-05-26",
          "totals": "0"
        },
        {
          "dates": "2022-05-27",
          "totals": "0"
        },
        {
          "dates": "2022-05-28",
          "totals": "0"
        },
        {
          "dates": "2022-05-29",
          "totals": "0"
        },
        {
          "dates": "2022-05-30",
          "totals": "0"
        },
        {
          "dates": "2022-05-31",
          "totals": "0"
        },
        {
          "dates": "2022-06-01",
          "totals": "0"
        },
        {
          "dates": "2022-06-02",
          "totals": "0"
        },
        {
          "dates": "2022-06-03",
          "totals": "0"
        },
        {
          "dates": "2022-06-04",
          "totals": "0"
        },
        {
          "dates": "2022-06-05",
          "totals": "0"
        },
        {
          "dates": "2022-06-06",
          "totals": "0"
        },
        {
          "dates": "2022-06-07",
          "totals": "0"
        },
        {
          "dates": "2022-06-08",
          "totals": "0"
        },
        {
          "dates": "2022-06-09",
          "totals": "0"
        },
        {
          "dates": "2022-06-10",
          "totals": "0"
        },
        {
          "dates": "2022-06-11",
          "totals": "0"
        },
        {
          "dates": "2022-06-12",
          "totals": "0"
        },
        {
          "dates": "2022-06-13",
          "totals": "0"
        },
        {
          "dates": "2022-06-14",
          "totals": "0"
        },
        {
          "dates": "2022-06-15",
          "totals": "0"
        },
        {
          "dates": "2022-06-16",
          "totals": "0"
        },
        {
          "dates": "2022-06-17",
          "totals": "0"
        },
        {
          "dates": "2022-06-18",
          "totals": "0"
        },
        {
          "dates": "2022-06-19",
          "totals": "0"
        },
        {
          "dates": "2022-06-20",
          "totals": "0"
        },
        {
          "dates": "2022-06-21",
          "totals": "0"
        },
        {
          "dates": "2022-06-22",
          "totals": "0"
        },
        {
          "dates": "2022-06-23",
          "totals": "0"
        },
        {
          "dates": "2022-06-24",
          "totals": "0"
        },
        {
          "dates": "2022-06-25",
          "totals": "0"
        },
        {
          "dates": "2022-06-26",
          "totals": "0"
        },
        {
          "dates": "2022-06-27",
          "totals": "0"
        },
        {
          "dates": "2022-06-28",
          "totals": "0"
        },
        {
          "dates": "2022-06-29",
          "totals": "0"
        },
        {
          "dates": "2022-06-30",
          "totals": "0"
        },
        {
          "dates": "2022-07-01",
          "totals": "0"
        },
        {
          "dates": "2022-07-02",
          "totals": "0"
        },
        {
          "dates": "2022-07-03",
          "totals": "0"
        },
        {
          "dates": "2022-07-04",
          "totals": "0"
        },
        {
          "dates": "2022-07-05",
          "totals": "0"
        },
        {
          "dates": "2022-07-06",
          "totals": "0"
        },
        {
          "dates": "2022-07-07",
          "totals": "0"
        },
        {
          "dates": "2022-07-08",
          "totals": "0"
        },
        {
          "dates": "2022-07-09",
          "totals": "0"
        },
        {
          "dates": "2022-07-10",
          "totals": "0"
        },
        {
          "dates": "2022-07-11",
          "totals": "0"
        },
        {
          "dates": "2022-07-12",
          "totals": "0"
        },
        {
          "dates": "2022-07-13",
          "totals": "0"
        },
        {
          "dates": "2022-07-14",
          "totals": "0"
        },
        {
          "dates": "2022-07-15",
          "totals": "0"
        },
        {
          "dates": "2022-07-16",
          "totals": "0"
        },
        {
          "dates": "2022-07-17",
          "totals": "0"
        },
        {
          "dates": "2022-07-18",
          "totals": "0"
        },
        {
          "dates": "2022-07-19",
          "totals": "0"
        },
        {
          "dates": "2022-07-20",
          "totals": "0"
        },
        {
          "dates": "2022-07-21",
          "totals": "0"
        },
        {
          "dates": "2022-07-22",
          "totals": "0"
        },
        {
          "dates": "2022-07-23",
          "totals": "0"
        },
        {
          "dates": "2022-07-24",
          "totals": "0"
        },
        {
          "dates": "2022-07-25",
          "totals": "0"
        },
        {
          "dates": "2022-07-26",
          "totals": "0"
        },
        {
          "dates": "2022-07-27",
          "totals": "0"
        },
        {
          "dates": "2022-07-28",
          "totals": "0"
        },
        {
          "dates": "2022-07-29",
          "totals": "0"
        },
        {
          "dates": "2022-07-30",
          "totals": "0"
        },
        {
          "dates": "2022-07-31",
          "totals": "0"
        },
        {
          "dates": "2022-08-01",
          "totals": "0"
        },
        {
          "dates": "2022-08-02",
          "totals": "0"
        },
        {
          "dates": "2022-08-03",
          "totals": "0"
        },
        {
          "dates": "2022-08-04",
          "totals": "0"
        },
        {
          "dates": "2022-08-05",
          "totals": "0"
        },
        {
          "dates": "2022-08-06",
          "totals": "0"
        },
        {
          "dates": "2022-08-07",
          "totals": "0"
        },
        {
          "dates": "2022-08-08",
          "totals": "0"
        },
        {
          "dates": "2022-08-09",
          "totals": "0"
        },
        {
          "dates": "2022-08-10",
          "totals": "0"
        },
        {
          "dates": "2022-08-11",
          "totals": "0"
        },
        {
          "dates": "2022-08-12",
          "totals": "0"
        },
        {
          "dates": "2022-08-13",
          "totals": "0"
        },
        {
          "dates": "2022-08-14",
          "totals": "0"
        },
        {
          "dates": "2022-08-15",
          "totals": "0"
        },
        {
          "dates": "2022-08-16",
          "totals": "0"
        },
        {
          "dates": "2022-08-17",
          "totals": "0"
        },
        {
          "dates": "2022-08-18",
          "totals": "0"
        },
        {
          "dates": "2022-08-19",
          "totals": "0"
        },
        {
          "dates": "2022-08-20",
          "totals": "0"
        },
        {
          "dates": "2022-08-21",
          "totals": "0"
        },
        {
          "dates": "2022-08-22",
          "totals": "0"
        },
        {
          "dates": "2022-08-23",
          "totals": "0"
        },
        {
          "dates": "2022-08-24",
          "totals": "0"
        },
        {
          "dates": "2022-08-25",
          "totals": "0"
        },
        {
          "dates": "2022-08-26",
          "totals": "0"
        },
        {
          "dates": "2022-08-27",
          "totals": "0"
        },
        {
          "dates": "2022-08-28",
          "totals": "0"
        },
        {
          "dates": "2022-08-29",
          "totals": "0"
        },
        {
          "dates": "2022-08-30",
          "totals": "0"
        },
        {
          "dates": "2022-08-31",
          "totals": "0"
        },
        {
          "dates": "2022-09-01",
          "totals": "0"
        },
        {
          "dates": "2022-09-02",
          "totals": "0"
        },
        {
          "dates": "2022-09-03",
          "totals": "0"
        },
        {
          "dates": "2022-09-04",
          "totals": "0"
        },
        {
          "dates": "2022-09-05",
          "totals": "0"
        },
        {
          "dates": "2022-09-06",
          "totals": "0"
        },
        {
          "dates": "2022-09-07",
          "totals": "0"
        },
        {
          "dates": "2022-09-08",
          "totals": "0"
        },
        {
          "dates": "2022-09-09",
          "totals": "0"
        },
        {
          "dates": "2022-09-10",
          "totals": "0"
        },
        {
          "dates": "2022-09-11",
          "totals": "0"
        },
        {
          "dates": "2022-09-12",
          "totals": "0"
        },
        {
          "dates": "2022-09-13",
          "totals": "0"
        },
        {
          "dates": "2022-09-14",
          "totals": "0"
        },
        {
          "dates": "2022-09-15",
          "totals": "0"
        },
        {
          "dates": "2022-09-16",
          "totals": "0"
        },
        {
          "dates": "2022-09-17",
          "totals": "0"
        },
        {
          "dates": "2022-09-18",
          "totals": "0"
        },
        {
          "dates": "2022-09-19",
          "totals": "0"
        },
        {
          "dates": "2022-09-20",
          "totals": "0"
        },
        {
          "dates": "2022-09-21",
          "totals": "0"
        },
        {
          "dates": "2022-09-22",
          "totals": "0"
        },
        {
          "dates": "2022-09-23",
          "totals": "0"
        },
        {
          "dates": "2022-09-24",
          "totals": "0"
        },
        {
          "dates": "2022-09-25",
          "totals": "0"
        },
        {
          "dates": "2022-09-26",
          "totals": "0"
        },
        {
          "dates": "2022-09-27",
          "totals": "0"
        },
        {
          "dates": "2022-09-28",
          "totals": "0"
        },
        {
          "dates": "2022-09-29",
          "totals": "0"
        },
        {
          "dates": "2022-09-30",
          "totals": "0"
        },
        {
          "dates": "2022-10-01",
          "totals": "0"
        },
        {
          "dates": "2022-10-02",
          "totals": "0"
        },
        {
          "dates": "2022-10-03",
          "totals": "0"
        },
        {
          "dates": "2022-10-04",
          "totals": "0"
        },
        {
          "dates": "2022-10-05",
          "totals": "0"
        },
        {
          "dates": "2022-10-06",
          "totals": "0"
        },
        {
          "dates": "2022-10-07",
          "totals": "0"
        },
        {
          "dates": "2022-10-08",
          "totals": "0"
        },
        {
          "dates": "2022-10-09",
          "totals": "0"
        },
        {
          "dates": "2022-10-10",
          "totals": "0"
        },
        {
          "dates": "2022-10-11",
          "totals": "0"
        },
        {
          "dates": "2022-10-12",
          "totals": "0"
        },
        {
          "dates": "2022-10-13",
          "totals": "0"
        },
        {
          "dates": "2022-10-14",
          "totals": "0"
        },
        {
          "dates": "2022-10-15",
          "totals": "0"
        },
        {
          "dates": "2022-10-16",
          "totals": "0"
        },
        {
          "dates": "2022-10-17",
          "totals": "0"
        },
        {
          "dates": "2022-10-18",
          "totals": "0"
        },
        {
          "dates": "2022-10-19",
          "totals": "0"
        },
        {
          "dates": "2022-10-20",
          "totals": "0"
        },
        {
          "dates": "2022-10-21",
          "totals": "0"
        },
        {
          "dates": "2022-10-22",
          "totals": "0"
        },
        {
          "dates": "2022-10-23",
          "totals": "0"
        },
        {
          "dates": "2022-10-24",
          "totals": "0"
        },
        {
          "dates": "2022-10-25",
          "totals": "0"
        },
        {
          "dates": "2022-10-26",
          "totals": "0"
        },
        {
          "dates": "2022-10-27",
          "totals": "0"
        },
        {
          "dates": "2022-10-28",
          "totals": "0"
        },
        {
          "dates": "2022-10-29",
          "totals": "0"
        },
        {
          "dates": "2022-10-30",
          "totals": "0"
        },
        {
          "dates": "2022-10-31",
          "totals": "0"
        },
        {
          "dates": "2022-11-01",
          "totals": "0"
        },
        {
          "dates": "2022-11-02",
          "totals": "0"
        },
        {
          "dates": "2022-11-03",
          "totals": "0"
        },
        {
          "dates": "2022-11-04",
          "totals": "0"
        },
        {
          "dates": "2022-11-05",
          "totals": "0"
        },
        {
          "dates": "2022-11-06",
          "totals": "0"
        },
        {
          "dates": "2022-11-07",
          "totals": "0"
        },
        {
          "dates": "2022-11-08",
          "totals": "0"
        },
        {
          "dates": "2022-11-09",
          "totals": "0"
        },
        {
          "dates": "2022-11-10",
          "totals": "0"
        },
        {
          "dates": "2022-11-11",
          "totals": "0"
        },
        {
          "dates": "2022-11-12",
          "totals": "0"
        },
        {
          "dates": "2022-11-13",
          "totals": "0"
        },
        {
          "dates": "2022-11-14",
          "totals": "0"
        },
        {
          "dates": "2022-11-15",
          "totals": "0"
        },
        {
          "dates": "2022-11-16",
          "totals": "0"
        },
        {
          "dates": "2022-11-17",
          "totals": "0"
        },
        {
          "dates": "2022-11-18",
          "totals": "0"
        },
        {
          "dates": "2022-11-19",
          "totals": "0"
        },
        {
          "dates": "2022-11-20",
          "totals": "0"
        },
        {
          "dates": "2022-11-21",
          "totals": "0"
        },
        {
          "dates": "2022-11-22",
          "totals": "0"
        },
        {
          "dates": "2022-11-23",
          "totals": "0"
        },
        {
          "dates": "2022-11-24",
          "totals": "0"
        },
        {
          "dates": "2022-11-25",
          "totals": "0"
        },
        {
          "dates": "2022-11-26",
          "totals": "0"
        },
        {
          "dates": "2022-11-27",
          "totals": "0"
        },
        {
          "dates": "2022-11-28",
          "totals": "0"
        },
        {
          "dates": "2022-11-29",
          "totals": "0"
        },
        {
          "dates": "2022-11-30",
          "totals": "0"
        },
        {
          "dates": "2022-12-01",
          "totals": "20"
        },
        {
          "dates": "2022-12-02",
          "totals": "0"
        },
        {
          "dates": "2022-12-03",
          "totals": "64"
        },
        {
          "dates": "2022-12-04",
          "totals": "0"
        },
        {
          "dates": "2022-12-05",
          "totals": "0"
        },
        {
          "dates": "2022-12-06",
          "totals": "0"
        },
        {
          "dates": "2022-12-07",
          "totals": "0"
        },
        {
          "dates": "2022-12-08",
          "totals": "0"
        },
        {
          "dates": "2022-12-09",
          "totals": "0"
        },
        {
          "dates": "2022-12-10",
          "totals": "0"
        },
        {
          "dates": "2022-12-11",
          "totals": "0"
        },
        {
          "dates": "2022-12-12",
          "totals": "0"
        },
        {
          "dates": "2022-12-13",
          "totals": "0"
        },
        {
          "dates": "2022-12-14",
          "totals": "0"
        },
        {
          "dates": "2022-12-15",
          "totals": "0"
        },
        {
          "dates": "2022-12-16",
          "totals": "0"
        },
        {
          "dates": "2022-12-17",
          "totals": "0"
        },
        {
          "dates": "2022-12-18",
          "totals": "0"
        },
        {
          "dates": "2022-12-19",
          "totals": "0"
        },
        {
          "dates": "2022-12-20",
          "totals": "0"
        },
        {
          "dates": "2022-12-21",
          "totals": "0"
        },
        {
          "dates": "2022-12-22",
          "totals": "0"
        },
        {
          "dates": "2022-12-23",
          "totals": "0"
        },
        {
          "dates": "2022-12-24",
          "totals": "0"
        },
        {
          "dates": "2022-12-25",
          "totals": "0"
        },
        {
          "dates": "2022-12-26",
          "totals": "0"
        },
        {
          "dates": "2022-12-27",
          "totals": "0"
        },
        {
          "dates": "2022-12-28",
          "totals": "0"
        },
        {
          "dates": "2022-12-29",
          "totals": "0"
        },
        {
          "dates": "2022-12-30",
          "totals": "0"
        },
        {
          "dates": "2022-12-31",
          "totals": "0"
        },
        {
          "dates": "2023-01-01",
          "totals": "0"
        },
        {
          "dates": "2023-01-02",
          "totals": "0"
        },
        {
          "dates": "2023-01-03",
          "totals": "0"
        },
        {
          "dates": "2023-01-04",
          "totals": "0"
        },
        {
          "dates": "2023-01-05",
          "totals": "0"
        },
        {
          "dates": "2023-01-06",
          "totals": "0"
        },
        {
          "dates": "2023-01-07",
          "totals": "0"
        },
        {
          "dates": "2023-01-08",
          "totals": "0"
        },
        {
          "dates": "2023-01-09",
          "totals": "0"
        },
        {
          "dates": "2023-01-10",
          "totals": "0"
        },
        {
          "dates": "2023-01-11",
          "totals": "0"
        },
        {
          "dates": "2023-01-12",
          "totals": "0"
        },
        {
          "dates": "2023-01-13",
          "totals": "0"
        },
        {
          "dates": "2023-01-14",
          "totals": "0"
        },
        {
          "dates": "2023-01-15",
          "totals": "0"
        },
        {
          "dates": "2023-01-16",
          "totals": "0"
        },
        {
          "dates": "2023-01-17",
          "totals": "0"
        },
        {
          "dates": "2023-01-18",
          "totals": "0"
        },
        {
          "dates": "2023-01-19",
          "totals": "0"
        },
        {
          "dates": "2023-01-20",
          "totals": "0"
        },
        {
          "dates": "2023-01-21",
          "totals": "0"
        },
        {
          "dates": "2023-01-22",
          "totals": "0"
        },
        {
          "dates": "2023-01-23",
          "totals": "0"
        },
        {
          "dates": "2023-01-24",
          "totals": "0"
        },
        {
          "dates": "2023-01-25",
          "totals": "0"
        },
        {
          "dates": "2023-01-26",
          "totals": "0"
        },
        {
          "dates": "2023-01-27",
          "totals": "0"
        },
        {
          "dates": "2023-01-28",
          "totals": "0"
        },
        {
          "dates": "2023-01-29",
          "totals": "0"
        },
        {
          "dates": "2023-01-30",
          "totals": "0"
        },
        {
          "dates": "2023-01-31",
          "totals": "32"
        },
        {
          "dates": "2023-02-01",
          "totals": "0"
        },
        {
          "dates": "2023-02-02",
          "totals": "0"
        },
        {
          "dates": "2023-02-03",
          "totals": "0"
        },
        {
          "dates": "2023-02-04",
          "totals": "0"
        },
        {
          "dates": "2023-02-05",
          "totals": "0"
        },
        {
          "dates": "2023-02-06",
          "totals": "0"
        },
        {
          "dates": "2023-02-07",
          "totals": "64"
        },
        {
          "dates": "2023-02-08",
          "totals": "192"
        },
        {
          "dates": "2023-02-09",
          "totals": "0"
        },
        {
          "dates": "2023-02-10",
          "totals": "0"
        },
        {
          "dates": "2023-02-11",
          "totals": "0"
        },
        {
          "dates": "2023-02-12",
          "totals": "0"
        },
        {
          "dates": "2023-02-13",
          "totals": "0"
        },
        {
          "dates": "2023-02-14",
          "totals": "0"
        },
        {
          "dates": "2023-02-15",
          "totals": "0"
        },
        {
          "dates": "2023-02-16",
          "totals": "0"
        },
        {
          "dates": "2023-02-17",
          "totals": "0"
        },
        {
          "dates": "2023-02-18",
          "totals": "0"
        },
        {
          "dates": "2023-02-19",
          "totals": "0"
        },
        {
          "dates": "2023-02-20",
          "totals": "0"
        },
        {
          "dates": "2023-02-21",
          "totals": "0"
        },
        {
          "dates": "2023-02-22",
          "totals": "0"
        },
        {
          "dates": "2023-02-23",
          "totals": "0"
        },
        {
          "dates": "2023-02-24",
          "totals": "0"
        },
        {
          "dates": "2023-02-25",
          "totals": "0"
        },
        {
          "dates": "2023-02-26",
          "totals": "0"
        },
        {
          "dates": "2023-02-27",
          "totals": "0"
        },
        {
          "dates": "2023-02-28",
          "totals": "0"
        },
        {
          "dates": "2023-03-01",
          "totals": "0"
        },
        {
          "dates": "2023-03-02",
          "totals": "0"
        },
        {
          "dates": "2023-03-03",
          "totals": "32"
        },
        {
          "dates": "2023-03-04",
          "totals": "0"
        },
        {
          "dates": "2023-03-05",
          "totals": "0"
        },
        {
          "dates": "2023-03-06",
          "totals": "0"
        },
        {
          "dates": "2023-03-07",
          "totals": "32"
        },
        {
          "dates": "2023-03-08",
          "totals": "192"
        },
        {
          "dates": "2023-03-09",
          "totals": "0"
        },
        {
          "dates": "2023-03-10",
          "totals": "0"
        },
        {
          "dates": "2023-03-11",
          "totals": "0"
        },
        {
          "dates": "2023-03-12",
          "totals": "0"
        },
        {
          "dates": "2023-03-13",
          "totals": "0"
        },
        {
          "dates": "2023-03-14",
          "totals": "0"
        },
        {
          "dates": "2023-03-15",
          "totals": "0"
        },
        {
          "dates": "2023-03-16",
          "totals": "0"
        },
        {
          "dates": "2023-03-17",
          "totals": "0"
        },
        {
          "dates": "2023-03-18",
          "totals": "0"
        },
        {
          "dates": "2023-03-19",
          "totals": "0"
        },
        {
          "dates": "2023-03-20",
          "totals": "0"
        },
        {
          "dates": "2023-03-21",
          "totals": "0"
        },
        {
          "dates": "2023-03-22",
          "totals": "0"
        },
        {
          "dates": "2023-03-23",
          "totals": "0"
        },
        {
          "dates": "2023-03-24",
          "totals": "0"
        },
        {
          "dates": "2023-03-25",
          "totals": "0"
        },
        {
          "dates": "2023-03-26",
          "totals": "0"
        },
        {
          "dates": "2023-03-27",
          "totals": "0"
        },
        {
          "dates": "2023-03-28",
          "totals": "0"
        },
        {
          "dates": "2023-03-29",
          "totals": "0"
        },
        {
          "dates": "2023-03-30",
          "totals": "0"
        },
        {
          "dates": "2023-03-31",
          "totals": "32"
        },
        {
          "dates": "2023-04-01",
          "totals": "32"
        },
        {
          "dates": "2023-04-02",
          "totals": "0"
        },
        {
          "dates": "2023-04-03",
          "totals": "0"
        },
        {
          "dates": "2023-04-04",
          "totals": "0"
        },
        {
          "dates": "2023-04-05",
          "totals": "0"
        },
        {
          "dates": "2023-04-06",
          "totals": "0"
        },
        {
          "dates": "2023-04-07",
          "totals": "64"
        },
        {
          "dates": "2023-04-08",
          "totals": "0"
        },
        {
          "dates": "2023-04-09",
          "totals": "0"
        },
        {
          "dates": "2023-04-10",
          "totals": "0"
        },
        {
          "dates": "2023-04-11",
          "totals": "0"
        },
        {
          "dates": "2023-04-12",
          "totals": "64"
        },
        {
          "dates": "2023-04-13",
          "totals": "32"
        },
        {
          "dates": "2023-04-14",
          "totals": "0"
        },
        {
          "dates": "2023-04-15",
          "totals": "0"
        },
        {
          "dates": "2023-04-16",
          "totals": "0"
        },
        {
          "dates": "2023-04-17",
          "totals": "0"
        },
        {
          "dates": "2023-04-18",
          "totals": "0"
        },
        {
          "dates": "2023-04-19",
          "totals": "0"
        },
        {
          "dates": "2023-04-20",
          "totals": "300"
        },
        {
          "dates": "2023-04-21",
          "totals": "0"
        },
        {
          "dates": "2023-04-22",
          "totals": "0"
        },
        {
          "dates": "2023-04-23",
          "totals": "0"
        },
        {
          "dates": "2023-04-24",
          "totals": "0"
        },
        {
          "dates": "2023-04-25",
          "totals": "0"
        },
        {
          "dates": "2023-04-26",
          "totals": "0"
        },
        {
          "dates": "2023-04-27",
          "totals": "0"
        },
        {
          "dates": "2023-04-28",
          "totals": "0"
        },
        {
          "dates": "2023-04-29",
          "totals": "0"
        },
        {
          "dates": "2023-04-30",
          "totals": "0"
        },
        {
          "dates": "2023-05-01",
          "totals": "0"
        },
        {
          "dates": "2023-05-02",
          "totals": "0"
        },
        {
          "dates": "2023-05-03",
          "totals": "0"
        },
        {
          "dates": "2023-05-04",
          "totals": "0"
        },
        {
          "dates": "2023-05-05",
          "totals": "0"
        },
        {
          "dates": "2023-05-06",
          "totals": "0"
        },
        {
          "dates": "2023-05-07",
          "totals": "0"
        },
        {
          "dates": "2023-05-08",
          "totals": "0"
        },
        {
          "dates": "2023-05-09",
          "totals": "0"
        },
        {
          "dates": "2023-05-10",
          "totals": "0"
        },
        {
          "dates": "2023-05-11",
          "totals": "0"
        },
        {
          "dates": "2023-05-12",
          "totals": "0"
        },
        {
          "dates": "2023-05-13",
          "totals": "0"
        },
        {
          "dates": "2023-05-14",
          "totals": "0"
        },
        {
          "dates": "2023-05-15",
          "totals": "0"
        },
        {
          "dates": "2023-05-16",
          "totals": "0"
        },
        {
          "dates": "2023-05-17",
          "totals": "0"
        },
        {
          "dates": "2023-05-18",
          "totals": "0"
        },
        {
          "dates": "2023-05-19",
          "totals": "0"
        },
        {
          "dates": "2023-05-20",
          "totals": "0"
        },
        {
          "dates": "2023-05-21",
          "totals": "0"
        },
        {
          "dates": "2023-05-22",
          "totals": "0"
        },
        {
          "dates": "2023-05-23",
          "totals": "0"
        },
        {
          "dates": "2023-05-24",
          "totals": "0"
        },
        {
          "dates": "2023-05-25",
          "totals": "0"
        },
        {
          "dates": "2023-05-26",
          "totals": "0"
        },
        {
          "dates": "2023-05-27",
          "totals": "0"
        },
        {
          "dates": "2023-05-28",
          "totals": "0"
        },
        {
          "dates": "2023-05-29",
          "totals": "0"
        },
        {
          "dates": "2023-05-30",
          "totals": "0"
        },
        {
          "dates": "2023-05-31",
          "totals": "0"
        },
        {
          "dates": "2023-06-01",
          "totals": "0"
        },
        {
          "dates": "2023-06-02",
          "totals": "0"
        },
        {
          "dates": "2023-06-03",
          "totals": "0"
        },
        {
          "dates": "2023-06-04",
          "totals": "0"
        },
        {
          "dates": "2023-06-05",
          "totals": "0"
        },
        {
          "dates": "2023-06-06",
          "totals": "0"
        },
        {
          "dates": "2023-06-07",
          "totals": "0"
        },
        {
          "dates": "2023-06-08",
          "totals": "0"
        },
        {
          "dates": "2023-06-09",
          "totals": "0"
        },
        {
          "dates": "2023-06-10",
          "totals": "0"
        },
        {
          "dates": "2023-06-11",
          "totals": "0"
        },
        {
          "dates": "2023-06-12",
          "totals": "0"
        },
        {
          "dates": "2023-06-13",
          "totals": "0"
        },
        {
          "dates": "2023-06-14",
          "totals": "0"
        },
        {
          "dates": "2023-06-15",
          "totals": "0"
        },
        {
          "dates": "2023-06-16",
          "totals": "0"
        },
        {
          "dates": "2023-06-17",
          "totals": "0"
        },
        {
          "dates": "2023-06-18",
          "totals": "0"
        },
        {
          "dates": "2023-06-19",
          "totals": "0"
        },
        {
          "dates": "2023-06-20",
          "totals": "0"
        },
        {
          "dates": "2023-06-21",
          "totals": "0"
        },
        {
          "dates": "2023-06-22",
          "totals": "0"
        },
        {
          "dates": "2023-06-23",
          "totals": "0"
        },
        {
          "dates": "2023-06-24",
          "totals": "0"
        },
        {
          "dates": "2023-06-25",
          "totals": "0"
        },
        {
          "dates": "2023-06-26",
          "totals": "0"
        },
        {
          "dates": "2023-06-27",
          "totals": "0"
        },
        {
          "dates": "2023-06-28",
          "totals": "0"
        },
        {
          "dates": "2023-06-29",
          "totals": "0"
        },
        {
          "dates": "2023-06-30",
          "totals": "0"
        },
        {
          "dates": "2023-07-01",
          "totals": "0"
        },
        {
          "dates": "2023-07-02",
          "totals": "0"
        },
        {
          "dates": "2023-07-03",
          "totals": "0"
        },
        {
          "dates": "2023-07-04",
          "totals": "0"
        },
        {
          "dates": "2023-07-05",
          "totals": "0"
        },
        {
          "dates": "2023-07-06",
          "totals": "0"
        },
        {
          "dates": "2023-07-07",
          "totals": "0"
        },
        {
          "dates": "2023-07-08",
          "totals": "0"
        },
        {
          "dates": "2023-07-09",
          "totals": "0"
        },
        {
          "dates": "2023-07-10",
          "totals": "0"
        },
        {
          "dates": "2023-07-11",
          "totals": "0"
        },
        {
          "dates": "2023-07-12",
          "totals": "0"
        },
        {
          "dates": "2023-07-13",
          "totals": "0"
        },
        {
          "dates": "2023-07-14",
          "totals": "0"
        },
        {
          "dates": "2023-07-15",
          "totals": "0"
        },
        {
          "dates": "2023-07-16",
          "totals": "0"
        },
        {
          "dates": "2023-07-17",
          "totals": "0"
        },
        {
          "dates": "2023-07-18",
          "totals": "0"
        },
        {
          "dates": "2023-07-19",
          "totals": "0"
        },
        {
          "dates": "2023-07-20",
          "totals": "0"
        },
        {
          "dates": "2023-07-21",
          "totals": "0"
        },
        {
          "dates": "2023-07-22",
          "totals": "0"
        },
        {
          "dates": "2023-07-23",
          "totals": "0"
        },
        {
          "dates": "2023-07-24",
          "totals": "0"
        },
        {
          "dates": "2023-07-25",
          "totals": "0"
        },
        {
          "dates": "2023-07-26",
          "totals": "0"
        },
        {
          "dates": "2023-07-27",
          "totals": "0"
        },
        {
          "dates": "2023-07-28",
          "totals": "0"
        },
        {
          "dates": "2023-07-29",
          "totals": "0"
        },
        {
          "dates": "2023-07-30",
          "totals": "0"
        },
        {
          "dates": "2023-07-31",
          "totals": "0"
        },
        {
          "dates": "2023-08-01",
          "totals": "0"
        },
        {
          "dates": "2023-08-02",
          "totals": "0"
        },
        {
          "dates": "2023-08-03",
          "totals": "0"
        },
        {
          "dates": "2023-08-04",
          "totals": "0"
        },
        {
          "dates": "2023-08-05",
          "totals": "0"
        },
        {
          "dates": "2023-08-06",
          "totals": "0"
        },
        {
          "dates": "2023-08-07",
          "totals": "0"
        },
        {
          "dates": "2023-08-08",
          "totals": "0"
        },
        {
          "dates": "2023-08-09",
          "totals": "0"
        },
        {
          "dates": "2023-08-10",
          "totals": "0"
        },
        {
          "dates": "2023-08-11",
          "totals": "0"
        },
        {
          "dates": "2023-08-12",
          "totals": "0"
        },
        {
          "dates": "2023-08-13",
          "totals": "0"
        },
        {
          "dates": "2023-08-14",
          "totals": "0"
        },
        {
          "dates": "2023-08-15",
          "totals": "0"
        },
        {
          "dates": "2023-08-16",
          "totals": "0"
        },
        {
          "dates": "2023-08-17",
          "totals": "0"
        },
        {
          "dates": "2023-08-18",
          "totals": "0"
        },
        {
          "dates": "2023-08-19",
          "totals": "0"
        },
        {
          "dates": "2023-08-20",
          "totals": "0"
        },
        {
          "dates": "2023-08-21",
          "totals": "0"
        },
        {
          "dates": "2023-08-22",
          "totals": "0"
        },
        {
          "dates": "2023-08-23",
          "totals": "0"
        },
        {
          "dates": "2023-08-24",
          "totals": "0"
        },
        {
          "dates": "2023-08-25",
          "totals": "0"
        },
        {
          "dates": "2023-08-26",
          "totals": "0"
        },
        {
          "dates": "2023-08-27",
          "totals": "0"
        },
        {
          "dates": "2023-08-28",
          "totals": "0"
        },
        {
          "dates": "2023-08-29",
          "totals": "0"
        },
        {
          "dates": "2023-08-30",
          "totals": "0"
        },
        {
          "dates": "2023-08-31",
          "totals": "0"
        },
        {
          "dates": "2023-09-01",
          "totals": "0"
        },
        {
          "dates": "2023-09-02",
          "totals": "0"
        },
        {
          "dates": "2023-09-03",
          "totals": "0"
        },
        {
          "dates": "2023-09-04",
          "totals": "0"
        },
        {
          "dates": "2023-09-05",
          "totals": "0"
        },
        {
          "dates": "2023-09-06",
          "totals": "0"
        },
        {
          "dates": "2023-09-07",
          "totals": "0"
        },
        {
          "dates": "2023-09-08",
          "totals": "0"
        },
        {
          "dates": "2023-09-09",
          "totals": "0"
        },
        {
          "dates": "2023-09-10",
          "totals": "0"
        },
        {
          "dates": "2023-09-11",
          "totals": "0"
        },
        {
          "dates": "2023-09-12",
          "totals": "0"
        },
        {
          "dates": "2023-09-13",
          "totals": "0"
        },
        {
          "dates": "2023-09-14",
          "totals": "0"
        },
        {
          "dates": "2023-09-15",
          "totals": "0"
        },
        {
          "dates": "2023-09-16",
          "totals": "0"
        },
        {
          "dates": "2023-09-17",
          "totals": "0"
        },
        {
          "dates": "2023-09-18",
          "totals": "0"
        },
        {
          "dates": "2023-09-19",
          "totals": "0"
        },
        {
          "dates": "2023-09-20",
          "totals": "0"
        },
        {
          "dates": "2023-09-21",
          "totals": "0"
        },
        {
          "dates": "2023-09-22",
          "totals": "0"
        },
        {
          "dates": "2023-09-23",
          "totals": "0"
        },
        {
          "dates": "2023-09-24",
          "totals": "0"
        },
        {
          "dates": "2023-09-25",
          "totals": "0"
        },
        {
          "dates": "2023-09-26",
          "totals": "0"
        },
        {
          "dates": "2023-09-27",
          "totals": "0"
        },
        {
          "dates": "2023-09-28",
          "totals": "0"
        },
        {
          "dates": "2023-09-29",
          "totals": "0"
        },
        {
          "dates": "2023-09-30",
          "totals": "0"
        },
        {
          "dates": "2023-10-01",
          "totals": "0"
        },
        {
          "dates": "2023-10-02",
          "totals": "0"
        },
        {
          "dates": "2023-10-03",
          "totals": "0"
        },
        {
          "dates": "2023-10-04",
          "totals": "0"
        },
        {
          "dates": "2023-10-05",
          "totals": "0"
        },
        {
          "dates": "2023-10-06",
          "totals": "0"
        },
        {
          "dates": "2023-10-07",
          "totals": "0"
        },
        {
          "dates": "2023-10-08",
          "totals": "0"
        },
        {
          "dates": "2023-10-09",
          "totals": "0"
        },
        {
          "dates": "2023-10-10",
          "totals": "0"
        },
        {
          "dates": "2023-10-11",
          "totals": "0"
        },
        {
          "dates": "2023-10-12",
          "totals": "32"
        },
        {
          "dates": "2023-10-13",
          "totals": "32"
        },
        {
          "dates": "2023-10-14",
          "totals": "0"
        },
        {
          "dates": "2023-10-15",
          "totals": "0"
        },
        {
          "dates": "2023-10-16",
          "totals": "1230"
        },
        {
          "dates": "2023-10-17",
          "totals": "6300"
        },
        {
          "dates": "2023-10-18",
          "totals": "6999"
        },
        {
          "dates": "2023-10-19",
          "totals": "3235"
        },
        {
          "dates": "2023-10-20",
          "totals": "630"
        },
        {
          "dates": "2023-10-21",
          "totals": "0"
        },
        {
          "dates": "2023-10-22",
          "totals": "0"
        },
        {
          "dates": "2023-10-23",
          "totals": "0"
        },
        {
          "dates": "2023-10-24",
          "totals": "0"
        },
        {
          "dates": "2023-10-25",
          "totals": "0"
        },
        {
          "dates": "2023-10-26",
          "totals": "0"
        },
        {
          "dates": "2023-10-27",
          "totals": "0"
        },
        {
          "dates": "2023-10-28",
          "totals": "0"
        },
        {
          "dates": "2023-10-29",
          "totals": "0"
        },
        {
          "dates": "2023-10-30",
          "totals": "0"
        },
        {
          "dates": "2023-10-31",
          "totals": "0"
        },
        {
          "dates": "2023-11-01",
          "totals": "0"
        },
        {
          "dates": "2023-11-02",
          "totals": "0"
        },
        {
          "dates": "2023-11-03",
          "totals": "0"
        },
        {
          "dates": "2023-11-04",
          "totals": "0"
        },
        {
          "dates": "2023-11-05",
          "totals": "0"
        },
        {
          "dates": "2023-11-06",
          "totals": "0"
        },
        {
          "dates": "2023-11-07",
          "totals": "0"
        },
        {
          "dates": "2023-11-08",
          "totals": "0"
        },
        {
          "dates": "2023-11-09",
          "totals": "0"
        },
        {
          "dates": "2023-11-10",
          "totals": "0"
        },
        {
          "dates": "2023-11-11",
          "totals": "0"
        },
        {
          "dates": "2023-11-12",
          "totals": "0"
        },
        {
          "dates": "2023-11-13",
          "totals": "0"
        },
        {
          "dates": "2023-11-14",
          "totals": "0"
        },
        {
          "dates": "2023-11-15",
          "totals": "0"
        },
        {
          "dates": "2023-11-16",
          "totals": "0"
        },
        {
          "dates": "2023-11-17",
          "totals": "0"
        },
        {
          "dates": "2023-11-18",
          "totals": "0"
        },
        {
          "dates": "2023-11-19",
          "totals": "0"
        },
        {
          "dates": "2023-11-20",
          "totals": "0"
        },
        {
          "dates": "2023-11-21",
          "totals": "0"
        },
        {
          "dates": "2023-11-22",
          "totals": "0"
        },
        {
          "dates": "2023-11-23",
          "totals": "0"
        },
        {
          "dates": "2023-11-24",
          "totals": "0"
        },
        {
          "dates": "2023-11-25",
          "totals": "0"
        },
        {
          "dates": "2023-11-26",
          "totals": "0"
        },
        {
          "dates": "2023-11-27",
          "totals": "0"
        },
        {
          "dates": "2023-11-28",
          "totals": "0"
        },
        {
          "dates": "2023-11-29",
          "totals": "0"
        },
        {
          "dates": "2023-11-30",
          "totals": "0"
        },
        {
          "dates": "2023-12-01",
          "totals": "0"
        },
        {
          "dates": "2023-12-02",
          "totals": "0"
        },
        {
          "dates": "2023-12-03",
          "totals": "0"
        },
        {
          "dates": "2023-12-04",
          "totals": "0"
        },
        {
          "dates": "2023-12-05",
          "totals": "0"
        },
        {
          "dates": "2023-12-06",
          "totals": "0"
        },
        {
          "dates": "2023-12-07",
          "totals": "0"
        },
        {
          "dates": "2023-12-08",
          "totals": "0"
        },
        {
          "dates": "2023-12-09",
          "totals": "0"
        },
        {
          "dates": "2023-12-10",
          "totals": "0"
        },
        {
          "dates": "2023-12-11",
          "totals": "0"
        },
        {
          "dates": "2023-12-12",
          "totals": "0"
        },
        {
          "dates": "2023-12-13",
          "totals": "0"
        },
        {
          "dates": "2023-12-14",
          "totals": "0"
        },
        {
          "dates": "2023-12-15",
          "totals": "0"
        },
        {
          "dates": "2023-12-16",
          "totals": "0"
        },
        {
          "dates": "2023-12-17",
          "totals": "0"
        },
        {
          "dates": "2023-12-18",
          "totals": "0"
        },
        {
          "dates": "2023-12-19",
          "totals": "0"
        },
        {
          "dates": "2023-12-20",
          "totals": "0"
        },
        {
          "dates": "2023-12-21",
          "totals": "0"
        },
        {
          "dates": "2023-12-22",
          "totals": "0"
        },
        {
          "dates": "2023-12-23",
          "totals": "0"
        },
        {
          "dates": "2023-12-24",
          "totals": "0"
        },
        {
          "dates": "2023-12-25",
          "totals": "0"
        },
        {
          "dates": "2023-12-26",
          "totals": "0"
        },
        {
          "dates": "2023-12-27",
          "totals": "0"
        },
        {
          "dates": "2023-12-28",
          "totals": "0"
        },
        {
          "dates": "2023-12-29",
          "totals": "0"
        },
        {
          "dates": "2023-12-30",
          "totals": "0"
        },
        {
          "dates": "2023-12-31",
          "totals": "0"
        },
        {
          "dates": "2024-01-01",
          "totals": "0"
        },
        {
          "dates": "2024-01-02",
          "totals": "0"
        },
        {
          "dates": "2024-01-03",
          "totals": "0"
        },
        {
          "dates": "2024-01-04",
          "totals": "0"
        },
        {
          "dates": "2024-01-05",
          "totals": "0"
        },
        {
          "dates": "2024-01-06",
          "totals": "0"
        },
        {
          "dates": "2024-01-07",
          "totals": "0"
        },
        {
          "dates": "2024-01-08",
          "totals": "0"
        },
        {
          "dates": "2024-01-09",
          "totals": "0"
        },
        {
          "dates": "2024-01-10",
          "totals": "0"
        },
        {
          "dates": "2024-01-11",
          "totals": "0"
        },
        {
          "dates": "2024-01-12",
          "totals": "0"
        },
        {
          "dates": "2024-01-13",
          "totals": "0"
        },
        {
          "dates": "2024-01-14",
          "totals": "0"
        },
        {
          "dates": "2024-01-15",
          "totals": "0"
        },
        {
          "dates": "2024-01-16",
          "totals": "0"
        },
        {
          "dates": "2024-01-17",
          "totals": "0"
        },
        {
          "dates": "2024-01-18",
          "totals": "0"
        },
        {
          "dates": "2024-01-19",
          "totals": "0"
        },
        {
          "dates": "2024-01-20",
          "totals": "0"
        },
        {
          "dates": "2024-01-21",
          "totals": "0"
        },
        {
          "dates": "2024-01-22",
          "totals": "0"
        },
        {
          "dates": "2024-01-23",
          "totals": "0"
        },
        {
          "dates": "2024-01-24",
          "totals": "0"
        },
        {
          "dates": "2024-01-25",
          "totals": "0"
        },
        {
          "dates": "2024-01-26",
          "totals": "0"
        },
        {
          "dates": "2024-01-27",
          "totals": "0"
        },
        {
          "dates": "2024-01-28",
          "totals": "0"
        },
        {
          "dates": "2024-01-29",
          "totals": "0"
        },
        {
          "dates": "2024-01-30",
          "totals": "0"
        },
        {
          "dates": "2024-01-31",
          "totals": "0"
        },
        {
          "dates": "2024-02-01",
          "totals": "0"
        },
        {
          "dates": "2024-02-02",
          "totals": "0"
        },
        {
          "dates": "2024-02-03",
          "totals": "0"
        },
        {
          "dates": "2024-02-04",
          "totals": "0"
        },
        {
          "dates": "2024-02-05",
          "totals": "0"
        },
        {
          "dates": "2024-02-06",
          "totals": "0"
        },
        {
          "dates": "2024-02-07",
          "totals": "0"
        },
        {
          "dates": "2024-02-08",
          "totals": "0"
        },
        {
          "dates": "2024-02-09",
          "totals": "0"
        },
        {
          "dates": "2024-02-10",
          "totals": "0"
        },
        {
          "dates": "2024-02-11",
          "totals": "0"
        },
        {
          "dates": "2024-02-12",
          "totals": "0"
        },
        {
          "dates": "2024-02-13",
          "totals": "0"
        },
        {
          "dates": "2024-02-14",
          "totals": "0"
        },
        {
          "dates": "2024-02-15",
          "totals": "0"
        },
        {
          "dates": "2024-02-16",
          "totals": "0"
        },
        {
          "dates": "2024-02-17",
          "totals": "0"
        },
        {
          "dates": "2024-02-18",
          "totals": "0"
        },
        {
          "dates": "2024-02-19",
          "totals": "0"
        },
        {
          "dates": "2024-02-20",
          "totals": "0"
        },
        {
          "dates": "2024-02-21",
          "totals": "0"
        },
        {
          "dates": "2024-02-22",
          "totals": "0"
        },
        {
          "dates": "2024-02-23",
          "totals": "0"
        },
        {
          "dates": "2024-02-24",
          "totals": "0"
        },
        {
          "dates": "2024-02-25",
          "totals": "0"
        },
        {
          "dates": "2024-02-26",
          "totals": "0"
        },
        {
          "dates": "2024-02-27",
          "totals": "0"
        },
        {
          "dates": "2024-02-28",
          "totals": "0"
        },
        {
          "dates": "2024-02-29",
          "totals": "0"
        },
        {
          "dates": "2024-03-01",
          "totals": "0"
        },
        {
          "dates": "2024-03-02",
          "totals": "0"
        },
        {
          "dates": "2024-03-03",
          "totals": "0"
        },
        {
          "dates": "2024-03-04",
          "totals": "0"
        },
        {
          "dates": "2024-03-05",
          "totals": "0"
        },
        {
          "dates": "2024-03-06",
          "totals": "0"
        },
        {
          "dates": "2024-03-07",
          "totals": "0"
        },
        {
          "dates": "2024-03-08",
          "totals": "0"
        },
        {
          "dates": "2024-03-09",
          "totals": "0"
        },
        {
          "dates": "2024-03-10",
          "totals": "0"
        },
        {
          "dates": "2024-03-11",
          "totals": "0"
        },
        {
          "dates": "2024-03-12",
          "totals": "0"
        },
        {
          "dates": "2024-03-13",
          "totals": "0"
        },
        {
          "dates": "2024-03-14",
          "totals": "0"
        },
        {
          "dates": "2024-03-15",
          "totals": "0"
        },
        {
          "dates": "2024-03-16",
          "totals": "0"
        },
        {
          "dates": "2024-03-17",
          "totals": "0"
        },
        {
          "dates": "2024-03-18",
          "totals": "0"
        },
        {
          "dates": "2024-03-19",
          "totals": "0"
        },
        {
          "dates": "2024-03-20",
          "totals": "0"
        },
        {
          "dates": "2024-03-21",
          "totals": "0"
        },
        {
          "dates": "2024-03-22",
          "totals": "0"
        },
        {
          "dates": "2024-03-23",
          "totals": "0"
        },
        {
          "dates": "2024-03-24",
          "totals": "0"
        },
        {
          "dates": "2024-03-25",
          "totals": "0"
        },
        {
          "dates": "2024-03-26",
          "totals": "0"
        },
        {
          "dates": "2024-03-27",
          "totals": "0"
        },
        {
          "dates": "2024-03-28",
          "totals": "0"
        },
        {
          "dates": "2024-03-29",
          "totals": "0"
        },
        {
          "dates": "2024-03-30",
          "totals": "0"
        },
        {
          "dates": "2024-03-31",
          "totals": "0"
        },
        {
          "dates": "2024-04-01",
          "totals": "0"
        },
        {
          "dates": "2024-04-02",
          "totals": "0"
        },
        {
          "dates": "2024-04-03",
          "totals": "0"
        },
        {
          "dates": "2024-04-04",
          "totals": "0"
        },
        {
          "dates": "2024-04-05",
          "totals": "0"
        },
        {
          "dates": "2024-04-06",
          "totals": "0"
        },
        {
          "dates": "2024-04-07",
          "totals": "0"
        },
        {
          "dates": "2024-04-08",
          "totals": "0"
        },
        {
          "dates": "2024-04-09",
          "totals": "330"
        },
        {
          "dates": "2024-04-10",
          "totals": "20"
        },
        {
          "dates": "2024-04-11",
          "totals": "104"
        },
        {
          "dates": "2024-04-12",
          "totals": "55"
        },
        {
          "dates": "2024-04-13",
          "totals": "0"
        },
        {
          "dates": "2024-04-14",
          "totals": "0"
        },
        {
          "dates": "2024-04-15",
          "totals": "576"
        },
        {
          "dates": "2024-04-16",
          "totals": "288"
        },
        {
          "dates": "2024-04-17",
          "totals": "0"
        },
        {
          "dates": "2024-04-18",
          "totals": "160"
        },
        {
          "dates": "2024-04-19",
          "totals": "352"
        },
        {
          "dates": "2024-04-20",
          "totals": "51"
        },
        {
          "dates": "2024-04-21",
          "totals": "0"
        },
        {
          "dates": "2024-04-22",
          "totals": "0"
        },
        {
          "dates": "2024-04-23",
          "totals": "0"
        },
        {
          "dates": "2024-04-24",
          "totals": "288"
        },
        {
          "dates": "2024-04-25",
          "totals": "38"
        },
        {
          "dates": "2024-04-26",
          "totals": "0"
        },
        {
          "dates": "2024-04-27",
          "totals": "0"
        },
        {
          "dates": "2024-04-28",
          "totals": "0"
        },
        {
          "dates": "2024-04-29",
          "totals": "0"
        },
        {
          "dates": "2024-04-30",
          "totals": "0"
        },
        {
          "dates": "2024-05-01",
          "totals": "32"
        },
        {
          "dates": "2024-05-02",
          "totals": "593"
        },
        {
          "dates": "2024-05-03",
          "totals": "531"
        },
        {
          "dates": "2024-05-04",
          "totals": "475"
        },
        {
          "dates": "2024-05-05",
          "totals": "432"
        },
        {
          "dates": "2024-05-06",
          "totals": "432"
        },
        {
          "dates": "2024-05-07",
          "totals": "496"
        },
        {
          "dates": "2024-05-08",
          "totals": "0"
        },
        {
          "dates": "2024-05-09",
          "totals": "128"
        },
        {
          "dates": "2024-05-10",
          "totals": "50"
        },
        {
          "dates": "2024-05-11",
          "totals": "0"
        },
        {
          "dates": "2024-05-12",
          "totals": "64"
        },
        {
          "dates": "2024-05-13",
          "totals": "354"
        },
        {
          "dates": "2024-05-14",
          "totals": "64"
        },
        {
          "dates": "2024-05-15",
          "totals": "50"
        },
        {
          "dates": "2024-05-16",
          "totals": "85"
        },
        {
          "dates": "2024-05-17",
          "totals": "56"
        },
        {
          "dates": "2024-05-18",
          "totals": "0"
        },
        {
          "dates": "2024-05-19",
          "totals": "0"
        },
        {
          "dates": "2024-05-20",
          "totals": "0"
        },
        {
          "dates": "2024-05-21",
          "totals": "0"
        },
        {
          "dates": "2024-05-22",
          "totals": "22"
        },
        {
          "dates": "2024-05-23",
          "totals": "125"
        },
        {
          "dates": "2024-05-24",
          "totals": "0"
        },
        {
          "dates": "2024-05-25",
          "totals": "0"
        },
        {
          "dates": "2024-05-26",
          "totals": "0"
        },
        {
          "dates": "2024-05-27",
          "totals": "0"
        },
        {
          "dates": "2024-05-28",
          "totals": "0"
        },
        {
          "dates": "2024-05-29",
          "totals": "0"
        },
        {
          "dates": "2024-05-30",
          "totals": "0"
        },
        {
          "dates": "2024-05-31",
          "totals": "0"
        },
        {
          "dates": "2024-06-01",
          "totals": "0"
        },
        {
          "dates": "2024-06-02",
          "totals": "0"
        },
        {
          "dates": "2024-06-03",
          "totals": "0"
        },
        {
          "dates": "2024-06-04",
          "totals": "0"
        },
        {
          "dates": "2024-06-05",
          "totals": "0"
        },
        {
          "dates": "2024-06-06",
          "totals": "0"
        },
        {
          "dates": "2024-06-07",
          "totals": "10"
        },
        {
          "dates": "2024-06-08",
          "totals": "0"
        },
        {
          "dates": "2024-06-09",
          "totals": "0"
        },
        {
          "dates": "2024-06-10",
          "totals": "0"
        },
        {
          "dates": "2024-06-11",
          "totals": "0"
        },
        {
          "dates": "2024-06-12",
          "totals": "0"
        },
        {
          "dates": "2024-06-13",
          "totals": "53"
        },
        {
          "dates": "2024-06-14",
          "totals": "0"
        },
        {
          "dates": "2024-06-15",
          "totals": "0"
        },
        {
          "dates": "2024-06-16",
          "totals": "0"
        },
        {
          "dates": "2024-06-17",
          "totals": "32"
        },
        {
          "dates": "2024-06-18",
          "totals": "0"
        },
        {
          "dates": "2024-06-19",
          "totals": "0"
        },
        {
          "dates": "2024-06-20",
          "totals": "0"
        },
        {
          "dates": "2024-06-21",
          "totals": "0"
        },
        {
          "dates": "2024-06-22",
          "totals": "0"
        },
        {
          "dates": "2024-06-23",
          "totals": "0"
        },
        {
          "dates": "2024-06-24",
          "totals": "215"
        },
        {
          "dates": "2024-06-25",
          "totals": "0"
        },
        {
          "dates": "2024-06-26",
          "totals": "320"
        },
        {
          "dates": "2024-06-27",
          "totals": "0"
        },
        {
          "dates": "2024-06-28",
          "totals": "0"
        },
        {
          "dates": "2024-06-29",
          "totals": "0"
        },
        {
          "dates": "2024-06-30",
          "totals": "0"
        },
        {
          "dates": "2024-07-01",
          "totals": "0"
        },
        {
          "dates": "2024-07-02",
          "totals": "0"
        },
        {
          "dates": "2024-07-03",
          "totals": "0"
        },
        {
          "dates": "2024-07-04",
          "totals": "0"
        },
        {
          "dates": "2024-07-05",
          "totals": "0"
        },
        {
          "dates": "2024-07-06",
          "totals": "0"
        },
        {
          "dates": "2024-07-07",
          "totals": "0"
        },
        {
          "dates": "2024-07-08",
          "totals": "0"
        },
        {
          "dates": "2024-07-09",
          "totals": "25"
        },
        {
          "dates": "2024-07-10",
          "totals": "0"
        },
        {
          "dates": "2024-07-11",
          "totals": "0"
        },
        {
          "dates": "2024-07-12",
          "totals": "0"
        },
        {
          "dates": "2024-07-13",
          "totals": "0"
        },
        {
          "dates": "2024-07-14",
          "totals": "0"
        },
        {
          "dates": "2024-07-15",
          "totals": "0"
        },
        {
          "dates": "2024-07-16",
          "totals": "0"
        },
        {
          "dates": "2024-07-17",
          "totals": "0"
        }
      ]
    },
    commitments_graph: {
      "commitment_graph_data": [
        {
          "dates": "2021-12-31",
          "totals": 300
        },
        {
          "dates": "2022-01-01",
          "totals": 300
        },
        {
          "dates": "2022-01-02",
          "totals": 300
        },
        {
          "dates": "2022-01-03",
          "totals": 300
        },
        {
          "dates": "2022-01-04",
          "totals": 300
        },
        {
          "dates": "2022-01-05",
          "totals": 300
        },
        {
          "dates": "2022-01-06",
          "totals": 300
        },
        {
          "dates": "2022-01-07",
          "totals": 300
        },
        {
          "dates": "2022-01-08",
          "totals": 300
        },
        {
          "dates": "2022-01-09",
          "totals": 300
        },
        {
          "dates": "2022-01-10",
          "totals": 300
        },
        {
          "dates": "2022-01-11",
          "totals": 300
        },
        {
          "dates": "2022-01-12",
          "totals": 300
        },
        {
          "dates": "2022-01-13",
          "totals": 300
        },
        {
          "dates": "2022-01-14",
          "totals": 300
        },
        {
          "dates": "2022-01-15",
          "totals": 300
        },
        {
          "dates": "2022-01-16",
          "totals": 300
        },
        {
          "dates": "2022-01-17",
          "totals": 300
        },
        {
          "dates": "2022-01-18",
          "totals": 300
        },
        {
          "dates": "2022-01-19",
          "totals": 300
        },
        {
          "dates": "2022-01-20",
          "totals": 300
        },
        {
          "dates": "2022-01-21",
          "totals": 300
        },
        {
          "dates": "2022-01-22",
          "totals": 300
        },
        {
          "dates": "2022-01-23",
          "totals": 300
        },
        {
          "dates": "2022-01-24",
          "totals": 300
        },
        {
          "dates": "2022-01-25",
          "totals": 300
        },
        {
          "dates": "2022-01-26",
          "totals": 301
        },
        {
          "dates": "2022-01-27",
          "totals": 301
        },
        {
          "dates": "2022-01-28",
          "totals": 301
        },
        {
          "dates": "2022-01-29",
          "totals": 301
        },
        {
          "dates": "2022-01-30",
          "totals": 301
        },
        {
          "dates": "2022-01-31",
          "totals": 301
        },
        {
          "dates": "2022-02-01",
          "totals": 301
        },
        {
          "dates": "2022-02-02",
          "totals": 301
        },
        {
          "dates": "2022-02-03",
          "totals": 301
        },
        {
          "dates": "2022-02-04",
          "totals": 301
        },
        {
          "dates": "2022-02-05",
          "totals": 301
        },
        {
          "dates": "2022-02-06",
          "totals": 301
        },
        {
          "dates": "2022-02-07",
          "totals": 301
        },
        {
          "dates": "2022-02-08",
          "totals": 301
        },
        {
          "dates": "2022-02-09",
          "totals": 301
        },
        {
          "dates": "2022-02-10",
          "totals": 301
        },
        {
          "dates": "2022-02-11",
          "totals": 301
        },
        {
          "dates": "2022-02-12",
          "totals": 301
        },
        {
          "dates": "2022-02-13",
          "totals": 301
        },
        {
          "dates": "2022-02-14",
          "totals": 301
        },
        {
          "dates": "2022-02-15",
          "totals": 301
        },
        {
          "dates": "2022-02-16",
          "totals": 301
        },
        {
          "dates": "2022-02-17",
          "totals": 301
        },
        {
          "dates": "2022-02-18",
          "totals": 301
        },
        {
          "dates": "2022-02-19",
          "totals": 301
        },
        {
          "dates": "2022-02-20",
          "totals": 301
        },
        {
          "dates": "2022-02-21",
          "totals": 301
        },
        {
          "dates": "2022-02-22",
          "totals": 301
        },
        {
          "dates": "2022-02-23",
          "totals": 301
        },
        {
          "dates": "2022-02-24",
          "totals": 301
        },
        {
          "dates": "2022-02-25",
          "totals": 301
        },
        {
          "dates": "2022-02-26",
          "totals": 301
        },
        {
          "dates": "2022-02-27",
          "totals": 301
        },
        {
          "dates": "2022-02-28",
          "totals": 301
        },
        {
          "dates": "2022-03-01",
          "totals": 301
        },
        {
          "dates": "2022-03-02",
          "totals": 301
        },
        {
          "dates": "2022-03-03",
          "totals": 301
        },
        {
          "dates": "2022-03-04",
          "totals": 301
        },
        {
          "dates": "2022-03-05",
          "totals": 301
        },
        {
          "dates": "2022-03-06",
          "totals": 301
        },
        {
          "dates": "2022-03-07",
          "totals": 301
        },
        {
          "dates": "2022-03-08",
          "totals": 301
        },
        {
          "dates": "2022-03-09",
          "totals": 301
        },
        {
          "dates": "2022-03-10",
          "totals": 301
        },
        {
          "dates": "2022-03-11",
          "totals": 301
        },
        {
          "dates": "2022-03-12",
          "totals": 301
        },
        {
          "dates": "2022-03-13",
          "totals": 301
        },
        {
          "dates": "2022-03-14",
          "totals": 301
        },
        {
          "dates": "2022-03-15",
          "totals": 301
        },
        {
          "dates": "2022-03-16",
          "totals": 301
        },
        {
          "dates": "2022-03-17",
          "totals": 301
        },
        {
          "dates": "2022-03-18",
          "totals": 301
        },
        {
          "dates": "2022-03-19",
          "totals": 301
        },
        {
          "dates": "2022-03-20",
          "totals": 301
        },
        {
          "dates": "2022-03-21",
          "totals": 301
        },
        {
          "dates": "2022-03-22",
          "totals": 301
        },
        {
          "dates": "2022-03-23",
          "totals": 301
        },
        {
          "dates": "2022-03-24",
          "totals": 301
        },
        {
          "dates": "2022-03-25",
          "totals": 301
        },
        {
          "dates": "2022-03-26",
          "totals": 301
        },
        {
          "dates": "2022-03-27",
          "totals": 301
        },
        {
          "dates": "2022-03-28",
          "totals": 301
        },
        {
          "dates": "2022-03-29",
          "totals": 301
        },
        {
          "dates": "2022-03-30",
          "totals": 301
        },
        {
          "dates": "2022-03-31",
          "totals": 301
        },
        {
          "dates": "2022-04-01",
          "totals": 301
        },
        {
          "dates": "2022-04-02",
          "totals": 301
        },
        {
          "dates": "2022-04-03",
          "totals": 301
        },
        {
          "dates": "2022-04-04",
          "totals": 301
        },
        {
          "dates": "2022-04-05",
          "totals": 301
        },
        {
          "dates": "2022-04-06",
          "totals": 301
        },
        {
          "dates": "2022-04-07",
          "totals": 301
        },
        {
          "dates": "2022-04-08",
          "totals": 301
        },
        {
          "dates": "2022-04-09",
          "totals": 301
        },
        {
          "dates": "2022-04-10",
          "totals": 301
        },
        {
          "dates": "2022-04-11",
          "totals": 301
        },
        {
          "dates": "2022-04-12",
          "totals": 301
        },
        {
          "dates": "2022-04-13",
          "totals": 301
        },
        {
          "dates": "2022-04-14",
          "totals": 301
        },
        {
          "dates": "2022-04-15",
          "totals": 301
        },
        {
          "dates": "2022-04-16",
          "totals": 301
        },
        {
          "dates": "2022-04-17",
          "totals": 301
        },
        {
          "dates": "2022-04-18",
          "totals": 301
        },
        {
          "dates": "2022-04-19",
          "totals": 301
        },
        {
          "dates": "2022-04-20",
          "totals": 301
        },
        {
          "dates": "2022-04-21",
          "totals": 301
        },
        {
          "dates": "2022-04-22",
          "totals": 301
        },
        {
          "dates": "2022-04-23",
          "totals": 301
        },
        {
          "dates": "2022-04-24",
          "totals": 301
        },
        {
          "dates": "2022-04-25",
          "totals": 301
        },
        {
          "dates": "2022-04-26",
          "totals": 301
        },
        {
          "dates": "2022-04-27",
          "totals": 301
        },
        {
          "dates": "2022-04-28",
          "totals": 301
        },
        {
          "dates": "2022-04-29",
          "totals": 301
        },
        {
          "dates": "2022-04-30",
          "totals": 301
        },
        {
          "dates": "2022-05-01",
          "totals": 301
        },
        {
          "dates": "2022-05-02",
          "totals": 301
        },
        {
          "dates": "2022-05-03",
          "totals": 301
        },
        {
          "dates": "2022-05-04",
          "totals": 301
        },
        {
          "dates": "2022-05-05",
          "totals": 301
        },
        {
          "dates": "2022-05-06",
          "totals": 301
        },
        {
          "dates": "2022-05-07",
          "totals": 301
        },
        {
          "dates": "2022-05-08",
          "totals": 301
        },
        {
          "dates": "2022-05-09",
          "totals": 301
        },
        {
          "dates": "2022-05-10",
          "totals": 301
        },
        {
          "dates": "2022-05-11",
          "totals": 301
        },
        {
          "dates": "2022-05-12",
          "totals": 301
        },
        {
          "dates": "2022-05-13",
          "totals": 301
        },
        {
          "dates": "2022-05-14",
          "totals": 301
        },
        {
          "dates": "2022-05-15",
          "totals": 301
        },
        {
          "dates": "2022-05-16",
          "totals": 301
        },
        {
          "dates": "2022-05-17",
          "totals": 301
        },
        {
          "dates": "2022-05-18",
          "totals": 301
        },
        {
          "dates": "2022-05-19",
          "totals": 301
        },
        {
          "dates": "2022-05-20",
          "totals": 301
        },
        {
          "dates": "2022-05-21",
          "totals": 301
        },
        {
          "dates": "2022-05-22",
          "totals": 301
        },
        {
          "dates": "2022-05-23",
          "totals": 301
        },
        {
          "dates": "2022-05-24",
          "totals": 301
        },
        {
          "dates": "2022-05-25",
          "totals": 301
        },
        {
          "dates": "2022-05-26",
          "totals": 301
        },
        {
          "dates": "2022-05-27",
          "totals": 301
        },
        {
          "dates": "2022-05-28",
          "totals": 301
        },
        {
          "dates": "2022-05-29",
          "totals": 301
        },
        {
          "dates": "2022-05-30",
          "totals": 301
        },
        {
          "dates": "2022-05-31",
          "totals": 301
        },
        {
          "dates": "2022-06-01",
          "totals": 301
        },
        {
          "dates": "2022-06-02",
          "totals": 301
        },
        {
          "dates": "2022-06-03",
          "totals": 301
        },
        {
          "dates": "2022-06-04",
          "totals": 301
        },
        {
          "dates": "2022-06-05",
          "totals": 301
        },
        {
          "dates": "2022-06-06",
          "totals": 301
        },
        {
          "dates": "2022-06-07",
          "totals": 301
        },
        {
          "dates": "2022-06-08",
          "totals": 301
        },
        {
          "dates": "2022-06-09",
          "totals": 301
        },
        {
          "dates": "2022-06-10",
          "totals": 301
        },
        {
          "dates": "2022-06-11",
          "totals": 301
        },
        {
          "dates": "2022-06-12",
          "totals": 301
        },
        {
          "dates": "2022-06-13",
          "totals": 301
        },
        {
          "dates": "2022-06-14",
          "totals": 301
        },
        {
          "dates": "2022-06-15",
          "totals": 301
        },
        {
          "dates": "2022-06-16",
          "totals": 301
        },
        {
          "dates": "2022-06-17",
          "totals": 301
        },
        {
          "dates": "2022-06-18",
          "totals": 301
        },
        {
          "dates": "2022-06-19",
          "totals": 301
        },
        {
          "dates": "2022-06-20",
          "totals": 301
        },
        {
          "dates": "2022-06-21",
          "totals": 301
        },
        {
          "dates": "2022-06-22",
          "totals": 301
        },
        {
          "dates": "2022-06-23",
          "totals": 301
        },
        {
          "dates": "2022-06-24",
          "totals": 301
        },
        {
          "dates": "2022-06-25",
          "totals": 301
        },
        {
          "dates": "2022-06-26",
          "totals": 301
        },
        {
          "dates": "2022-06-27",
          "totals": 301
        },
        {
          "dates": "2022-06-28",
          "totals": 301
        },
        {
          "dates": "2022-06-29",
          "totals": 301
        },
        {
          "dates": "2022-06-30",
          "totals": 301
        },
        {
          "dates": "2022-07-01",
          "totals": 301
        },
        {
          "dates": "2022-07-02",
          "totals": 301
        },
        {
          "dates": "2022-07-03",
          "totals": 301
        },
        {
          "dates": "2022-07-04",
          "totals": 301
        },
        {
          "dates": "2022-07-05",
          "totals": 301
        },
        {
          "dates": "2022-07-06",
          "totals": 301
        },
        {
          "dates": "2022-07-07",
          "totals": 301
        },
        {
          "dates": "2022-07-08",
          "totals": 301
        },
        {
          "dates": "2022-07-09",
          "totals": 301
        },
        {
          "dates": "2022-07-10",
          "totals": 301
        },
        {
          "dates": "2022-07-11",
          "totals": 301
        },
        {
          "dates": "2022-07-12",
          "totals": 301
        },
        {
          "dates": "2022-07-13",
          "totals": 301
        },
        {
          "dates": "2022-07-14",
          "totals": 301
        },
        {
          "dates": "2022-07-15",
          "totals": 301
        },
        {
          "dates": "2022-07-16",
          "totals": 301
        },
        {
          "dates": "2022-07-17",
          "totals": 301
        },
        {
          "dates": "2022-07-18",
          "totals": 301
        },
        {
          "dates": "2022-07-19",
          "totals": 301
        },
        {
          "dates": "2022-07-20",
          "totals": 301
        },
        {
          "dates": "2022-07-21",
          "totals": 301
        },
        {
          "dates": "2022-07-22",
          "totals": 301
        },
        {
          "dates": "2022-07-23",
          "totals": 301
        },
        {
          "dates": "2022-07-24",
          "totals": 301
        },
        {
          "dates": "2022-07-25",
          "totals": 301
        },
        {
          "dates": "2022-07-26",
          "totals": 301
        },
        {
          "dates": "2022-07-27",
          "totals": 301
        },
        {
          "dates": "2022-07-28",
          "totals": 301
        },
        {
          "dates": "2022-07-29",
          "totals": 301
        },
        {
          "dates": "2022-07-30",
          "totals": 301
        },
        {
          "dates": "2022-07-31",
          "totals": 301
        },
        {
          "dates": "2022-08-01",
          "totals": 301
        },
        {
          "dates": "2022-08-02",
          "totals": 301
        },
        {
          "dates": "2022-08-03",
          "totals": 301
        },
        {
          "dates": "2022-08-04",
          "totals": 301
        },
        {
          "dates": "2022-08-05",
          "totals": 301
        },
        {
          "dates": "2022-08-06",
          "totals": 301
        },
        {
          "dates": "2022-08-07",
          "totals": 301
        },
        {
          "dates": "2022-08-08",
          "totals": 301
        },
        {
          "dates": "2022-08-09",
          "totals": 301
        },
        {
          "dates": "2022-08-10",
          "totals": 301
        },
        {
          "dates": "2022-08-11",
          "totals": 301
        },
        {
          "dates": "2022-08-12",
          "totals": 301
        },
        {
          "dates": "2022-08-13",
          "totals": 301
        },
        {
          "dates": "2022-08-14",
          "totals": 301
        },
        {
          "dates": "2022-08-15",
          "totals": 301
        },
        {
          "dates": "2022-08-16",
          "totals": 301
        },
        {
          "dates": "2022-08-17",
          "totals": 301
        },
        {
          "dates": "2022-08-18",
          "totals": 301
        },
        {
          "dates": "2022-08-19",
          "totals": 301
        },
        {
          "dates": "2022-08-20",
          "totals": 301
        },
        {
          "dates": "2022-08-21",
          "totals": 301
        },
        {
          "dates": "2022-08-22",
          "totals": 301
        },
        {
          "dates": "2022-08-23",
          "totals": 301
        },
        {
          "dates": "2022-08-24",
          "totals": 301
        },
        {
          "dates": "2022-08-25",
          "totals": 301
        },
        {
          "dates": "2022-08-26",
          "totals": 301
        },
        {
          "dates": "2022-08-27",
          "totals": 301
        },
        {
          "dates": "2022-08-28",
          "totals": 301
        },
        {
          "dates": "2022-08-29",
          "totals": 301
        },
        {
          "dates": "2022-08-30",
          "totals": 301
        },
        {
          "dates": "2022-08-31",
          "totals": 301
        },
        {
          "dates": "2022-09-01",
          "totals": 301
        },
        {
          "dates": "2022-09-02",
          "totals": 301
        },
        {
          "dates": "2022-09-03",
          "totals": 301
        },
        {
          "dates": "2022-09-04",
          "totals": 301
        },
        {
          "dates": "2022-09-05",
          "totals": 301
        },
        {
          "dates": "2022-09-06",
          "totals": 301
        },
        {
          "dates": "2022-09-07",
          "totals": 301
        },
        {
          "dates": "2022-09-08",
          "totals": 301
        },
        {
          "dates": "2022-09-09",
          "totals": 301
        },
        {
          "dates": "2022-09-10",
          "totals": 301
        },
        {
          "dates": "2022-09-11",
          "totals": 301
        },
        {
          "dates": "2022-09-12",
          "totals": 301
        },
        {
          "dates": "2022-09-13",
          "totals": 301
        },
        {
          "dates": "2022-09-14",
          "totals": 301
        },
        {
          "dates": "2022-09-15",
          "totals": 301
        },
        {
          "dates": "2022-09-16",
          "totals": 301
        },
        {
          "dates": "2022-09-17",
          "totals": 301
        },
        {
          "dates": "2022-09-18",
          "totals": 301
        },
        {
          "dates": "2022-09-19",
          "totals": 301
        },
        {
          "dates": "2022-09-20",
          "totals": 301
        },
        {
          "dates": "2022-09-21",
          "totals": 301
        },
        {
          "dates": "2022-09-22",
          "totals": 301
        },
        {
          "dates": "2022-09-23",
          "totals": 301
        },
        {
          "dates": "2022-09-24",
          "totals": 301
        },
        {
          "dates": "2022-09-25",
          "totals": 301
        },
        {
          "dates": "2022-09-26",
          "totals": 301
        },
        {
          "dates": "2022-09-27",
          "totals": 301
        },
        {
          "dates": "2022-09-28",
          "totals": 301
        },
        {
          "dates": "2022-09-29",
          "totals": 301
        },
        {
          "dates": "2022-09-30",
          "totals": 301
        },
        {
          "dates": "2022-10-01",
          "totals": 301
        },
        {
          "dates": "2022-10-02",
          "totals": 301
        },
        {
          "dates": "2022-10-03",
          "totals": 301
        },
        {
          "dates": "2022-10-04",
          "totals": 301
        },
        {
          "dates": "2022-10-05",
          "totals": 301
        },
        {
          "dates": "2022-10-06",
          "totals": 301
        },
        {
          "dates": "2022-10-07",
          "totals": 301
        },
        {
          "dates": "2022-10-08",
          "totals": 301
        },
        {
          "dates": "2022-10-09",
          "totals": 301
        },
        {
          "dates": "2022-10-10",
          "totals": 301
        },
        {
          "dates": "2022-10-11",
          "totals": 301
        },
        {
          "dates": "2022-10-12",
          "totals": 301
        },
        {
          "dates": "2022-10-13",
          "totals": 301
        },
        {
          "dates": "2022-10-14",
          "totals": 301
        },
        {
          "dates": "2022-10-15",
          "totals": 301
        },
        {
          "dates": "2022-10-16",
          "totals": 301
        },
        {
          "dates": "2022-10-17",
          "totals": 301
        },
        {
          "dates": "2022-10-18",
          "totals": 301
        },
        {
          "dates": "2022-10-19",
          "totals": 301
        },
        {
          "dates": "2022-10-20",
          "totals": 301
        },
        {
          "dates": "2022-10-21",
          "totals": 301
        },
        {
          "dates": "2022-10-22",
          "totals": 301
        },
        {
          "dates": "2022-10-23",
          "totals": 301
        },
        {
          "dates": "2022-10-24",
          "totals": 301
        },
        {
          "dates": "2022-10-25",
          "totals": 301
        },
        {
          "dates": "2022-10-26",
          "totals": 301
        },
        {
          "dates": "2022-10-27",
          "totals": 301
        },
        {
          "dates": "2022-10-28",
          "totals": 301
        },
        {
          "dates": "2022-10-29",
          "totals": 301
        },
        {
          "dates": "2022-10-30",
          "totals": 301
        },
        {
          "dates": "2022-10-31",
          "totals": 301
        },
        {
          "dates": "2022-11-01",
          "totals": 301
        },
        {
          "dates": "2022-11-02",
          "totals": 301
        },
        {
          "dates": "2022-11-03",
          "totals": 301
        },
        {
          "dates": "2022-11-04",
          "totals": 301
        },
        {
          "dates": "2022-11-05",
          "totals": 301
        },
        {
          "dates": "2022-11-06",
          "totals": 301
        },
        {
          "dates": "2022-11-07",
          "totals": 301
        },
        {
          "dates": "2022-11-08",
          "totals": 301
        },
        {
          "dates": "2022-11-09",
          "totals": 301
        },
        {
          "dates": "2022-11-10",
          "totals": 301
        },
        {
          "dates": "2022-11-11",
          "totals": 301
        },
        {
          "dates": "2022-11-12",
          "totals": 301
        },
        {
          "dates": "2022-11-13",
          "totals": 301
        },
        {
          "dates": "2022-11-14",
          "totals": 301
        },
        {
          "dates": "2022-11-15",
          "totals": 301
        },
        {
          "dates": "2022-11-16",
          "totals": 301
        },
        {
          "dates": "2022-11-17",
          "totals": 301
        },
        {
          "dates": "2022-11-18",
          "totals": 301
        },
        {
          "dates": "2022-11-19",
          "totals": 301
        },
        {
          "dates": "2022-11-20",
          "totals": 301
        },
        {
          "dates": "2022-11-21",
          "totals": 301
        },
        {
          "dates": "2022-11-22",
          "totals": 301
        },
        {
          "dates": "2022-11-23",
          "totals": 301
        },
        {
          "dates": "2022-11-24",
          "totals": 301
        },
        {
          "dates": "2022-11-25",
          "totals": 301
        },
        {
          "dates": "2022-11-26",
          "totals": 301
        },
        {
          "dates": "2022-11-27",
          "totals": 301
        },
        {
          "dates": "2022-11-28",
          "totals": 301
        },
        {
          "dates": "2022-11-29",
          "totals": 301
        },
        {
          "dates": "2022-11-30",
          "totals": 301
        },
        {
          "dates": "2022-12-01",
          "totals": 303
        },
        {
          "dates": "2022-12-02",
          "totals": 303
        },
        {
          "dates": "2022-12-03",
          "totals": 303
        },
        {
          "dates": "2022-12-04",
          "totals": 303
        },
        {
          "dates": "2022-12-05",
          "totals": 303
        },
        {
          "dates": "2022-12-06",
          "totals": 303
        },
        {
          "dates": "2022-12-07",
          "totals": 303
        },
        {
          "dates": "2022-12-08",
          "totals": 303
        },
        {
          "dates": "2022-12-09",
          "totals": 303
        },
        {
          "dates": "2022-12-10",
          "totals": 303
        },
        {
          "dates": "2022-12-11",
          "totals": 303
        },
        {
          "dates": "2022-12-12",
          "totals": 303
        },
        {
          "dates": "2022-12-13",
          "totals": 303
        },
        {
          "dates": "2022-12-14",
          "totals": 303
        },
        {
          "dates": "2022-12-15",
          "totals": 303
        },
        {
          "dates": "2022-12-16",
          "totals": 303
        },
        {
          "dates": "2022-12-17",
          "totals": 303
        },
        {
          "dates": "2022-12-18",
          "totals": 303
        },
        {
          "dates": "2022-12-19",
          "totals": 303
        },
        {
          "dates": "2022-12-20",
          "totals": 303
        },
        {
          "dates": "2022-12-21",
          "totals": 303
        },
        {
          "dates": "2022-12-22",
          "totals": 303
        },
        {
          "dates": "2022-12-23",
          "totals": 303
        },
        {
          "dates": "2022-12-24",
          "totals": 303
        },
        {
          "dates": "2022-12-25",
          "totals": 303
        },
        {
          "dates": "2022-12-26",
          "totals": 303
        },
        {
          "dates": "2022-12-27",
          "totals": 303
        },
        {
          "dates": "2022-12-28",
          "totals": 303
        },
        {
          "dates": "2022-12-29",
          "totals": 303
        },
        {
          "dates": "2022-12-30",
          "totals": 303
        },
        {
          "dates": "2022-12-31",
          "totals": 303
        },
        {
          "dates": "2023-01-01",
          "totals": 303
        },
        {
          "dates": "2023-01-02",
          "totals": 303
        },
        {
          "dates": "2023-01-03",
          "totals": 303
        },
        {
          "dates": "2023-01-04",
          "totals": 303
        },
        {
          "dates": "2023-01-05",
          "totals": 303
        },
        {
          "dates": "2023-01-06",
          "totals": 303
        },
        {
          "dates": "2023-01-07",
          "totals": 303
        },
        {
          "dates": "2023-01-08",
          "totals": 303
        },
        {
          "dates": "2023-01-09",
          "totals": 303
        },
        {
          "dates": "2023-01-10",
          "totals": 303
        },
        {
          "dates": "2023-01-11",
          "totals": 303
        },
        {
          "dates": "2023-01-12",
          "totals": 303
        },
        {
          "dates": "2023-01-13",
          "totals": 303
        },
        {
          "dates": "2023-01-14",
          "totals": 303
        },
        {
          "dates": "2023-01-15",
          "totals": 303
        },
        {
          "dates": "2023-01-16",
          "totals": 303
        },
        {
          "dates": "2023-01-17",
          "totals": 303
        },
        {
          "dates": "2023-01-18",
          "totals": 304
        },
        {
          "dates": "2023-01-19",
          "totals": 304
        },
        {
          "dates": "2023-01-20",
          "totals": 304
        },
        {
          "dates": "2023-01-21",
          "totals": 304
        },
        {
          "dates": "2023-01-22",
          "totals": 304
        },
        {
          "dates": "2023-01-23",
          "totals": 304
        },
        {
          "dates": "2023-01-24",
          "totals": 304
        },
        {
          "dates": "2023-01-25",
          "totals": 304
        },
        {
          "dates": "2023-01-26",
          "totals": 304
        },
        {
          "dates": "2023-01-27",
          "totals": 305
        },
        {
          "dates": "2023-01-28",
          "totals": 305
        },
        {
          "dates": "2023-01-29",
          "totals": 305
        },
        {
          "dates": "2023-01-30",
          "totals": 305
        },
        {
          "dates": "2023-01-31",
          "totals": 305
        },
        {
          "dates": "2023-02-01",
          "totals": 305
        },
        {
          "dates": "2023-02-02",
          "totals": 305
        },
        {
          "dates": "2023-02-03",
          "totals": 305
        },
        {
          "dates": "2023-02-04",
          "totals": 305
        },
        {
          "dates": "2023-02-05",
          "totals": 305
        },
        {
          "dates": "2023-02-06",
          "totals": 305
        },
        {
          "dates": "2023-02-07",
          "totals": 307
        },
        {
          "dates": "2023-02-08",
          "totals": 314
        },
        {
          "dates": "2023-02-09",
          "totals": 314
        },
        {
          "dates": "2023-02-10",
          "totals": 314
        },
        {
          "dates": "2023-02-11",
          "totals": 314
        },
        {
          "dates": "2023-02-12",
          "totals": 314
        },
        {
          "dates": "2023-02-13",
          "totals": 314
        },
        {
          "dates": "2023-02-14",
          "totals": 315
        },
        {
          "dates": "2023-02-15",
          "totals": 315
        },
        {
          "dates": "2023-02-16",
          "totals": 315
        },
        {
          "dates": "2023-02-17",
          "totals": 315
        },
        {
          "dates": "2023-02-18",
          "totals": 315
        },
        {
          "dates": "2023-02-19",
          "totals": 315
        },
        {
          "dates": "2023-02-20",
          "totals": 315
        },
        {
          "dates": "2023-02-21",
          "totals": 315
        },
        {
          "dates": "2023-02-22",
          "totals": 315
        },
        {
          "dates": "2023-02-23",
          "totals": 315
        },
        {
          "dates": "2023-02-24",
          "totals": 315
        },
        {
          "dates": "2023-02-25",
          "totals": 315
        },
        {
          "dates": "2023-02-26",
          "totals": 315
        },
        {
          "dates": "2023-02-27",
          "totals": 315
        },
        {
          "dates": "2023-02-28",
          "totals": 315
        },
        {
          "dates": "2023-03-01",
          "totals": 315
        },
        {
          "dates": "2023-03-02",
          "totals": 315
        },
        {
          "dates": "2023-03-03",
          "totals": 315
        },
        {
          "dates": "2023-03-04",
          "totals": 315
        },
        {
          "dates": "2023-03-05",
          "totals": 315
        },
        {
          "dates": "2023-03-06",
          "totals": 315
        },
        {
          "dates": "2023-03-07",
          "totals": 315
        },
        {
          "dates": "2023-03-08",
          "totals": 315
        },
        {
          "dates": "2023-03-09",
          "totals": 315
        },
        {
          "dates": "2023-03-10",
          "totals": 315
        },
        {
          "dates": "2023-03-11",
          "totals": 315
        },
        {
          "dates": "2023-03-12",
          "totals": 315
        },
        {
          "dates": "2023-03-13",
          "totals": 315
        },
        {
          "dates": "2023-03-14",
          "totals": 315
        },
        {
          "dates": "2023-03-15",
          "totals": 315
        },
        {
          "dates": "2023-03-16",
          "totals": 315
        },
        {
          "dates": "2023-03-17",
          "totals": 315
        },
        {
          "dates": "2023-03-18",
          "totals": 315
        },
        {
          "dates": "2023-03-19",
          "totals": 315
        },
        {
          "dates": "2023-03-20",
          "totals": 315
        },
        {
          "dates": "2023-03-21",
          "totals": 315
        },
        {
          "dates": "2023-03-22",
          "totals": 315
        },
        {
          "dates": "2023-03-23",
          "totals": 315
        },
        {
          "dates": "2023-03-24",
          "totals": 315
        },
        {
          "dates": "2023-03-25",
          "totals": 315
        },
        {
          "dates": "2023-03-26",
          "totals": 315
        },
        {
          "dates": "2023-03-27",
          "totals": 315
        },
        {
          "dates": "2023-03-28",
          "totals": 315
        },
        {
          "dates": "2023-03-29",
          "totals": 315
        },
        {
          "dates": "2023-03-30",
          "totals": 315
        },
        {
          "dates": "2023-03-31",
          "totals": 315
        },
        {
          "dates": "2023-04-01",
          "totals": 315
        },
        {
          "dates": "2023-04-02",
          "totals": 315
        },
        {
          "dates": "2023-04-03",
          "totals": 315
        },
        {
          "dates": "2023-04-04",
          "totals": 315
        },
        {
          "dates": "2023-04-05",
          "totals": 315
        },
        {
          "dates": "2023-04-06",
          "totals": 315
        },
        {
          "dates": "2023-04-07",
          "totals": 315
        },
        {
          "dates": "2023-04-08",
          "totals": 315
        },
        {
          "dates": "2023-04-09",
          "totals": 315
        },
        {
          "dates": "2023-04-10",
          "totals": 315
        },
        {
          "dates": "2023-04-11",
          "totals": 315
        },
        {
          "dates": "2023-04-12",
          "totals": 315
        },
        {
          "dates": "2023-04-13",
          "totals": 316
        },
        {
          "dates": "2023-04-14",
          "totals": 316
        },
        {
          "dates": "2023-04-15",
          "totals": 316
        },
        {
          "dates": "2023-04-16",
          "totals": 316
        },
        {
          "dates": "2023-04-17",
          "totals": 316
        },
        {
          "dates": "2023-04-18",
          "totals": 316
        },
        {
          "dates": "2023-04-19",
          "totals": 316
        },
        {
          "dates": "2023-04-20",
          "totals": 316
        },
        {
          "dates": "2023-04-21",
          "totals": 316
        },
        {
          "dates": "2023-04-22",
          "totals": 316
        },
        {
          "dates": "2023-04-23",
          "totals": 316
        },
        {
          "dates": "2023-04-24",
          "totals": 316
        },
        {
          "dates": "2023-04-25",
          "totals": 316
        },
        {
          "dates": "2023-04-26",
          "totals": 316
        },
        {
          "dates": "2023-04-27",
          "totals": 316
        },
        {
          "dates": "2023-04-28",
          "totals": 316
        },
        {
          "dates": "2023-04-29",
          "totals": 316
        },
        {
          "dates": "2023-04-30",
          "totals": 316
        },
        {
          "dates": "2023-05-01",
          "totals": 316
        },
        {
          "dates": "2023-05-02",
          "totals": 316
        },
        {
          "dates": "2023-05-03",
          "totals": 316
        },
        {
          "dates": "2023-05-04",
          "totals": 316
        },
        {
          "dates": "2023-05-05",
          "totals": 316
        },
        {
          "dates": "2023-05-06",
          "totals": 316
        },
        {
          "dates": "2023-05-07",
          "totals": 316
        },
        {
          "dates": "2023-05-08",
          "totals": 316
        },
        {
          "dates": "2023-05-09",
          "totals": 316
        },
        {
          "dates": "2023-05-10",
          "totals": 316
        },
        {
          "dates": "2023-05-11",
          "totals": 316
        },
        {
          "dates": "2023-05-12",
          "totals": 316
        },
        {
          "dates": "2023-05-13",
          "totals": 316
        },
        {
          "dates": "2023-05-14",
          "totals": 316
        },
        {
          "dates": "2023-05-15",
          "totals": 316
        },
        {
          "dates": "2023-05-16",
          "totals": 316
        },
        {
          "dates": "2023-05-17",
          "totals": 316
        },
        {
          "dates": "2023-05-18",
          "totals": 316
        },
        {
          "dates": "2023-05-19",
          "totals": 316
        },
        {
          "dates": "2023-05-20",
          "totals": 316
        },
        {
          "dates": "2023-05-21",
          "totals": 316
        },
        {
          "dates": "2023-05-22",
          "totals": 316
        },
        {
          "dates": "2023-05-23",
          "totals": 316
        },
        {
          "dates": "2023-05-24",
          "totals": 316
        },
        {
          "dates": "2023-05-25",
          "totals": 316
        },
        {
          "dates": "2023-05-26",
          "totals": 316
        },
        {
          "dates": "2023-05-27",
          "totals": 316
        },
        {
          "dates": "2023-05-28",
          "totals": 316
        },
        {
          "dates": "2023-05-29",
          "totals": 316
        },
        {
          "dates": "2023-05-30",
          "totals": 316
        },
        {
          "dates": "2023-05-31",
          "totals": 316
        },
        {
          "dates": "2023-06-01",
          "totals": 316
        },
        {
          "dates": "2023-06-02",
          "totals": 316
        },
        {
          "dates": "2023-06-03",
          "totals": 316
        },
        {
          "dates": "2023-06-04",
          "totals": 316
        },
        {
          "dates": "2023-06-05",
          "totals": 316
        },
        {
          "dates": "2023-06-06",
          "totals": 316
        },
        {
          "dates": "2023-06-07",
          "totals": 317
        },
        {
          "dates": "2023-06-08",
          "totals": 317
        },
        {
          "dates": "2023-06-09",
          "totals": 318
        },
        {
          "dates": "2023-06-10",
          "totals": 318
        },
        {
          "dates": "2023-06-11",
          "totals": 318
        },
        {
          "dates": "2023-06-12",
          "totals": 318
        },
        {
          "dates": "2023-06-13",
          "totals": 319
        },
        {
          "dates": "2023-06-14",
          "totals": 319
        },
        {
          "dates": "2023-06-15",
          "totals": 319
        },
        {
          "dates": "2023-06-16",
          "totals": 319
        },
        {
          "dates": "2023-06-17",
          "totals": 319
        },
        {
          "dates": "2023-06-18",
          "totals": 319
        },
        {
          "dates": "2023-06-19",
          "totals": 319
        },
        {
          "dates": "2023-06-20",
          "totals": 319
        },
        {
          "dates": "2023-06-21",
          "totals": 319
        },
        {
          "dates": "2023-06-22",
          "totals": 319
        },
        {
          "dates": "2023-06-23",
          "totals": 319
        },
        {
          "dates": "2023-06-24",
          "totals": 319
        },
        {
          "dates": "2023-06-25",
          "totals": 319
        },
        {
          "dates": "2023-06-26",
          "totals": 319
        },
        {
          "dates": "2023-06-27",
          "totals": 319
        },
        {
          "dates": "2023-06-28",
          "totals": 320
        },
        {
          "dates": "2023-06-29",
          "totals": 320
        },
        {
          "dates": "2023-06-30",
          "totals": 320
        },
        {
          "dates": "2023-07-01",
          "totals": 320
        },
        {
          "dates": "2023-07-02",
          "totals": 320
        },
        {
          "dates": "2023-07-03",
          "totals": 320
        },
        {
          "dates": "2023-07-04",
          "totals": 320
        },
        {
          "dates": "2023-07-05",
          "totals": 320
        },
        {
          "dates": "2023-07-06",
          "totals": 320
        },
        {
          "dates": "2023-07-07",
          "totals": 320
        },
        {
          "dates": "2023-07-08",
          "totals": 320
        },
        {
          "dates": "2023-07-09",
          "totals": 320
        },
        {
          "dates": "2023-07-10",
          "totals": 320
        },
        {
          "dates": "2023-07-11",
          "totals": 320
        },
        {
          "dates": "2023-07-12",
          "totals": 320
        },
        {
          "dates": "2023-07-13",
          "totals": 320
        },
        {
          "dates": "2023-07-14",
          "totals": 320
        },
        {
          "dates": "2023-07-15",
          "totals": 320
        },
        {
          "dates": "2023-07-16",
          "totals": 320
        },
        {
          "dates": "2023-07-17",
          "totals": 320
        },
        {
          "dates": "2023-07-18",
          "totals": 320
        },
        {
          "dates": "2023-07-19",
          "totals": 320
        },
        {
          "dates": "2023-07-20",
          "totals": 320
        },
        {
          "dates": "2023-07-21",
          "totals": 320
        },
        {
          "dates": "2023-07-22",
          "totals": 320
        },
        {
          "dates": "2023-07-23",
          "totals": 320
        },
        {
          "dates": "2023-07-24",
          "totals": 320
        },
        {
          "dates": "2023-07-25",
          "totals": 320
        },
        {
          "dates": "2023-07-26",
          "totals": 320
        },
        {
          "dates": "2023-07-27",
          "totals": 320
        },
        {
          "dates": "2023-07-28",
          "totals": 320
        },
        {
          "dates": "2023-07-29",
          "totals": 320
        },
        {
          "dates": "2023-07-30",
          "totals": 320
        },
        {
          "dates": "2023-07-31",
          "totals": 320
        },
        {
          "dates": "2023-08-01",
          "totals": 320
        },
        {
          "dates": "2023-08-02",
          "totals": 320
        },
        {
          "dates": "2023-08-03",
          "totals": 320
        },
        {
          "dates": "2023-08-04",
          "totals": 320
        },
        {
          "dates": "2023-08-05",
          "totals": 320
        },
        {
          "dates": "2023-08-06",
          "totals": 320
        },
        {
          "dates": "2023-08-07",
          "totals": 320
        },
        {
          "dates": "2023-08-08",
          "totals": 320
        },
        {
          "dates": "2023-08-09",
          "totals": 320
        },
        {
          "dates": "2023-08-10",
          "totals": 320
        },
        {
          "dates": "2023-08-11",
          "totals": 320
        },
        {
          "dates": "2023-08-12",
          "totals": 320
        },
        {
          "dates": "2023-08-13",
          "totals": 320
        },
        {
          "dates": "2023-08-14",
          "totals": 320
        },
        {
          "dates": "2023-08-15",
          "totals": 320
        },
        {
          "dates": "2023-08-16",
          "totals": 320
        },
        {
          "dates": "2023-08-17",
          "totals": 320
        },
        {
          "dates": "2023-08-18",
          "totals": 320
        },
        {
          "dates": "2023-08-19",
          "totals": 320
        },
        {
          "dates": "2023-08-20",
          "totals": 320
        },
        {
          "dates": "2023-08-21",
          "totals": 320
        },
        {
          "dates": "2023-08-22",
          "totals": 320
        },
        {
          "dates": "2023-08-23",
          "totals": 320
        },
        {
          "dates": "2023-08-24",
          "totals": 320
        },
        {
          "dates": "2023-08-25",
          "totals": 320
        },
        {
          "dates": "2023-08-26",
          "totals": 320
        },
        {
          "dates": "2023-08-27",
          "totals": 320
        },
        {
          "dates": "2023-08-28",
          "totals": 320
        },
        {
          "dates": "2023-08-29",
          "totals": 320
        },
        {
          "dates": "2023-08-30",
          "totals": 320
        },
        {
          "dates": "2023-08-31",
          "totals": 320
        },
        {
          "dates": "2023-09-01",
          "totals": 320
        },
        {
          "dates": "2023-09-02",
          "totals": 320
        },
        {
          "dates": "2023-09-03",
          "totals": 320
        },
        {
          "dates": "2023-09-04",
          "totals": 320
        },
        {
          "dates": "2023-09-05",
          "totals": 320
        },
        {
          "dates": "2023-09-06",
          "totals": 320
        },
        {
          "dates": "2023-09-07",
          "totals": 320
        },
        {
          "dates": "2023-09-08",
          "totals": 320
        },
        {
          "dates": "2023-09-09",
          "totals": 320
        },
        {
          "dates": "2023-09-10",
          "totals": 320
        },
        {
          "dates": "2023-09-11",
          "totals": 320
        },
        {
          "dates": "2023-09-12",
          "totals": 320
        },
        {
          "dates": "2023-09-13",
          "totals": 320
        },
        {
          "dates": "2023-09-14",
          "totals": 320
        },
        {
          "dates": "2023-09-15",
          "totals": 320
        },
        {
          "dates": "2023-09-16",
          "totals": 320
        },
        {
          "dates": "2023-09-17",
          "totals": 320
        },
        {
          "dates": "2023-09-18",
          "totals": 320
        },
        {
          "dates": "2023-09-19",
          "totals": 320
        },
        {
          "dates": "2023-09-20",
          "totals": 320
        },
        {
          "dates": "2023-09-21",
          "totals": 320
        },
        {
          "dates": "2023-09-22",
          "totals": 320
        },
        {
          "dates": "2023-09-23",
          "totals": 320
        },
        {
          "dates": "2023-09-24",
          "totals": 320
        },
        {
          "dates": "2023-09-25",
          "totals": 320
        },
        {
          "dates": "2023-09-26",
          "totals": 320
        },
        {
          "dates": "2023-09-27",
          "totals": 320
        },
        {
          "dates": "2023-09-28",
          "totals": 320
        },
        {
          "dates": "2023-09-29",
          "totals": 320
        },
        {
          "dates": "2023-09-30",
          "totals": 320
        },
        {
          "dates": "2023-10-01",
          "totals": 320
        },
        {
          "dates": "2023-10-02",
          "totals": 320
        },
        {
          "dates": "2023-10-03",
          "totals": 320
        },
        {
          "dates": "2023-10-04",
          "totals": 320
        },
        {
          "dates": "2023-10-05",
          "totals": 320
        },
        {
          "dates": "2023-10-06",
          "totals": 320
        },
        {
          "dates": "2023-10-07",
          "totals": 320
        },
        {
          "dates": "2023-10-08",
          "totals": 320
        },
        {
          "dates": "2023-10-09",
          "totals": 320
        },
        {
          "dates": "2023-10-10",
          "totals": 320
        },
        {
          "dates": "2023-10-11",
          "totals": 320
        },
        {
          "dates": "2023-10-12",
          "totals": 321
        },
        {
          "dates": "2023-10-13",
          "totals": 322
        },
        {
          "dates": "2023-10-14",
          "totals": 322
        },
        {
          "dates": "2023-10-15",
          "totals": 322
        },
        {
          "dates": "2023-10-16",
          "totals": 322
        },
        {
          "dates": "2023-10-17",
          "totals": 323
        },
        {
          "dates": "2023-10-18",
          "totals": 325
        },
        {
          "dates": "2023-10-19",
          "totals": 325
        },
        {
          "dates": "2023-10-20",
          "totals": 325
        },
        {
          "dates": "2023-10-21",
          "totals": 325
        },
        {
          "dates": "2023-10-22",
          "totals": 325
        },
        {
          "dates": "2023-10-23",
          "totals": 325
        },
        {
          "dates": "2023-10-24",
          "totals": 325
        },
        {
          "dates": "2023-10-25",
          "totals": 325
        },
        {
          "dates": "2023-10-26",
          "totals": 325
        },
        {
          "dates": "2023-10-27",
          "totals": 325
        },
        {
          "dates": "2023-10-28",
          "totals": 325
        },
        {
          "dates": "2023-10-29",
          "totals": 325
        },
        {
          "dates": "2023-10-30",
          "totals": 325
        },
        {
          "dates": "2023-10-31",
          "totals": 325
        },
        {
          "dates": "2023-11-01",
          "totals": 325
        },
        {
          "dates": "2023-11-02",
          "totals": 325
        },
        {
          "dates": "2023-11-03",
          "totals": 325
        },
        {
          "dates": "2023-11-04",
          "totals": 325
        },
        {
          "dates": "2023-11-05",
          "totals": 325
        },
        {
          "dates": "2023-11-06",
          "totals": 325
        },
        {
          "dates": "2023-11-07",
          "totals": 325
        },
        {
          "dates": "2023-11-08",
          "totals": 325
        },
        {
          "dates": "2023-11-09",
          "totals": 325
        },
        {
          "dates": "2023-11-10",
          "totals": 325
        },
        {
          "dates": "2023-11-11",
          "totals": 325
        },
        {
          "dates": "2023-11-12",
          "totals": 325
        },
        {
          "dates": "2023-11-13",
          "totals": 325
        },
        {
          "dates": "2023-11-14",
          "totals": 325
        },
        {
          "dates": "2023-11-15",
          "totals": 325
        },
        {
          "dates": "2023-11-16",
          "totals": 325
        },
        {
          "dates": "2023-11-17",
          "totals": 325
        },
        {
          "dates": "2023-11-18",
          "totals": 325
        },
        {
          "dates": "2023-11-19",
          "totals": 325
        },
        {
          "dates": "2023-11-20",
          "totals": 325
        },
        {
          "dates": "2023-11-21",
          "totals": 325
        },
        {
          "dates": "2023-11-22",
          "totals": 325
        },
        {
          "dates": "2023-11-23",
          "totals": 325
        },
        {
          "dates": "2023-11-24",
          "totals": 325
        },
        {
          "dates": "2023-11-25",
          "totals": 325
        },
        {
          "dates": "2023-11-26",
          "totals": 325
        },
        {
          "dates": "2023-11-27",
          "totals": 325
        },
        {
          "dates": "2023-11-28",
          "totals": 325
        },
        {
          "dates": "2023-11-29",
          "totals": 325
        },
        {
          "dates": "2023-11-30",
          "totals": 325
        },
        {
          "dates": "2023-12-01",
          "totals": 325
        },
        {
          "dates": "2023-12-02",
          "totals": 325
        },
        {
          "dates": "2023-12-03",
          "totals": 325
        },
        {
          "dates": "2023-12-04",
          "totals": 325
        },
        {
          "dates": "2023-12-05",
          "totals": 325
        },
        {
          "dates": "2023-12-06",
          "totals": 325
        },
        {
          "dates": "2023-12-07",
          "totals": 325
        },
        {
          "dates": "2023-12-08",
          "totals": 325
        },
        {
          "dates": "2023-12-09",
          "totals": 325
        },
        {
          "dates": "2023-12-10",
          "totals": 325
        },
        {
          "dates": "2023-12-11",
          "totals": 325
        },
        {
          "dates": "2023-12-12",
          "totals": 325
        },
        {
          "dates": "2023-12-13",
          "totals": 325
        },
        {
          "dates": "2023-12-14",
          "totals": 325
        },
        {
          "dates": "2023-12-15",
          "totals": 325
        },
        {
          "dates": "2023-12-16",
          "totals": 325
        },
        {
          "dates": "2023-12-17",
          "totals": 325
        },
        {
          "dates": "2023-12-18",
          "totals": 325
        },
        {
          "dates": "2023-12-19",
          "totals": 325
        },
        {
          "dates": "2023-12-20",
          "totals": 325
        },
        {
          "dates": "2023-12-21",
          "totals": 325
        },
        {
          "dates": "2023-12-22",
          "totals": 325
        },
        {
          "dates": "2023-12-23",
          "totals": 325
        },
        {
          "dates": "2023-12-24",
          "totals": 325
        },
        {
          "dates": "2023-12-25",
          "totals": 325
        },
        {
          "dates": "2023-12-26",
          "totals": 325
        },
        {
          "dates": "2023-12-27",
          "totals": 325
        },
        {
          "dates": "2023-12-28",
          "totals": 325
        },
        {
          "dates": "2023-12-29",
          "totals": 325
        },
        {
          "dates": "2023-12-30",
          "totals": 325
        },
        {
          "dates": "2023-12-31",
          "totals": 325
        },
        {
          "dates": "2024-01-01",
          "totals": 325
        },
        {
          "dates": "2024-01-02",
          "totals": 325
        },
        {
          "dates": "2024-01-03",
          "totals": 325
        },
        {
          "dates": "2024-01-04",
          "totals": 325
        },
        {
          "dates": "2024-01-05",
          "totals": 325
        },
        {
          "dates": "2024-01-06",
          "totals": 325
        },
        {
          "dates": "2024-01-07",
          "totals": 325
        },
        {
          "dates": "2024-01-08",
          "totals": 325
        },
        {
          "dates": "2024-01-09",
          "totals": 325
        },
        {
          "dates": "2024-01-10",
          "totals": 325
        },
        {
          "dates": "2024-01-11",
          "totals": 325
        },
        {
          "dates": "2024-01-12",
          "totals": 325
        },
        {
          "dates": "2024-01-13",
          "totals": 325
        },
        {
          "dates": "2024-01-14",
          "totals": 325
        },
        {
          "dates": "2024-01-15",
          "totals": 325
        },
        {
          "dates": "2024-01-16",
          "totals": 325
        },
        {
          "dates": "2024-01-17",
          "totals": 325
        },
        {
          "dates": "2024-01-18",
          "totals": 325
        },
        {
          "dates": "2024-01-19",
          "totals": 325
        },
        {
          "dates": "2024-01-20",
          "totals": 325
        },
        {
          "dates": "2024-01-21",
          "totals": 325
        },
        {
          "dates": "2024-01-22",
          "totals": 325
        },
        {
          "dates": "2024-01-23",
          "totals": 325
        },
        {
          "dates": "2024-01-24",
          "totals": 325
        },
        {
          "dates": "2024-01-25",
          "totals": 325
        },
        {
          "dates": "2024-01-26",
          "totals": 325
        },
        {
          "dates": "2024-01-27",
          "totals": 325
        },
        {
          "dates": "2024-01-28",
          "totals": 325
        },
        {
          "dates": "2024-01-29",
          "totals": 325
        },
        {
          "dates": "2024-01-30",
          "totals": 325
        },
        {
          "dates": "2024-01-31",
          "totals": 325
        },
        {
          "dates": "2024-02-01",
          "totals": 325
        },
        {
          "dates": "2024-02-02",
          "totals": 325
        },
        {
          "dates": "2024-02-03",
          "totals": 325
        },
        {
          "dates": "2024-02-04",
          "totals": 325
        },
        {
          "dates": "2024-02-05",
          "totals": 325
        },
        {
          "dates": "2024-02-06",
          "totals": 325
        },
        {
          "dates": "2024-02-07",
          "totals": 325
        },
        {
          "dates": "2024-02-08",
          "totals": 325
        },
        {
          "dates": "2024-02-09",
          "totals": 325
        },
        {
          "dates": "2024-02-10",
          "totals": 325
        },
        {
          "dates": "2024-02-11",
          "totals": 325
        },
        {
          "dates": "2024-02-12",
          "totals": 325
        },
        {
          "dates": "2024-02-13",
          "totals": 325
        },
        {
          "dates": "2024-02-14",
          "totals": 325
        },
        {
          "dates": "2024-02-15",
          "totals": 325
        },
        {
          "dates": "2024-02-16",
          "totals": 325
        },
        {
          "dates": "2024-02-17",
          "totals": 325
        },
        {
          "dates": "2024-02-18",
          "totals": 325
        },
        {
          "dates": "2024-02-19",
          "totals": 325
        },
        {
          "dates": "2024-02-20",
          "totals": 325
        },
        {
          "dates": "2024-02-21",
          "totals": 325
        },
        {
          "dates": "2024-02-22",
          "totals": 325
        },
        {
          "dates": "2024-02-23",
          "totals": 325
        },
        {
          "dates": "2024-02-24",
          "totals": 325
        },
        {
          "dates": "2024-02-25",
          "totals": 325
        },
        {
          "dates": "2024-02-26",
          "totals": 325
        },
        {
          "dates": "2024-02-27",
          "totals": 325
        },
        {
          "dates": "2024-02-28",
          "totals": 325
        },
        {
          "dates": "2024-02-29",
          "totals": 325
        },
        {
          "dates": "2024-03-01",
          "totals": 325
        },
        {
          "dates": "2024-03-02",
          "totals": 325
        },
        {
          "dates": "2024-03-03",
          "totals": 325
        },
        {
          "dates": "2024-03-04",
          "totals": 325
        },
        {
          "dates": "2024-03-05",
          "totals": 325
        },
        {
          "dates": "2024-03-06",
          "totals": 325
        },
        {
          "dates": "2024-03-07",
          "totals": 325
        },
        {
          "dates": "2024-03-08",
          "totals": 325
        },
        {
          "dates": "2024-03-09",
          "totals": 325
        },
        {
          "dates": "2024-03-10",
          "totals": 325
        },
        {
          "dates": "2024-03-11",
          "totals": 325
        },
        {
          "dates": "2024-03-12",
          "totals": 325
        },
        {
          "dates": "2024-03-13",
          "totals": 325
        },
        {
          "dates": "2024-03-14",
          "totals": 325
        },
        {
          "dates": "2024-03-15",
          "totals": 325
        },
        {
          "dates": "2024-03-16",
          "totals": 325
        },
        {
          "dates": "2024-03-17",
          "totals": 325
        },
        {
          "dates": "2024-03-18",
          "totals": 325
        },
        {
          "dates": "2024-03-19",
          "totals": 325
        },
        {
          "dates": "2024-03-20",
          "totals": 325
        },
        {
          "dates": "2024-03-21",
          "totals": 325
        },
        {
          "dates": "2024-03-22",
          "totals": 325
        },
        {
          "dates": "2024-03-23",
          "totals": 325
        },
        {
          "dates": "2024-03-24",
          "totals": 325
        },
        {
          "dates": "2024-03-25",
          "totals": 325
        },
        {
          "dates": "2024-03-26",
          "totals": 325
        },
        {
          "dates": "2024-03-27",
          "totals": 325
        },
        {
          "dates": "2024-03-28",
          "totals": 325
        },
        {
          "dates": "2024-03-29",
          "totals": 325
        },
        {
          "dates": "2024-03-30",
          "totals": 325
        },
        {
          "dates": "2024-03-31",
          "totals": 325
        },
        {
          "dates": "2024-04-01",
          "totals": 325
        },
        {
          "dates": "2024-04-02",
          "totals": 325
        },
        {
          "dates": "2024-04-03",
          "totals": 325
        },
        {
          "dates": "2024-04-04",
          "totals": 325
        },
        {
          "dates": "2024-04-05",
          "totals": 325
        },
        {
          "dates": "2024-04-06",
          "totals": 325
        },
        {
          "dates": "2024-04-07",
          "totals": 325
        },
        {
          "dates": "2024-04-08",
          "totals": 325
        },
        {
          "dates": "2024-04-09",
          "totals": 333
        },
        {
          "dates": "2024-04-10",
          "totals": 333
        },
        {
          "dates": "2024-04-11",
          "totals": 333
        },
        {
          "dates": "2024-04-12",
          "totals": 335
        },
        {
          "dates": "2024-04-13",
          "totals": 335
        },
        {
          "dates": "2024-04-14",
          "totals": 335
        },
        {
          "dates": "2024-04-15",
          "totals": 344
        },
        {
          "dates": "2024-04-16",
          "totals": 348
        },
        {
          "dates": "2024-04-17",
          "totals": 348
        },
        {
          "dates": "2024-04-18",
          "totals": 351
        },
        {
          "dates": "2024-04-19",
          "totals": 358
        },
        {
          "dates": "2024-04-20",
          "totals": 358
        },
        {
          "dates": "2024-04-21",
          "totals": 358
        },
        {
          "dates": "2024-04-22",
          "totals": 358
        },
        {
          "dates": "2024-04-23",
          "totals": 358
        },
        {
          "dates": "2024-04-24",
          "totals": 362
        },
        {
          "dates": "2024-04-25",
          "totals": 365
        },
        {
          "dates": "2024-04-26",
          "totals": 365
        },
        {
          "dates": "2024-04-27",
          "totals": 365
        },
        {
          "dates": "2024-04-28",
          "totals": 365
        },
        {
          "dates": "2024-04-29",
          "totals": 365
        },
        {
          "dates": "2024-04-30",
          "totals": 365
        },
        {
          "dates": "2024-05-01",
          "totals": 366
        },
        {
          "dates": "2024-05-02",
          "totals": 368
        },
        {
          "dates": "2024-05-03",
          "totals": 369
        },
        {
          "dates": "2024-05-04",
          "totals": 370
        },
        {
          "dates": "2024-05-05",
          "totals": 370
        },
        {
          "dates": "2024-05-06",
          "totals": 371
        },
        {
          "dates": "2024-05-07",
          "totals": 373
        },
        {
          "dates": "2024-05-08",
          "totals": 373
        },
        {
          "dates": "2024-05-09",
          "totals": 373
        },
        {
          "dates": "2024-05-10",
          "totals": 373
        },
        {
          "dates": "2024-05-11",
          "totals": 373
        },
        {
          "dates": "2024-05-12",
          "totals": 373
        },
        {
          "dates": "2024-05-13",
          "totals": 374
        },
        {
          "dates": "2024-05-14",
          "totals": 374
        },
        {
          "dates": "2024-05-15",
          "totals": 374
        },
        {
          "dates": "2024-05-16",
          "totals": 377
        },
        {
          "dates": "2024-05-17",
          "totals": 377
        },
        {
          "dates": "2024-05-18",
          "totals": 377
        },
        {
          "dates": "2024-05-19",
          "totals": 377
        },
        {
          "dates": "2024-05-20",
          "totals": 377
        },
        {
          "dates": "2024-05-21",
          "totals": 377
        },
        {
          "dates": "2024-05-22",
          "totals": 377
        },
        {
          "dates": "2024-05-23",
          "totals": 377
        },
        {
          "dates": "2024-05-24",
          "totals": 377
        },
        {
          "dates": "2024-05-25",
          "totals": 377
        },
        {
          "dates": "2024-05-26",
          "totals": 377
        },
        {
          "dates": "2024-05-27",
          "totals": 377
        },
        {
          "dates": "2024-05-28",
          "totals": 377
        },
        {
          "dates": "2024-05-29",
          "totals": 377
        },
        {
          "dates": "2024-05-30",
          "totals": 377
        },
        {
          "dates": "2024-05-31",
          "totals": 377
        },
        {
          "dates": "2024-06-01",
          "totals": 377
        },
        {
          "dates": "2024-06-02",
          "totals": 377
        },
        {
          "dates": "2024-06-03",
          "totals": 377
        },
        {
          "dates": "2024-06-04",
          "totals": 377
        },
        {
          "dates": "2024-06-05",
          "totals": 377
        },
        {
          "dates": "2024-06-06",
          "totals": 377
        },
        {
          "dates": "2024-06-07",
          "totals": 377
        },
        {
          "dates": "2024-06-08",
          "totals": 377
        },
        {
          "dates": "2024-06-09",
          "totals": 377
        },
        {
          "dates": "2024-06-10",
          "totals": 377
        },
        {
          "dates": "2024-06-11",
          "totals": 377
        },
        {
          "dates": "2024-06-12",
          "totals": 377
        },
        {
          "dates": "2024-06-13",
          "totals": 378
        },
        {
          "dates": "2024-06-14",
          "totals": 378
        },
        {
          "dates": "2024-06-15",
          "totals": 378
        },
        {
          "dates": "2024-06-16",
          "totals": 378
        },
        {
          "dates": "2024-06-17",
          "totals": 385
        },
        {
          "dates": "2024-06-18",
          "totals": 385
        },
        {
          "dates": "2024-06-19",
          "totals": 385
        },
        {
          "dates": "2024-06-20",
          "totals": 385
        },
        {
          "dates": "2024-06-21",
          "totals": 385
        },
        {
          "dates": "2024-06-22",
          "totals": 385
        },
        {
          "dates": "2024-06-23",
          "totals": 385
        },
        {
          "dates": "2024-06-24",
          "totals": 386
        },
        {
          "dates": "2024-06-25",
          "totals": 386
        },
        {
          "dates": "2024-06-26",
          "totals": 386
        },
        {
          "dates": "2024-06-27",
          "totals": 386
        },
        {
          "dates": "2024-06-28",
          "totals": 386
        },
        {
          "dates": "2024-06-29",
          "totals": 386
        },
        {
          "dates": "2024-06-30",
          "totals": 386
        },
        {
          "dates": "2024-07-01",
          "totals": 386
        },
        {
          "dates": "2024-07-02",
          "totals": 386
        },
        {
          "dates": "2024-07-03",
          "totals": 386
        },
        {
          "dates": "2024-07-04",
          "totals": 386
        },
        {
          "dates": "2024-07-05",
          "totals": 386
        },
        {
          "dates": "2024-07-06",
          "totals": 386
        },
        {
          "dates": "2024-07-07",
          "totals": 386
        },
        {
          "dates": "2024-07-08",
          "totals": 386
        },
        {
          "dates": "2024-07-09",
          "totals": 388
        },
        {
          "dates": "2024-07-10",
          "totals": 388
        },
        {
          "dates": "2024-07-11",
          "totals": 388
        },
        {
          "dates": "2024-07-12",
          "totals": 391
        },
        {
          "dates": "2024-07-13",
          "totals": 391
        },
        {
          "dates": "2024-07-14",
          "totals": 391
        },
        {
          "dates": "2024-07-15",
          "totals": 391
        },
        {
          "dates": "2024-07-16",
          "totals": 391
        },
        {
          "dates": "2024-07-17",
          "totals": 391
        }
      ]
    }
}

export const activities = {
    activities: [
        {
          "id": 331,
          "client_id": 207,
          "admin_id": 542,
          "donor_id": 17135,
          "table_name": "commitments",
          "record_id": 23289,
          "action": "add_sponsorship",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"Dianne Test CC Monthly\",\"amount\":\"32\",\"method\":\"External Processor\",\"designation\":\"Bianca Jean-Baptiste\",\"done_by\":\"Leslie Jobs\"}",
          "created_at": "2024-07-12T05:18:25.000000Z",
          "updated_at": "2024-07-12T05:18:25.000000Z",
          "description": "<a href=\"/app/view_donor/17135\"><strong>Dianne Test CC Monthly</strong></a> has sponsored <strong>Bianca Jean-Baptiste</strong> with <strong>32</strong> by <strong>External Processor</strong>"
        },
        {
          "id": 330,
          "client_id": 207,
          "admin_id": 542,
          "donor_id": 16924,
          "table_name": "commitments",
          "record_id": 23288,
          "action": "add_sponsorship",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"Thad & Test Collins Paypal\",\"amount\":\"32\",\"method\":\"Wire Transfer\",\"designation\":\"Caroline Agenord\",\"done_by\":\"Leslie Jobs\"}",
          "created_at": "2024-07-12T05:17:18.000000Z",
          "updated_at": "2024-07-12T05:17:18.000000Z",
          "description": "<a href=\"/app/view_donor/16924\"><strong>Thad & Test Collins Paypal</strong></a> has sponsored <strong>Caroline Agenord</strong> with <strong>32</strong> by <strong>Wire Transfer</strong>"
        },
        {
          "id": 329,
          "client_id": 207,
          "admin_id": 542,
          "donor_id": 17017,
          "table_name": "commitments",
          "record_id": 23287,
          "action": "add_sponsorship",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"Test Donor Shaban Paypal, monthly\",\"amount\":\"32\",\"method\":\"Cash\",\"designation\":\"Stevenson Simon\",\"done_by\":\"Leslie Jobs\"}",
          "created_at": "2024-07-12T05:16:38.000000Z",
          "updated_at": "2024-07-12T05:16:38.000000Z",
          "description": "<a href=\"/app/view_donor/17017\"><strong>Test Donor Shaban Paypal, monthly</strong></a> has sponsored <strong>Stevenson Simon</strong> with <strong>32</strong> by <strong>Cash</strong>"
        },
        {
          "id": 327,
          "client_id": 207,
          "admin_id": 542,
          "donor_id": null,
          "table_name": "donations",
          "record_id": 379539,
          "action": "add_donation_receipt_email",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"Test Mulimwa\",\"emailset_id\":337,\"details\":{\"donor\":{\"dn_donor_name\":\"Test Mulimwa\"},\"donation\":{\"designations\":\" @ 13 (One-time)\",\"total_amount\":\"13\",\"method\":\"Cash\",\"date\":\"Jul 9, 2024\"}},\"subject\":\"Donation Receipt\",\"body\":\"<p>Thank you for your donation  @ 13 (One-time) for 13. This email serves as your donation receipt.<\\/p>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<table style=\\\"\\\" border-color:#666;width:80%;margin:20px=\\\"\\\" auto;\\\"\\\"=\\\"\\\" cellpadding=\\\"\\\" 10\\\"\\\"=\\\"\\\">\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tbody>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tDonor Name\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t[donor_name]\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tDesignation\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t[designation_name]\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tAmount\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t$[amount]\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tMethod\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tCash\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tFrequency\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t[frequency]<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tbody>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/table><p>Jul 9, 2024<\\/p>\",\"done_by\":\"System\"}",
          "created_at": "2024-07-09T13:56:34.000000Z",
          "updated_at": "2024-07-09T13:56:34.000000Z",
          "description": "A donation receipt email for <strong></strong> has been sent to <strong>Test Mulimwa</strong>"
        },
        {
          "id": 328,
          "client_id": 207,
          "admin_id": 542,
          "donor_id": 26134,
          "table_name": "donations",
          "record_id": 379539,
          "action": "add_donation",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"Test Mulimwa\",\"amount\":\"13\",\"method\":\"Cash\",\"designation\":\"Kelluckson Jack\",\"done_by\":\"Leslie Jobs\"}",
          "created_at": "2024-07-09T13:56:34.000000Z",
          "updated_at": "2024-07-09T13:56:34.000000Z",
          "description": "<a href=\"/app/view_donor/26134\"><strong>Test Mulimwa</strong></a> has donated <strong>13</strong> by <strong>Cash</strong> for <strong>Kelluckson Jack</strong>"
        },
        {
          "id": 326,
          "client_id": 207,
          "admin_id": 542,
          "donor_id": 26133,
          "table_name": "donors",
          "record_id": 26133,
          "action": "edit_donor",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"Test Sponsor\",\"done_by\":\"Leslie Jobs\"}",
          "created_at": "2024-07-09T13:39:26.000000Z",
          "updated_at": "2024-07-09T13:39:26.000000Z",
          "description": "Donor <a href=\"/app/view_donor/26133\"><strong>Test Sponsor</strong></a> profile has been updated"
        },
        {
          "id": 325,
          "client_id": 207,
          "admin_id": 542,
          "donor_id": 26133,
          "table_name": "donations",
          "record_id": 379538,
          "action": "add_donation",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"Test Sponsor\",\"amount\":\"12\",\"method\":\"Check\",\"designation\":\"Bag of Rice\",\"done_by\":\"Leslie Jobs\"}",
          "created_at": "2024-07-09T13:38:36.000000Z",
          "updated_at": "2024-07-09T13:38:36.000000Z",
          "description": "<a href=\"/app/view_donor/26133\"><strong>Test Sponsor</strong></a> has donated <strong>12</strong> by <strong>Check</strong> for <strong>Bag of Rice</strong>"
        },
        {
          "id": 324,
          "client_id": 207,
          "admin_id": 542,
          "donor_id": null,
          "table_name": "donations",
          "record_id": 379538,
          "action": "add_donation_receipt_email",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"Test Sponsor\",\"emailset_id\":337,\"details\":{\"donor\":{\"dn_donor_name\":\"Test Sponsor\"},\"donation\":{\"designations\":\" @ 12 (One-time)\",\"total_amount\":\"12\",\"method\":\"Check\",\"date\":\"Jul 9, 2024\"}},\"subject\":\"Donation Receipt\",\"body\":\"<p>Thank you for your donation  @ 12 (One-time) for 12. This email serves as your donation receipt.<\\/p>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<table style=\\\"\\\" border-color:#666;width:80%;margin:20px=\\\"\\\" auto;\\\"\\\"=\\\"\\\" cellpadding=\\\"\\\" 10\\\"\\\"=\\\"\\\">\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tbody>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tDonor Name\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t[donor_name]\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tDesignation\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t[designation_name]\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tAmount\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t$[amount]\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tMethod\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tCheck\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tFrequency\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t[frequency]<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tbody>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/table><p>Jul 9, 2024<\\/p>\",\"done_by\":\"System\"}",
          "created_at": "2024-07-09T13:38:35.000000Z",
          "updated_at": "2024-07-09T13:38:35.000000Z",
          "description": "A donation receipt email for <strong></strong> has been sent to <strong>Test Sponsor</strong>"
        },
        {
          "id": 323,
          "client_id": 207,
          "admin_id": 542,
          "donor_id": null,
          "table_name": "entities",
          "record_id": 48046,
          "action": "add_entity",
          "deleted_at": null,
          "additional_data": "{\"entity_name\":\"David Sente\",\"done_by\":\"Leslie Jobs\"}",
          "created_at": "2024-07-09T13:35:33.000000Z",
          "updated_at": "2024-07-09T13:35:33.000000Z",
          "description": "Recipient <strong>David Sente</strong> has been added"
        },
        {
          "id": 322,
          "client_id": 207,
          "admin_id": 542,
          "donor_id": null,
          "table_name": "news_letters",
          "record_id": 25,
          "action": "delete_newsletter",
          "deleted_at": null,
          "additional_data": "{\"title\":\"Test tiny mce self host\",\"done_by\":\"Leslie Jobs\"}",
          "created_at": "2024-07-03T09:54:16.000000Z",
          "updated_at": "2024-07-03T09:54:16.000000Z",
          "description": "Draft newsletter <strong>Test tiny mce self host</strong> has been deleted"
        },
        {
          "id": 321,
          "client_id": 207,
          "admin_id": 542,
          "donor_id": null,
          "table_name": "news_letters",
          "record_id": 26,
          "action": "delete_newsletter",
          "deleted_at": null,
          "additional_data": "{\"title\":\"jk k\",\"done_by\":\"Leslie Jobs\"}",
          "created_at": "2024-07-03T09:54:11.000000Z",
          "updated_at": "2024-07-03T09:54:11.000000Z",
          "description": "Draft newsletter <strong>jk k</strong> has been deleted"
        },
        {
          "id": 317,
          "client_id": 207,
          "admin_id": 542,
          "donor_id": 37242,
          "table_name": "donoremails",
          "record_id": 17618,
          "action": "draft_message",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"No Sponsor Name Found\",\"entity_name\":\"Deleted Entity\",\"subject\":\"test send file\",\"message\":\"test send file<br>Attached File Included: Empty.jpeghttps:\\/\\/s3-us-west-1.amazonaws.com\\/hys\\/fce86eb3-31ea-4fd0-a121-181a2c6c5fc9.jpeg\",\"done_by\":\"Leslie Jobs\"}",
          "created_at": "2024-06-27T17:07:24.000000Z",
          "updated_at": "2024-06-27T17:07:24.000000Z",
          "description": "An email from <strong>Deleted Entity</strong> to <strong>No Sponsor Name Found</strong> has been drafted"
        },
        {
          "id": 318,
          "client_id": 207,
          "admin_id": 542,
          "donor_id": 37273,
          "table_name": "donoremails",
          "record_id": 17619,
          "action": "draft_message",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"No Sponsor Name Found\",\"entity_name\":\"Deleted Entity\",\"subject\":\"test send file\",\"message\":\"test send file<br>Attached File Included: Empty.jpeghttps:\\/\\/s3-us-west-1.amazonaws.com\\/hys\\/fce86eb3-31ea-4fd0-a121-181a2c6c5fc9.jpeg\",\"done_by\":\"Leslie Jobs\"}",
          "created_at": "2024-06-27T17:07:24.000000Z",
          "updated_at": "2024-06-27T17:07:24.000000Z",
          "description": "An email from <strong>Deleted Entity</strong> to <strong>No Sponsor Name Found</strong> has been drafted"
        },
        {
          "id": 319,
          "client_id": 207,
          "admin_id": 542,
          "donor_id": 37240,
          "table_name": "donoremails",
          "record_id": 17620,
          "action": "draft_message",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"No Sponsor Name Found\",\"entity_name\":\"Deleted Entity\",\"subject\":\"test send file\",\"message\":\"test send file<br>Attached File Included: Empty.jpeghttps:\\/\\/s3-us-west-1.amazonaws.com\\/hys\\/fce86eb3-31ea-4fd0-a121-181a2c6c5fc9.jpeg\",\"done_by\":\"Leslie Jobs\"}",
          "created_at": "2024-06-27T17:07:24.000000Z",
          "updated_at": "2024-06-27T17:07:24.000000Z",
          "description": "An email from <strong>Deleted Entity</strong> to <strong>No Sponsor Name Found</strong> has been drafted"
        },
        {
          "id": 320,
          "client_id": 207,
          "admin_id": 542,
          "donor_id": 48045,
          "table_name": "donoremails",
          "record_id": 17621,
          "action": "draft_message",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"No Sponsor Name Found\",\"entity_name\":\"Deleted Entity\",\"subject\":\"test send file\",\"message\":\"test send file<br>Attached File Included: Empty.jpeghttps:\\/\\/s3-us-west-1.amazonaws.com\\/hys\\/fce86eb3-31ea-4fd0-a121-181a2c6c5fc9.jpeg\",\"done_by\":\"Leslie Jobs\"}",
          "created_at": "2024-06-27T17:07:24.000000Z",
          "updated_at": "2024-06-27T17:07:24.000000Z",
          "description": "An email from <strong>Deleted Entity</strong> to <strong>No Sponsor Name Found</strong> has been drafted"
        },
        {
          "id": 316,
          "client_id": 207,
          "admin_id": 542,
          "donor_id": 37224,
          "table_name": "donoremails",
          "record_id": 17617,
          "action": "draft_message",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"No Sponsor Name Found\",\"entity_name\":\"Deleted Entity\",\"subject\":\"test send file\",\"message\":\"test send file<br>Attached File Included: Empty.jpeghttps:\\/\\/s3-us-west-1.amazonaws.com\\/hys\\/fce86eb3-31ea-4fd0-a121-181a2c6c5fc9.jpeg\",\"done_by\":\"Leslie Jobs\"}",
          "created_at": "2024-06-27T17:07:23.000000Z",
          "updated_at": "2024-06-27T17:07:23.000000Z",
          "description": "An email from <strong>Deleted Entity</strong> to <strong>No Sponsor Name Found</strong> has been drafted"
        },
        {
          "id": 314,
          "client_id": 207,
          "admin_id": 542,
          "donor_id": null,
          "table_name": "donations",
          "record_id": 379525,
          "action": "add_donation_receipt_email",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"John, Katie & Clara Richter CC Monthly\",\"emailset_id\":337,\"details\":{\"donor\":{\"id\":\"17166\",\"client_id\":\"207\",\"hysform_id\":\"639\",\"do_not_email\":\"0\",\"wait_time\":\"\",\"who_added\":\"{\\\"type\\\":\\\"donor\\\",\\\"method\\\":\\\"individual\\\",\\\"id\\\":\\\"\\\"}\",\"stripe_cust_id\":\"\",\"authorize_profile\":\"\",\"json_fields\":\"{\\\"dn_donor_name\\\":\\\"John, Katie & Clara Richter\\\",\\\"dn_address\\\":\\\"dev+6@helpyousponsor.com\\\",\\\"dn_home_address\\\":\\\"405 Hackberry Ln Box 363\\\",\\\"dn_payment_type\\\":\\\"CC Monthly\\\",\\\"dn_child_sponsored\\\":\\\"Estilien Claudensky\\\",\\\"fakeusernameremembered\\\":\\\"\\\",\\\"fakepasswordremembered\\\":\\\"\\\",\\\"password\\\":\\\"\\\"}\",\"deleted_at\":\"\",\"created_at\":\"2018-11-04T22:27:57.000000Z\",\"updated_at\":\"2020-09-09T00:34:40.000000Z\",\"last_login\":\"2020-09-09 00:34:20\",\"__hevo__database_name\":\"apphys_new\",\"__hevo__ingested_at\":\"1679725257574\",\"__hevo__marked_deleted\":\"0\",\"__hevo__source_modified_at\":\"\",\"stripe_card_id\":\"\",\"paypal_email\":\"\",\"dn_donor_name\":\"John, Katie & Clara Richter\",\"dn_address\":\"dev+6@helpyousponsor.com\",\"dn_home_address\":\"405 Hackberry Ln Box 363\",\"dn_payment_type\":\"CC Monthly\",\"dn_child_sponsored\":\"Estilien Claudensky\",\"fakeusernameremembered\":\"\",\"fakepasswordremembered\":\"\",\"donor_id\":\"17166\"},\"donation\":{\"designations\":\" @ 10.00 (One-time)\",\"total_amount\":\"10.00\",\"method\":\"Cash\",\"date\":\"Jun 24, 2024\"}},\"subject\":\"Donation Receipt\",\"body\":\"<p>Thank you for your donation  @ 10.00 (One-time) for 10.00. This email serves as your donation receipt.<\\/p>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<table style=\\\"\\\" border-color:#666;width:80%;margin:20px=\\\"\\\" auto;\\\"\\\"=\\\"\\\" cellpadding=\\\"\\\" 10\\\"\\\"=\\\"\\\">\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tbody>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tDonor Name\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t[donor_name]\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tDesignation\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t[designation_name]\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tAmount\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t$[amount]\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tMethod\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tCash\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tFrequency\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t[frequency]<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tbody>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/table><p>Jun 24, 2024<\\/p>\",\"done_by\":\"System\"}",
          "created_at": "2024-06-24T19:48:18.000000Z",
          "updated_at": "2024-06-24T19:48:18.000000Z",
          "description": "A donation receipt email for <strong></strong> has been sent to <strong>John, Katie & Clara Richter CC Monthly</strong>"
        },
        {
          "id": 315,
          "client_id": 207,
          "admin_id": 542,
          "donor_id": 17166,
          "table_name": "donations",
          "record_id": 379525,
          "action": "add_donation",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"John, Katie & Clara Richter CC Monthly\",\"amount\":\"10.00\",\"method\":\"Cash\",\"designation\":\"Choudna Pierre\",\"done_by\":\"Leslie Jobs\"}",
          "created_at": "2024-06-24T19:48:18.000000Z",
          "updated_at": "2024-06-24T19:48:18.000000Z",
          "description": "<a href=\"/app/view_donor/17166\"><strong>John, Katie & Clara Richter CC Monthly</strong></a> has donated <strong>10.00</strong> by <strong>Cash</strong> for <strong>Choudna Pierre</strong>"
        },
        {
          "id": 313,
          "client_id": 207,
          "admin_id": 542,
          "donor_id": 17166,
          "table_name": "donations",
          "record_id": 379524,
          "action": "add_donation",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"John, Katie & Clara Richter CC Monthly\",\"amount\":\"10.00\",\"method\":\"Cash\",\"designation\":\"Choudna Pierre\",\"done_by\":\"Leslie Jobs\"}",
          "created_at": "2024-06-24T19:39:49.000000Z",
          "updated_at": "2024-06-24T19:39:49.000000Z",
          "description": "<a href=\"/app/view_donor/17166\"><strong>John, Katie & Clara Richter CC Monthly</strong></a> has donated <strong>10.00</strong> by <strong>Cash</strong> for <strong>Choudna Pierre</strong>"
        },
        {
          "id": 312,
          "client_id": 207,
          "admin_id": 542,
          "donor_id": null,
          "table_name": "donations",
          "record_id": 379524,
          "action": "add_donation_receipt_email",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"John, Katie & Clara Richter CC Monthly\",\"emailset_id\":337,\"details\":{\"donor\":{\"id\":\"17166\",\"client_id\":\"207\",\"hysform_id\":\"639\",\"do_not_email\":\"0\",\"wait_time\":\"\",\"who_added\":\"{\\\"type\\\":\\\"donor\\\",\\\"method\\\":\\\"individual\\\",\\\"id\\\":\\\"\\\"}\",\"stripe_cust_id\":\"\",\"authorize_profile\":\"\",\"json_fields\":\"{\\\"dn_donor_name\\\":\\\"John, Katie & Clara Richter\\\",\\\"dn_address\\\":\\\"dev+6@helpyousponsor.com\\\",\\\"dn_home_address\\\":\\\"405 Hackberry Ln Box 363\\\",\\\"dn_payment_type\\\":\\\"CC Monthly\\\",\\\"dn_child_sponsored\\\":\\\"Estilien Claudensky\\\",\\\"fakeusernameremembered\\\":\\\"\\\",\\\"fakepasswordremembered\\\":\\\"\\\",\\\"password\\\":\\\"\\\"}\",\"deleted_at\":\"\",\"created_at\":\"2018-11-04T22:27:57.000000Z\",\"updated_at\":\"2020-09-09T00:34:40.000000Z\",\"last_login\":\"2020-09-09 00:34:20\",\"__hevo__database_name\":\"apphys_new\",\"__hevo__ingested_at\":\"1679725257574\",\"__hevo__marked_deleted\":\"0\",\"__hevo__source_modified_at\":\"\",\"stripe_card_id\":\"\",\"paypal_email\":\"\",\"dn_donor_name\":\"John, Katie & Clara Richter\",\"dn_address\":\"dev+6@helpyousponsor.com\",\"dn_home_address\":\"405 Hackberry Ln Box 363\",\"dn_payment_type\":\"CC Monthly\",\"dn_child_sponsored\":\"Estilien Claudensky\",\"fakeusernameremembered\":\"\",\"fakepasswordremembered\":\"\",\"donor_id\":\"17166\"},\"donation\":{\"designations\":\" @ 10.00 (One-time)\",\"total_amount\":\"10.00\",\"method\":\"Cash\",\"date\":\"Jun 24, 2024\"}},\"subject\":\"Donation Receipt\",\"body\":\"<p>Thank you for your donation  @ 10.00 (One-time) for 10.00. This email serves as your donation receipt.<\\/p>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<table style=\\\"\\\" border-color:#666;width:80%;margin:20px=\\\"\\\" auto;\\\"\\\"=\\\"\\\" cellpadding=\\\"\\\" 10\\\"\\\"=\\\"\\\">\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tbody>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tDonor Name\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t[donor_name]\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tDesignation\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t[designation_name]\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tAmount\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t$[amount]\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tMethod\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tCash\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tFrequency\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t[frequency]<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tbody>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/table><p>Jun 24, 2024<\\/p>\",\"done_by\":\"System\"}",
          "created_at": "2024-06-24T19:39:48.000000Z",
          "updated_at": "2024-06-24T19:39:48.000000Z",
          "description": "A donation receipt email for <strong></strong> has been sent to <strong>John, Katie & Clara Richter CC Monthly</strong>"
        },
        {
          "id": 311,
          "client_id": 207,
          "admin_id": 542,
          "donor_id": 17017,
          "table_name": "donors",
          "record_id": 17017,
          "action": "edit_donor",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"Test Donor Shaban Paypal, monthly\",\"done_by\":\"Leslie Jobs\"}",
          "created_at": "2024-06-24T05:50:06.000000Z",
          "updated_at": "2024-06-24T05:50:06.000000Z",
          "description": "Donor <a href=\"/app/view_donor/17017\"><strong>Test Donor Shaban Paypal, monthly</strong></a> profile has been updated"
        },
        {
          "id": 310,
          "client_id": 207,
          "admin_id": 542,
          "donor_id": 17017,
          "table_name": "donors",
          "record_id": 17017,
          "action": "edit_donor",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"Test Donor Shaban Paypal, monthly\",\"done_by\":\"Leslie Jobs\"}",
          "created_at": "2024-06-24T05:50:05.000000Z",
          "updated_at": "2024-06-24T05:50:05.000000Z",
          "description": "Donor <a href=\"/app/view_donor/17017\"><strong>Test Donor Shaban Paypal, monthly</strong></a> profile has been updated"
        },
        {
          "id": 309,
          "client_id": 207,
          "admin_id": 542,
          "donor_id": 16924,
          "table_name": "donations",
          "record_id": 379521,
          "action": "add_donation",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"Thad & Test Collins Paypal\",\"amount\":\"67\",\"method\":\"Check\",\"designation\":\"Claudania Estilien\",\"done_by\":\"Leslie Jobs\"}",
          "created_at": "2024-06-24T05:14:35.000000Z",
          "updated_at": "2024-06-24T05:14:35.000000Z",
          "description": "<a href=\"/app/view_donor/16924\"><strong>Thad & Test Collins Paypal</strong></a> has donated <strong>67</strong> by <strong>Check</strong> for <strong>Claudania Estilien</strong>"
        },
        {
          "id": 308,
          "client_id": 207,
          "admin_id": 542,
          "donor_id": null,
          "table_name": "donations",
          "record_id": 379521,
          "action": "add_donation_receipt_email",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"Thad & Test Collins Paypal\",\"emailset_id\":337,\"details\":{\"donor\":{\"dn_donor_name\":\"Thad & Test Collins\",\"dn_address\":\"dev+4@helpyousponsor.com\",\"dn_home_address\":\"885 Forest Edge Dr Coralville IA 52241-3374\",\"dn_payment_type\":\"Paypal\",\"dn_child_sponsored\":\"Dermilton Coq\",\"fakeusernameremembered\":\"\",\"fakepasswordremembered\":\"\",\"password\":\"\"},\"donation\":{\"designations\":\" @ 67 (One-time)\",\"total_amount\":\"67\",\"method\":\"Check\",\"date\":\"Jun 24, 2024\"}},\"subject\":\"Donation Receipt\",\"body\":\"<p>Thank you for your donation  @ 67 (One-time) for 67. This email serves as your donation receipt.<\\/p>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<table style=\\\"\\\" border-color:#666;width:80%;margin:20px=\\\"\\\" auto;\\\"\\\"=\\\"\\\" cellpadding=\\\"\\\" 10\\\"\\\"=\\\"\\\">\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tbody>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tDonor Name\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t[donor_name]\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tDesignation\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t[designation_name]\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tAmount\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t$[amount]\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tMethod\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tCheck\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tFrequency\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t[frequency]<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tbody>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/table><p>Jun 24, 2024<\\/p>\",\"done_by\":\"System\"}",
          "created_at": "2024-06-24T05:14:34.000000Z",
          "updated_at": "2024-06-24T05:14:34.000000Z",
          "description": "A donation receipt email for <strong></strong> has been sent to <strong>Thad & Test Collins Paypal</strong>"
        },
        {
          "id": 307,
          "client_id": 207,
          "admin_id": null,
          "donor_id": 26087,
          "table_name": "donoremails",
          "record_id": 17616,
          "action": "donor_message_send",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"Schade\",\"entity_name\":\"Louidjivenson Vilsaint\",\"subject\":\"test frontend image\",\"message\":\"<p>test frontend image<\\/p>\\n\\nFile Name: 1422b93a-0e86-4fdb-b8ef-13e7cc440a80.jpeg\",\"done_by\":\"Schade\"}",
          "created_at": "2024-06-20T19:38:11.000000Z",
          "updated_at": "2024-06-20T19:38:11.000000Z",
          "description": "An email from <strong>Schade</strong> to <strong>Louidjivenson Vilsaint</strong> has been sent"
        },
        {
          "id": 306,
          "client_id": 207,
          "admin_id": null,
          "donor_id": 26087,
          "table_name": "donoremails",
          "record_id": 17615,
          "action": "donor_message_send",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"Schade\",\"entity_name\":\"Louidjivenson Vilsaint\",\"subject\":\"Test frontend\",\"message\":\"<p>Test frontend body<\\/p>\",\"done_by\":\"Schade\"}",
          "created_at": "2024-06-20T19:37:12.000000Z",
          "updated_at": "2024-06-20T19:37:12.000000Z",
          "description": "An email from <strong>Schade</strong> to <strong>Louidjivenson Vilsaint</strong> has been sent"
        },
        {
          "id": 305,
          "client_id": 207,
          "admin_id": 1983,
          "donor_id": null,
          "table_name": "users",
          "record_id": 1983,
          "action": "verification_email",
          "deleted_at": null,
          "additional_data": "{\"user_name\":\"Test Shaban Admin\",\"done_by\":\"System\"}",
          "created_at": "2024-06-13T20:14:56.000000Z",
          "updated_at": "2024-06-13T20:14:56.000000Z",
          "description": "A verification email has been sent to <strong>Test Shaban Admin</strong>"
        },
        {
          "id": 304,
          "client_id": 207,
          "admin_id": 542,
          "donor_id": 15799,
          "table_name": "donoremails",
          "record_id": 17614,
          "action": "draft_message",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"Test Sarah \",\"entity_name\":\"Emerdjina Charles\",\"subject\":\"test draft\",\"message\":\"<p>test draft<\\/p><br>\\n\\nFile Name: 47d1e2be-e319-47ec-b683-bcf83c34be1c.jpg\",\"done_by\":\"Leslie Jobs\"}",
          "created_at": "2024-06-13T09:37:48.000000Z",
          "updated_at": "2024-06-13T09:37:48.000000Z",
          "description": "An email from <strong>Emerdjina Charles</strong> to <strong>Test Sarah </strong> has been drafted"
        },
        {
          "id": 303,
          "client_id": 207,
          "admin_id": 542,
          "donor_id": 15799,
          "table_name": "donoremails",
          "record_id": 17606,
          "action": "approve_draft_message",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"Test Sarah \",\"entity_name\":\"Emerdjina Charles\",\"subject\":\"Hello\",\"message\":\"<p>Hello<\\/p><br>\",\"done_by\":\"Leslie Jobs\"}",
          "created_at": "2024-06-13T09:06:37.000000Z",
          "updated_at": "2024-06-13T09:06:37.000000Z",
          "description": "An email from <strong>Emerdjina Charles</strong> to <strong>Test Sarah </strong> has been approved and sent"
        },
        {
          "id": 302,
          "client_id": 207,
          "admin_id": 542,
          "donor_id": 15799,
          "table_name": "donoremails",
          "record_id": 17608,
          "action": "approve_draft_message",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"Test Sarah \",\"entity_name\":\"Emerdjina Charles\",\"subject\":\"dfsf\",\"message\":\"<p>fsdfsdf<\\/p><br>\\n\\nFile Name: ed224170-8801-4749-9451-8a7a45bbc9f4.jpeg\",\"done_by\":\"Leslie Jobs\"}",
          "created_at": "2024-06-13T09:05:35.000000Z",
          "updated_at": "2024-06-13T09:05:35.000000Z",
          "description": "An email from <strong>Emerdjina Charles</strong> to <strong>Test Sarah </strong> has been approved and sent"
        },
        {
          "id": 301,
          "client_id": 207,
          "admin_id": 542,
          "donor_id": 15799,
          "table_name": "donoremails",
          "record_id": 17610,
          "action": "approve_draft_message",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"Test Sarah \",\"entity_name\":\"Emerdjina Charles\",\"subject\":\"Hello\",\"message\":\"<p>Hello<\\/p><br>\\n\\nFile Name: b752c524-9e56-4e65-b145-719ccb161e1c.jpeg\",\"done_by\":\"Leslie Jobs\"}",
          "created_at": "2024-06-13T09:05:10.000000Z",
          "updated_at": "2024-06-13T09:05:10.000000Z",
          "description": "An email from <strong>Emerdjina Charles</strong> to <strong>Test Sarah </strong> has been approved and sent"
        },
        {
          "id": 300,
          "client_id": 207,
          "admin_id": 542,
          "donor_id": null,
          "table_name": "entities",
          "record_id": 35915,
          "action": "edit_entity",
          "deleted_at": null,
          "additional_data": "{\"entity_name\":{\"id\":35915,\"name\":\"Emerdjina Charles\",\"program_id\":929},\"done_by\":\"Leslie Jobs\",\"old_entity_data\":35915}",
          "created_at": "2024-06-12T09:57:23.000000Z",
          "updated_at": "2024-06-12T09:57:23.000000Z",
          "description": "Recipient <strong>Emerdjina Charles</strong> has been edited"
        },
        {
          "id": 299,
          "client_id": 207,
          "admin_id": 542,
          "donor_id": null,
          "table_name": "entities",
          "record_id": 48042,
          "action": "edit_entity",
          "deleted_at": null,
          "additional_data": "{\"entity_name\":{\"id\":48042,\"name\":\"Tonny Mulidwa\",\"program_id\":929},\"done_by\":\"Leslie Jobs\",\"old_entity_data\":48042}",
          "created_at": "2024-06-12T09:33:28.000000Z",
          "updated_at": "2024-06-12T09:33:28.000000Z",
          "description": "Recipient <strong>Tonny Mulidwa</strong> has been edited"
        },
        {
          "id": 298,
          "client_id": 207,
          "admin_id": 542,
          "donor_id": null,
          "table_name": "entities",
          "record_id": 48041,
          "action": "edit_entity",
          "deleted_at": null,
          "additional_data": "{\"entity_name\":{\"id\":48041,\"name\":\"Danie Kigozi\",\"program_id\":929},\"done_by\":\"Leslie Jobs\",\"old_entity_data\":48041}",
          "created_at": "2024-06-11T09:45:19.000000Z",
          "updated_at": "2024-06-11T09:45:19.000000Z",
          "description": "Recipient <strong>Danie Kigozi</strong> has been edited"
        },
        {
          "id": 297,
          "client_id": 207,
          "admin_id": 542,
          "donor_id": null,
          "table_name": "entities",
          "record_id": 48040,
          "action": "edit_entity",
          "deleted_at": null,
          "additional_data": "{\"entity_name\":{\"id\":48040,\"name\":\"Alicia Jamie 2\",\"program_id\":929},\"done_by\":\"Leslie Jobs\",\"old_entity_data\":48040}",
          "created_at": "2024-06-11T09:35:06.000000Z",
          "updated_at": "2024-06-11T09:35:06.000000Z",
          "description": "Recipient <strong>Alicia Jamie 2</strong> has been edited"
        },
        {
          "id": 296,
          "client_id": 207,
          "admin_id": 542,
          "donor_id": null,
          "table_name": "entities",
          "record_id": 48039,
          "action": "edit_entity",
          "deleted_at": null,
          "additional_data": "{\"entity_name\":{\"id\":48039,\"name\":\"Alicia Jamie\",\"program_id\":929},\"done_by\":\"Leslie Jobs\",\"old_entity_data\":48039}",
          "created_at": "2024-06-11T09:33:00.000000Z",
          "updated_at": "2024-06-11T09:33:00.000000Z",
          "description": "Recipient <strong>Alicia Jamie</strong> has been edited"
        },
        {
          "id": 295,
          "client_id": 207,
          "admin_id": 542,
          "donor_id": null,
          "table_name": "entities",
          "record_id": 48039,
          "action": "edit_entity",
          "deleted_at": null,
          "additional_data": "{\"entity_name\":{\"id\":48039,\"name\":\"Alicia Jamie\",\"program_id\":929},\"done_by\":\"Leslie Jobs\",\"old_entity_data\":48039}",
          "created_at": "2024-06-11T09:32:30.000000Z",
          "updated_at": "2024-06-11T09:32:30.000000Z",
          "description": "Recipient <strong>Alicia Jamie</strong> has been edited"
        },
        {
          "id": 294,
          "client_id": 207,
          "admin_id": 542,
          "donor_id": null,
          "table_name": "entities",
          "record_id": 48038,
          "action": "edit_entity",
          "deleted_at": null,
          "additional_data": "{\"entity_name\":{\"id\":48038,\"name\":\"Mubiru Devis\",\"program_id\":929},\"done_by\":\"Leslie Jobs\",\"old_entity_data\":48038}",
          "created_at": "2024-06-11T09:29:58.000000Z",
          "updated_at": "2024-06-11T09:29:58.000000Z",
          "description": "Recipient <strong>Mubiru Devis</strong> has been edited"
        },
        {
          "id": 293,
          "client_id": 207,
          "admin_id": 542,
          "donor_id": null,
          "table_name": "entities",
          "record_id": 48038,
          "action": "edit_entity",
          "deleted_at": null,
          "additional_data": "{\"entity_name\":{\"id\":48038,\"name\":\"Mubiru Devis\",\"program_id\":929},\"done_by\":\"Leslie Jobs\",\"old_entity_data\":48038}",
          "created_at": "2024-06-11T07:58:50.000000Z",
          "updated_at": "2024-06-11T07:58:50.000000Z",
          "description": "Recipient <strong>Mubiru Devis</strong> has been edited"
        },
        {
          "id": 292,
          "client_id": 207,
          "admin_id": 542,
          "donor_id": null,
          "table_name": "entities",
          "record_id": 48038,
          "action": "edit_entity",
          "deleted_at": null,
          "additional_data": "{\"entity_name\":{\"id\":48038,\"name\":\"Mubiru Devis\",\"program_id\":929},\"done_by\":\"Leslie Jobs\",\"old_entity_data\":48038}",
          "created_at": "2024-06-11T07:58:30.000000Z",
          "updated_at": "2024-06-11T07:58:30.000000Z",
          "description": "Recipient <strong>Mubiru Devis</strong> has been edited"
        },
        {
          "id": 291,
          "client_id": 207,
          "admin_id": 542,
          "donor_id": null,
          "table_name": "entities",
          "record_id": 48038,
          "action": "edit_entity",
          "deleted_at": null,
          "additional_data": "{\"entity_name\":{\"id\":48038,\"name\":\"Mubiru Devis\",\"program_id\":929},\"done_by\":\"Leslie Jobs\",\"old_entity_data\":48038}",
          "created_at": "2024-06-11T07:55:36.000000Z",
          "updated_at": "2024-06-11T07:55:36.000000Z",
          "description": "Recipient <strong>Mubiru Devis</strong> has been edited"
        },
        {
          "id": 290,
          "client_id": 207,
          "admin_id": 542,
          "donor_id": null,
          "table_name": "entities",
          "record_id": 48038,
          "action": "edit_entity",
          "deleted_at": null,
          "additional_data": "{\"entity_name\":{\"id\":48038,\"name\":\"Mubiru Devis\",\"program_id\":929},\"done_by\":\"Leslie Jobs\",\"old_entity_data\":48038}",
          "created_at": "2024-06-11T07:55:08.000000Z",
          "updated_at": "2024-06-11T07:55:08.000000Z",
          "description": "Recipient <strong>Mubiru Devis</strong> has been edited"
        },
        {
          "id": 289,
          "client_id": 207,
          "admin_id": 542,
          "donor_id": null,
          "table_name": "entities",
          "record_id": 48038,
          "action": "edit_entity",
          "deleted_at": null,
          "additional_data": "{\"entity_name\":{\"id\":48038,\"name\":\"Mubiru Devis\",\"program_id\":929},\"done_by\":\"Leslie Jobs\",\"old_entity_data\":48038}",
          "created_at": "2024-06-11T07:48:25.000000Z",
          "updated_at": "2024-06-11T07:48:25.000000Z",
          "description": "Recipient <strong>Mubiru Devis</strong> has been edited"
        },
        {
          "id": 288,
          "client_id": 207,
          "admin_id": 542,
          "donor_id": null,
          "table_name": "entities",
          "record_id": 48038,
          "action": "edit_entity",
          "deleted_at": null,
          "additional_data": "{\"entity_name\":{\"id\":48038,\"name\":\"Mubiru Devis\",\"program_id\":929},\"done_by\":\"Leslie Jobs\",\"old_entity_data\":48038}",
          "created_at": "2024-06-11T07:38:03.000000Z",
          "updated_at": "2024-06-11T07:38:03.000000Z",
          "description": "Recipient <strong>Mubiru Devis</strong> has been edited"
        },
        {
          "id": 287,
          "client_id": 207,
          "admin_id": 542,
          "donor_id": null,
          "table_name": "entities",
          "record_id": 48038,
          "action": "edit_entity",
          "deleted_at": null,
          "additional_data": "{\"entity_name\":{\"id\":48038,\"name\":\"Mubiru Devis\",\"program_id\":929},\"done_by\":\"Leslie Jobs\",\"old_entity_data\":48038}",
          "created_at": "2024-06-10T20:16:52.000000Z",
          "updated_at": "2024-06-10T20:16:52.000000Z",
          "description": "Recipient <strong>Mubiru Devis</strong> has been edited"
        },
        {
          "id": 286,
          "client_id": 207,
          "admin_id": 542,
          "donor_id": null,
          "table_name": "entities",
          "record_id": 48037,
          "action": "edit_entity",
          "deleted_at": null,
          "additional_data": "{\"entity_name\":{\"id\":48037,\"name\":\"Fredrick Olanya\",\"program_id\":929},\"done_by\":\"Leslie Jobs\",\"old_entity_data\":48037}",
          "created_at": "2024-06-10T19:38:12.000000Z",
          "updated_at": "2024-06-10T19:38:12.000000Z",
          "description": "Recipient <strong>Fredrick Olanya</strong> has been edited"
        },
        {
          "id": 285,
          "client_id": 207,
          "admin_id": 542,
          "donor_id": null,
          "table_name": "entities",
          "record_id": 48037,
          "action": "edit_entity",
          "deleted_at": null,
          "additional_data": "{\"entity_name\":{\"id\":48037,\"name\":\"Fredrick Olanya\",\"program_id\":929},\"done_by\":\"Leslie Jobs\",\"old_entity_data\":48037}",
          "created_at": "2024-06-10T13:37:10.000000Z",
          "updated_at": "2024-06-10T13:37:10.000000Z",
          "description": "Recipient <strong>Fredrick Olanya</strong> has been edited"
        },
        {
          "id": 284,
          "client_id": 207,
          "admin_id": 542,
          "donor_id": null,
          "table_name": "entities",
          "record_id": 48037,
          "action": "edit_entity",
          "deleted_at": null,
          "additional_data": "{\"entity_name\":{\"id\":48037,\"name\":\"Fredrick Olanya\",\"program_id\":929},\"done_by\":\"Leslie Jobs\",\"old_entity_data\":48037}",
          "created_at": "2024-06-10T13:36:49.000000Z",
          "updated_at": "2024-06-10T13:36:49.000000Z",
          "description": "Recipient <strong>Fredrick Olanya</strong> has been edited"
        },
        {
          "id": 283,
          "client_id": 207,
          "admin_id": 542,
          "donor_id": null,
          "table_name": "entities",
          "record_id": 48036,
          "action": "edit_entity",
          "deleted_at": null,
          "additional_data": "{\"entity_name\":{\"id\":48036,\"name\":\"Kyle Steven\",\"program_id\":929},\"done_by\":\"Leslie Jobs\",\"old_entity_data\":48036}",
          "created_at": "2024-06-10T13:05:46.000000Z",
          "updated_at": "2024-06-10T13:05:46.000000Z",
          "description": "Recipient <strong>Kyle Steven</strong> has been edited"
        },
        {
          "id": 282,
          "client_id": 207,
          "admin_id": 542,
          "donor_id": null,
          "table_name": "entities",
          "record_id": 48034,
          "action": "edit_entity",
          "deleted_at": null,
          "additional_data": "{\"entity_name\":{\"id\":48034,\"name\":\"Tonny Stack 2\",\"program_id\":929},\"done_by\":\"Leslie Jobs\",\"old_entity_data\":48034}",
          "created_at": "2024-06-10T13:02:18.000000Z",
          "updated_at": "2024-06-10T13:02:18.000000Z",
          "description": "Recipient <strong>Tonny Stack 2</strong> has been edited"
        },
        {
          "id": 281,
          "client_id": 207,
          "admin_id": 542,
          "donor_id": null,
          "table_name": "entities",
          "record_id": 48034,
          "action": "edit_entity",
          "deleted_at": null,
          "additional_data": "{\"entity_name\":{\"id\":48034,\"name\":\"Tonny Stack 2\",\"program_id\":929},\"done_by\":\"Leslie Jobs\",\"old_entity_data\":48034}",
          "created_at": "2024-06-10T12:56:22.000000Z",
          "updated_at": "2024-06-10T12:56:22.000000Z",
          "description": "Recipient <strong>Tonny Stack 2</strong> has been edited"
        },
        {
          "id": 280,
          "client_id": 207,
          "admin_id": 542,
          "donor_id": null,
          "table_name": "entities",
          "record_id": 48034,
          "action": "edit_entity",
          "deleted_at": null,
          "additional_data": "{\"entity_name\":{\"id\":48034,\"name\":\"Tonny Stack 2\",\"program_id\":929},\"done_by\":\"Leslie Jobs\",\"old_entity_data\":48034}",
          "created_at": "2024-06-10T12:37:15.000000Z",
          "updated_at": "2024-06-10T12:37:15.000000Z",
          "description": "Recipient <strong>Tonny Stack 2</strong> has been edited"
        },
        {
          "id": 279,
          "client_id": 207,
          "admin_id": 542,
          "donor_id": null,
          "table_name": "entities",
          "record_id": 48034,
          "action": "edit_entity",
          "deleted_at": null,
          "additional_data": "{\"entity_name\":{\"id\":48034,\"name\":\"Tonny Stack 2\",\"program_id\":929},\"done_by\":\"Leslie Jobs\",\"old_entity_data\":48034}",
          "created_at": "2024-06-10T12:31:07.000000Z",
          "updated_at": "2024-06-10T12:31:07.000000Z",
          "description": "Recipient <strong>Tonny Stack 2</strong> has been edited"
        },
        {
          "id": 278,
          "client_id": 207,
          "admin_id": 542,
          "donor_id": null,
          "table_name": "entities",
          "record_id": 48034,
          "action": "edit_entity",
          "deleted_at": null,
          "additional_data": "{\"entity_name\":{\"id\":48034,\"name\":\"Tonny Stack 2\",\"program_id\":929},\"done_by\":\"Leslie Jobs\",\"old_entity_data\":48034}",
          "created_at": "2024-06-10T12:23:07.000000Z",
          "updated_at": "2024-06-10T12:23:07.000000Z",
          "description": "Recipient <strong>Tonny Stack 2</strong> has been edited"
        },
        {
          "id": 277,
          "client_id": 207,
          "admin_id": 542,
          "donor_id": 16043,
          "table_name": "donoremails",
          "record_id": 17612,
          "action": "draft_message",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"Test Sule Cash\",\"entity_name\":\"Estilien Claudensky\",\"subject\":\"Test deleting image\",\"message\":\"<p>body<\\/p><br>\",\"done_by\":\"Leslie Jobs\"}",
          "created_at": "2024-06-10T06:59:26.000000Z",
          "updated_at": "2024-06-10T06:59:26.000000Z",
          "description": "An email from <strong>Estilien Claudensky</strong> to <strong>Test Sule Cash</strong> has been drafted"
        },
        {
          "id": 276,
          "client_id": 207,
          "admin_id": 542,
          "donor_id": 15799,
          "table_name": "donoremails",
          "record_id": 17610,
          "action": "draft_message",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"Test Sarah \",\"entity_name\":\"Emerdjina Charles\",\"subject\":\"Hello\",\"message\":\"<p>Hello<\\/p><br>\\n\\nFile Name: b752c524-9e56-4e65-b145-719ccb161e1c.jpeg\",\"done_by\":\"Leslie Jobs\"}",
          "created_at": "2024-06-06T20:05:57.000000Z",
          "updated_at": "2024-06-06T20:05:57.000000Z",
          "description": "An email from <strong>Emerdjina Charles</strong> to <strong>Test Sarah </strong> has been drafted"
        },
        {
          "id": 275,
          "client_id": 207,
          "admin_id": 542,
          "donor_id": 15799,
          "table_name": "donoremails",
          "record_id": 17609,
          "action": "draft_message",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"Test Sarah \",\"entity_name\":\"Emerdjina Charles\",\"subject\":\"Hello\",\"message\":\"<p>jhsdjf<\\/p><br>\\n\\nFile Name: 41674b23-62aa-4c4f-a956-d7896746998f.HEIC\",\"done_by\":\"Leslie Jobs\"}",
          "created_at": "2024-06-06T19:12:07.000000Z",
          "updated_at": "2024-06-06T19:12:07.000000Z",
          "description": "An email from <strong>Emerdjina Charles</strong> to <strong>Test Sarah </strong> has been drafted"
        },
        {
          "id": 274,
          "client_id": 207,
          "admin_id": 542,
          "donor_id": 15799,
          "table_name": "donoremails",
          "record_id": 17608,
          "action": "draft_message",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"Test Sarah \",\"entity_name\":\"Emerdjina Charles\",\"subject\":\"dfsf\",\"message\":\"<p>fsdfsdf<\\/p><br>\\n\\nFile Name: ed224170-8801-4749-9451-8a7a45bbc9f4.jpeg\",\"done_by\":\"Leslie Jobs\"}",
          "created_at": "2024-06-06T19:10:32.000000Z",
          "updated_at": "2024-06-06T19:10:32.000000Z",
          "description": "An email from <strong>Emerdjina Charles</strong> to <strong>Test Sarah </strong> has been drafted"
        },
        {
          "id": 273,
          "client_id": 207,
          "admin_id": 542,
          "donor_id": 15799,
          "table_name": "donoremails",
          "record_id": 17607,
          "action": "draft_message",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"Test Sarah \",\"entity_name\":\"Emerdjina Charles\",\"subject\":\"Hello\",\"message\":\"<p>Hello<\\/p><br>\\n\\nFile Name: d1206f3a-8cf6-4ce0-bd74-32c2213f84d5.HEIC\",\"done_by\":\"Leslie Jobs\"}",
          "created_at": "2024-06-06T19:04:01.000000Z",
          "updated_at": "2024-06-06T19:04:01.000000Z",
          "description": "An email from <strong>Emerdjina Charles</strong> to <strong>Test Sarah </strong> has been drafted"
        },
        {
          "id": 246,
          "client_id": 207,
          "admin_id": 542,
          "donor_id": 15799,
          "table_name": "donoremails",
          "record_id": 17606,
          "action": "draft_message",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"Test Sarah \",\"entity_name\":\"Emerdjina Charles\",\"subject\":\"Hello\",\"message\":\"<p>Hello<\\/p><br>\",\"done_by\":\"Leslie Jobs\"}",
          "created_at": "2024-06-05T11:29:02.000000Z",
          "updated_at": "2024-06-05T11:29:02.000000Z",
          "description": "An email from <strong>Emerdjina Charles</strong> to <strong>Test Sarah </strong> has been drafted"
        },
        {
          "id": 245,
          "client_id": 207,
          "admin_id": 542,
          "donor_id": 15799,
          "table_name": "commitments",
          "record_id": 22995,
          "action": "restore_commitment",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"Sarahdev2\",\"entity_name\":{\"id\":35915,\"name\":\"Emerdjina Charles\",\"program_id\":929},\"done_by\":\"Leslie Jobs\"}",
          "created_at": "2024-06-04T20:01:07.000000Z",
          "updated_at": "2024-06-04T20:01:07.000000Z",
          "description": "A commitment by <a href=\"/app/view_donor/15799\"><strong>Sarahdev2</strong></a> for <strong>Emerdjina Charles</strong> has been restored"
        },
        {
          "id": 244,
          "client_id": 207,
          "admin_id": 542,
          "donor_id": 16043,
          "table_name": "donoremails",
          "record_id": 17603,
          "action": "approve_draft_message",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"Test Sule Cash\",\"entity_name\":\"Ismylove Jean\",\"subject\":\"test approve\",\"message\":\"<p>test approve<\\/p><br>\",\"done_by\":\"Leslie Jobs\"}",
          "created_at": "2024-05-29T12:44:07.000000Z",
          "updated_at": "2024-05-29T12:44:07.000000Z",
          "description": "An email from <strong>Ismylove Jean</strong> to <strong>Test Sule Cash</strong> has been approved and sent"
        },
        {
          "id": 243,
          "client_id": 207,
          "admin_id": 542,
          "donor_id": 16043,
          "table_name": "donoremails",
          "record_id": 17605,
          "action": "draft_message",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"Test Sule Cash\",\"entity_name\":\"Ismylove Jean\",\"subject\":\"Test\",\"message\":\"<p>Test&nbsp;<\\/p><br>\",\"done_by\":\"Leslie Jobs\"}",
          "created_at": "2024-05-29T12:41:45.000000Z",
          "updated_at": "2024-05-29T12:41:45.000000Z",
          "description": "An email from <strong>Ismylove Jean</strong> to <strong>Test Sule Cash</strong> has been drafted"
        },
        {
          "id": 242,
          "client_id": 207,
          "admin_id": 542,
          "donor_id": 17017,
          "table_name": "donoremails",
          "record_id": 17604,
          "action": "draft_message",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"Test Donor Shaban Paypal, monthly\",\"entity_name\":\"Peterson Jean\",\"subject\":\"test approve\",\"message\":\"<p>test approve<\\/p><br>\",\"done_by\":\"Leslie Jobs\"}",
          "created_at": "2024-05-29T12:30:36.000000Z",
          "updated_at": "2024-05-29T12:30:36.000000Z",
          "description": "An email from <strong>Peterson Jean</strong> to <strong>Test Donor Shaban Paypal, monthly</strong> has been drafted"
        },
        {
          "id": 241,
          "client_id": 207,
          "admin_id": 542,
          "donor_id": null,
          "table_name": "donoremails",
          "record_id": 17603,
          "action": "assign_admin_message",
          "deleted_at": null,
          "additional_data": "{\"admin_name\":\"Leslie Jobs\",\"subject\":\"test approve\",\"message\":\"<p>test approve<\\/p><br>\",\"done_by\":\"Leslie Jobs\"}",
          "created_at": "2024-05-29T12:28:38.000000Z",
          "updated_at": "2024-05-29T12:28:38.000000Z",
          "description": "An email has been assigned to <strong>Leslie Jobs</strong>"
        },
        {
          "id": 240,
          "client_id": 207,
          "admin_id": 542,
          "donor_id": 16043,
          "table_name": "donoremails",
          "record_id": 17603,
          "action": "draft_message",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"Test Sule Cash\",\"entity_name\":\"Ismylove Jean\",\"subject\":\"test approve\",\"message\":\"<p>test approve<\\/p><br>\",\"done_by\":\"Leslie Jobs\"}",
          "created_at": "2024-05-29T12:27:51.000000Z",
          "updated_at": "2024-05-29T12:27:51.000000Z",
          "description": "An email from <strong>Ismylove Jean</strong> to <strong>Test Sule Cash</strong> has been drafted"
        },
        {
          "id": 239,
          "client_id": 207,
          "admin_id": 542,
          "donor_id": 17017,
          "table_name": "donoremails",
          "record_id": 17601,
          "action": "draft_message",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"Test Donor Shaban Paypal, monthly\",\"entity_name\":\"Peterson Jean\",\"subject\":\"Test Draft\",\"message\":\"<p>Test Draft<\\/p><br>\",\"done_by\":\"Leslie Jobs\"}",
          "created_at": "2024-05-28T18:52:03.000000Z",
          "updated_at": "2024-05-28T18:52:03.000000Z",
          "description": "An email from <strong>Peterson Jean</strong> to <strong>Test Donor Shaban Paypal, monthly</strong> has been drafted"
        },
        {
          "id": 238,
          "client_id": 207,
          "admin_id": null,
          "donor_id": 17017,
          "table_name": "donoremails",
          "record_id": 17600,
          "action": "donor_message_send",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"Test Donor Shaban Paypal, monthly\",\"entity_name\":\"Peterson Jean\",\"subject\":\"Re: Test Attachment\",\"message\":\"<p>Test Attachment<\\/p>\\n\\nFile Name: efd62c1a-0917-4938-bd73-6bc40fd7aeae.png\",\"done_by\":\"Test Donor Shaban Paypal, monthly\"}",
          "created_at": "2024-05-28T18:48:29.000000Z",
          "updated_at": "2024-05-28T18:48:29.000000Z",
          "description": "An email from <strong>Test Donor Shaban Paypal, monthly</strong> to <strong>Peterson Jean</strong> has been sent"
        },
        {
          "id": 236,
          "client_id": 207,
          "admin_id": 542,
          "donor_id": 17017,
          "table_name": "donoremails",
          "record_id": 17599,
          "action": "draft_message",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"Test Donor Shaban Paypal, monthly\",\"entity_name\":\"Peterson Jean\",\"subject\":\"Test Attachment\",\"message\":\"<p>Test Attachment<\\/p><br>\\n\\nFile Name: b1259e7c-e695-46f2-8978-aeccb3c316fd.png\",\"done_by\":\"Leslie Jobs\"}",
          "created_at": "2024-05-28T18:44:26.000000Z",
          "updated_at": "2024-05-28T18:44:26.000000Z",
          "description": "An email from <strong>Peterson Jean</strong> to <strong>Test Donor Shaban Paypal, monthly</strong> has been drafted"
        },
        {
          "id": 237,
          "client_id": 207,
          "admin_id": 542,
          "donor_id": 17017,
          "table_name": "donoremails",
          "record_id": 17599,
          "action": "send_message",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"Test Donor Shaban Paypal, monthly\",\"entity_name\":\"Peterson Jean\",\"subject\":\"Test Attachment\",\"message\":\"<p>Test Attachment<\\/p><br>\\n\\nFile Name: b1259e7c-e695-46f2-8978-aeccb3c316fd.png\",\"done_by\":\"Leslie Jobs\"}",
          "created_at": "2024-05-28T18:44:26.000000Z",
          "updated_at": "2024-05-28T18:44:26.000000Z",
          "description": "An email from <strong>Peterson Jean</strong> to <strong>Test Donor Shaban Paypal, monthly</strong> has been sent"
        },
        {
          "id": 235,
          "client_id": 207,
          "admin_id": 542,
          "donor_id": 16043,
          "table_name": "donoremails",
          "record_id": 17598,
          "action": "draft_message",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"Test Sule Cash\",\"entity_name\":\"Estilien Claudensky\",\"subject\":\"test draft\",\"message\":\"<p>test draft<\\/p><br>\",\"done_by\":\"Leslie Jobs\"}",
          "created_at": "2024-05-28T18:40:02.000000Z",
          "updated_at": "2024-05-28T18:40:02.000000Z",
          "description": "An email from <strong>Estilien Claudensky</strong> to <strong>Test Sule Cash</strong> has been drafted"
        },
        {
          "id": 234,
          "client_id": 207,
          "admin_id": 542,
          "donor_id": null,
          "table_name": "entities",
          "record_id": 35915,
          "action": "edit_entity",
          "deleted_at": null,
          "additional_data": "{\"entity_name\":{\"id\":35915,\"name\":\"Emerdjina Charles\",\"program_id\":929},\"done_by\":\"Leslie Jobs\",\"old_entity_data\":{\"id\":35915,\"client_id\":207,\"program_id\":929,\"status\":\"0\",\"re_add\":null,\"sp_amount\":\"32\",\"sp_num\":\"2\",\"wait_time\":\"2024-05-20\",\"json_fields\":\"{\\\"en_child_name\\\":\\\"Emerdjina Charles\\\",\\\"en_gender\\\":\\\"Male\\\",\\\"en_grade\\\":\\\"4\\\",\\\"en_age\\\":\\\"\\\",\\\"en_birthdate\\\":\\\"2023-03-11\\\",\\\"en_favorite_subject\\\":\\\"Mathematics\\\",\\\"en_test_check_box\\\":\\\"\\\\\\\"[\\\\\\\\\\\\\\\"no\\\\\\\\\\\\\\\"]\\\\\\\"\\\",\\\"en_test_field_boolea\\\":\\\"yes\\\",\\\"en_test_checkbox_2\\\":\\\"\\\\\\\"[\\\\\\\\\\\\\\\"maybe\\\\\\\\\\\\\\\"]\\\\\\\"\\\",\\\"id\\\":\\\"35915\\\",\\\"client_id\\\":\\\"207\\\",\\\"program_id\\\":\\\"929\\\",\\\"status\\\":\\\"0\\\",\\\"re_add\\\":\\\"\\\",\\\"wait_time\\\":\\\"2024-05-20\\\",\\\"json_fields\\\":\\\"{\\\\\\\"en_child_name\\\\\\\":\\\\\\\"Emerdjina Charles\\\\\\\",\\\\\\\"en_gender\\\\\\\":\\\\\\\"Female\\\\\\\",\\\\\\\"en_grade\\\\\\\":\\\\\\\"4\\\\\\\",\\\\\\\"en_age\\\\\\\":\\\\\\\"\\\\\\\",\\\\\\\"en_birthdate\\\\\\\":\\\\\\\"2023-03-11\\\\\\\",\\\\\\\"en_favorite_subject\\\\\\\":\\\\\\\"Mathematics\\\\\\\",\\\\\\\"en_test_check_box\\\\\\\":\\\\\\\"[\\\\\\\\\\\\\\\"no\\\\\\\\\\\\\\\"]\\\\\\\",\\\\\\\"en_test_field_boolea\\\\\\\":\\\\\\\"yes\\\\\\\",\\\\\\\"en_test_checkbox_2\\\\\\\":\\\\\\\"[\\\\\\\\\\\\\\\"maybe\\\\\\\\\\\\\\\"]\\\\\\\",\\\\\\\"client_id\\\\\\\":\\\\\\\"207\\\\\\\",\\\\\\\"entity_id\\\\\\\":\\\\\\\"35915\\\\\\\"}\\\",\\\"deleted_at\\\":\\\"\\\",\\\"created_at\\\":\\\"2018-08-19T17:40:04.000000Z\\\",\\\"updated_at\\\":\\\"2024-05-24T09:18:12.000000Z\\\",\\\"__hevo__database_name\\\":\\\"apphys_new\\\",\\\"__hevo__ingested_at\\\":\\\"1679725261350\\\",\\\"__hevo__marked_deleted\\\":\\\"0\\\",\\\"__hevo__source_modified_at\\\":\\\"\\\",\\\"entity_id\\\":\\\"35915\\\"}\",\"deleted_at\":null,\"created_at\":\"2018-08-19T17:40:04.000000Z\",\"updated_at\":\"2024-05-24T09:28:58.000000Z\",\"__hevo__database_name\":\"apphys_new\",\"__hevo__ingested_at\":1679725261350,\"__hevo__marked_deleted\":0,\"__hevo__source_modified_at\":null}}",
          "created_at": "2024-05-24T09:32:56.000000Z",
          "updated_at": "2024-05-24T09:32:56.000000Z",
          "description": "Recipient <strong>Emerdjina Charles</strong> has been edited"
        },
        {
          "id": 233,
          "client_id": 207,
          "admin_id": 542,
          "donor_id": null,
          "table_name": "entities",
          "record_id": 35915,
          "action": "edit_entity",
          "deleted_at": null,
          "additional_data": "{\"entity_name\":{\"id\":35915,\"name\":\"Emerdjina Charles\",\"program_id\":929},\"done_by\":\"Leslie Jobs\",\"old_entity_data\":{\"id\":35915,\"client_id\":207,\"program_id\":929,\"status\":\"0\",\"re_add\":null,\"sp_amount\":\"32\",\"sp_num\":\"2\",\"wait_time\":\"2024-05-20\",\"json_fields\":\"{\\\"en_child_name\\\":\\\"Emerdjina Charles\\\",\\\"en_gender\\\":\\\"Female\\\",\\\"en_grade\\\":\\\"4\\\",\\\"en_age\\\":\\\"\\\",\\\"en_birthdate\\\":\\\"2023-03-11\\\",\\\"en_favorite_subject\\\":\\\"Mathematics\\\",\\\"en_test_check_box\\\":\\\"[\\\\\\\"no\\\\\\\"]\\\",\\\"en_test_field_boolea\\\":\\\"yes\\\",\\\"en_test_checkbox_2\\\":\\\"[\\\\\\\"maybe\\\\\\\"]\\\",\\\"client_id\\\":\\\"207\\\",\\\"entity_id\\\":\\\"35915\\\"}\",\"deleted_at\":null,\"created_at\":\"2018-08-19T17:40:04.000000Z\",\"updated_at\":\"2024-05-24T09:18:12.000000Z\",\"__hevo__database_name\":\"apphys_new\",\"__hevo__ingested_at\":1679725261350,\"__hevo__marked_deleted\":0,\"__hevo__source_modified_at\":null}}",
          "created_at": "2024-05-24T09:28:58.000000Z",
          "updated_at": "2024-05-24T09:28:58.000000Z",
          "description": "Recipient <strong>Emerdjina Charles</strong> has been edited"
        },
        {
          "id": 232,
          "client_id": 207,
          "admin_id": 542,
          "donor_id": null,
          "table_name": "entities",
          "record_id": 35915,
          "action": "restore_entity",
          "deleted_at": null,
          "additional_data": "{\"entity_name\":{\"id\":\"35915\",\"name\":\"Emerdjina Charles\",\"program_id\":929},\"done_by\":\"Leslie Jobs\"}",
          "created_at": "2024-05-24T09:18:12.000000Z",
          "updated_at": "2024-05-24T09:18:12.000000Z",
          "description": "Recipient <strong>Emerdjina Charles</strong> has been restored"
        },
        {
          "id": 231,
          "client_id": 207,
          "admin_id": 542,
          "donor_id": null,
          "table_name": "entities",
          "record_id": 35915,
          "action": "archive_entity",
          "deleted_at": null,
          "additional_data": "{\"entity_name\":{\"id\":\"35915\",\"name\":\"Emerdjina Charles\",\"program_id\":929},\"done_by\":\"Leslie Jobs\"}",
          "created_at": "2024-05-24T09:17:47.000000Z",
          "updated_at": "2024-05-24T09:17:47.000000Z",
          "description": "Recipient <strong>Emerdjina Charles</strong> has been archived"
        },
        {
          "id": 230,
          "client_id": 207,
          "admin_id": null,
          "donor_id": 17017,
          "table_name": "donoremails",
          "record_id": 17597,
          "action": "donor_message_send",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"Test Donor Shaban Paypal, monthly\",\"entity_name\":\"Mayson Pierre\",\"subject\":\"Re: pierre message\",\"message\":\"<p>thanks<\\/p>\",\"done_by\":\"Test Donor Shaban Paypal, monthly\"}",
          "created_at": "2024-05-21T05:28:22.000000Z",
          "updated_at": "2024-05-21T05:28:22.000000Z",
          "description": "An email from <strong>Test Donor Shaban Paypal, monthly</strong> to <strong>Mayson Pierre</strong> has been sent"
        },
        {
          "id": 229,
          "client_id": 207,
          "admin_id": null,
          "donor_id": 17017,
          "table_name": "donoremails",
          "record_id": 17596,
          "action": "donor_message_send",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"Test Donor Shaban Paypal, monthly\",\"entity_name\":\"Mayson Pierre\",\"subject\":\"Re: pierre message\",\"message\":\"<p>is life good<\\/p>\",\"done_by\":\"Test Donor Shaban Paypal, monthly\"}",
          "created_at": "2024-05-21T05:28:03.000000Z",
          "updated_at": "2024-05-21T05:28:03.000000Z",
          "description": "An email from <strong>Test Donor Shaban Paypal, monthly</strong> to <strong>Mayson Pierre</strong> has been sent"
        },
        {
          "id": 228,
          "client_id": 207,
          "admin_id": null,
          "donor_id": 17017,
          "table_name": "donoremails",
          "record_id": 17595,
          "action": "donor_message_send",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"Test Donor Shaban Paypal, monthly\",\"entity_name\":\"Mayson Pierre\",\"subject\":\"Re: pierre message\",\"message\":\"<p>is life okay<\\/p>\",\"done_by\":\"Test Donor Shaban Paypal, monthly\"}",
          "created_at": "2024-05-21T05:27:36.000000Z",
          "updated_at": "2024-05-21T05:27:36.000000Z",
          "description": "An email from <strong>Test Donor Shaban Paypal, monthly</strong> to <strong>Mayson Pierre</strong> has been sent"
        },
        {
          "id": 226,
          "client_id": 207,
          "admin_id": 542,
          "donor_id": 26092,
          "table_name": "donoremails",
          "record_id": 17594,
          "action": "draft_message",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"Diama Magic\",\"entity_name\":\"Ismylove Jean\",\"subject\":\"Hows the weather\",\"message\":\"<p>Hows the weather<\\/p><br>\",\"done_by\":\"Leslie Jobs\"}",
          "created_at": "2024-05-21T05:27:16.000000Z",
          "updated_at": "2024-05-21T05:27:16.000000Z",
          "description": "An email from <strong>Ismylove Jean</strong> to <strong>Diama Magic</strong> has been drafted"
        },
        {
          "id": 227,
          "client_id": 207,
          "admin_id": 542,
          "donor_id": 26092,
          "table_name": "donoremails",
          "record_id": 17594,
          "action": "send_message",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"Diama Magic\",\"entity_name\":\"Ismylove Jean\",\"subject\":\"Hows the weather\",\"message\":\"<p>Hows the weather<\\/p><br>\",\"done_by\":\"Leslie Jobs\"}",
          "created_at": "2024-05-21T05:27:16.000000Z",
          "updated_at": "2024-05-21T05:27:16.000000Z",
          "description": "An email from <strong>Ismylove Jean</strong> to <strong>Diama Magic</strong> has been sent"
        },
        {
          "id": 224,
          "client_id": 207,
          "admin_id": 542,
          "donor_id": 16043,
          "table_name": "donoremails",
          "record_id": 17592,
          "action": "draft_message",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"Test Sule Cash\",\"entity_name\":\"Ismylove Jean\",\"subject\":\"Testing alert\",\"message\":\"<p>Testing Alert<\\/p><br>\",\"done_by\":\"Leslie Jobs\"}",
          "created_at": "2024-05-21T05:15:58.000000Z",
          "updated_at": "2024-05-21T05:15:58.000000Z",
          "description": "An email from <strong>Ismylove Jean</strong> to <strong>Test Sule Cash</strong> has been drafted"
        },
        {
          "id": 225,
          "client_id": 207,
          "admin_id": 542,
          "donor_id": 16043,
          "table_name": "donoremails",
          "record_id": 17592,
          "action": "send_message",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"Test Sule Cash\",\"entity_name\":\"Ismylove Jean\",\"subject\":\"Testing alert\",\"message\":\"<p>Testing Alert<\\/p><br>\",\"done_by\":\"Leslie Jobs\"}",
          "created_at": "2024-05-21T05:15:58.000000Z",
          "updated_at": "2024-05-21T05:15:58.000000Z",
          "description": "An email from <strong>Ismylove Jean</strong> to <strong>Test Sule Cash</strong> has been sent"
        },
        {
          "id": 223,
          "client_id": 207,
          "admin_id": null,
          "donor_id": 17017,
          "table_name": "donoremails",
          "record_id": 17591,
          "action": "donor_message_send",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"Test Donor Shaban Paypal, monthly\",\"entity_name\":\"Mayson Pierre\",\"subject\":\"Re: pierre message\",\"message\":\"<p>How is grade 5<\\/p>\",\"done_by\":\"Test Donor Shaban Paypal, monthly\"}",
          "created_at": "2024-05-21T05:15:30.000000Z",
          "updated_at": "2024-05-21T05:15:30.000000Z",
          "description": "An email from <strong>Test Donor Shaban Paypal, monthly</strong> to <strong>Mayson Pierre</strong> has been sent"
        },
        {
          "id": 222,
          "client_id": 207,
          "admin_id": null,
          "donor_id": 17017,
          "table_name": "donoremails",
          "record_id": 17590,
          "action": "donor_message_send",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"Test Donor Shaban Paypal, monthly\",\"entity_name\":\"Mayson Pierre\",\"subject\":\"Re: pierre message\",\"message\":\"<p>hows school<\\/p>\",\"done_by\":\"Test Donor Shaban Paypal, monthly\"}",
          "created_at": "2024-05-21T05:13:49.000000Z",
          "updated_at": "2024-05-21T05:13:49.000000Z",
          "description": "An email from <strong>Test Donor Shaban Paypal, monthly</strong> to <strong>Mayson Pierre</strong> has been sent"
        },
        {
          "id": 220,
          "client_id": 207,
          "admin_id": 542,
          "donor_id": 16043,
          "table_name": "donoremails",
          "record_id": 17589,
          "action": "draft_message",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"Test Sule Cash\",\"entity_name\":\"Estilien Claudensky\",\"subject\":\"Okay\",\"message\":\"<p>Okay<\\/p><br>\",\"done_by\":\"Leslie Jobs\"}",
          "created_at": "2024-05-21T05:13:14.000000Z",
          "updated_at": "2024-05-21T05:13:14.000000Z",
          "description": "An email from <strong>Estilien Claudensky</strong> to <strong>Test Sule Cash</strong> has been drafted"
        },
        {
          "id": 221,
          "client_id": 207,
          "admin_id": 542,
          "donor_id": 16043,
          "table_name": "donoremails",
          "record_id": 17589,
          "action": "send_message",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"Test Sule Cash\",\"entity_name\":\"Estilien Claudensky\",\"subject\":\"Okay\",\"message\":\"<p>Okay<\\/p><br>\",\"done_by\":\"Leslie Jobs\"}",
          "created_at": "2024-05-21T05:13:14.000000Z",
          "updated_at": "2024-05-21T05:13:14.000000Z",
          "description": "An email from <strong>Estilien Claudensky</strong> to <strong>Test Sule Cash</strong> has been sent"
        },
        {
          "id": 219,
          "client_id": 207,
          "admin_id": null,
          "donor_id": 17017,
          "table_name": "donoremails",
          "record_id": 17587,
          "action": "donor_message_send",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"Test Donor Shaban Paypal, monthly\",\"entity_name\":\"Mayson Pierre\",\"subject\":\"pierre message\",\"message\":\"<p>pierre message<\\/p>\",\"done_by\":\"Test Donor Shaban Paypal, monthly\"}",
          "created_at": "2024-05-21T05:11:36.000000Z",
          "updated_at": "2024-05-21T05:11:36.000000Z",
          "description": "An email from <strong>Test Donor Shaban Paypal, monthly</strong> to <strong>Mayson Pierre</strong> has been sent"
        },
        {
          "id": 218,
          "client_id": 207,
          "admin_id": null,
          "donor_id": 17017,
          "table_name": "donoremails",
          "record_id": 17586,
          "action": "donor_message_send",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"Test Donor Shaban Paypal, monthly\",\"entity_name\":\"Echelanda Jean-Baptiste\",\"subject\":\"Re: new message\",\"message\":\"<p>2<\\/p>\",\"done_by\":\"Test Donor Shaban Paypal, monthly\"}",
          "created_at": "2024-05-21T05:11:11.000000Z",
          "updated_at": "2024-05-21T05:11:11.000000Z",
          "description": "An email from <strong>Test Donor Shaban Paypal, monthly</strong> to <strong>Echelanda Jean-Baptiste</strong> has been sent"
        },
        {
          "id": 217,
          "client_id": 207,
          "admin_id": null,
          "donor_id": 17017,
          "table_name": "donoremails",
          "record_id": 17585,
          "action": "donor_message_send",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"Test Donor Shaban Paypal, monthly\",\"entity_name\":\"Echelanda Jean-Baptiste\",\"subject\":\"new message\",\"message\":\"<p>new message<\\/p>\",\"done_by\":\"Test Donor Shaban Paypal, monthly\"}",
          "created_at": "2024-05-21T05:10:49.000000Z",
          "updated_at": "2024-05-21T05:10:49.000000Z",
          "description": "An email from <strong>Test Donor Shaban Paypal, monthly</strong> to <strong>Echelanda Jean-Baptiste</strong> has been sent"
        },
        {
          "id": 216,
          "client_id": 207,
          "admin_id": null,
          "donor_id": 17017,
          "table_name": "donoremails",
          "record_id": 17584,
          "action": "donor_message_send",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"Test Donor Shaban Paypal, monthly\",\"entity_name\":\"Sophia Saint-Louis\",\"subject\":\"david has started school\",\"message\":\"<p>david has started school<\\/p>\",\"done_by\":\"Test Donor Shaban Paypal, monthly\"}",
          "created_at": "2024-05-21T05:09:56.000000Z",
          "updated_at": "2024-05-21T05:09:56.000000Z",
          "description": "An email from <strong>Test Donor Shaban Paypal, monthly</strong> to <strong>Sophia Saint-Louis</strong> has been sent"
        },
        {
          "id": 215,
          "client_id": 207,
          "admin_id": null,
          "donor_id": 17017,
          "table_name": "donoremails",
          "record_id": 17583,
          "action": "donor_message_send",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"Test Donor Shaban Paypal, monthly\",\"entity_name\":\"Isedervensley Saint-Julles\",\"subject\":\"Re: 23\",\"message\":\"<p>47<\\/p>\",\"done_by\":\"Test Donor Shaban Paypal, monthly\"}",
          "created_at": "2024-05-21T05:09:13.000000Z",
          "updated_at": "2024-05-21T05:09:13.000000Z",
          "description": "An email from <strong>Test Donor Shaban Paypal, monthly</strong> to <strong>Isedervensley Saint-Julles</strong> has been sent"
        },
        {
          "id": 214,
          "client_id": 207,
          "admin_id": null,
          "donor_id": 17017,
          "table_name": "donoremails",
          "record_id": 17582,
          "action": "donor_message_send",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"Test Donor Shaban Paypal, monthly\",\"entity_name\":\"Isedervensley Saint-Julles\",\"subject\":\"Re: 23\",\"message\":\"<p>45<\\/p>\",\"done_by\":\"Test Donor Shaban Paypal, monthly\"}",
          "created_at": "2024-05-21T05:08:50.000000Z",
          "updated_at": "2024-05-21T05:08:50.000000Z",
          "description": "An email from <strong>Test Donor Shaban Paypal, monthly</strong> to <strong>Isedervensley Saint-Julles</strong> has been sent"
        },
        {
          "id": 213,
          "client_id": 207,
          "admin_id": null,
          "donor_id": 17017,
          "table_name": "donoremails",
          "record_id": 17581,
          "action": "donor_message_send",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"Test Donor Shaban Paypal, monthly\",\"entity_name\":\"Isedervensley Saint-Julles\",\"subject\":\"Re: 23\",\"message\":\"<p>25<\\/p>\",\"done_by\":\"Test Donor Shaban Paypal, monthly\"}",
          "created_at": "2024-05-21T05:08:30.000000Z",
          "updated_at": "2024-05-21T05:08:30.000000Z",
          "description": "An email from <strong>Test Donor Shaban Paypal, monthly</strong> to <strong>Isedervensley Saint-Julles</strong> has been sent"
        },
        {
          "id": 212,
          "client_id": 207,
          "admin_id": null,
          "donor_id": 17017,
          "table_name": "donoremails",
          "record_id": 17580,
          "action": "donor_message_send",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"Test Donor Shaban Paypal, monthly\",\"entity_name\":\"Isedervensley Saint-Julles\",\"subject\":\"Re: 23\",\"message\":\"<p>24<\\/p>\",\"done_by\":\"Test Donor Shaban Paypal, monthly\"}",
          "created_at": "2024-05-21T05:08:10.000000Z",
          "updated_at": "2024-05-21T05:08:10.000000Z",
          "description": "An email from <strong>Test Donor Shaban Paypal, monthly</strong> to <strong>Isedervensley Saint-Julles</strong> has been sent"
        },
        {
          "id": 211,
          "client_id": 207,
          "admin_id": null,
          "donor_id": 17017,
          "table_name": "donoremails",
          "record_id": 17579,
          "action": "donor_message_send",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"Test Donor Shaban Paypal, monthly\",\"entity_name\":\"Isedervensley Saint-Julles\",\"subject\":\"23\",\"message\":\"<p>23<\\/p>\",\"done_by\":\"Test Donor Shaban Paypal, monthly\"}",
          "created_at": "2024-05-21T05:05:35.000000Z",
          "updated_at": "2024-05-21T05:05:35.000000Z",
          "description": "An email from <strong>Test Donor Shaban Paypal, monthly</strong> to <strong>Isedervensley Saint-Julles</strong> has been sent"
        },
        {
          "id": 210,
          "client_id": 207,
          "admin_id": null,
          "donor_id": 17017,
          "table_name": "donoremails",
          "record_id": 17578,
          "action": "donor_message_send",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"Test Donor Shaban Paypal, monthly\",\"entity_name\":\"Isedervensley Saint-Julles\",\"subject\":\"22\",\"message\":\"<p>22<\\/p>\",\"done_by\":\"Test Donor Shaban Paypal, monthly\"}",
          "created_at": "2024-05-21T05:04:56.000000Z",
          "updated_at": "2024-05-21T05:04:56.000000Z",
          "description": "An email from <strong>Test Donor Shaban Paypal, monthly</strong> to <strong>Isedervensley Saint-Julles</strong> has been sent"
        },
        {
          "id": 209,
          "client_id": 207,
          "admin_id": null,
          "donor_id": 17017,
          "table_name": "donoremails",
          "record_id": 17577,
          "action": "donor_message_send",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"Test Donor Shaban Paypal, monthly\",\"entity_name\":\"Isedervensley Saint-Julles\",\"subject\":\"21st message\",\"message\":\"<p>21st message<\\/p>\",\"done_by\":\"Test Donor Shaban Paypal, monthly\"}",
          "created_at": "2024-05-21T05:04:26.000000Z",
          "updated_at": "2024-05-21T05:04:26.000000Z",
          "description": "An email from <strong>Test Donor Shaban Paypal, monthly</strong> to <strong>Isedervensley Saint-Julles</strong> has been sent"
        },
        {
          "id": 208,
          "client_id": 207,
          "admin_id": null,
          "donor_id": 17017,
          "table_name": "donoremails",
          "record_id": 17576,
          "action": "donor_message_send",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"Test Donor Shaban Paypal, monthly\",\"entity_name\":\"Sophia Saint-Louis\",\"subject\":\"Greetings\",\"message\":\"<p>Greetings<\\/p>\",\"done_by\":\"Test Donor Shaban Paypal, monthly\"}",
          "created_at": "2024-05-20T19:54:21.000000Z",
          "updated_at": "2024-05-20T19:54:21.000000Z",
          "description": "An email from <strong>Test Donor Shaban Paypal, monthly</strong> to <strong>Sophia Saint-Louis</strong> has been sent"
        },
        {
          "id": 207,
          "client_id": 207,
          "admin_id": null,
          "donor_id": 17017,
          "table_name": "donoremails",
          "record_id": 17575,
          "action": "donor_message_send",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"Test Donor Shaban Paypal, monthly\",\"entity_name\":\"Malache Basquin\",\"subject\":\"Re: Greetings\",\"message\":\"<p>Greetings 3<\\/p>\",\"done_by\":\"Test Donor Shaban Paypal, monthly\"}",
          "created_at": "2024-05-20T19:53:43.000000Z",
          "updated_at": "2024-05-20T19:53:43.000000Z",
          "description": "An email from <strong>Test Donor Shaban Paypal, monthly</strong> to <strong>Malache Basquin</strong> has been sent"
        },
        {
          "id": 206,
          "client_id": 207,
          "admin_id": null,
          "donor_id": 17017,
          "table_name": "donoremails",
          "record_id": 17574,
          "action": "donor_message_send",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"Test Donor Shaban Paypal, monthly\",\"entity_name\":\"Malache Basquin\",\"subject\":\"Re: Greetings\",\"message\":\"<p>Greetings 2<\\/p>\",\"done_by\":\"Test Donor Shaban Paypal, monthly\"}",
          "created_at": "2024-05-20T19:52:59.000000Z",
          "updated_at": "2024-05-20T19:52:59.000000Z",
          "description": "An email from <strong>Test Donor Shaban Paypal, monthly</strong> to <strong>Malache Basquin</strong> has been sent"
        },
        {
          "id": 205,
          "client_id": 207,
          "admin_id": null,
          "donor_id": 17017,
          "table_name": "donoremails",
          "record_id": 17573,
          "action": "donor_message_send",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"Test Donor Shaban Paypal, monthly\",\"entity_name\":\"Malache Basquin\",\"subject\":\"Greetings\",\"message\":\"<p>Greetings<\\/p>\",\"done_by\":\"Test Donor Shaban Paypal, monthly\"}",
          "created_at": "2024-05-20T19:41:49.000000Z",
          "updated_at": "2024-05-20T19:41:49.000000Z",
          "description": "An email from <strong>Test Donor Shaban Paypal, monthly</strong> to <strong>Malache Basquin</strong> has been sent"
        },
        {
          "id": 203,
          "client_id": 207,
          "admin_id": 542,
          "donor_id": 17017,
          "table_name": "donoremails",
          "record_id": 17571,
          "action": "draft_message",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"Test Donor Shaban Paypal, monthly\",\"entity_name\":\"Isedervensley Saint-Julles\",\"subject\":\"photo\",\"message\":\"<p>photo moments<\\/p><br>\\n\\nFile Name: 295886fa-ff8f-4c8d-872c-f6c996dde709.png\",\"done_by\":\"Leslie Jobs\"}",
          "created_at": "2024-05-20T14:37:08.000000Z",
          "updated_at": "2024-05-20T14:37:08.000000Z",
          "description": "An email from <strong>Isedervensley Saint-Julles</strong> to <strong>Test Donor Shaban Paypal, monthly</strong> has been drafted"
        },
        {
          "id": 204,
          "client_id": 207,
          "admin_id": 542,
          "donor_id": 17017,
          "table_name": "donoremails",
          "record_id": 17571,
          "action": "send_message",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"Test Donor Shaban Paypal, monthly\",\"entity_name\":\"Isedervensley Saint-Julles\",\"subject\":\"photo\",\"message\":\"<p>photo moments<\\/p><br>\\n\\nFile Name: 295886fa-ff8f-4c8d-872c-f6c996dde709.png\",\"done_by\":\"Leslie Jobs\"}",
          "created_at": "2024-05-20T14:37:08.000000Z",
          "updated_at": "2024-05-20T14:37:08.000000Z",
          "description": "An email from <strong>Isedervensley Saint-Julles</strong> to <strong>Test Donor Shaban Paypal, monthly</strong> has been sent"
        },
        {
          "id": 202,
          "client_id": 207,
          "admin_id": null,
          "donor_id": 17017,
          "table_name": "donoremails",
          "record_id": 17570,
          "action": "donor_message_send",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"Test Donor Shaban Paypal, monthly\",\"entity_name\":\"Jonalis Jude-Na\\u00edca\",\"subject\":\"Re: Greetings\",\"message\":\"<p>Any plans today<\\/p>\",\"done_by\":\"Test Donor Shaban Paypal, monthly\"}",
          "created_at": "2024-05-20T09:45:23.000000Z",
          "updated_at": "2024-05-20T09:45:23.000000Z",
          "description": "An email from <strong>Test Donor Shaban Paypal, monthly</strong> to <strong>Jonalis Jude-Na\u00edca</strong> has been sent"
        },
        {
          "id": 201,
          "client_id": 207,
          "admin_id": null,
          "donor_id": 17017,
          "table_name": "donoremails",
          "record_id": 17569,
          "action": "donor_message_send",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"Test Donor Shaban Paypal, monthly\",\"entity_name\":\"Jonalis Jude-Na\\u00edca\",\"subject\":\"Re: Greetings\",\"message\":\"<p>Greetings again<\\/p>\",\"done_by\":\"Test Donor Shaban Paypal, monthly\"}",
          "created_at": "2024-05-20T09:37:29.000000Z",
          "updated_at": "2024-05-20T09:37:29.000000Z",
          "description": "An email from <strong>Test Donor Shaban Paypal, monthly</strong> to <strong>Jonalis Jude-Na\u00edca</strong> has been sent"
        },
        {
          "id": 200,
          "client_id": 207,
          "admin_id": null,
          "donor_id": 17017,
          "table_name": "donoremails",
          "record_id": 17568,
          "action": "donor_message_send",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"Test Donor Shaban Paypal, monthly\",\"entity_name\":\"Jonalis Jude-Na\\u00edca\",\"subject\":\"Greetings\",\"message\":\"<p>Greetings<\\/p>\",\"done_by\":\"Test Donor Shaban Paypal, monthly\"}",
          "created_at": "2024-05-20T09:33:29.000000Z",
          "updated_at": "2024-05-20T09:33:29.000000Z",
          "description": "An email from <strong>Test Donor Shaban Paypal, monthly</strong> to <strong>Jonalis Jude-Na\u00edca</strong> has been sent"
        },
        {
          "id": 199,
          "client_id": 207,
          "admin_id": null,
          "donor_id": 17017,
          "table_name": "donoremails",
          "record_id": 17567,
          "action": "donor_message_send",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"Test Donor Shaban Paypal, monthly\",\"entity_name\":\"Peterson Jean\",\"subject\":\"Re: 20th checkin\",\"message\":\"<p>today is a holiday<\\/p>\",\"done_by\":\"Test Donor Shaban Paypal, monthly\"}",
          "created_at": "2024-05-20T09:32:26.000000Z",
          "updated_at": "2024-05-20T09:32:26.000000Z",
          "description": "An email from <strong>Test Donor Shaban Paypal, monthly</strong> to <strong>Peterson Jean</strong> has been sent"
        },
        {
          "id": 198,
          "client_id": 207,
          "admin_id": null,
          "donor_id": 17017,
          "table_name": "donoremails",
          "record_id": 17566,
          "action": "donor_message_send",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"Test Donor Shaban Paypal, monthly\",\"entity_name\":\"Peterson Jean\",\"subject\":\"Re: 20th checkin\",\"message\":\"<p>How are you <\\/p>\",\"done_by\":\"Test Donor Shaban Paypal, monthly\"}",
          "created_at": "2024-05-20T09:28:54.000000Z",
          "updated_at": "2024-05-20T09:28:54.000000Z",
          "description": "An email from <strong>Test Donor Shaban Paypal, monthly</strong> to <strong>Peterson Jean</strong> has been sent"
        },
        {
          "id": 197,
          "client_id": 207,
          "admin_id": null,
          "donor_id": 17017,
          "table_name": "donoremails",
          "record_id": 17565,
          "action": "donor_message_send",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"Test Donor Shaban Paypal, monthly\",\"entity_name\":\"Peterson Jean\",\"subject\":\"Re: 20th checkin\",\"message\":\"<p>AND EGGS<\\/p>\",\"done_by\":\"Test Donor Shaban Paypal, monthly\"}",
          "created_at": "2024-05-20T09:27:28.000000Z",
          "updated_at": "2024-05-20T09:27:28.000000Z",
          "description": "An email from <strong>Test Donor Shaban Paypal, monthly</strong> to <strong>Peterson Jean</strong> has been sent"
        },
        {
          "id": 196,
          "client_id": 207,
          "admin_id": null,
          "donor_id": 17017,
          "table_name": "donoremails",
          "record_id": 17564,
          "action": "donor_message_send",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"Test Donor Shaban Paypal, monthly\",\"entity_name\":\"Peterson Jean\",\"subject\":\"Re: 20th checkin\",\"message\":\"<p>We ate fries<\\/p>\",\"done_by\":\"Test Donor Shaban Paypal, monthly\"}",
          "created_at": "2024-05-20T09:25:44.000000Z",
          "updated_at": "2024-05-20T09:25:44.000000Z",
          "description": "An email from <strong>Test Donor Shaban Paypal, monthly</strong> to <strong>Peterson Jean</strong> has been sent"
        },
        {
          "id": 195,
          "client_id": 207,
          "admin_id": null,
          "donor_id": 17017,
          "table_name": "donoremails",
          "record_id": 17563,
          "action": "donor_message_send",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"Test Donor Shaban Paypal, monthly\",\"entity_name\":\"Peterson Jean\",\"subject\":\"Re: 20th checkin\",\"message\":\"<p>u good<\\/p>\",\"done_by\":\"Test Donor Shaban Paypal, monthly\"}",
          "created_at": "2024-05-20T09:23:42.000000Z",
          "updated_at": "2024-05-20T09:23:42.000000Z",
          "description": "An email from <strong>Test Donor Shaban Paypal, monthly</strong> to <strong>Peterson Jean</strong> has been sent"
        },
        {
          "id": 194,
          "client_id": 207,
          "admin_id": null,
          "donor_id": 17017,
          "table_name": "donoremails",
          "record_id": 17562,
          "action": "donor_message_send",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"Test Donor Shaban Paypal, monthly\",\"entity_name\":\"Peterson Jean\",\"subject\":\"20th checkin\",\"message\":\"<p>20th checkin<\\/p>\",\"done_by\":\"Test Donor Shaban Paypal, monthly\"}",
          "created_at": "2024-05-20T08:40:36.000000Z",
          "updated_at": "2024-05-20T08:40:36.000000Z",
          "description": "An email from <strong>Test Donor Shaban Paypal, monthly</strong> to <strong>Peterson Jean</strong> has been sent"
        },
        {
          "id": 192,
          "client_id": 207,
          "admin_id": 542,
          "donor_id": 16043,
          "table_name": "donoremails",
          "record_id": 17561,
          "action": "draft_message",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"Test Sule Cash\",\"entity_name\":\"Ismylove Jean\",\"subject\":\"check\",\"message\":\"<p>check<\\/p><br>\",\"done_by\":\"Leslie Jobs\"}",
          "created_at": "2024-05-20T07:02:50.000000Z",
          "updated_at": "2024-05-20T07:02:50.000000Z",
          "description": "An email from <strong>Ismylove Jean</strong> to <strong>Test Sule Cash</strong> has been drafted"
        },
        {
          "id": 193,
          "client_id": 207,
          "admin_id": 542,
          "donor_id": 16043,
          "table_name": "donoremails",
          "record_id": 17561,
          "action": "send_message",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"Test Sule Cash\",\"entity_name\":\"Ismylove Jean\",\"subject\":\"check\",\"message\":\"<p>check<\\/p><br>\",\"done_by\":\"Leslie Jobs\"}",
          "created_at": "2024-05-20T07:02:50.000000Z",
          "updated_at": "2024-05-20T07:02:50.000000Z",
          "description": "An email from <strong>Ismylove Jean</strong> to <strong>Test Sule Cash</strong> has been sent"
        },
        {
          "id": 190,
          "client_id": 207,
          "admin_id": 542,
          "donor_id": 17017,
          "table_name": "donoremails",
          "record_id": 17560,
          "action": "draft_message",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"Test Donor Shaban Paypal, monthly\",\"entity_name\":\"Isedervensley Saint-Julles\",\"subject\":\"giood\",\"message\":\"<p>good<\\/p><br>\",\"done_by\":\"Leslie Jobs\"}",
          "created_at": "2024-05-20T07:01:39.000000Z",
          "updated_at": "2024-05-20T07:01:39.000000Z",
          "description": "An email from <strong>Isedervensley Saint-Julles</strong> to <strong>Test Donor Shaban Paypal, monthly</strong> has been drafted"
        },
        {
          "id": 191,
          "client_id": 207,
          "admin_id": 542,
          "donor_id": 17017,
          "table_name": "donoremails",
          "record_id": 17560,
          "action": "send_message",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"Test Donor Shaban Paypal, monthly\",\"entity_name\":\"Isedervensley Saint-Julles\",\"subject\":\"giood\",\"message\":\"<p>good<\\/p><br>\",\"done_by\":\"Leslie Jobs\"}",
          "created_at": "2024-05-20T07:01:39.000000Z",
          "updated_at": "2024-05-20T07:01:39.000000Z",
          "description": "An email from <strong>Isedervensley Saint-Julles</strong> to <strong>Test Donor Shaban Paypal, monthly</strong> has been sent"
        },
        {
          "id": 188,
          "client_id": 207,
          "admin_id": 542,
          "donor_id": 16043,
          "table_name": "donoremails",
          "record_id": 17559,
          "action": "draft_message",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"Test Sule Cash\",\"entity_name\":\"Estilien Claudensky\",\"subject\":\"hello\",\"message\":\"<p>hello<\\/p><br>\",\"done_by\":\"Leslie Jobs\"}",
          "created_at": "2024-05-20T07:00:49.000000Z",
          "updated_at": "2024-05-20T07:00:49.000000Z",
          "description": "An email from <strong>Estilien Claudensky</strong> to <strong>Test Sule Cash</strong> has been drafted"
        },
        {
          "id": 189,
          "client_id": 207,
          "admin_id": 542,
          "donor_id": 16043,
          "table_name": "donoremails",
          "record_id": 17559,
          "action": "send_message",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"Test Sule Cash\",\"entity_name\":\"Estilien Claudensky\",\"subject\":\"hello\",\"message\":\"<p>hello<\\/p><br>\",\"done_by\":\"Leslie Jobs\"}",
          "created_at": "2024-05-20T07:00:49.000000Z",
          "updated_at": "2024-05-20T07:00:49.000000Z",
          "description": "An email from <strong>Estilien Claudensky</strong> to <strong>Test Sule Cash</strong> has been sent"
        },
        {
          "id": 187,
          "client_id": 207,
          "admin_id": null,
          "donor_id": 26087,
          "table_name": "donoremails",
          "record_id": 17558,
          "action": "donor_message_send",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"Schade\",\"entity_name\":\"Louidjivenson Vilsaint\",\"subject\":\"Testing for arnold\",\"message\":\"<p>Testing for arnold<\\/p>\",\"done_by\":\"Schade\"}",
          "created_at": "2024-05-17T20:20:32.000000Z",
          "updated_at": "2024-05-17T20:20:32.000000Z",
          "description": "An email from <strong>Schade</strong> to <strong>Louidjivenson Vilsaint</strong> has been sent"
        },
        {
          "id": 186,
          "client_id": 207,
          "admin_id": null,
          "donor_id": 26087,
          "table_name": "donoremails",
          "record_id": 17557,
          "action": "donor_message_send",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"Schade\",\"entity_name\":\"Louidjivenson Vilsaint\",\"subject\":\"helo\",\"message\":\"<p>kndfkjsdf 1324<\\/p>\",\"done_by\":\"Schade\"}",
          "created_at": "2024-05-17T20:18:36.000000Z",
          "updated_at": "2024-05-17T20:18:36.000000Z",
          "description": "An email from <strong>Schade</strong> to <strong>Louidjivenson Vilsaint</strong> has been sent"
        },
        {
          "id": 185,
          "client_id": 207,
          "admin_id": null,
          "donor_id": 26087,
          "table_name": "donoremails",
          "record_id": 17556,
          "action": "donor_message_send",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"Schade\",\"entity_name\":\"Louidjivenson Vilsaint\",\"subject\":\"Hi\",\"message\":\"<p>Hijkbsdfkj<\\/p>\",\"done_by\":\"Schade\"}",
          "created_at": "2024-05-17T20:16:07.000000Z",
          "updated_at": "2024-05-17T20:16:07.000000Z",
          "description": "An email from <strong>Schade</strong> to <strong>Louidjivenson Vilsaint</strong> has been sent"
        },
        {
          "id": 184,
          "client_id": 207,
          "admin_id": null,
          "donor_id": 26087,
          "table_name": "donoremails",
          "record_id": 17555,
          "action": "donor_message_send",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"Schade\",\"entity_name\":\"Louidjivenson Vilsaint\",\"subject\":\"Testing\",\"message\":\"<p>Testing 3 emails<\\/p>\",\"done_by\":\"Schade\"}",
          "created_at": "2024-05-17T20:14:19.000000Z",
          "updated_at": "2024-05-17T20:14:19.000000Z",
          "description": "An email from <strong>Schade</strong> to <strong>Louidjivenson Vilsaint</strong> has been sent"
        },
        {
          "id": 183,
          "client_id": 207,
          "admin_id": null,
          "donor_id": 26087,
          "table_name": "donoremails",
          "record_id": 17554,
          "action": "donor_message_send",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"Schade\",\"entity_name\":\"Louidjivenson Vilsaint\",\"subject\":\"Hi heloo\",\"message\":\"<p>Hi heloo<\\/p>\",\"done_by\":\"Schade\"}",
          "created_at": "2024-05-17T20:12:37.000000Z",
          "updated_at": "2024-05-17T20:12:37.000000Z",
          "description": "An email from <strong>Schade</strong> to <strong>Louidjivenson Vilsaint</strong> has been sent"
        },
        {
          "id": 182,
          "client_id": 207,
          "admin_id": null,
          "donor_id": 26087,
          "table_name": "donoremails",
          "record_id": 17553,
          "action": "donor_message_send",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"Schade\",\"entity_name\":\"Louidjivenson Vilsaint\",\"subject\":\"Hi\",\"message\":\"<p>Hi<\\/p>\",\"done_by\":\"Schade\"}",
          "created_at": "2024-05-17T20:07:56.000000Z",
          "updated_at": "2024-05-17T20:07:56.000000Z",
          "description": "An email from <strong>Schade</strong> to <strong>Louidjivenson Vilsaint</strong> has been sent"
        },
        {
          "id": 180,
          "client_id": 207,
          "admin_id": 542,
          "donor_id": 15799,
          "table_name": "donoremails",
          "record_id": 17552,
          "action": "draft_message",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"Test Sarah \",\"entity_name\":\"Emerdjina Charles\",\"subject\":\"Testing time\",\"message\":\"<p>Testing time<\\/p><br>\",\"done_by\":\"Leslie Jobs\"}",
          "created_at": "2024-05-17T20:04:15.000000Z",
          "updated_at": "2024-05-17T20:04:15.000000Z",
          "description": "An email from <strong>Emerdjina Charles</strong> to <strong>Test Sarah </strong> has been drafted"
        },
        {
          "id": 181,
          "client_id": 207,
          "admin_id": 542,
          "donor_id": 15799,
          "table_name": "donoremails",
          "record_id": 17552,
          "action": "send_message",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"Test Sarah \",\"entity_name\":\"Emerdjina Charles\",\"subject\":\"Testing time\",\"message\":\"<p>Testing time<\\/p><br>\",\"done_by\":\"Leslie Jobs\"}",
          "created_at": "2024-05-17T20:04:15.000000Z",
          "updated_at": "2024-05-17T20:04:15.000000Z",
          "description": "An email from <strong>Emerdjina Charles</strong> to <strong>Test Sarah </strong> has been sent"
        },
        {
          "id": 178,
          "client_id": 207,
          "admin_id": 542,
          "donor_id": 26087,
          "table_name": "donoremails",
          "record_id": 17551,
          "action": "draft_message",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"Schade\",\"entity_name\":\"Louidjivenson Vilsaint\",\"subject\":\"Hi\",\"message\":\"<p>Hi<\\/p><p><br><\\/p><br>\",\"done_by\":\"Leslie Jobs\"}",
          "created_at": "2024-05-17T20:03:15.000000Z",
          "updated_at": "2024-05-17T20:03:15.000000Z",
          "description": "An email from <strong>Louidjivenson Vilsaint</strong> to <strong>Schade</strong> has been drafted"
        },
        {
          "id": 179,
          "client_id": 207,
          "admin_id": 542,
          "donor_id": 26087,
          "table_name": "donoremails",
          "record_id": 17551,
          "action": "send_message",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"Schade\",\"entity_name\":\"Louidjivenson Vilsaint\",\"subject\":\"Hi\",\"message\":\"<p>Hi<\\/p><p><br><\\/p><br>\",\"done_by\":\"Leslie Jobs\"}",
          "created_at": "2024-05-17T20:03:15.000000Z",
          "updated_at": "2024-05-17T20:03:15.000000Z",
          "description": "An email from <strong>Louidjivenson Vilsaint</strong> to <strong>Schade</strong> has been sent"
        },
        {
          "id": 177,
          "client_id": 207,
          "admin_id": 542,
          "donor_id": null,
          "table_name": "donors",
          "record_id": 16667,
          "action": "archive_donor",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"dev3\",\"done_by\":\"Leslie Jobs\"}",
          "created_at": "2024-05-17T20:02:32.000000Z",
          "updated_at": "2024-05-17T20:02:32.000000Z",
          "description": "Donor <a href=\"/app/view_donor/16667\"><strong>dev3</strong></a> has been archived"
        },
        {
          "id": 176,
          "client_id": 207,
          "admin_id": 542,
          "donor_id": 17135,
          "table_name": "commitments",
          "record_id": 17114,
          "action": "restore_commitment",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"dev5\",\"entity_name\":{\"id\":37501,\"name\":\"Djedjilove Auralus\",\"program_id\":929},\"done_by\":\"Leslie Jobs\"}",
          "created_at": "2024-05-17T19:59:58.000000Z",
          "updated_at": "2024-05-17T19:59:58.000000Z",
          "description": "A commitment by <a href=\"/app/view_donor/17135\"><strong>dev5</strong></a> for <strong>Djedjilove Auralus</strong> has been restored"
        },
        {
          "id": 175,
          "client_id": 207,
          "admin_id": 542,
          "donor_id": 17135,
          "table_name": "commitments",
          "record_id": 17114,
          "action": "archive_commitment",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"dev5\",\"entity_name\":{\"id\":37501,\"name\":\"Djedjilove Auralus\",\"program_id\":929},\"done_by\":\"Leslie Jobs\"}",
          "created_at": "2024-05-17T19:59:47.000000Z",
          "updated_at": "2024-05-17T19:59:47.000000Z",
          "description": "A commitment by <a href=\"/app/view_donor/17135\"><strong>dev5</strong></a> for <strong>Djedjilove Auralus</strong> has been archived"
        },
        {
          "id": 174,
          "client_id": 207,
          "admin_id": null,
          "donor_id": 17017,
          "table_name": "donoremails",
          "record_id": 17549,
          "action": "donor_message_send",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"Test Donor Shaban Paypal, monthly\",\"entity_name\":\"Peterson Jean\",\"subject\":\"Hello message to you\",\"message\":\"<p>Hello message to you<\\/p>\",\"done_by\":\"Test Donor Shaban Paypal, monthly\"}",
          "created_at": "2024-05-17T17:31:45.000000Z",
          "updated_at": "2024-05-17T17:31:45.000000Z",
          "description": "An email from <strong>Test Donor Shaban Paypal, monthly</strong> to <strong>Peterson Jean</strong> has been sent"
        },
        {
          "id": 173,
          "client_id": 207,
          "admin_id": null,
          "donor_id": 17017,
          "table_name": "donoremails",
          "record_id": 17547,
          "action": "donor_message_send",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"Test Donor Shaban Paypal, monthly\",\"entity_name\":\"Peterson Jean\",\"subject\":\"Re: Happy bd\",\"message\":\"<p>Thank you<\\/p>\",\"done_by\":\"Test Donor Shaban Paypal, monthly\"}",
          "created_at": "2024-05-17T15:30:41.000000Z",
          "updated_at": "2024-05-17T15:30:41.000000Z",
          "description": "An email from <strong>Test Donor Shaban Paypal, monthly</strong> to <strong>Peterson Jean</strong> has been sent"
        },
        {
          "id": 171,
          "client_id": 207,
          "admin_id": 542,
          "donor_id": 17017,
          "table_name": "donoremails",
          "record_id": 17546,
          "action": "draft_message",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"Test Donor Shaban Paypal, monthly\",\"entity_name\":\"Peterson Jean\",\"subject\":\"Happy bd\",\"message\":\"<p>Happy bd<\\/p><br>\",\"done_by\":\"Leslie Jobs\"}",
          "created_at": "2024-05-17T15:30:15.000000Z",
          "updated_at": "2024-05-17T15:30:15.000000Z",
          "description": "An email from <strong>Peterson Jean</strong> to <strong>Test Donor Shaban Paypal, monthly</strong> has been drafted"
        },
        {
          "id": 172,
          "client_id": 207,
          "admin_id": 542,
          "donor_id": 17017,
          "table_name": "donoremails",
          "record_id": 17546,
          "action": "send_message",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"Test Donor Shaban Paypal, monthly\",\"entity_name\":\"Peterson Jean\",\"subject\":\"Happy bd\",\"message\":\"<p>Happy bd<\\/p><br>\",\"done_by\":\"Leslie Jobs\"}",
          "created_at": "2024-05-17T15:30:15.000000Z",
          "updated_at": "2024-05-17T15:30:15.000000Z",
          "description": "An email from <strong>Peterson Jean</strong> to <strong>Test Donor Shaban Paypal, monthly</strong> has been sent"
        },
        {
          "id": 170,
          "client_id": 207,
          "admin_id": null,
          "donor_id": 17017,
          "table_name": "donoremails",
          "record_id": 17545,
          "action": "donor_message_send",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"Test Donor Shaban Paypal, monthly\",\"entity_name\":\"Peterson Jean\",\"subject\":\"Re: Hello Merry Christmas\",\"message\":\"<p>Merry Christmas too<\\/p>\",\"done_by\":\"Test Donor Shaban Paypal, monthly\"}",
          "created_at": "2024-05-17T15:27:43.000000Z",
          "updated_at": "2024-05-17T15:27:43.000000Z",
          "description": "An email from <strong>Test Donor Shaban Paypal, monthly</strong> to <strong>Peterson Jean</strong> has been sent"
        },
        {
          "id": 168,
          "client_id": 207,
          "admin_id": 542,
          "donor_id": 17017,
          "table_name": "donoremails",
          "record_id": 17544,
          "action": "draft_message",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"Test Donor Shaban Paypal, monthly\",\"entity_name\":\"Peterson Jean\",\"subject\":\"Hello Merry Christmas\",\"message\":\"<p>Hello Merry Christmas<\\/p><br>\",\"done_by\":\"Leslie Jobs\"}",
          "created_at": "2024-05-17T15:22:42.000000Z",
          "updated_at": "2024-05-17T15:22:42.000000Z",
          "description": "An email from <strong>Peterson Jean</strong> to <strong>Test Donor Shaban Paypal, monthly</strong> has been drafted"
        },
        {
          "id": 169,
          "client_id": 207,
          "admin_id": 542,
          "donor_id": 17017,
          "table_name": "donoremails",
          "record_id": 17544,
          "action": "send_message",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"Test Donor Shaban Paypal, monthly\",\"entity_name\":\"Peterson Jean\",\"subject\":\"Hello Merry Christmas\",\"message\":\"<p>Hello Merry Christmas<\\/p><br>\",\"done_by\":\"Leslie Jobs\"}",
          "created_at": "2024-05-17T15:22:42.000000Z",
          "updated_at": "2024-05-17T15:22:42.000000Z",
          "description": "An email from <strong>Peterson Jean</strong> to <strong>Test Donor Shaban Paypal, monthly</strong> has been sent"
        },
        {
          "id": 167,
          "client_id": 207,
          "admin_id": 542,
          "donor_id": 17017,
          "table_name": "donations",
          "record_id": 379501,
          "action": "refund_donation",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"Test Donor Shaban Paypal, monthly\",\"amount\":37,\"done_by\":\"System\"}",
          "created_at": "2024-05-16T07:58:33.000000Z",
          "updated_at": "2024-05-16T07:58:33.000000Z",
          "description": "Donor <a href=\"/app/view_donor/17017\"><strong>Test Donor Shaban Paypal, monthly</strong></a> has been refunded"
        },
        {
          "id": 165,
          "client_id": 207,
          "admin_id": 542,
          "donor_id": 17017,
          "table_name": "commitments",
          "record_id": 23275,
          "action": "add_sponsorship",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"Test Donor Shaban Paypal, monthly\",\"amount\":\"32\",\"method\":\"Credit Card\",\"designation\":\"Echelanda Jean-Baptiste\",\"done_by\":\"Leslie Jobs\"}",
          "created_at": "2024-05-16T07:03:36.000000Z",
          "updated_at": "2024-05-16T07:03:36.000000Z",
          "description": "<a href=\"/app/view_donor/17017\"><strong>Test Donor Shaban Paypal, monthly</strong></a> has sponsored <strong>Echelanda Jean-Baptiste</strong> with <strong>32</strong> by <strong>Credit Card</strong>"
        },
        {
          "id": 164,
          "client_id": 207,
          "admin_id": 542,
          "donor_id": 17017,
          "table_name": "commitments",
          "record_id": 23274,
          "action": "add_sponsorship",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"Test Donor Shaban Paypal, monthly\",\"amount\":\"32\",\"method\":\"Wire Transfer\",\"designation\":\"Mayson Pierre\",\"done_by\":\"Leslie Jobs\"}",
          "created_at": "2024-05-16T07:02:47.000000Z",
          "updated_at": "2024-05-16T07:02:47.000000Z",
          "description": "<a href=\"/app/view_donor/17017\"><strong>Test Donor Shaban Paypal, monthly</strong></a> has sponsored <strong>Mayson Pierre</strong> with <strong>32</strong> by <strong>Wire Transfer</strong>"
        },
        {
          "id": 163,
          "client_id": 207,
          "admin_id": 542,
          "donor_id": 17017,
          "table_name": "commitments",
          "record_id": 23273,
          "action": "add_sponsorship",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"Test Donor Shaban Paypal, monthly\",\"amount\":\"32\",\"method\":\"Credit Card\",\"designation\":\"Sophia Saint-Louis\",\"done_by\":\"Leslie Jobs\"}",
          "created_at": "2024-05-16T07:01:21.000000Z",
          "updated_at": "2024-05-16T07:01:21.000000Z",
          "description": "<a href=\"/app/view_donor/17017\"><strong>Test Donor Shaban Paypal, monthly</strong></a> has sponsored <strong>Sophia Saint-Louis</strong> with <strong>32</strong> by <strong>Credit Card</strong>"
        },
        {
          "id": 162,
          "client_id": 207,
          "admin_id": 542,
          "donor_id": null,
          "table_name": "donors",
          "record_id": 26112,
          "action": "delete_donor",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"Philly Williams\",\"done_by\":\"Leslie Jobs\"}",
          "created_at": "2024-05-14T05:11:02.000000Z",
          "updated_at": "2024-05-14T05:11:02.000000Z",
          "description": "Donor <a href=\"/app/view_donor/26112\"><strong>Philly Williams</strong></a> has been deleted"
        },
        {
          "id": 161,
          "client_id": 207,
          "admin_id": 542,
          "donor_id": null,
          "table_name": "donors",
          "record_id": 26112,
          "action": "archive_donor",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"Philly Williams\",\"done_by\":\"Leslie Jobs\"}",
          "created_at": "2024-05-14T05:10:54.000000Z",
          "updated_at": "2024-05-14T05:10:54.000000Z",
          "description": "Donor <a href=\"/app/view_donor/26112\"><strong>Philly Williams</strong></a> has been archived"
        },
        {
          "id": 157,
          "client_id": 207,
          "admin_id": 542,
          "donor_id": 26112,
          "table_name": "commitments",
          "record_id": 23272,
          "action": "edit_commitment",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"Philly Williams Cash\",\"entity_name\":{\"id\":37230,\"name\":\"Sophia Saint-Louis\",\"program_id\":929},\"done_by\":\"Leslie Jobs\",\"old_commitment\":{\"id\":23272,\"client_id\":207,\"donor_id\":26112,\"donor_entity_id\":37226,\"type\":1,\"frequency\":1,\"until\":\"0000-00-00\",\"amount\":32,\"designation\":37230,\"method\":1,\"arb_subscription_id\":\"\",\"funding\":0,\"last\":\"2024-04-30\",\"deleted_at\":null,\"created_at\":\"2024-05-14T05:04:08.000000Z\",\"updated_at\":\"2024-05-14T05:05:00.000000Z\"}}",
          "created_at": "2024-05-14T05:05:54.000000Z",
          "updated_at": "2024-05-14T05:05:54.000000Z",
          "description": "A commitment for <strong>Sophia Saint-Louis</strong> has been edited"
        },
        {
          "id": 156,
          "client_id": 207,
          "admin_id": 542,
          "donor_id": 26112,
          "table_name": "commitments",
          "record_id": 23272,
          "action": "restore_commitment",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"Philly Williams\",\"entity_name\":{\"id\":37230,\"name\":\"Sophia Saint-Louis\",\"program_id\":929},\"done_by\":\"Leslie Jobs\"}",
          "created_at": "2024-05-14T05:05:01.000000Z",
          "updated_at": "2024-05-14T05:05:01.000000Z",
          "description": "A commitment by <a href=\"/app/view_donor/26112\"><strong>Philly Williams</strong></a> for <strong>Sophia Saint-Louis</strong> has been restored"
        },
        {
          "id": 155,
          "client_id": 207,
          "admin_id": 542,
          "donor_id": 26112,
          "table_name": "commitments",
          "record_id": 23272,
          "action": "archive_commitment",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"Philly Williams\",\"entity_name\":{\"id\":37230,\"name\":\"Sophia Saint-Louis\",\"program_id\":929},\"done_by\":\"Leslie Jobs\"}",
          "created_at": "2024-05-14T05:04:38.000000Z",
          "updated_at": "2024-05-14T05:04:38.000000Z",
          "description": "A commitment by <a href=\"/app/view_donor/26112\"><strong>Philly Williams</strong></a> for <strong>Sophia Saint-Louis</strong> has been archived"
        },
        {
          "id": 154,
          "client_id": 207,
          "admin_id": 542,
          "donor_id": 26112,
          "table_name": "commitments",
          "record_id": 23272,
          "action": "add_sponsorship",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"Philly Williams Cash\",\"amount\":\"32\",\"method\":\"Cash\",\"designation\":\"Sophia Saint-Louis\",\"done_by\":\"Leslie Jobs\"}",
          "created_at": "2024-05-14T05:04:08.000000Z",
          "updated_at": "2024-05-14T05:04:08.000000Z",
          "description": "<a href=\"/app/view_donor/26112\"><strong>Philly Williams Cash</strong></a> has sponsored <strong>Sophia Saint-Louis</strong> with <strong>32</strong> by <strong>Cash</strong>"
        },
        {
          "id": 152,
          "client_id": 207,
          "admin_id": 542,
          "donor_id": 26112,
          "table_name": "commitments",
          "record_id": 23271,
          "action": "add_sponsorship_email",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"Philly Williams Cash\",\"emailset_id\":337,\"details\":{\"entity\":{\"en_child_name\":\"Echelanda Jean-Baptiste\",\"en_gender\":\"Female\",\"en_grade\":\"PS III\",\"en_age\":\"5\",\"en_birthdate\":\"09-05-2013\",\"en_favorite_subject\":\"\"},\"donor\":{\"id\":26112,\"client_id\":\"207\",\"hysform_id\":639,\"do_not_email\":0,\"wait_time\":null,\"who_added\":\"{\\\"type\\\":\\\"admin\\\",\\\"method\\\":\\\"individual\\\",\\\"id\\\":\\\"207\\\"}\",\"stripe_cust_id\":null,\"authorize_profile\":null,\"json_fields\":\"{\\\"dn_donor_name\\\":\\\"Philly Williams\\\"}\",\"deleted_at\":null,\"created_at\":\"2024-05-14T04:58:43.000000Z\",\"updated_at\":\"2024-05-14T04:58:43.000000Z\",\"last_login\":null,\"__hevo__database_name\":null,\"__hevo__ingested_at\":null,\"__hevo__marked_deleted\":null,\"__hevo__source_modified_at\":null,\"stripe_card_id\":null,\"paypal_email\":null,\"dn_donor_name\":\"Philly Williams\",\"dn_payment_type\":\"Cash\",\"donor_id\":26112},\"other\":{\"date\":\"May 14, 2024\",\"username\":\"Philly Williams\"}},\"subject\":\"Welcome to our sponsorship program\",\"body\":\"<p>Hello Philly Williams,<\\/p><p>Welcome to our sponsorship program. We are thankful you decided to sponsor Echelanda Jean-Baptiste. Here is all the information you need to know about the program and contacting your child.<\\/p><p>Sincerely,<\\/p><p>Program Director<\\/p>\",\"done_by\":\"System\"}",
          "created_at": "2024-05-14T05:03:33.000000Z",
          "updated_at": "2024-05-14T05:03:33.000000Z",
          "description": "Action performed"
        },
        {
          "id": 153,
          "client_id": 207,
          "admin_id": 542,
          "donor_id": 26112,
          "table_name": "commitments",
          "record_id": 23271,
          "action": "add_sponsorship",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"Philly Williams Cash\",\"amount\":\"32\",\"method\":\"Credit Card\",\"designation\":\"Echelanda Jean-Baptiste\",\"done_by\":\"Leslie Jobs\"}",
          "created_at": "2024-05-14T05:03:33.000000Z",
          "updated_at": "2024-05-14T05:03:33.000000Z",
          "description": "<a href=\"/app/view_donor/26112\"><strong>Philly Williams Cash</strong></a> has sponsored <strong>Echelanda Jean-Baptiste</strong> with <strong>32</strong> by <strong>Credit Card</strong>"
        },
        {
          "id": 151,
          "client_id": 207,
          "admin_id": 542,
          "donor_id": 26112,
          "table_name": "donations",
          "record_id": 379513,
          "action": "add_donation",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"Philly Williams Cash\",\"amount\":\"34\",\"method\":\"Wire Transfer\",\"designation\":\"Bag of Rice\",\"done_by\":\"Leslie Jobs\"}",
          "created_at": "2024-05-14T05:00:59.000000Z",
          "updated_at": "2024-05-14T05:00:59.000000Z",
          "description": "<a href=\"/app/view_donor/26112\"><strong>Philly Williams Cash</strong></a> has donated <strong>34</strong> by <strong>Wire Transfer</strong> for <strong>Bag of Rice</strong>"
        },
        {
          "id": 150,
          "client_id": 207,
          "admin_id": null,
          "donor_id": 26087,
          "table_name": "commitments",
          "record_id": 23211,
          "action": "donor_charge_email",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"Schade\",\"details\":{\"method\":\"Credit Card\",\"designations\":\"Louidjivenson Vilsaint @ $32 per Month (Paid Every Month)\",\"date\":\"May 13, 2024\",\"total_amount\":32},\"subject\":\"Donation Receipt\",\"body\":\"<p>Thank you for your donation Louidjivenson Vilsaint @ $32 per Month (Paid Every Month) for 32. This email serves as your donation receipt.<\\/p>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<table style=\\\"\\\" border-color:#666;width:80%;margin:20px=\\\"\\\" auto;\\\"\\\"=\\\"\\\" cellpadding=\\\"\\\" 10\\\"\\\"=\\\"\\\">\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tbody>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tDonor Name\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t[donor_name]\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tDesignation\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t[designation_name]\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tAmount\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t$[amount]\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tMethod\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tCredit Card\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tFrequency\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t[frequency]<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tbody>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/table><p>May 13, 2024<\\/p>\",\"done_by\":\"System\"}",
          "created_at": "2024-05-13T12:06:54.000000Z",
          "updated_at": "2024-05-13T12:06:54.000000Z",
          "description": "A donation receipt email for <strong>Louidjivenson Vilsaint @ $32 per Month (Paid Every Month)</strong> has been sent to <a href=\"/app/view_donor/26087\"><strong>Schade</strong></a>"
        },
        {
          "id": 149,
          "client_id": 207,
          "admin_id": 542,
          "donor_id": null,
          "table_name": "donors",
          "record_id": 24658,
          "action": "delete_donor",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"\",\"done_by\":\"Leslie Jobs\"}",
          "created_at": "2024-05-13T11:50:02.000000Z",
          "updated_at": "2024-05-13T11:50:02.000000Z",
          "description": "Donor <a href=\"/app/view_donor/24658\"><strong></strong></a> has been deleted"
        },
        {
          "id": 148,
          "client_id": 207,
          "admin_id": 542,
          "donor_id": 26111,
          "table_name": "commitments",
          "record_id": 23269,
          "action": "restore_commitment",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"Chance Mathews\",\"entity_name\":{\"id\":37194,\"name\":\"Wismika Chery\",\"program_id\":929},\"done_by\":\"Leslie Jobs\"}",
          "created_at": "2024-05-13T11:48:12.000000Z",
          "updated_at": "2024-05-13T11:48:12.000000Z",
          "description": "A commitment by <a href=\"/app/view_donor/26111\"><strong>Chance Mathews</strong></a> for <strong>Wismika Chery</strong> has been restored"
        },
        {
          "id": 147,
          "client_id": 207,
          "admin_id": 542,
          "donor_id": 26111,
          "table_name": "commitments",
          "record_id": 23270,
          "action": "archive_commitment",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"Chance Mathews\",\"entity_name\":{\"id\":37243,\"name\":\"Echelanda Jean-Baptiste\",\"program_id\":929},\"done_by\":\"Leslie Jobs\"}",
          "created_at": "2024-05-13T11:47:47.000000Z",
          "updated_at": "2024-05-13T11:47:47.000000Z",
          "description": "A commitment by <a href=\"/app/view_donor/26111\"><strong>Chance Mathews</strong></a> for <strong>Echelanda Jean-Baptiste</strong> has been archived"
        },
        {
          "id": 144,
          "client_id": 207,
          "admin_id": 542,
          "donor_id": 26111,
          "table_name": "commitments",
          "record_id": 23270,
          "action": "edit_commitment",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"Chance Mathews Visa\",\"entity_name\":{\"id\":37243,\"name\":\"Echelanda Jean-Baptiste\",\"program_id\":929},\"done_by\":\"Leslie Jobs\",\"old_commitment\":{\"id\":23270,\"client_id\":207,\"donor_id\":26111,\"donor_entity_id\":37224,\"type\":1,\"frequency\":3,\"until\":\"0000-00-00\",\"amount\":32,\"designation\":37243,\"method\":1,\"arb_subscription_id\":\"\",\"funding\":0,\"last\":\"2023-11-30\",\"deleted_at\":null,\"created_at\":\"2024-05-13T11:45:59.000000Z\",\"updated_at\":\"2024-05-13T11:45:59.000000Z\"}}",
          "created_at": "2024-05-13T11:46:41.000000Z",
          "updated_at": "2024-05-13T11:46:41.000000Z",
          "description": "A commitment for <strong>Echelanda Jean-Baptiste</strong> has been edited"
        },
        {
          "id": 143,
          "client_id": 207,
          "admin_id": 542,
          "donor_id": 26111,
          "table_name": "commitments",
          "record_id": 23270,
          "action": "add_sponsorship",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"Chance Mathews Visa\",\"amount\":\"32\",\"method\":\"Cash\",\"designation\":\"Echelanda Jean-Baptiste\",\"done_by\":\"Leslie Jobs\"}",
          "created_at": "2024-05-13T11:46:00.000000Z",
          "updated_at": "2024-05-13T11:46:00.000000Z",
          "description": "<a href=\"/app/view_donor/26111\"><strong>Chance Mathews Visa</strong></a> has sponsored <strong>Echelanda Jean-Baptiste</strong> with <strong>32</strong> by <strong>Cash</strong>"
        },
        {
          "id": 142,
          "client_id": 207,
          "admin_id": 542,
          "donor_id": 26111,
          "table_name": "commitments",
          "record_id": 23270,
          "action": "add_sponsorship_email",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"Chance Mathews Visa\",\"emailset_id\":337,\"details\":{\"entity\":{\"en_child_name\":\"Echelanda Jean-Baptiste\",\"en_gender\":\"Female\",\"en_grade\":\"PS III\",\"en_age\":\"5\",\"en_birthdate\":\"09-05-2013\",\"en_favorite_subject\":\"\"},\"donor\":{\"id\":26111,\"client_id\":\"207\",\"hysform_id\":639,\"do_not_email\":0,\"wait_time\":null,\"who_added\":\"{\\\"type\\\":\\\"admin\\\",\\\"method\\\":\\\"individual\\\",\\\"id\\\":\\\"207\\\"}\",\"stripe_cust_id\":null,\"authorize_profile\":null,\"json_fields\":\"{\\\"dn_donor_name\\\":\\\"Chance Mathews\\\"}\",\"deleted_at\":null,\"created_at\":\"2024-05-13T11:31:28.000000Z\",\"updated_at\":\"2024-05-13T11:31:28.000000Z\",\"last_login\":null,\"__hevo__database_name\":null,\"__hevo__ingested_at\":null,\"__hevo__marked_deleted\":null,\"__hevo__source_modified_at\":null,\"stripe_card_id\":null,\"paypal_email\":null,\"dn_donor_name\":\"Chance Mathews\",\"dn_payment_type\":\"Visa\",\"donor_id\":26111},\"other\":{\"date\":\"May 13, 2024\",\"username\":\"Chance Mathews\"}},\"subject\":\"Welcome to our sponsorship program\",\"body\":\"<p>Hello Chance Mathews,<\\/p><p>Welcome to our sponsorship program. We are thankful you decided to sponsor Echelanda Jean-Baptiste. Here is all the information you need to know about the program and contacting your child.<\\/p><p>Sincerely,<\\/p><p>Program Director<\\/p>\",\"done_by\":\"System\"}",
          "created_at": "2024-05-13T11:45:59.000000Z",
          "updated_at": "2024-05-13T11:45:59.000000Z",
          "description": "Action performed"
        },
        {
          "id": 140,
          "client_id": 207,
          "admin_id": 542,
          "donor_id": 26111,
          "table_name": "donations",
          "record_id": 379509,
          "action": "add_donation_receipt_email",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"Chance Mathews Visa\",\"emailset_id\":337,\"details\":{\"donor\":{\"id\":26111,\"client_id\":\"207\",\"hysform_id\":639,\"do_not_email\":0,\"wait_time\":null,\"who_added\":\"{\\\"type\\\":\\\"admin\\\",\\\"method\\\":\\\"individual\\\",\\\"id\\\":\\\"207\\\"}\",\"stripe_cust_id\":null,\"authorize_profile\":null,\"json_fields\":\"{\\\"dn_donor_name\\\":\\\"Chance Mathews\\\"}\",\"deleted_at\":null,\"created_at\":\"2024-05-13T11:31:28.000000Z\",\"updated_at\":\"2024-05-13T11:31:28.000000Z\",\"last_login\":null,\"__hevo__database_name\":null,\"__hevo__ingested_at\":null,\"__hevo__marked_deleted\":null,\"__hevo__source_modified_at\":null,\"stripe_card_id\":null,\"paypal_email\":null,\"dn_donor_name\":\"Chance Mathews\",\"dn_payment_type\":\"Visa\",\"donor_id\":26111},\"donation\":{\"designations\":\" @ 45 (One-time)\",\"total_amount\":\"45\",\"method\":\"Cash\",\"date\":\"May 23, 2024\"}},\"subject\":\"Donation Receipt\",\"body\":\"<p>Thank you for your donation  @ 45 (One-time) for 45. This email serves as your donation receipt.<\\/p>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<table style=\\\"\\\" border-color:#666;width:80%;margin:20px=\\\"\\\" auto;\\\"\\\"=\\\"\\\" cellpadding=\\\"\\\" 10\\\"\\\"=\\\"\\\">\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tbody>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tDonor Name\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t[donor_name]\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tDesignation\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t[designation_name]\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tAmount\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t$[amount]\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tMethod\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tCash\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tFrequency\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t[frequency]<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tbody>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/table><p>May 23, 2024<\\/p>\",\"done_by\":\"System\"}",
          "created_at": "2024-05-13T11:45:20.000000Z",
          "updated_at": "2024-05-13T11:45:20.000000Z",
          "description": "A donation receipt email for <strong></strong> has been sent to <strong>Chance Mathews Visa</strong>"
        },
        {
          "id": 141,
          "client_id": 207,
          "admin_id": 542,
          "donor_id": 26111,
          "table_name": "donations",
          "record_id": 379509,
          "action": "add_donation",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"Chance Mathews Visa\",\"amount\":\"45\",\"method\":\"Cash\",\"designation\":\"Bag of Rice\",\"done_by\":\"Leslie Jobs\"}",
          "created_at": "2024-05-13T11:45:20.000000Z",
          "updated_at": "2024-05-13T11:45:20.000000Z",
          "description": "<a href=\"/app/view_donor/26111\"><strong>Chance Mathews Visa</strong></a> has donated <strong>45</strong> by <strong>Cash</strong> for <strong>Bag of Rice</strong>"
        },
        {
          "id": 139,
          "client_id": 207,
          "admin_id": 542,
          "donor_id": 26111,
          "table_name": "donations",
          "record_id": 379508,
          "action": "add_donation",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"Chance Mathews Visa\",\"amount\":\"45\",\"method\":\"Credit Card\",\"designation\":\"Bag of Beans\",\"done_by\":\"Leslie Jobs\"}",
          "created_at": "2024-05-13T11:44:19.000000Z",
          "updated_at": "2024-05-13T11:44:19.000000Z",
          "description": "<a href=\"/app/view_donor/26111\"><strong>Chance Mathews Visa</strong></a> has donated <strong>45</strong> by <strong>Credit Card</strong> for <strong>Bag of Beans</strong>"
        },
        {
          "id": 138,
          "client_id": 207,
          "admin_id": 542,
          "donor_id": 26111,
          "table_name": "commitments",
          "record_id": 23269,
          "action": "archive_commitment",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"Chance Mathews\",\"entity_name\":{\"id\":37194,\"name\":\"Wismika Chery\",\"program_id\":929},\"done_by\":\"Leslie Jobs\"}",
          "created_at": "2024-05-13T11:41:33.000000Z",
          "updated_at": "2024-05-13T11:41:33.000000Z",
          "description": "A commitment by <a href=\"/app/view_donor/26111\"><strong>Chance Mathews</strong></a> for <strong>Wismika Chery</strong> has been archived"
        },
        {
          "id": 137,
          "client_id": 207,
          "admin_id": 542,
          "donor_id": 26111,
          "table_name": "commitments",
          "record_id": 23269,
          "action": "restore_commitment",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"Chance Mathews\",\"entity_name\":{\"id\":37194,\"name\":\"Wismika Chery\",\"program_id\":929},\"done_by\":\"Leslie Jobs\"}",
          "created_at": "2024-05-13T11:41:23.000000Z",
          "updated_at": "2024-05-13T11:41:23.000000Z",
          "description": "A commitment by <a href=\"/app/view_donor/26111\"><strong>Chance Mathews</strong></a> for <strong>Wismika Chery</strong> has been restored"
        },
        {
          "id": 136,
          "client_id": 207,
          "admin_id": 542,
          "donor_id": 26111,
          "table_name": "commitments",
          "record_id": 23269,
          "action": "archive_commitment",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"Chance Mathews\",\"entity_name\":{\"id\":37194,\"name\":\"Wismika Chery\",\"program_id\":929},\"done_by\":\"Leslie Jobs\"}",
          "created_at": "2024-05-13T11:41:13.000000Z",
          "updated_at": "2024-05-13T11:41:13.000000Z",
          "description": "A commitment by <a href=\"/app/view_donor/26111\"><strong>Chance Mathews</strong></a> for <strong>Wismika Chery</strong> has been archived"
        },
        {
          "id": 132,
          "client_id": 207,
          "admin_id": 542,
          "donor_id": 26111,
          "table_name": "commitments",
          "record_id": 23269,
          "action": "add_sponsorship",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"Chance Mathews Visa\",\"amount\":\"32\",\"method\":\"Credit Card\",\"designation\":\"Wismika Chery\",\"done_by\":\"Leslie Jobs\"}",
          "created_at": "2024-05-13T11:37:12.000000Z",
          "updated_at": "2024-05-13T11:37:12.000000Z",
          "description": "<a href=\"/app/view_donor/26111\"><strong>Chance Mathews Visa</strong></a> has sponsored <strong>Wismika Chery</strong> with <strong>32</strong> by <strong>Credit Card</strong>"
        },
        {
          "id": 131,
          "client_id": 207,
          "admin_id": 542,
          "donor_id": 26111,
          "table_name": "donations",
          "record_id": 379504,
          "action": "add_donation",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"Chance Mathews Visa\",\"amount\":\"13\",\"method\":\"Credit Card\",\"designation\":\"Bag of Rice\",\"done_by\":\"Leslie Jobs\"}",
          "created_at": "2024-05-13T11:35:06.000000Z",
          "updated_at": "2024-05-13T11:35:06.000000Z",
          "description": "<a href=\"/app/view_donor/26111\"><strong>Chance Mathews Visa</strong></a> has donated <strong>13</strong> by <strong>Credit Card</strong> for <strong>Bag of Rice</strong>"
        },
        {
          "id": 129,
          "client_id": 207,
          "admin_id": 542,
          "donor_id": 26111,
          "table_name": "donations",
          "record_id": 379503,
          "action": "add_donation_receipt_email",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"Chance Mathews Visa\",\"emailset_id\":337,\"details\":{\"donor\":{\"id\":26111,\"client_id\":\"207\",\"hysform_id\":639,\"do_not_email\":0,\"wait_time\":null,\"who_added\":\"{\\\"type\\\":\\\"admin\\\",\\\"method\\\":\\\"individual\\\",\\\"id\\\":\\\"207\\\"}\",\"stripe_cust_id\":null,\"authorize_profile\":null,\"json_fields\":\"{\\\"dn_donor_name\\\":\\\"Chance Mathews\\\"}\",\"deleted_at\":null,\"created_at\":\"2024-05-13T11:31:28.000000Z\",\"updated_at\":\"2024-05-13T11:31:28.000000Z\",\"last_login\":null,\"__hevo__database_name\":null,\"__hevo__ingested_at\":null,\"__hevo__marked_deleted\":null,\"__hevo__source_modified_at\":null,\"stripe_card_id\":null,\"paypal_email\":null,\"dn_donor_name\":\"Chance Mathews\",\"dn_payment_type\":\"Visa\",\"donor_id\":26111},\"donation\":{\"designations\":\" @ 42 (One-time)\",\"total_amount\":\"42\",\"method\":\"Credit Card\",\"date\":\"May 13, 2024\"}},\"subject\":\"Donation Receipt\",\"body\":\"<p>Thank you for your donation  @ 42 (One-time) for 42. This email serves as your donation receipt.<\\/p>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<table style=\\\"\\\" border-color:#666;width:80%;margin:20px=\\\"\\\" auto;\\\"\\\"=\\\"\\\" cellpadding=\\\"\\\" 10\\\"\\\"=\\\"\\\">\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tbody>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tDonor Name\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t[donor_name]\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tDesignation\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t[designation_name]\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tAmount\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t$[amount]\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tMethod\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tCredit Card\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tFrequency\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t[frequency]<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tbody>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/table><p>May 13, 2024<\\/p>\",\"done_by\":\"System\"}",
          "created_at": "2024-05-13T11:33:55.000000Z",
          "updated_at": "2024-05-13T11:33:55.000000Z",
          "description": "A donation receipt email for <strong></strong> has been sent to <strong>Chance Mathews Visa</strong>"
        },
        {
          "id": 130,
          "client_id": 207,
          "admin_id": 542,
          "donor_id": 26111,
          "table_name": "donations",
          "record_id": 379503,
          "action": "add_donation",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"Chance Mathews Visa\",\"amount\":\"42\",\"method\":\"Credit Card\",\"designation\":\"Bag of Rice\",\"done_by\":\"Leslie Jobs\"}",
          "created_at": "2024-05-13T11:33:55.000000Z",
          "updated_at": "2024-05-13T11:33:55.000000Z",
          "description": "<a href=\"/app/view_donor/26111\"><strong>Chance Mathews Visa</strong></a> has donated <strong>42</strong> by <strong>Credit Card</strong> for <strong>Bag of Rice</strong>"
        },
        {
          "id": 127,
          "client_id": 207,
          "admin_id": 542,
          "donor_id": 17017,
          "table_name": "donations",
          "record_id": 379502,
          "action": "add_donation_receipt_email",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"Test Donor Shaban Paypal, monthly\",\"emailset_id\":337,\"details\":{\"donor\":{\"dn_donor_name\":\"Test Donor Shaban\",\"dn_payment_type\":\"Paypal, monthly\",\"dn_child_sponsored\":\"Isedervensley Saint-Julles &  Peterson Jean\",\"fakeusernameremembered\":\"\",\"fakepasswordremembered\":\"\"},\"donation\":{\"designations\":\" @ 56 (One-time)\",\"total_amount\":\"56\",\"method\":\"External Processor\",\"date\":\"May 16, 2024\"}},\"subject\":\"Donation Receipt\",\"body\":\"<p>Thank you for your donation  @ 56 (One-time) for 56. This email serves as your donation receipt.<\\/p>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<table style=\\\"\\\" border-color:#666;width:80%;margin:20px=\\\"\\\" auto;\\\"\\\"=\\\"\\\" cellpadding=\\\"\\\" 10\\\"\\\"=\\\"\\\">\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tbody>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tDonor Name\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t[donor_name]\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tDesignation\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t[designation_name]\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tAmount\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t$[amount]\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tMethod\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tExternal Processor\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tFrequency\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t[frequency]<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tbody>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/table><p>May 16, 2024<\\/p>\",\"done_by\":\"System\"}",
          "created_at": "2024-05-13T09:34:26.000000Z",
          "updated_at": "2024-05-13T09:34:26.000000Z",
          "description": "A donation receipt email for <strong></strong> has been sent to <strong>Test Donor Shaban Paypal, monthly</strong>"
        },
        {
          "id": 128,
          "client_id": 207,
          "admin_id": 542,
          "donor_id": 17017,
          "table_name": "donations",
          "record_id": 379502,
          "action": "add_donation",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"Test Donor Shaban Paypal, monthly\",\"amount\":\"56\",\"method\":\"External Processor\",\"designation\":\"Malache Basquin\",\"done_by\":\"Leslie Jobs\"}",
          "created_at": "2024-05-13T09:34:26.000000Z",
          "updated_at": "2024-05-13T09:34:26.000000Z",
          "description": "<a href=\"/app/view_donor/17017\"><strong>Test Donor Shaban Paypal, monthly</strong></a> has donated <strong>56</strong> by <strong>External Processor</strong> for <strong>Malache Basquin</strong>"
        },
        {
          "id": 124,
          "client_id": 207,
          "admin_id": 542,
          "donor_id": 17017,
          "table_name": "donations",
          "record_id": 379500,
          "action": "add_donation_receipt_email",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"Test Donor Shaban Paypal, monthly\",\"emailset_id\":337,\"details\":{\"donor\":{\"dn_donor_name\":\"Test Donor Shaban\",\"dn_payment_type\":\"Paypal, monthly\",\"dn_child_sponsored\":\"Isedervensley Saint-Julles &  Peterson Jean\",\"fakeusernameremembered\":\"\",\"fakepasswordremembered\":\"\"},\"donation\":{\"designations\":\" @ 34 (One-time)\",\"total_amount\":\"34\",\"method\":\"Credit Card\",\"date\":\"May 13, 2024\"}},\"subject\":\"Donation Receipt\",\"body\":\"<p>Thank you for your donation  @ 34 (One-time) for 34. This email serves as your donation receipt.<\\/p>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<table style=\\\"\\\" border-color:#666;width:80%;margin:20px=\\\"\\\" auto;\\\"\\\"=\\\"\\\" cellpadding=\\\"\\\" 10\\\"\\\"=\\\"\\\">\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tbody>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tDonor Name\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t[donor_name]\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tDesignation\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t[designation_name]\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tAmount\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t$[amount]\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tMethod\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tCredit Card\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tFrequency\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t[frequency]<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tbody>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/table><p>May 13, 2024<\\/p>\",\"done_by\":\"System\"}",
          "created_at": "2024-05-13T09:31:35.000000Z",
          "updated_at": "2024-05-13T09:31:35.000000Z",
          "description": "A donation receipt email for <strong></strong> has been sent to <strong>Test Donor Shaban Paypal, monthly</strong>"
        },
        {
          "id": 125,
          "client_id": 207,
          "admin_id": 542,
          "donor_id": 17017,
          "table_name": "donations",
          "record_id": 379500,
          "action": "add_donation",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"Test Donor Shaban Paypal, monthly\",\"amount\":\"34\",\"method\":\"Credit Card\",\"designation\":\"Peterson Jean\",\"done_by\":\"Leslie Jobs\"}",
          "created_at": "2024-05-13T09:31:35.000000Z",
          "updated_at": "2024-05-13T09:31:35.000000Z",
          "description": "<a href=\"/app/view_donor/17017\"><strong>Test Donor Shaban Paypal, monthly</strong></a> has donated <strong>34</strong> by <strong>Credit Card</strong> for <strong>Peterson Jean</strong>"
        },
        {
          "id": 123,
          "client_id": 207,
          "admin_id": null,
          "donor_id": 26094,
          "table_name": "commitments",
          "record_id": 23225,
          "action": "donor_charge_email",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"Test Evelyn\",\"details\":{\"method\":\"Credit Card\",\"designations\":\"Dahenslow Etienne @ $32 per Month (Paid Every Month)\",\"date\":\"May 12, 2024\",\"total_amount\":32},\"subject\":\"Donation Receipt\",\"body\":\"<p>Thank you for your donation Dahenslow Etienne @ $32 per Month (Paid Every Month) for 32. This email serves as your donation receipt.<\\/p>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<table style=\\\"\\\" border-color:#666;width:80%;margin:20px=\\\"\\\" auto;\\\"\\\"=\\\"\\\" cellpadding=\\\"\\\" 10\\\"\\\"=\\\"\\\">\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tbody>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tDonor Name\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t[donor_name]\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tDesignation\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t[designation_name]\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tAmount\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t$[amount]\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tMethod\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tCredit Card\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tFrequency\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t[frequency]<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tbody>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/table><p>May 12, 2024<\\/p>\",\"done_by\":\"System\"}",
          "created_at": "2024-05-12T12:07:07.000000Z",
          "updated_at": "2024-05-12T12:07:07.000000Z",
          "description": "A donation receipt email for <strong>Dahenslow Etienne @ $32 per Month (Paid Every Month)</strong> has been sent to <a href=\"/app/view_donor/26094\"><strong>Test Evelyn</strong></a>"
        },
        {
          "id": 122,
          "client_id": 207,
          "admin_id": null,
          "donor_id": 17166,
          "table_name": "commitments",
          "record_id": 23210,
          "action": "donor_charge_email",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"John, Katie & Clara Richter CC Monthly\",\"details\":{\"method\":\"Credit Card\",\"designations\":\"Wilna Dervil @ $32 per Month (Paid Every Month)\",\"date\":\"May 12, 2024\",\"total_amount\":32},\"subject\":\"Donation Receipt\",\"body\":\"<p>Thank you for your donation Wilna Dervil @ $32 per Month (Paid Every Month) for 32. This email serves as your donation receipt.<\\/p>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<table style=\\\"\\\" border-color:#666;width:80%;margin:20px=\\\"\\\" auto;\\\"\\\"=\\\"\\\" cellpadding=\\\"\\\" 10\\\"\\\"=\\\"\\\">\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tbody>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tDonor Name\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t[donor_name]\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tDesignation\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t[designation_name]\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tAmount\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t$[amount]\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tMethod\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tCredit Card\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tFrequency\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t[frequency]<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tbody>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/table><p>May 12, 2024<\\/p>\",\"done_by\":\"System\"}",
          "created_at": "2024-05-12T12:06:48.000000Z",
          "updated_at": "2024-05-12T12:06:48.000000Z",
          "description": "A donation receipt email for <strong>Wilna Dervil @ $32 per Month (Paid Every Month)</strong> has been sent to <a href=\"/app/view_donor/17166\"><strong>John, Katie & Clara Richter CC Monthly</strong></a>"
        },
        {
          "id": 119,
          "client_id": 207,
          "admin_id": 542,
          "donor_id": 26087,
          "table_name": "donoremails",
          "record_id": 17543,
          "action": "draft_message",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"Schade\",\"entity_name\":\"Louidjivenson Vilsaint\",\"subject\":\"Hello\",\"message\":\"<p>Hello<\\/p><br>\",\"done_by\":\"Leslie Jobs\"}",
          "created_at": "2024-05-09T19:16:35.000000Z",
          "updated_at": "2024-05-09T19:16:35.000000Z",
          "description": "An email from <strong>Louidjivenson Vilsaint</strong> to <strong>Schade</strong> has been drafted"
        },
        {
          "id": 120,
          "client_id": 207,
          "admin_id": 542,
          "donor_id": 26087,
          "table_name": "donoremails",
          "record_id": 17543,
          "action": "send_message",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"Schade\",\"entity_name\":\"Louidjivenson Vilsaint\",\"subject\":\"Hello\",\"message\":\"<p>Hello<\\/p><br>\",\"done_by\":\"Leslie Jobs\"}",
          "created_at": "2024-05-09T19:16:35.000000Z",
          "updated_at": "2024-05-09T19:16:35.000000Z",
          "description": "An email from <strong>Louidjivenson Vilsaint</strong> to <strong>Schade</strong> has been sent"
        },
        {
          "id": 118,
          "client_id": 207,
          "admin_id": null,
          "donor_id": 26103,
          "table_name": "donoremails",
          "record_id": 17542,
          "action": "donor_message_send",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"Test Leo 10\",\"entity_name\":\"Djeff Pierre\",\"subject\":\"test time\",\"message\":\"<p>test time<\\/p>\",\"done_by\":\"Test Leo 10\"}",
          "created_at": "2024-05-09T15:48:54.000000Z",
          "updated_at": "2024-05-09T15:48:54.000000Z",
          "description": "An email from <strong>Test Leo 10</strong> to <strong>Djeff Pierre</strong> has been sent"
        },
        {
          "id": 115,
          "client_id": 207,
          "admin_id": null,
          "donor_id": 26094,
          "table_name": "commitments",
          "record_id": 23220,
          "action": "donor_charge_email",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"Test Evelyn\",\"details\":{\"method\":\"Credit Card\",\"designations\":\"Djouninho Saint-Juste @ $32 per Month (Paid Every Month)\",\"date\":\"May 9, 2024\",\"total_amount\":32},\"subject\":\"Donation Receipt\",\"body\":\"<p>Thank you for your donation Djouninho Saint-Juste @ $32 per Month (Paid Every Month) for 32. This email serves as your donation receipt.<\\/p>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<table style=\\\"\\\" border-color:#666;width:80%;margin:20px=\\\"\\\" auto;\\\"\\\"=\\\"\\\" cellpadding=\\\"\\\" 10\\\"\\\"=\\\"\\\">\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tbody>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tDonor Name\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t[donor_name]\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tDesignation\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t[designation_name]\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tAmount\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t$[amount]\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tMethod\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tCredit Card\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tFrequency\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t[frequency]<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tbody>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/table><p>May 9, 2024<\\/p>\",\"done_by\":\"System\"}",
          "created_at": "2024-05-09T12:07:28.000000Z",
          "updated_at": "2024-05-09T12:07:28.000000Z",
          "description": "A donation receipt email for <strong>Djouninho Saint-Juste @ $32 per Month (Paid Every Month)</strong> has been sent to <a href=\"/app/view_donor/26094\"><strong>Test Evelyn</strong></a>"
        },
        {
          "id": 114,
          "client_id": 207,
          "admin_id": null,
          "donor_id": 26094,
          "table_name": "commitments",
          "record_id": 23219,
          "action": "donor_charge_email",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"Test Evelyn\",\"details\":{\"method\":\"Credit Card\",\"designations\":\"Rose-Landa Auguste @ $32 per Month (Paid Every Month)\",\"date\":\"May 9, 2024\",\"total_amount\":32},\"subject\":\"Donation Receipt\",\"body\":\"<p>Thank you for your donation Rose-Landa Auguste @ $32 per Month (Paid Every Month) for 32. This email serves as your donation receipt.<\\/p>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<table style=\\\"\\\" border-color:#666;width:80%;margin:20px=\\\"\\\" auto;\\\"\\\"=\\\"\\\" cellpadding=\\\"\\\" 10\\\"\\\"=\\\"\\\">\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tbody>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tDonor Name\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t[donor_name]\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tDesignation\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t[designation_name]\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tAmount\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t$[amount]\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tMethod\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tCredit Card\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tFrequency\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t[frequency]<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tbody>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/table><p>May 9, 2024<\\/p>\",\"done_by\":\"System\"}",
          "created_at": "2024-05-09T12:07:25.000000Z",
          "updated_at": "2024-05-09T12:07:25.000000Z",
          "description": "A donation receipt email for <strong>Rose-Landa Auguste @ $32 per Month (Paid Every Month)</strong> has been sent to <a href=\"/app/view_donor/26094\"><strong>Test Evelyn</strong></a>"
        },
        {
          "id": 113,
          "client_id": 207,
          "admin_id": null,
          "donor_id": 26093,
          "table_name": "commitments",
          "record_id": 23217,
          "action": "donor_charge_email",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"Test Zawede\",\"details\":{\"method\":\"Credit Card\",\"designations\":\"Loudemiya Rich\\u00e9 @ $32 per Month (Paid Every Month)\",\"date\":\"May 9, 2024\",\"total_amount\":32},\"subject\":\"Donation Receipt\",\"body\":\"<p>Thank you for your donation Loudemiya Rich\\u00e9 @ $32 per Month (Paid Every Month) for 32. This email serves as your donation receipt.<\\/p>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<table style=\\\"\\\" border-color:#666;width:80%;margin:20px=\\\"\\\" auto;\\\"\\\"=\\\"\\\" cellpadding=\\\"\\\" 10\\\"\\\"=\\\"\\\">\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tbody>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tDonor Name\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t[donor_name]\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tDesignation\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t[designation_name]\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tAmount\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t$[amount]\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tMethod\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tCredit Card\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tFrequency\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t[frequency]<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tbody>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/table><p>May 9, 2024<\\/p>\",\"done_by\":\"System\"}",
          "created_at": "2024-05-09T12:07:21.000000Z",
          "updated_at": "2024-05-09T12:07:21.000000Z",
          "description": "A donation receipt email for <strong>Loudemiya Rich\u00e9 @ $32 per Month (Paid Every Month)</strong> has been sent to <a href=\"/app/view_donor/26093\"><strong>Test Zawede</strong></a>"
        },
        {
          "id": 112,
          "client_id": 207,
          "admin_id": null,
          "donor_id": 26093,
          "table_name": "commitments",
          "record_id": 23216,
          "action": "donor_charge_email",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"Test Zawede\",\"details\":{\"method\":\"Credit Card\",\"designations\":\"Judena\\u00eflie DuMassair @ $32 per Month (Paid Every Month)\",\"date\":\"May 9, 2024\",\"total_amount\":32},\"subject\":\"Donation Receipt\",\"body\":\"<p>Thank you for your donation Judena\\u00eflie DuMassair @ $32 per Month (Paid Every Month) for 32. This email serves as your donation receipt.<\\/p>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<table style=\\\"\\\" border-color:#666;width:80%;margin:20px=\\\"\\\" auto;\\\"\\\"=\\\"\\\" cellpadding=\\\"\\\" 10\\\"\\\"=\\\"\\\">\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tbody>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tDonor Name\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t[donor_name]\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tDesignation\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t[designation_name]\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tAmount\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t$[amount]\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tMethod\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tCredit Card\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tFrequency\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t[frequency]<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tbody>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/table><p>May 9, 2024<\\/p>\",\"done_by\":\"System\"}",
          "created_at": "2024-05-09T12:07:18.000000Z",
          "updated_at": "2024-05-09T12:07:18.000000Z",
          "description": "A donation receipt email for <strong>Judena\u00eflie DuMassair @ $32 per Month (Paid Every Month)</strong> has been sent to <a href=\"/app/view_donor/26093\"><strong>Test Zawede</strong></a>"
        },
        {
          "id": 111,
          "client_id": 207,
          "admin_id": 542,
          "donor_id": 17017,
          "table_name": "commitments",
          "record_id": 23224,
          "action": "restore_commitment",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"shabanlubanga@gmail.com\",\"entity_name\":{\"id\":36316,\"name\":\"Jonalis Jude-Na\\u00edca\",\"program_id\":929},\"done_by\":\"Leslie Jobs\"}",
          "created_at": "2024-05-09T08:05:29.000000Z",
          "updated_at": "2024-05-09T08:05:29.000000Z",
          "description": "A commitment by <a href=\"/app/view_donor/17017\"><strong>shabanlubanga@gmail.com</strong></a> for <strong>Jonalis Jude-Na\u00edca</strong> has been restored"
        },
        {
          "id": 110,
          "client_id": 207,
          "admin_id": 542,
          "donor_id": 17017,
          "table_name": "commitments",
          "record_id": 23224,
          "action": "archive_commitment",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"shabanlubanga@gmail.com\",\"entity_name\":{\"id\":36316,\"name\":\"Jonalis Jude-Na\\u00edca\",\"program_id\":929},\"done_by\":\"Leslie Jobs\"}",
          "created_at": "2024-05-09T08:03:15.000000Z",
          "updated_at": "2024-05-09T08:03:15.000000Z",
          "description": "A commitment by <a href=\"/app/view_donor/17017\"><strong>shabanlubanga@gmail.com</strong></a> for <strong>Jonalis Jude-Na\u00edca</strong> has been archived"
        },
        {
          "id": 109,
          "client_id": 207,
          "admin_id": 542,
          "donor_id": 17017,
          "table_name": "commitments",
          "record_id": 23224,
          "action": "restore_commitment",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"shabanlubanga@gmail.com\",\"entity_name\":{\"id\":36316,\"name\":\"Jonalis Jude-Na\\u00edca\",\"program_id\":929},\"done_by\":\"Leslie Jobs\"}",
          "created_at": "2024-05-08T20:53:39.000000Z",
          "updated_at": "2024-05-08T20:53:39.000000Z",
          "description": "A commitment by <a href=\"/app/view_donor/17017\"><strong>shabanlubanga@gmail.com</strong></a> for <strong>Jonalis Jude-Na\u00edca</strong> has been restored"
        },
        {
          "id": 108,
          "client_id": 207,
          "admin_id": 542,
          "donor_id": 17017,
          "table_name": "commitments",
          "record_id": 23224,
          "action": "archive_commitment",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"shabanlubanga@gmail.com\",\"entity_name\":{\"id\":36316,\"name\":\"Jonalis Jude-Na\\u00edca\",\"program_id\":929},\"done_by\":\"Leslie Jobs\"}",
          "created_at": "2024-05-08T20:53:27.000000Z",
          "updated_at": "2024-05-08T20:53:27.000000Z",
          "description": "A commitment by <a href=\"/app/view_donor/17017\"><strong>shabanlubanga@gmail.com</strong></a> for <strong>Jonalis Jude-Na\u00edca</strong> has been archived"
        },
        {
          "id": 98,
          "client_id": 207,
          "admin_id": 542,
          "donor_id": 26087,
          "table_name": "donoremails",
          "record_id": 17537,
          "action": "draft_message",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"Schade\",\"entity_name\":\"Louidjivenson Vilsaint\",\"subject\":\"Hi\",\"message\":\"<p>Hi<\\/p><br>\",\"done_by\":\"Leslie Jobs\"}",
          "created_at": "2024-05-08T20:13:02.000000Z",
          "updated_at": "2024-05-08T20:13:02.000000Z",
          "description": "An email from <strong>Louidjivenson Vilsaint</strong> to <strong>Schade</strong> has been drafted"
        },
        {
          "id": 99,
          "client_id": 207,
          "admin_id": 542,
          "donor_id": 26087,
          "table_name": "donoremails",
          "record_id": 17537,
          "action": "send_message",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"Schade\",\"entity_name\":\"Louidjivenson Vilsaint\",\"subject\":\"Hi\",\"message\":\"<p>Hi<\\/p><br>\",\"done_by\":\"Leslie Jobs\"}",
          "created_at": "2024-05-08T20:13:02.000000Z",
          "updated_at": "2024-05-08T20:13:02.000000Z",
          "description": "An email from <strong>Louidjivenson Vilsaint</strong> to <strong>Schade</strong> has been sent"
        },
        {
          "id": 97,
          "client_id": 207,
          "admin_id": 542,
          "donor_id": 17135,
          "table_name": "commitments",
          "record_id": 17114,
          "action": "restore_commitment",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"dev5\",\"entity_name\":{\"id\":37501,\"name\":\"Djedjilove Auralus\",\"program_id\":929},\"done_by\":\"Leslie Jobs\"}",
          "created_at": "2024-05-08T20:06:41.000000Z",
          "updated_at": "2024-05-08T20:06:41.000000Z",
          "description": "A commitment by <a href=\"/app/view_donor/17135\"><strong>dev5</strong></a> for <strong>Djedjilove Auralus</strong> has been restored"
        },
        {
          "id": 96,
          "client_id": 207,
          "admin_id": 542,
          "donor_id": 17135,
          "table_name": "commitments",
          "record_id": 17114,
          "action": "archive_commitment",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"dev5\",\"entity_name\":{\"id\":37501,\"name\":\"Djedjilove Auralus\",\"program_id\":929},\"done_by\":\"Leslie Jobs\"}",
          "created_at": "2024-05-08T20:06:20.000000Z",
          "updated_at": "2024-05-08T20:06:20.000000Z",
          "description": "A commitment by <a href=\"/app/view_donor/17135\"><strong>dev5</strong></a> for <strong>Djedjilove Auralus</strong> has been archived"
        },
        {
          "id": 87,
          "client_id": 207,
          "admin_id": 542,
          "donor_id": 26087,
          "table_name": "donoremails",
          "record_id": 17533,
          "action": "draft_message",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"Schade\",\"entity_name\":\"Louidjivenson Vilsaint\",\"subject\":\"Hello\",\"message\":\"<p>Hello<\\/p><br>\",\"done_by\":\"Leslie Jobs\"}",
          "created_at": "2024-05-08T19:50:36.000000Z",
          "updated_at": "2024-05-08T19:50:36.000000Z",
          "description": "An email from <strong>Louidjivenson Vilsaint</strong> to <strong>Schade</strong> has been drafted"
        },
        {
          "id": 88,
          "client_id": 207,
          "admin_id": 542,
          "donor_id": 26087,
          "table_name": "donoremails",
          "record_id": 17533,
          "action": "send_message",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"Schade\",\"entity_name\":\"Louidjivenson Vilsaint\",\"subject\":\"Hello\",\"message\":\"<p>Hello<\\/p><br>\",\"done_by\":\"Leslie Jobs\"}",
          "created_at": "2024-05-08T19:50:36.000000Z",
          "updated_at": "2024-05-08T19:50:36.000000Z",
          "description": "An email from <strong>Louidjivenson Vilsaint</strong> to <strong>Schade</strong> has been sent"
        },
        {
          "id": 85,
          "client_id": 207,
          "admin_id": 542,
          "donor_id": 26092,
          "table_name": "donoremails",
          "record_id": 17532,
          "action": "draft_message",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"Diama Magic\",\"entity_name\":\"Ismylove Jean\",\"subject\":\"Hello\",\"message\":\"<p>hello<\\/p><br>\",\"done_by\":\"Leslie Jobs\"}",
          "created_at": "2024-05-08T19:49:57.000000Z",
          "updated_at": "2024-05-08T19:49:57.000000Z",
          "description": "An email from <strong>Ismylove Jean</strong> to <strong>Diama Magic</strong> has been drafted"
        },
        {
          "id": 86,
          "client_id": 207,
          "admin_id": 542,
          "donor_id": 26092,
          "table_name": "donoremails",
          "record_id": 17532,
          "action": "send_message",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"Diama Magic\",\"entity_name\":\"Ismylove Jean\",\"subject\":\"Hello\",\"message\":\"<p>hello<\\/p><br>\",\"done_by\":\"Leslie Jobs\"}",
          "created_at": "2024-05-08T19:49:57.000000Z",
          "updated_at": "2024-05-08T19:49:57.000000Z",
          "description": "An email from <strong>Ismylove Jean</strong> to <strong>Diama Magic</strong> has been sent"
        },
        {
          "id": 79,
          "client_id": 207,
          "admin_id": 542,
          "donor_id": 17017,
          "table_name": "donors",
          "record_id": 17017,
          "action": "account_setup_email",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"Test Donor Shaban Paypal, monthly\",\"done_by\":\"Leslie Jobs\"}",
          "created_at": "2024-05-08T19:23:47.000000Z",
          "updated_at": "2024-05-08T19:23:47.000000Z",
          "description": "An account setup notification email for <a href=\"/app/view_donor/17017\"><strong>Test Donor Shaban Paypal, monthly</strong></a> has been sent"
        },
        {
          "id": 75,
          "client_id": 207,
          "admin_id": 542,
          "donor_id": null,
          "table_name": "donors",
          "record_id": 24651,
          "action": "restore_donor",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"\",\"done_by\":\"Leslie Jobs\"}",
          "created_at": "2024-05-08T19:23:13.000000Z",
          "updated_at": "2024-05-08T19:23:13.000000Z",
          "description": "Donor <a href=\"/app/view_donor/24651\"><strong></strong></a> has been restored"
        },
        {
          "id": 76,
          "client_id": 207,
          "admin_id": 542,
          "donor_id": null,
          "table_name": "donors",
          "record_id": 24652,
          "action": "restore_donor",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"\",\"done_by\":\"Leslie Jobs\"}",
          "created_at": "2024-05-08T19:23:13.000000Z",
          "updated_at": "2024-05-08T19:23:13.000000Z",
          "description": "Donor <a href=\"/app/view_donor/24652\"><strong></strong></a> has been restored"
        },
        {
          "id": 77,
          "client_id": 207,
          "admin_id": 542,
          "donor_id": null,
          "table_name": "donors",
          "record_id": 24653,
          "action": "restore_donor",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"\",\"done_by\":\"Leslie Jobs\"}",
          "created_at": "2024-05-08T19:23:13.000000Z",
          "updated_at": "2024-05-08T19:23:13.000000Z",
          "description": "Donor <a href=\"/app/view_donor/24653\"><strong></strong></a> has been restored"
        },
        {
          "id": 78,
          "client_id": 207,
          "admin_id": 542,
          "donor_id": null,
          "table_name": "donors",
          "record_id": 24654,
          "action": "restore_donor",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"\",\"done_by\":\"Leslie Jobs\"}",
          "created_at": "2024-05-08T19:23:13.000000Z",
          "updated_at": "2024-05-08T19:23:13.000000Z",
          "description": "Donor <a href=\"/app/view_donor/24654\"><strong></strong></a> has been restored"
        },
        {
          "id": 69,
          "client_id": 207,
          "admin_id": 542,
          "donor_id": null,
          "table_name": "donors",
          "record_id": 16667,
          "action": "restore_donor",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"dev3\",\"done_by\":\"Leslie Jobs\"}",
          "created_at": "2024-05-08T19:23:12.000000Z",
          "updated_at": "2024-05-08T19:23:12.000000Z",
          "description": "Donor <a href=\"/app/view_donor/16667\"><strong>dev3</strong></a> has been restored"
        },
        {
          "id": 70,
          "client_id": 207,
          "admin_id": 542,
          "donor_id": null,
          "table_name": "donors",
          "record_id": 24630,
          "action": "restore_donor",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"jridge\",\"done_by\":\"Leslie Jobs\"}",
          "created_at": "2024-05-08T19:23:12.000000Z",
          "updated_at": "2024-05-08T19:23:12.000000Z",
          "description": "Donor <a href=\"/app/view_donor/24630\"><strong>jridge</strong></a> has been restored"
        },
        {
          "id": 71,
          "client_id": 207,
          "admin_id": 542,
          "donor_id": null,
          "table_name": "donors",
          "record_id": 24641,
          "action": "restore_donor",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"TestDonor5\",\"done_by\":\"Leslie Jobs\"}",
          "created_at": "2024-05-08T19:23:12.000000Z",
          "updated_at": "2024-05-08T19:23:12.000000Z",
          "description": "Donor <a href=\"/app/view_donor/24641\"><strong>TestDonor5</strong></a> has been restored"
        },
        {
          "id": 72,
          "client_id": 207,
          "admin_id": 542,
          "donor_id": null,
          "table_name": "donors",
          "record_id": 24648,
          "action": "restore_donor",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"\",\"done_by\":\"Leslie Jobs\"}",
          "created_at": "2024-05-08T19:23:12.000000Z",
          "updated_at": "2024-05-08T19:23:12.000000Z",
          "description": "Donor <a href=\"/app/view_donor/24648\"><strong></strong></a> has been restored"
        },
        {
          "id": 73,
          "client_id": 207,
          "admin_id": 542,
          "donor_id": null,
          "table_name": "donors",
          "record_id": 24649,
          "action": "restore_donor",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"\",\"done_by\":\"Leslie Jobs\"}",
          "created_at": "2024-05-08T19:23:12.000000Z",
          "updated_at": "2024-05-08T19:23:12.000000Z",
          "description": "Donor <a href=\"/app/view_donor/24649\"><strong></strong></a> has been restored"
        },
        {
          "id": 74,
          "client_id": 207,
          "admin_id": 542,
          "donor_id": null,
          "table_name": "donors",
          "record_id": 24650,
          "action": "restore_donor",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"\",\"done_by\":\"Leslie Jobs\"}",
          "created_at": "2024-05-08T19:23:12.000000Z",
          "updated_at": "2024-05-08T19:23:12.000000Z",
          "description": "Donor <a href=\"/app/view_donor/24650\"><strong></strong></a> has been restored"
        },
        {
          "id": 59,
          "client_id": 207,
          "admin_id": 542,
          "donor_id": null,
          "table_name": "donors",
          "record_id": 24630,
          "action": "archive_donor",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"jridge\",\"done_by\":\"Leslie Jobs\"}",
          "created_at": "2024-05-08T19:22:34.000000Z",
          "updated_at": "2024-05-08T19:22:34.000000Z",
          "description": "Donor <a href=\"/app/view_donor/24630\"><strong>jridge</strong></a> has been archived"
        },
        {
          "id": 60,
          "client_id": 207,
          "admin_id": 542,
          "donor_id": null,
          "table_name": "donors",
          "record_id": 24641,
          "action": "archive_donor",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"TestDonor5\",\"done_by\":\"Leslie Jobs\"}",
          "created_at": "2024-05-08T19:22:34.000000Z",
          "updated_at": "2024-05-08T19:22:34.000000Z",
          "description": "Donor <a href=\"/app/view_donor/24641\"><strong>TestDonor5</strong></a> has been archived"
        },
        {
          "id": 61,
          "client_id": 207,
          "admin_id": 542,
          "donor_id": null,
          "table_name": "donors",
          "record_id": 24649,
          "action": "archive_donor",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"\",\"done_by\":\"Leslie Jobs\"}",
          "created_at": "2024-05-08T19:22:34.000000Z",
          "updated_at": "2024-05-08T19:22:34.000000Z",
          "description": "Donor <a href=\"/app/view_donor/24649\"><strong></strong></a> has been archived"
        },
        {
          "id": 62,
          "client_id": 207,
          "admin_id": 542,
          "donor_id": null,
          "table_name": "donors",
          "record_id": 24650,
          "action": "archive_donor",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"\",\"done_by\":\"Leslie Jobs\"}",
          "created_at": "2024-05-08T19:22:34.000000Z",
          "updated_at": "2024-05-08T19:22:34.000000Z",
          "description": "Donor <a href=\"/app/view_donor/24650\"><strong></strong></a> has been archived"
        },
        {
          "id": 63,
          "client_id": 207,
          "admin_id": 542,
          "donor_id": null,
          "table_name": "donors",
          "record_id": 24651,
          "action": "archive_donor",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"\",\"done_by\":\"Leslie Jobs\"}",
          "created_at": "2024-05-08T19:22:34.000000Z",
          "updated_at": "2024-05-08T19:22:34.000000Z",
          "description": "Donor <a href=\"/app/view_donor/24651\"><strong></strong></a> has been archived"
        },
        {
          "id": 64,
          "client_id": 207,
          "admin_id": 542,
          "donor_id": null,
          "table_name": "donors",
          "record_id": 24652,
          "action": "archive_donor",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"\",\"done_by\":\"Leslie Jobs\"}",
          "created_at": "2024-05-08T19:22:34.000000Z",
          "updated_at": "2024-05-08T19:22:34.000000Z",
          "description": "Donor <a href=\"/app/view_donor/24652\"><strong></strong></a> has been archived"
        },
        {
          "id": 65,
          "client_id": 207,
          "admin_id": 542,
          "donor_id": null,
          "table_name": "donors",
          "record_id": 24653,
          "action": "archive_donor",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"\",\"done_by\":\"Leslie Jobs\"}",
          "created_at": "2024-05-08T19:22:34.000000Z",
          "updated_at": "2024-05-08T19:22:34.000000Z",
          "description": "Donor <a href=\"/app/view_donor/24653\"><strong></strong></a> has been archived"
        },
        {
          "id": 66,
          "client_id": 207,
          "admin_id": 542,
          "donor_id": null,
          "table_name": "donors",
          "record_id": 24654,
          "action": "archive_donor",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"\",\"done_by\":\"Leslie Jobs\"}",
          "created_at": "2024-05-08T19:22:34.000000Z",
          "updated_at": "2024-05-08T19:22:34.000000Z",
          "description": "Donor <a href=\"/app/view_donor/24654\"><strong></strong></a> has been archived"
        },
        {
          "id": 67,
          "client_id": 207,
          "admin_id": 542,
          "donor_id": null,
          "table_name": "donors",
          "record_id": 24655,
          "action": "archive_donor",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"\",\"done_by\":\"Leslie Jobs\"}",
          "created_at": "2024-05-08T19:22:34.000000Z",
          "updated_at": "2024-05-08T19:22:34.000000Z",
          "description": "Donor <a href=\"/app/view_donor/24655\"><strong></strong></a> has been archived"
        },
        {
          "id": 68,
          "client_id": 207,
          "admin_id": 542,
          "donor_id": null,
          "table_name": "donors",
          "record_id": 24658,
          "action": "archive_donor",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"\",\"done_by\":\"Leslie Jobs\"}",
          "created_at": "2024-05-08T19:22:34.000000Z",
          "updated_at": "2024-05-08T19:22:34.000000Z",
          "description": "Donor <a href=\"/app/view_donor/24658\"><strong></strong></a> has been archived"
        },
        {
          "id": 58,
          "client_id": 207,
          "admin_id": 542,
          "donor_id": null,
          "table_name": "donors",
          "record_id": 17017,
          "action": "restore_donor",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"shabanlubanga@gmail.com\",\"done_by\":\"Leslie Jobs\"}",
          "created_at": "2024-05-08T19:19:07.000000Z",
          "updated_at": "2024-05-08T19:19:07.000000Z",
          "description": "Donor <a href=\"/app/view_donor/17017\"><strong>shabanlubanga@gmail.com</strong></a> has been restored"
        },
        {
          "id": 57,
          "client_id": 207,
          "admin_id": 542,
          "donor_id": null,
          "table_name": "donors",
          "record_id": 17017,
          "action": "archive_donor",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"shabanlubanga@gmail.com\",\"done_by\":\"Leslie Jobs\"}",
          "created_at": "2024-05-08T19:18:43.000000Z",
          "updated_at": "2024-05-08T19:18:43.000000Z",
          "description": "Donor <a href=\"/app/view_donor/17017\"><strong>shabanlubanga@gmail.com</strong></a> has been archived"
        },
        {
          "id": 56,
          "client_id": 207,
          "admin_id": 542,
          "donor_id": null,
          "table_name": "donors",
          "record_id": 15522,
          "action": "restore_donor",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"dev1\",\"done_by\":\"Leslie Jobs\"}",
          "created_at": "2024-05-08T15:57:22.000000Z",
          "updated_at": "2024-05-08T15:57:22.000000Z",
          "description": "Donor <a href=\"/app/view_donor/15522\"><strong>dev1</strong></a> has been restored"
        },
        {
          "id": 55,
          "client_id": 207,
          "admin_id": null,
          "donor_id": 26087,
          "table_name": "commitments",
          "record_id": 23211,
          "action": "donor_charge_email",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"Schade\",\"details\":{\"method\":\"Credit Card\",\"designations\":\"Louidjivenson Vilsaint @ $32 per Month (Paid Every Month)\",\"date\":\"May 7, 2024\",\"total_amount\":32},\"subject\":\"Donation Receipt\",\"body\":\"<p>Thank you for your donation Louidjivenson Vilsaint @ $32 per Month (Paid Every Month) for 32. This email serves as your donation receipt.<\\/p>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<table style=\\\"\\\" border-color:#666;width:80%;margin:20px=\\\"\\\" auto;\\\"\\\"=\\\"\\\" cellpadding=\\\"\\\" 10\\\"\\\"=\\\"\\\">\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tbody>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tDonor Name\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t[donor_name]\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tDesignation\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t[designation_name]\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tAmount\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t$[amount]\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tMethod\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tCredit Card\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tFrequency\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t[frequency]<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tbody>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/table><p>May 7, 2024<\\/p>\",\"done_by\":\"System\"}",
          "created_at": "2024-05-07T12:07:50.000000Z",
          "updated_at": "2024-05-07T12:07:50.000000Z",
          "description": "A donation receipt email for <strong>Louidjivenson Vilsaint @ $32 per Month (Paid Every Month)</strong> has been sent to <a href=\"/app/view_donor/26087\"><strong>Schade</strong></a>"
        },
        {
          "id": 54,
          "client_id": 207,
          "admin_id": null,
          "donor_id": 17166,
          "table_name": "commitments",
          "record_id": 23210,
          "action": "donor_charge_email",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"John, Katie & Clara Richter CC Monthly\",\"details\":{\"method\":\"Credit Card\",\"designations\":\"Wilna Dervil @ $32 per Month (Paid Every Month)\",\"date\":\"May 7, 2024\",\"total_amount\":32},\"subject\":\"Donation Receipt\",\"body\":\"<p>Thank you for your donation Wilna Dervil @ $32 per Month (Paid Every Month) for 32. This email serves as your donation receipt.<\\/p>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<table style=\\\"\\\" border-color:#666;width:80%;margin:20px=\\\"\\\" auto;\\\"\\\"=\\\"\\\" cellpadding=\\\"\\\" 10\\\"\\\"=\\\"\\\">\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tbody>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tDonor Name\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t[donor_name]\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tDesignation\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t[designation_name]\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tAmount\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t$[amount]\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tMethod\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tCredit Card\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tFrequency\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t[frequency]<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tbody>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/table><p>May 7, 2024<\\/p>\",\"done_by\":\"System\"}",
          "created_at": "2024-05-07T12:07:47.000000Z",
          "updated_at": "2024-05-07T12:07:47.000000Z",
          "description": "A donation receipt email for <strong>Wilna Dervil @ $32 per Month (Paid Every Month)</strong> has been sent to <a href=\"/app/view_donor/17166\"><strong>John, Katie & Clara Richter CC Monthly</strong></a>"
        },
        {
          "id": 53,
          "client_id": 207,
          "admin_id": null,
          "donor_id": 26087,
          "table_name": "commitments",
          "record_id": 23211,
          "action": "donor_charge_email",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"Schade\",\"details\":{\"method\":\"Credit Card\",\"designations\":\"Louidjivenson Vilsaint @ $32 per Month (Paid Every Month)\",\"date\":\"May 6, 2024\",\"total_amount\":32},\"subject\":\"Donation Receipt\",\"body\":\"<p>Thank you for your donation Louidjivenson Vilsaint @ $32 per Month (Paid Every Month) for 32. This email serves as your donation receipt.<\\/p>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<table style=\\\"\\\" border-color:#666;width:80%;margin:20px=\\\"\\\" auto;\\\"\\\"=\\\"\\\" cellpadding=\\\"\\\" 10\\\"\\\"=\\\"\\\">\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tbody>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tDonor Name\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t[donor_name]\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tDesignation\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t[designation_name]\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tAmount\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t$[amount]\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tMethod\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tCredit Card\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tFrequency\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t[frequency]<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tbody>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/table><p>May 6, 2024<\\/p>\",\"done_by\":\"System\"}",
          "created_at": "2024-05-06T12:07:28.000000Z",
          "updated_at": "2024-05-06T12:07:28.000000Z",
          "description": "A donation receipt email for <strong>Louidjivenson Vilsaint @ $32 per Month (Paid Every Month)</strong> has been sent to <a href=\"/app/view_donor/26087\"><strong>Schade</strong></a>"
        },
        {
          "id": 52,
          "client_id": 207,
          "admin_id": null,
          "donor_id": 17166,
          "table_name": "commitments",
          "record_id": 23210,
          "action": "donor_charge_email",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"John, Katie & Clara Richter CC Monthly\",\"details\":{\"method\":\"Credit Card\",\"designations\":\"Wilna Dervil @ $32 per Month (Paid Every Month)\",\"date\":\"May 6, 2024\",\"total_amount\":32},\"subject\":\"Donation Receipt\",\"body\":\"<p>Thank you for your donation Wilna Dervil @ $32 per Month (Paid Every Month) for 32. This email serves as your donation receipt.<\\/p>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<table style=\\\"\\\" border-color:#666;width:80%;margin:20px=\\\"\\\" auto;\\\"\\\"=\\\"\\\" cellpadding=\\\"\\\" 10\\\"\\\"=\\\"\\\">\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tbody>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tDonor Name\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t[donor_name]\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tDesignation\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t[designation_name]\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tAmount\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t$[amount]\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tMethod\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tCredit Card\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tFrequency\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t[frequency]<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tbody>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/table><p>May 6, 2024<\\/p>\",\"done_by\":\"System\"}",
          "created_at": "2024-05-06T12:07:25.000000Z",
          "updated_at": "2024-05-06T12:07:25.000000Z",
          "description": "A donation receipt email for <strong>Wilna Dervil @ $32 per Month (Paid Every Month)</strong> has been sent to <a href=\"/app/view_donor/17166\"><strong>John, Katie & Clara Richter CC Monthly</strong></a>"
        },
        {
          "id": 51,
          "client_id": 207,
          "admin_id": 542,
          "donor_id": 17274,
          "table_name": "commitments",
          "record_id": 23261,
          "action": "add_sponsorship",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"Amanda test Online CC 19th\",\"amount\":\"32\",\"method\":\"PayPal\",\"designation\":\"Djoka\\u00ebff C\\u00e9natus\",\"done_by\":\"Leslie Jobs\"}",
          "created_at": "2024-05-06T08:08:01.000000Z",
          "updated_at": "2024-05-06T08:08:01.000000Z",
          "description": "<a href=\"/app/view_donor/17274\"><strong>Amanda test Online CC 19th</strong></a> has sponsored <strong>Djoka\u00ebff C\u00e9natus</strong> with <strong>32</strong> by <strong>PayPal</strong>"
        },
        {
          "id": 50,
          "client_id": 207,
          "admin_id": null,
          "donor_id": 17273,
          "table_name": "commitments",
          "record_id": 23260,
          "action": "payment_remider_email",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"Jim test CC monthly\",\"details\":{\"designation_name\":\"Dieuftama\\u00efka Pierre\",\"amount\":32,\"method\":\"Check\"},\"subject\":\"HYS Demo\",\"body\":\"<p>Hi [donor_name],<\\/p><p>We are updating our sponsorship database and are asking that all of our sponsors confirm if they would like to continue or discontinue their sponsorship.  <\\/p><p>Your information:<\\/p><p>Dieuftama\\u00efka Pierre sponsored for 32 Check [frequency]<\\/p><p>Please respond to this email with either continue or discontinue so we can have the most accurate information and continue to provide for the children.<\\/p><p>We sincerely thank you for your support of our ministry. It is only through people like you that we are able to do what we do.<\\/p><p>Sincerely,<\\/p><p>Sponsorship Team<\\/p>\",\"done_by\":\"System\"}",
          "created_at": "2024-05-05T12:08:17.000000Z",
          "updated_at": "2024-05-05T12:08:17.000000Z",
          "description": "A payment reminder email for <strong>Dieuftama\u00efka Pierre</strong> has been sent to <a href=\"/app/view_donor/17273\"><strong>Jim test CC monthly</strong></a>"
        },
        {
          "id": 49,
          "client_id": 207,
          "admin_id": null,
          "donor_id": 26087,
          "table_name": "commitments",
          "record_id": 23211,
          "action": "donor_charge_email",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"Schade\",\"details\":{\"method\":\"Credit Card\",\"designations\":\"Louidjivenson Vilsaint @ $32 per Month (Paid Every Month)\",\"date\":\"May 5, 2024\",\"total_amount\":32},\"subject\":\"Donation Receipt\",\"body\":\"<p>Thank you for your donation Louidjivenson Vilsaint @ $32 per Month (Paid Every Month) for 32. This email serves as your donation receipt.<\\/p>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<table style=\\\"\\\" border-color:#666;width:80%;margin:20px=\\\"\\\" auto;\\\"\\\"=\\\"\\\" cellpadding=\\\"\\\" 10\\\"\\\"=\\\"\\\">\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tbody>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tDonor Name\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t[donor_name]\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tDesignation\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t[designation_name]\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tAmount\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t$[amount]\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tMethod\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tCredit Card\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tFrequency\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t[frequency]<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tbody>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/table><p>May 5, 2024<\\/p>\",\"done_by\":\"System\"}",
          "created_at": "2024-05-05T12:07:10.000000Z",
          "updated_at": "2024-05-05T12:07:10.000000Z",
          "description": "A donation receipt email for <strong>Louidjivenson Vilsaint @ $32 per Month (Paid Every Month)</strong> has been sent to <a href=\"/app/view_donor/26087\"><strong>Schade</strong></a>"
        },
        {
          "id": 48,
          "client_id": 207,
          "admin_id": null,
          "donor_id": 17166,
          "table_name": "commitments",
          "record_id": 23210,
          "action": "donor_charge_email",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"John, Katie & Clara Richter CC Monthly\",\"details\":{\"method\":\"Credit Card\",\"designations\":\"Wilna Dervil @ $32 per Month (Paid Every Month)\",\"date\":\"May 5, 2024\",\"total_amount\":32},\"subject\":\"Donation Receipt\",\"body\":\"<p>Thank you for your donation Wilna Dervil @ $32 per Month (Paid Every Month) for 32. This email serves as your donation receipt.<\\/p>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<table style=\\\"\\\" border-color:#666;width:80%;margin:20px=\\\"\\\" auto;\\\"\\\"=\\\"\\\" cellpadding=\\\"\\\" 10\\\"\\\"=\\\"\\\">\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tbody>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tDonor Name\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t[donor_name]\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tDesignation\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t[designation_name]\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tAmount\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t$[amount]\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tMethod\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tCredit Card\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tFrequency\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t[frequency]<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tbody>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/table><p>May 5, 2024<\\/p>\",\"done_by\":\"System\"}",
          "created_at": "2024-05-05T12:07:07.000000Z",
          "updated_at": "2024-05-05T12:07:07.000000Z",
          "description": "A donation receipt email for <strong>Wilna Dervil @ $32 per Month (Paid Every Month)</strong> has been sent to <a href=\"/app/view_donor/17166\"><strong>John, Katie & Clara Richter CC Monthly</strong></a>"
        },
        {
          "id": 47,
          "client_id": 207,
          "admin_id": null,
          "donor_id": 17273,
          "table_name": "commitments",
          "record_id": 23260,
          "action": "payment_remider_email",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"Jim test CC monthly\",\"details\":{\"designation_name\":\"Dieuftama\\u00efka Pierre\",\"amount\":32,\"method\":\"Check\"},\"subject\":\"HYS Demo\",\"body\":\"<p>Hi [donor_name],<\\/p><p>We are updating our sponsorship database and are asking that all of our sponsors confirm if they would like to continue or discontinue their sponsorship.  <\\/p><p>Your information:<\\/p><p>Dieuftama\\u00efka Pierre sponsored for 32 Check [frequency]<\\/p><p>Please respond to this email with either continue or discontinue so we can have the most accurate information and continue to provide for the children.<\\/p><p>We sincerely thank you for your support of our ministry. It is only through people like you that we are able to do what we do.<\\/p><p>Sincerely,<\\/p><p>Sponsorship Team<\\/p>\",\"done_by\":\"System\"}",
          "created_at": "2024-05-04T12:08:05.000000Z",
          "updated_at": "2024-05-04T12:08:05.000000Z",
          "description": "A payment reminder email for <strong>Dieuftama\u00efka Pierre</strong> has been sent to <a href=\"/app/view_donor/17273\"><strong>Jim test CC monthly</strong></a>"
        },
        {
          "id": 46,
          "client_id": 207,
          "admin_id": null,
          "donor_id": 26087,
          "table_name": "commitments",
          "record_id": 23211,
          "action": "donor_charge_email",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"Schade\",\"details\":{\"method\":\"Credit Card\",\"designations\":\"Louidjivenson Vilsaint @ $32 per Month (Paid Every Month)\",\"date\":\"May 4, 2024\",\"total_amount\":32},\"subject\":\"Donation Receipt\",\"body\":\"<p>Thank you for your donation Louidjivenson Vilsaint @ $32 per Month (Paid Every Month) for 32. This email serves as your donation receipt.<\\/p>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<table style=\\\"\\\" border-color:#666;width:80%;margin:20px=\\\"\\\" auto;\\\"\\\"=\\\"\\\" cellpadding=\\\"\\\" 10\\\"\\\"=\\\"\\\">\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tbody>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tDonor Name\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t[donor_name]\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tDesignation\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t[designation_name]\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tAmount\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t$[amount]\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tMethod\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tCredit Card\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tFrequency\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t[frequency]<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tbody>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/table><p>May 4, 2024<\\/p>\",\"done_by\":\"System\"}",
          "created_at": "2024-05-04T12:06:59.000000Z",
          "updated_at": "2024-05-04T12:06:59.000000Z",
          "description": "A donation receipt email for <strong>Louidjivenson Vilsaint @ $32 per Month (Paid Every Month)</strong> has been sent to <a href=\"/app/view_donor/26087\"><strong>Schade</strong></a>"
        },
        {
          "id": 45,
          "client_id": 207,
          "admin_id": null,
          "donor_id": 17166,
          "table_name": "commitments",
          "record_id": 23210,
          "action": "donor_charge_email",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"John, Katie & Clara Richter CC Monthly\",\"details\":{\"method\":\"Credit Card\",\"designations\":\"Wilna Dervil @ $32 per Month (Paid Every Month)\",\"date\":\"May 4, 2024\",\"total_amount\":32},\"subject\":\"Donation Receipt\",\"body\":\"<p>Thank you for your donation Wilna Dervil @ $32 per Month (Paid Every Month) for 32. This email serves as your donation receipt.<\\/p>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<table style=\\\"\\\" border-color:#666;width:80%;margin:20px=\\\"\\\" auto;\\\"\\\"=\\\"\\\" cellpadding=\\\"\\\" 10\\\"\\\"=\\\"\\\">\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tbody>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tDonor Name\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t[donor_name]\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tDesignation\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t[designation_name]\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tAmount\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t$[amount]\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tMethod\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tCredit Card\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tFrequency\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t[frequency]<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tbody>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/table><p>May 4, 2024<\\/p>\",\"done_by\":\"System\"}",
          "created_at": "2024-05-04T12:06:56.000000Z",
          "updated_at": "2024-05-04T12:06:56.000000Z",
          "description": "A donation receipt email for <strong>Wilna Dervil @ $32 per Month (Paid Every Month)</strong> has been sent to <a href=\"/app/view_donor/17166\"><strong>John, Katie & Clara Richter CC Monthly</strong></a>"
        },
        {
          "id": 44,
          "client_id": 207,
          "admin_id": 542,
          "donor_id": 17273,
          "table_name": "commitments",
          "record_id": 23260,
          "action": "add_sponsorship",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"Jim test CC monthly\",\"amount\":\"32\",\"method\":\"Check\",\"designation\":\"Dieuftama\\u00efka Pierre\",\"done_by\":\"Leslie Jobs\"}",
          "created_at": "2024-05-04T08:21:07.000000Z",
          "updated_at": "2024-05-04T08:21:07.000000Z",
          "description": "<a href=\"/app/view_donor/17273\"><strong>Jim test CC monthly</strong></a> has sponsored <strong>Dieuftama\u00efka Pierre</strong> with <strong>32</strong> by <strong>Check</strong>"
        },
        {
          "id": 43,
          "client_id": 207,
          "admin_id": 542,
          "donor_id": 17135,
          "table_name": "donations",
          "record_id": 379470,
          "action": "add_donation",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"Dianne Test CC Monthly\",\"amount\":\"50\",\"method\":\"Wire Transfer\",\"designation\":\"Djedjilove Auralus\",\"done_by\":\"Leslie Jobs\"}",
          "created_at": "2024-05-03T16:32:35.000000Z",
          "updated_at": "2024-05-03T16:32:35.000000Z",
          "description": "<a href=\"/app/view_donor/17135\"><strong>Dianne Test CC Monthly</strong></a> has donated <strong>50</strong> by <strong>Wire Transfer</strong> for <strong>Djedjilove Auralus</strong>"
        },
        {
          "id": 42,
          "client_id": 207,
          "admin_id": null,
          "donor_id": 17166,
          "table_name": "commitments",
          "record_id": 23259,
          "action": "donor_charge_email",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"John, Katie & Clara Richter CC Monthly\",\"details\":{\"method\":\"Credit Card\",\"designations\":\"Choudna Pierre @ $32 per Month (Paid Every Month)\",\"date\":\"May 3, 2024\",\"total_amount\":32},\"subject\":\"Donation Receipt\",\"body\":\"<p>Thank you for your donation Choudna Pierre @ $32 per Month (Paid Every Month) for 32. This email serves as your donation receipt.<\\/p>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<table style=\\\"\\\" border-color:#666;width:80%;margin:20px=\\\"\\\" auto;\\\"\\\"=\\\"\\\" cellpadding=\\\"\\\" 10\\\"\\\"=\\\"\\\">\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tbody>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tDonor Name\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t[donor_name]\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tDesignation\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t[designation_name]\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tAmount\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t$[amount]\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tMethod\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tCredit Card\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tFrequency\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t[frequency]<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tbody>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/table><p>May 3, 2024<\\/p>\",\"done_by\":\"System\"}",
          "created_at": "2024-05-03T12:08:17.000000Z",
          "updated_at": "2024-05-03T12:08:17.000000Z",
          "description": "A donation receipt email for <strong>Choudna Pierre @ $32 per Month (Paid Every Month)</strong> has been sent to <a href=\"/app/view_donor/17166\"><strong>John, Katie & Clara Richter CC Monthly</strong></a>"
        },
        {
          "id": 41,
          "client_id": 207,
          "admin_id": null,
          "donor_id": 26087,
          "table_name": "commitments",
          "record_id": 23211,
          "action": "donor_charge_email",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"Schade\",\"details\":{\"method\":\"Credit Card\",\"designations\":\"Louidjivenson Vilsaint @ $32 per Month (Paid Every Month)\",\"date\":\"May 3, 2024\",\"total_amount\":32},\"subject\":\"Donation Receipt\",\"body\":\"<p>Thank you for your donation Louidjivenson Vilsaint @ $32 per Month (Paid Every Month) for 32. This email serves as your donation receipt.<\\/p>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<table style=\\\"\\\" border-color:#666;width:80%;margin:20px=\\\"\\\" auto;\\\"\\\"=\\\"\\\" cellpadding=\\\"\\\" 10\\\"\\\"=\\\"\\\">\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tbody>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tDonor Name\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t[donor_name]\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tDesignation\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t[designation_name]\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tAmount\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t$[amount]\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tMethod\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tCredit Card\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tFrequency\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t[frequency]<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tbody>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/table><p>May 3, 2024<\\/p>\",\"done_by\":\"System\"}",
          "created_at": "2024-05-03T12:07:08.000000Z",
          "updated_at": "2024-05-03T12:07:08.000000Z",
          "description": "A donation receipt email for <strong>Louidjivenson Vilsaint @ $32 per Month (Paid Every Month)</strong> has been sent to <a href=\"/app/view_donor/26087\"><strong>Schade</strong></a>"
        },
        {
          "id": 40,
          "client_id": 207,
          "admin_id": null,
          "donor_id": 17166,
          "table_name": "commitments",
          "record_id": 23210,
          "action": "donor_charge_email",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"John, Katie & Clara Richter CC Monthly\",\"details\":{\"method\":\"Credit Card\",\"designations\":\"Wilna Dervil @ $32 per Month (Paid Every Month)\",\"date\":\"May 3, 2024\",\"total_amount\":32},\"subject\":\"Donation Receipt\",\"body\":\"<p>Thank you for your donation Wilna Dervil @ $32 per Month (Paid Every Month) for 32. This email serves as your donation receipt.<\\/p>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<table style=\\\"\\\" border-color:#666;width:80%;margin:20px=\\\"\\\" auto;\\\"\\\"=\\\"\\\" cellpadding=\\\"\\\" 10\\\"\\\"=\\\"\\\">\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tbody>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tDonor Name\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t[donor_name]\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tDesignation\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t[designation_name]\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tAmount\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t$[amount]\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tMethod\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tCredit Card\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tFrequency\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t[frequency]<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tbody>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/table><p>May 3, 2024<\\/p>\",\"done_by\":\"System\"}",
          "created_at": "2024-05-03T12:07:05.000000Z",
          "updated_at": "2024-05-03T12:07:05.000000Z",
          "description": "A donation receipt email for <strong>Wilna Dervil @ $32 per Month (Paid Every Month)</strong> has been sent to <a href=\"/app/view_donor/17166\"><strong>John, Katie & Clara Richter CC Monthly</strong></a>"
        },
        {
          "id": 39,
          "client_id": 207,
          "admin_id": 542,
          "donor_id": 17166,
          "table_name": "commitments",
          "record_id": 23259,
          "action": "add_sponsorship",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"John, Katie & Clara Richter CC Monthly\",\"amount\":\"32\",\"method\":\"Credit Card\",\"designation\":\"Choudna Pierre\",\"done_by\":\"Leslie Jobs\"}",
          "created_at": "2024-05-03T08:51:20.000000Z",
          "updated_at": "2024-05-03T08:51:20.000000Z",
          "description": "<a href=\"/app/view_donor/17166\"><strong>John, Katie & Clara Richter CC Monthly</strong></a> has sponsored <strong>Choudna Pierre</strong> with <strong>32</strong> by <strong>Credit Card</strong>"
        },
        {
          "id": 38,
          "client_id": 207,
          "admin_id": 542,
          "donor_id": 17135,
          "table_name": "donations",
          "record_id": 379462,
          "action": "add_donation",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"Dianne Test CC Monthly\",\"amount\":\"11.00\",\"method\":\"Credit Card\",\"designation\":\"Alvens John Kennley Estil\",\"done_by\":\"Leslie Jobs\"}",
          "created_at": "2024-05-02T22:41:16.000000Z",
          "updated_at": "2024-05-02T22:41:16.000000Z",
          "description": "<a href=\"/app/view_donor/17135\"><strong>Dianne Test CC Monthly</strong></a> has donated <strong>11.00</strong> by <strong>Credit Card</strong> for <strong>Alvens John Kennley Estil</strong>"
        },
        {
          "id": 37,
          "client_id": 207,
          "admin_id": 542,
          "donor_id": 17135,
          "table_name": "donations",
          "record_id": 379461,
          "action": "add_donation",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"Dianne Test CC Monthly\",\"amount\":\"10.00\",\"method\":\"Credit Card\",\"designation\":\"Alvens John Kennley Estil\",\"done_by\":\"Leslie Jobs\"}",
          "created_at": "2024-05-02T22:40:51.000000Z",
          "updated_at": "2024-05-02T22:40:51.000000Z",
          "description": "<a href=\"/app/view_donor/17135\"><strong>Dianne Test CC Monthly</strong></a> has donated <strong>10.00</strong> by <strong>Credit Card</strong> for <strong>Alvens John Kennley Estil</strong>"
        },
        {
          "id": 259,
          "client_id": 207,
          "admin_id": null,
          "donor_id": 17166,
          "table_name": "donations",
          "record_id": 379518,
          "action": "commitment_donation_email",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"John, Katie & Clara Richter CC Monthly\",\"details\":{\"donor\":{\"id\":\"17166\",\"client_id\":\"207\",\"hysform_id\":\"639\",\"do_not_email\":\"0\",\"wait_time\":\"\",\"who_added\":\"{\\\"type\\\":\\\"donor\\\",\\\"method\\\":\\\"individual\\\",\\\"id\\\":\\\"\\\"}\",\"stripe_cust_id\":\"\",\"authorize_profile\":\"\",\"json_fields\":\"{\\\"dn_donor_name\\\":\\\"John, Katie & Clara Richter\\\",\\\"dn_address\\\":\\\"dev+6@helpyousponsor.com\\\",\\\"dn_home_address\\\":\\\"405 Hackberry Ln Box 363\\\",\\\"dn_payment_type\\\":\\\"CC Monthly\\\",\\\"dn_child_sponsored\\\":\\\"Estilien Claudensky\\\",\\\"fakeusernameremembered\\\":\\\"\\\",\\\"fakepasswordremembered\\\":\\\"\\\",\\\"password\\\":\\\"\\\"}\",\"deleted_at\":\"\",\"created_at\":\"2018-11-04T22:27:57.000000Z\",\"updated_at\":\"2020-09-09T00:34:40.000000Z\",\"last_login\":\"2020-09-09 00:34:20\",\"__hevo__database_name\":\"apphys_new\",\"__hevo__ingested_at\":\"1679725257574\",\"__hevo__marked_deleted\":\"0\",\"__hevo__source_modified_at\":\"\",\"stripe_card_id\":\"\",\"paypal_email\":\"\",\"dn_donor_name\":\"John, Katie & Clara Richter\",\"dn_address\":\"dev+6@helpyousponsor.com\",\"dn_home_address\":\"405 Hackberry Ln Box 363\",\"dn_payment_type\":\"CC Monthly\",\"dn_child_sponsored\":\"Estilien Claudensky\",\"fakeusernameremembered\":\"\",\"fakepasswordremembered\":\"\",\"donor_id\":\"17166\"},\"donation\":{\"designations\":\"Wilna Dervil @ 32 (Every Month)\",\"total_amount\":32,\"method\":\"Credit Card\",\"date\":\"May 2, 2024\"}},\"subject\":\"Donation Receipt\",\"body\":\"<p>Thank you for your donation Wilna Dervil @ 32 (Every Month) for 32. This email serves as your donation receipt.<\\/p>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<table style=\\\"\\\" border-color:#666;width:80%;margin:20px=\\\"\\\" auto;\\\"\\\"=\\\"\\\" cellpadding=\\\"\\\" 10\\\"\\\"=\\\"\\\">\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tbody>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tDonor Name\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t[donor_name]\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tDesignation\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t[designation_name]\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tAmount\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t$[amount]\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tMethod\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tCredit Card\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tFrequency\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t[frequency]<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tbody>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/table><p>May 2, 2024<\\/p>\",\"done_by\":\"System\"}",
          "created_at": "2024-05-02T18:53:20.000000Z",
          "updated_at": "2024-05-02T18:53:20.000000Z",
          "description": "A commitment donation receipt email for <strong>Estilien Claudensky</strong> has been sent to <a href=\"/app/view_donor/17166\"><strong>John, Katie & Clara Richter CC Monthly</strong></a>"
        },
        {
          "id": 272,
          "client_id": 207,
          "admin_id": null,
          "donor_id": 17166,
          "table_name": "donations",
          "record_id": 379518,
          "action": "commitment_donation_email",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"John, Katie & Clara Richter CC Monthly\",\"details\":{\"donor\":{\"id\":\"17166\",\"client_id\":\"207\",\"hysform_id\":\"639\",\"do_not_email\":\"0\",\"wait_time\":\"\",\"who_added\":\"{\\\"type\\\":\\\"donor\\\",\\\"method\\\":\\\"individual\\\",\\\"id\\\":\\\"\\\"}\",\"stripe_cust_id\":\"\",\"authorize_profile\":\"\",\"json_fields\":\"{\\\"dn_donor_name\\\":\\\"John, Katie & Clara Richter\\\",\\\"dn_address\\\":\\\"dev+6@helpyousponsor.com\\\",\\\"dn_home_address\\\":\\\"405 Hackberry Ln Box 363\\\",\\\"dn_payment_type\\\":\\\"CC Monthly\\\",\\\"dn_child_sponsored\\\":\\\"Estilien Claudensky\\\",\\\"fakeusernameremembered\\\":\\\"\\\",\\\"fakepasswordremembered\\\":\\\"\\\",\\\"password\\\":\\\"\\\"}\",\"deleted_at\":\"\",\"created_at\":\"2018-11-04T22:27:57.000000Z\",\"updated_at\":\"2020-09-09T00:34:40.000000Z\",\"last_login\":\"2020-09-09 00:34:20\",\"__hevo__database_name\":\"apphys_new\",\"__hevo__ingested_at\":\"1679725257574\",\"__hevo__marked_deleted\":\"0\",\"__hevo__source_modified_at\":\"\",\"stripe_card_id\":\"\",\"paypal_email\":\"\",\"dn_donor_name\":\"John, Katie & Clara Richter\",\"dn_address\":\"dev+6@helpyousponsor.com\",\"dn_home_address\":\"405 Hackberry Ln Box 363\",\"dn_payment_type\":\"CC Monthly\",\"dn_child_sponsored\":\"Estilien Claudensky\",\"fakeusernameremembered\":\"\",\"fakepasswordremembered\":\"\",\"donor_id\":\"17166\"},\"donation\":{\"designations\":\"Wilna Dervil @ 32 (Every Month)\",\"total_amount\":32,\"method\":\"Credit Card\",\"date\":\"May 2, 2024\"}},\"subject\":\"Donation Receipt\",\"body\":\"<p>Thank you for your donation Wilna Dervil @ 32 (Every Month) for 32. This email serves as your donation receipt.<\\/p>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<table style=\\\"\\\" border-color:#666;width:80%;margin:20px=\\\"\\\" auto;\\\"\\\"=\\\"\\\" cellpadding=\\\"\\\" 10\\\"\\\"=\\\"\\\">\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tbody>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tDonor Name\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t[donor_name]\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tDesignation\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t[designation_name]\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tAmount\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t$[amount]\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tMethod\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tCredit Card\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tFrequency\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t[frequency]<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tbody>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/table><p>May 2, 2024<\\/p>\",\"done_by\":\"System\"}",
          "created_at": "2024-05-02T18:53:20.000000Z",
          "updated_at": "2024-05-02T18:53:20.000000Z",
          "description": "A commitment donation receipt email for <strong>Estilien Claudensky</strong> has been sent to <a href=\"/app/view_donor/17166\"><strong>John, Katie & Clara Richter CC Monthly</strong></a>"
        },
        {
          "id": 258,
          "client_id": 207,
          "admin_id": null,
          "donor_id": 17166,
          "table_name": "donations",
          "record_id": 379517,
          "action": "commitment_donation_email",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"John, Katie & Clara Richter CC Monthly\",\"details\":{\"donor\":{\"id\":\"17166\",\"client_id\":\"207\",\"hysform_id\":\"639\",\"do_not_email\":\"0\",\"wait_time\":\"\",\"who_added\":\"{\\\"type\\\":\\\"donor\\\",\\\"method\\\":\\\"individual\\\",\\\"id\\\":\\\"\\\"}\",\"stripe_cust_id\":\"\",\"authorize_profile\":\"\",\"json_fields\":\"{\\\"dn_donor_name\\\":\\\"John, Katie & Clara Richter\\\",\\\"dn_address\\\":\\\"dev+6@helpyousponsor.com\\\",\\\"dn_home_address\\\":\\\"405 Hackberry Ln Box 363\\\",\\\"dn_payment_type\\\":\\\"CC Monthly\\\",\\\"dn_child_sponsored\\\":\\\"Estilien Claudensky\\\",\\\"fakeusernameremembered\\\":\\\"\\\",\\\"fakepasswordremembered\\\":\\\"\\\",\\\"password\\\":\\\"\\\"}\",\"deleted_at\":\"\",\"created_at\":\"2018-11-04T22:27:57.000000Z\",\"updated_at\":\"2020-09-09T00:34:40.000000Z\",\"last_login\":\"2020-09-09 00:34:20\",\"__hevo__database_name\":\"apphys_new\",\"__hevo__ingested_at\":\"1679725257574\",\"__hevo__marked_deleted\":\"0\",\"__hevo__source_modified_at\":\"\",\"stripe_card_id\":\"\",\"paypal_email\":\"\",\"dn_donor_name\":\"John, Katie & Clara Richter\",\"dn_address\":\"dev+6@helpyousponsor.com\",\"dn_home_address\":\"405 Hackberry Ln Box 363\",\"dn_payment_type\":\"CC Monthly\",\"dn_child_sponsored\":\"Estilien Claudensky\",\"fakeusernameremembered\":\"\",\"fakepasswordremembered\":\"\",\"donor_id\":\"17166\"},\"donation\":{\"designations\":\"Estilien Claudensky @ 32 (Every Month)\",\"total_amount\":32,\"method\":\"Credit Card\",\"date\":\"May 2, 2024\"}},\"subject\":\"Donation Receipt\",\"body\":\"<p>Thank you for your donation Estilien Claudensky @ 32 (Every Month) for 32. This email serves as your donation receipt.<\\/p>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<table style=\\\"\\\" border-color:#666;width:80%;margin:20px=\\\"\\\" auto;\\\"\\\"=\\\"\\\" cellpadding=\\\"\\\" 10\\\"\\\"=\\\"\\\">\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tbody>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tDonor Name\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t[donor_name]\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tDesignation\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t[designation_name]\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tAmount\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t$[amount]\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tMethod\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tCredit Card\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tFrequency\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t[frequency]<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tbody>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/table><p>May 2, 2024<\\/p>\",\"done_by\":\"System\"}",
          "created_at": "2024-05-02T18:51:00.000000Z",
          "updated_at": "2024-05-02T18:51:00.000000Z",
          "description": "A commitment donation receipt email for <strong>Estilien Claudensky</strong> has been sent to <a href=\"/app/view_donor/17166\"><strong>John, Katie & Clara Richter CC Monthly</strong></a>"
        },
        {
          "id": 271,
          "client_id": 207,
          "admin_id": null,
          "donor_id": 17166,
          "table_name": "donations",
          "record_id": 379517,
          "action": "commitment_donation_email",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"John, Katie & Clara Richter CC Monthly\",\"details\":{\"donor\":{\"id\":\"17166\",\"client_id\":\"207\",\"hysform_id\":\"639\",\"do_not_email\":\"0\",\"wait_time\":\"\",\"who_added\":\"{\\\"type\\\":\\\"donor\\\",\\\"method\\\":\\\"individual\\\",\\\"id\\\":\\\"\\\"}\",\"stripe_cust_id\":\"\",\"authorize_profile\":\"\",\"json_fields\":\"{\\\"dn_donor_name\\\":\\\"John, Katie & Clara Richter\\\",\\\"dn_address\\\":\\\"dev+6@helpyousponsor.com\\\",\\\"dn_home_address\\\":\\\"405 Hackberry Ln Box 363\\\",\\\"dn_payment_type\\\":\\\"CC Monthly\\\",\\\"dn_child_sponsored\\\":\\\"Estilien Claudensky\\\",\\\"fakeusernameremembered\\\":\\\"\\\",\\\"fakepasswordremembered\\\":\\\"\\\",\\\"password\\\":\\\"\\\"}\",\"deleted_at\":\"\",\"created_at\":\"2018-11-04T22:27:57.000000Z\",\"updated_at\":\"2020-09-09T00:34:40.000000Z\",\"last_login\":\"2020-09-09 00:34:20\",\"__hevo__database_name\":\"apphys_new\",\"__hevo__ingested_at\":\"1679725257574\",\"__hevo__marked_deleted\":\"0\",\"__hevo__source_modified_at\":\"\",\"stripe_card_id\":\"\",\"paypal_email\":\"\",\"dn_donor_name\":\"John, Katie & Clara Richter\",\"dn_address\":\"dev+6@helpyousponsor.com\",\"dn_home_address\":\"405 Hackberry Ln Box 363\",\"dn_payment_type\":\"CC Monthly\",\"dn_child_sponsored\":\"Estilien Claudensky\",\"fakeusernameremembered\":\"\",\"fakepasswordremembered\":\"\",\"donor_id\":\"17166\"},\"donation\":{\"designations\":\"Estilien Claudensky @ 32 (Every Month)\",\"total_amount\":32,\"method\":\"Credit Card\",\"date\":\"May 2, 2024\"}},\"subject\":\"Donation Receipt\",\"body\":\"<p>Thank you for your donation Estilien Claudensky @ 32 (Every Month) for 32. This email serves as your donation receipt.<\\/p>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<table style=\\\"\\\" border-color:#666;width:80%;margin:20px=\\\"\\\" auto;\\\"\\\"=\\\"\\\" cellpadding=\\\"\\\" 10\\\"\\\"=\\\"\\\">\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tbody>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tDonor Name\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t[donor_name]\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tDesignation\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t[designation_name]\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tAmount\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t$[amount]\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tMethod\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tCredit Card\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tFrequency\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t[frequency]<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tbody>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/table><p>May 2, 2024<\\/p>\",\"done_by\":\"System\"}",
          "created_at": "2024-05-02T18:51:00.000000Z",
          "updated_at": "2024-05-02T18:51:00.000000Z",
          "description": "A commitment donation receipt email for <strong>Estilien Claudensky</strong> has been sent to <a href=\"/app/view_donor/17166\"><strong>John, Katie & Clara Richter CC Monthly</strong></a>"
        },
        {
          "id": 33,
          "client_id": 207,
          "admin_id": 542,
          "donor_id": 17166,
          "table_name": "donations",
          "record_id": 379458,
          "action": "add_donation_receipt_email",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"John, Katie & Clara Richter CC Monthly\",\"emailset_id\":337,\"details\":{\"donor\":{\"id\":\"17166\",\"client_id\":\"207\",\"hysform_id\":\"639\",\"do_not_email\":\"0\",\"wait_time\":\"\",\"who_added\":\"{\\\"type\\\":\\\"donor\\\",\\\"method\\\":\\\"individual\\\",\\\"id\\\":\\\"\\\"}\",\"stripe_cust_id\":\"\",\"authorize_profile\":\"\",\"json_fields\":\"{\\\"dn_donor_name\\\":\\\"John, Katie & Clara Richter\\\",\\\"dn_address\\\":\\\"dev+6@helpyousponsor.com\\\",\\\"dn_home_address\\\":\\\"405 Hackberry Ln Box 363\\\",\\\"dn_payment_type\\\":\\\"CC Monthly\\\",\\\"dn_child_sponsored\\\":\\\"Estilien Claudensky\\\",\\\"fakeusernameremembered\\\":\\\"\\\",\\\"fakepasswordremembered\\\":\\\"\\\",\\\"password\\\":\\\"\\\"}\",\"deleted_at\":\"\",\"created_at\":\"2018-11-04T22:27:57.000000Z\",\"updated_at\":\"2020-09-09T00:34:40.000000Z\",\"last_login\":\"2020-09-09 00:34:20\",\"__hevo__database_name\":\"apphys_new\",\"__hevo__ingested_at\":\"1679725257574\",\"__hevo__marked_deleted\":\"0\",\"__hevo__source_modified_at\":\"\",\"stripe_card_id\":\"\",\"paypal_email\":\"\",\"dn_donor_name\":\"John, Katie & Clara Richter\",\"dn_address\":\"dev+6@helpyousponsor.com\",\"dn_home_address\":\"405 Hackberry Ln Box 363\",\"dn_payment_type\":\"CC Monthly\",\"dn_child_sponsored\":\"Estilien Claudensky\",\"fakeusernameremembered\":\"\",\"fakepasswordremembered\":\"\",\"donor_id\":\"17166\"},\"donation\":{\"designations\":\" @ 25.00 (One-time)\",\"total_amount\":\"25.00\",\"method\":\"Credit Card\",\"date\":\"May 3, 2024\"}},\"subject\":\"Donation Receipt\",\"body\":\"<p>Thank you for your donation  @ 25.00 (One-time) for 25.00. This email serves as your donation receipt.<\\/p>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<table style=\\\"\\\" border-color:#666;width:80%;margin:20px=\\\"\\\" auto;\\\"\\\"=\\\"\\\" cellpadding=\\\"\\\" 10\\\"\\\"=\\\"\\\">\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tbody>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tDonor Name\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t[donor_name]\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tDesignation\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t[designation_name]\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tAmount\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t$[amount]\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tMethod\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tCredit Card\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tFrequency\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t[frequency]<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tbody>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/table><p>May 3, 2024<\\/p>\",\"done_by\":\"System\"}",
          "created_at": "2024-05-02T18:47:08.000000Z",
          "updated_at": "2024-05-02T18:47:08.000000Z",
          "description": "A donation receipt email for <strong></strong> has been sent to <strong>John, Katie & Clara Richter CC Monthly</strong>"
        },
        {
          "id": 34,
          "client_id": 207,
          "admin_id": 542,
          "donor_id": 17166,
          "table_name": "donations",
          "record_id": 379458,
          "action": "add_donation",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"John, Katie & Clara Richter CC Monthly\",\"amount\":\"25.00\",\"method\":\"Credit Card\",\"designation\":\"Wilna Dervil\",\"done_by\":\"Leslie Jobs\"}",
          "created_at": "2024-05-02T18:47:08.000000Z",
          "updated_at": "2024-05-02T18:47:08.000000Z",
          "description": "<a href=\"/app/view_donor/17166\"><strong>John, Katie & Clara Richter CC Monthly</strong></a> has donated <strong>25.00</strong> by <strong>Credit Card</strong> for <strong>Wilna Dervil</strong>"
        },
        {
          "id": 32,
          "client_id": 207,
          "admin_id": 542,
          "donor_id": 17166,
          "table_name": "donations",
          "record_id": 379457,
          "action": "add_donation",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"John, Katie & Clara Richter CC Monthly\",\"amount\":\"20.00\",\"method\":\"Credit Card\",\"designation\":\"Wilna Dervil\",\"done_by\":\"Leslie Jobs\"}",
          "created_at": "2024-05-02T18:46:31.000000Z",
          "updated_at": "2024-05-02T18:46:31.000000Z",
          "description": "<a href=\"/app/view_donor/17166\"><strong>John, Katie & Clara Richter CC Monthly</strong></a> has donated <strong>20.00</strong> by <strong>Credit Card</strong> for <strong>Wilna Dervil</strong>"
        },
        {
          "id": 31,
          "client_id": 207,
          "admin_id": 542,
          "donor_id": 17166,
          "table_name": "donations",
          "record_id": 379457,
          "action": "add_donation_receipt_email",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"John, Katie & Clara Richter CC Monthly\",\"emailset_id\":337,\"details\":{\"donor\":{\"id\":\"17166\",\"client_id\":\"207\",\"hysform_id\":\"639\",\"do_not_email\":\"0\",\"wait_time\":\"\",\"who_added\":\"{\\\"type\\\":\\\"donor\\\",\\\"method\\\":\\\"individual\\\",\\\"id\\\":\\\"\\\"}\",\"stripe_cust_id\":\"\",\"authorize_profile\":\"\",\"json_fields\":\"{\\\"dn_donor_name\\\":\\\"John, Katie & Clara Richter\\\",\\\"dn_address\\\":\\\"dev+6@helpyousponsor.com\\\",\\\"dn_home_address\\\":\\\"405 Hackberry Ln Box 363\\\",\\\"dn_payment_type\\\":\\\"CC Monthly\\\",\\\"dn_child_sponsored\\\":\\\"Estilien Claudensky\\\",\\\"fakeusernameremembered\\\":\\\"\\\",\\\"fakepasswordremembered\\\":\\\"\\\",\\\"password\\\":\\\"\\\"}\",\"deleted_at\":\"\",\"created_at\":\"2018-11-04T22:27:57.000000Z\",\"updated_at\":\"2020-09-09T00:34:40.000000Z\",\"last_login\":\"2020-09-09 00:34:20\",\"__hevo__database_name\":\"apphys_new\",\"__hevo__ingested_at\":\"1679725257574\",\"__hevo__marked_deleted\":\"0\",\"__hevo__source_modified_at\":\"\",\"stripe_card_id\":\"\",\"paypal_email\":\"\",\"dn_donor_name\":\"John, Katie & Clara Richter\",\"dn_address\":\"dev+6@helpyousponsor.com\",\"dn_home_address\":\"405 Hackberry Ln Box 363\",\"dn_payment_type\":\"CC Monthly\",\"dn_child_sponsored\":\"Estilien Claudensky\",\"fakeusernameremembered\":\"\",\"fakepasswordremembered\":\"\",\"donor_id\":\"17166\"},\"donation\":{\"designations\":\" @ 20.00 (One-time)\",\"total_amount\":\"20.00\",\"method\":\"Credit Card\",\"date\":\"May 2, 2024\"}},\"subject\":\"Donation Receipt\",\"body\":\"<p>Thank you for your donation  @ 20.00 (One-time) for 20.00. This email serves as your donation receipt.<\\/p>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<table style=\\\"\\\" border-color:#666;width:80%;margin:20px=\\\"\\\" auto;\\\"\\\"=\\\"\\\" cellpadding=\\\"\\\" 10\\\"\\\"=\\\"\\\">\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tbody>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tDonor Name\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t[donor_name]\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tDesignation\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t[designation_name]\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tAmount\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t$[amount]\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tMethod\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tCredit Card\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tFrequency\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t[frequency]<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tbody>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/table><p>May 2, 2024<\\/p>\",\"done_by\":\"System\"}",
          "created_at": "2024-05-02T18:46:30.000000Z",
          "updated_at": "2024-05-02T18:46:30.000000Z",
          "description": "A donation receipt email for <strong></strong> has been sent to <strong>John, Katie & Clara Richter CC Monthly</strong>"
        },
        {
          "id": 30,
          "client_id": 207,
          "admin_id": null,
          "donor_id": 26094,
          "table_name": "commitments",
          "record_id": 23221,
          "action": "donor_charge_email",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"Test Evelyn\",\"details\":{\"method\":\"Credit Card\",\"designations\":\"Kidena\\u00efca Sainrilus @ $32 per Month (Paid Every Month)\",\"date\":\"May 2, 2024\",\"total_amount\":32},\"subject\":\"Donation Receipt\",\"body\":\"<p>Thank you for your donation Kidena\\u00efca Sainrilus @ $32 per Month (Paid Every Month) for 32. This email serves as your donation receipt.<\\/p>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<table style=\\\"\\\" border-color:#666;width:80%;margin:20px=\\\"\\\" auto;\\\"\\\"=\\\"\\\" cellpadding=\\\"\\\" 10\\\"\\\"=\\\"\\\">\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tbody>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tDonor Name\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t[donor_name]\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tDesignation\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t[designation_name]\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tAmount\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t$[amount]\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tMethod\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tCredit Card\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tFrequency\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t[frequency]<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tbody>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/table><p>May 2, 2024<\\/p>\",\"done_by\":\"System\"}",
          "created_at": "2024-05-02T12:05:17.000000Z",
          "updated_at": "2024-05-02T12:05:17.000000Z",
          "description": "A donation receipt email for <strong>Kidena\u00efca Sainrilus @ $32 per Month (Paid Every Month)</strong> has been sent to <a href=\"/app/view_donor/26094\"><strong>Test Evelyn</strong></a>"
        },
        {
          "id": 29,
          "client_id": 207,
          "admin_id": null,
          "donor_id": 26087,
          "table_name": "commitments",
          "record_id": 23211,
          "action": "donor_charge_email",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"Schade\",\"details\":{\"method\":\"Credit Card\",\"designations\":\"Louidjivenson Vilsaint @ $32 per Month (Paid Every Month)\",\"date\":\"May 2, 2024\",\"total_amount\":32},\"subject\":\"Donation Receipt\",\"body\":\"<p>Thank you for your donation Louidjivenson Vilsaint @ $32 per Month (Paid Every Month) for 32. This email serves as your donation receipt.<\\/p>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<table style=\\\"\\\" border-color:#666;width:80%;margin:20px=\\\"\\\" auto;\\\"\\\"=\\\"\\\" cellpadding=\\\"\\\" 10\\\"\\\"=\\\"\\\">\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tbody>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tDonor Name\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t[donor_name]\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tDesignation\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t[designation_name]\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tAmount\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t$[amount]\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tMethod\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tCredit Card\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tFrequency\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t[frequency]<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tbody>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/table><p>May 2, 2024<\\/p>\",\"done_by\":\"System\"}",
          "created_at": "2024-05-02T12:05:03.000000Z",
          "updated_at": "2024-05-02T12:05:03.000000Z",
          "description": "A donation receipt email for <strong>Louidjivenson Vilsaint @ $32 per Month (Paid Every Month)</strong> has been sent to <a href=\"/app/view_donor/26087\"><strong>Schade</strong></a>"
        },
        {
          "id": 28,
          "client_id": 207,
          "admin_id": null,
          "donor_id": 17166,
          "table_name": "commitments",
          "record_id": 23210,
          "action": "donor_charge_email",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"John, Katie & Clara Richter CC Monthly\",\"details\":{\"method\":\"Credit Card\",\"designations\":\"Wilna Dervil @ $32 per Month (Paid Every Month)\",\"date\":\"May 2, 2024\",\"total_amount\":32},\"subject\":\"Donation Receipt\",\"body\":\"<p>Thank you for your donation Wilna Dervil @ $32 per Month (Paid Every Month) for 32. This email serves as your donation receipt.<\\/p>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<table style=\\\"\\\" border-color:#666;width:80%;margin:20px=\\\"\\\" auto;\\\"\\\"=\\\"\\\" cellpadding=\\\"\\\" 10\\\"\\\"=\\\"\\\">\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tbody>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tDonor Name\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t[donor_name]\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tDesignation\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t[designation_name]\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tAmount\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t$[amount]\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tMethod\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tCredit Card\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tFrequency\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t[frequency]<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tbody>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/table><p>May 2, 2024<\\/p>\",\"done_by\":\"System\"}",
          "created_at": "2024-05-02T12:05:00.000000Z",
          "updated_at": "2024-05-02T12:05:00.000000Z",
          "description": "A donation receipt email for <strong>Wilna Dervil @ $32 per Month (Paid Every Month)</strong> has been sent to <a href=\"/app/view_donor/17166\"><strong>John, Katie & Clara Richter CC Monthly</strong></a>"
        },
        {
          "id": 257,
          "client_id": 207,
          "admin_id": null,
          "donor_id": 17166,
          "table_name": "donations",
          "record_id": 379516,
          "action": "commitment_donation_email",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"John, Katie & Clara Richter CC Monthly\",\"details\":{\"donor\":{\"id\":\"17166\",\"client_id\":\"207\",\"hysform_id\":\"639\",\"do_not_email\":\"0\",\"wait_time\":\"\",\"who_added\":\"{\\\"type\\\":\\\"donor\\\",\\\"method\\\":\\\"individual\\\",\\\"id\\\":\\\"\\\"}\",\"stripe_cust_id\":\"\",\"authorize_profile\":\"\",\"json_fields\":\"{\\\"dn_donor_name\\\":\\\"John, Katie & Clara Richter\\\",\\\"dn_address\\\":\\\"dev+6@helpyousponsor.com\\\",\\\"dn_home_address\\\":\\\"405 Hackberry Ln Box 363\\\",\\\"dn_payment_type\\\":\\\"CC Monthly\\\",\\\"dn_child_sponsored\\\":\\\"Estilien Claudensky\\\",\\\"fakeusernameremembered\\\":\\\"\\\",\\\"fakepasswordremembered\\\":\\\"\\\",\\\"password\\\":\\\"\\\"}\",\"deleted_at\":\"\",\"created_at\":\"2018-11-04T22:27:57.000000Z\",\"updated_at\":\"2020-09-09T00:34:40.000000Z\",\"last_login\":\"2020-09-09 00:34:20\",\"__hevo__database_name\":\"apphys_new\",\"__hevo__ingested_at\":\"1679725257574\",\"__hevo__marked_deleted\":\"0\",\"__hevo__source_modified_at\":\"\",\"stripe_card_id\":\"\",\"paypal_email\":\"\",\"dn_donor_name\":\"John, Katie & Clara Richter\",\"dn_address\":\"dev+6@helpyousponsor.com\",\"dn_home_address\":\"405 Hackberry Ln Box 363\",\"dn_payment_type\":\"CC Monthly\",\"dn_child_sponsored\":\"Estilien Claudensky\",\"fakeusernameremembered\":\"\",\"fakepasswordremembered\":\"\",\"donor_id\":\"17166\"},\"donation\":{\"designations\":\"Estilien Claudensky @ 32 (Every Month)\",\"total_amount\":32,\"method\":\"Credit Card\",\"date\":\"May 2, 2024\"}},\"subject\":\"Donation Receipt\",\"body\":\"<p>Thank you for your donation Estilien Claudensky @ 32 (Every Month) for 32. This email serves as your donation receipt.<\\/p>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<table style=\\\"\\\" border-color:#666;width:80%;margin:20px=\\\"\\\" auto;\\\"\\\"=\\\"\\\" cellpadding=\\\"\\\" 10\\\"\\\"=\\\"\\\">\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tbody>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tDonor Name\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t[donor_name]\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tDesignation\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t[designation_name]\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tAmount\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t$[amount]\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tMethod\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tCredit Card\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tFrequency\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t[frequency]<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tbody>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/table><p>May 2, 2024<\\/p>\",\"done_by\":\"System\"}",
          "created_at": "2024-05-02T09:45:33.000000Z",
          "updated_at": "2024-05-02T09:45:33.000000Z",
          "description": "A commitment donation receipt email for <strong>Estilien Claudensky</strong> has been sent to <a href=\"/app/view_donor/17166\"><strong>John, Katie & Clara Richter CC Monthly</strong></a>"
        },
        {
          "id": 270,
          "client_id": 207,
          "admin_id": null,
          "donor_id": 17166,
          "table_name": "donations",
          "record_id": 379516,
          "action": "commitment_donation_email",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"John, Katie & Clara Richter CC Monthly\",\"details\":{\"donor\":{\"id\":\"17166\",\"client_id\":\"207\",\"hysform_id\":\"639\",\"do_not_email\":\"0\",\"wait_time\":\"\",\"who_added\":\"{\\\"type\\\":\\\"donor\\\",\\\"method\\\":\\\"individual\\\",\\\"id\\\":\\\"\\\"}\",\"stripe_cust_id\":\"\",\"authorize_profile\":\"\",\"json_fields\":\"{\\\"dn_donor_name\\\":\\\"John, Katie & Clara Richter\\\",\\\"dn_address\\\":\\\"dev+6@helpyousponsor.com\\\",\\\"dn_home_address\\\":\\\"405 Hackberry Ln Box 363\\\",\\\"dn_payment_type\\\":\\\"CC Monthly\\\",\\\"dn_child_sponsored\\\":\\\"Estilien Claudensky\\\",\\\"fakeusernameremembered\\\":\\\"\\\",\\\"fakepasswordremembered\\\":\\\"\\\",\\\"password\\\":\\\"\\\"}\",\"deleted_at\":\"\",\"created_at\":\"2018-11-04T22:27:57.000000Z\",\"updated_at\":\"2020-09-09T00:34:40.000000Z\",\"last_login\":\"2020-09-09 00:34:20\",\"__hevo__database_name\":\"apphys_new\",\"__hevo__ingested_at\":\"1679725257574\",\"__hevo__marked_deleted\":\"0\",\"__hevo__source_modified_at\":\"\",\"stripe_card_id\":\"\",\"paypal_email\":\"\",\"dn_donor_name\":\"John, Katie & Clara Richter\",\"dn_address\":\"dev+6@helpyousponsor.com\",\"dn_home_address\":\"405 Hackberry Ln Box 363\",\"dn_payment_type\":\"CC Monthly\",\"dn_child_sponsored\":\"Estilien Claudensky\",\"fakeusernameremembered\":\"\",\"fakepasswordremembered\":\"\",\"donor_id\":\"17166\"},\"donation\":{\"designations\":\"Estilien Claudensky @ 32 (Every Month)\",\"total_amount\":32,\"method\":\"Credit Card\",\"date\":\"May 2, 2024\"}},\"subject\":\"Donation Receipt\",\"body\":\"<p>Thank you for your donation Estilien Claudensky @ 32 (Every Month) for 32. This email serves as your donation receipt.<\\/p>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<table style=\\\"\\\" border-color:#666;width:80%;margin:20px=\\\"\\\" auto;\\\"\\\"=\\\"\\\" cellpadding=\\\"\\\" 10\\\"\\\"=\\\"\\\">\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tbody>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tDonor Name\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t[donor_name]\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tDesignation\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t[designation_name]\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tAmount\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t$[amount]\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tMethod\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tCredit Card\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tFrequency\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t[frequency]<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tbody>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/table><p>May 2, 2024<\\/p>\",\"done_by\":\"System\"}",
          "created_at": "2024-05-02T09:45:33.000000Z",
          "updated_at": "2024-05-02T09:45:33.000000Z",
          "description": "A commitment donation receipt email for <strong>Estilien Claudensky</strong> has been sent to <a href=\"/app/view_donor/17166\"><strong>John, Katie & Clara Richter CC Monthly</strong></a>"
        },
        {
          "id": 256,
          "client_id": 207,
          "admin_id": null,
          "donor_id": 17166,
          "table_name": "donations",
          "record_id": 379515,
          "action": "commitment_donation_email",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"John, Katie & Clara Richter CC Monthly\",\"details\":{\"donor\":{\"id\":\"17166\",\"client_id\":\"207\",\"hysform_id\":\"639\",\"do_not_email\":\"0\",\"wait_time\":\"\",\"who_added\":\"{\\\"type\\\":\\\"donor\\\",\\\"method\\\":\\\"individual\\\",\\\"id\\\":\\\"\\\"}\",\"stripe_cust_id\":\"\",\"authorize_profile\":\"\",\"json_fields\":\"{\\\"dn_donor_name\\\":\\\"John, Katie & Clara Richter\\\",\\\"dn_address\\\":\\\"dev+6@helpyousponsor.com\\\",\\\"dn_home_address\\\":\\\"405 Hackberry Ln Box 363\\\",\\\"dn_payment_type\\\":\\\"CC Monthly\\\",\\\"dn_child_sponsored\\\":\\\"Estilien Claudensky\\\",\\\"fakeusernameremembered\\\":\\\"\\\",\\\"fakepasswordremembered\\\":\\\"\\\",\\\"password\\\":\\\"\\\"}\",\"deleted_at\":\"\",\"created_at\":\"2018-11-04T22:27:57.000000Z\",\"updated_at\":\"2020-09-09T00:34:40.000000Z\",\"last_login\":\"2020-09-09 00:34:20\",\"__hevo__database_name\":\"apphys_new\",\"__hevo__ingested_at\":\"1679725257574\",\"__hevo__marked_deleted\":\"0\",\"__hevo__source_modified_at\":\"\",\"stripe_card_id\":\"\",\"paypal_email\":\"\",\"dn_donor_name\":\"John, Katie & Clara Richter\",\"dn_address\":\"dev+6@helpyousponsor.com\",\"dn_home_address\":\"405 Hackberry Ln Box 363\",\"dn_payment_type\":\"CC Monthly\",\"dn_child_sponsored\":\"Estilien Claudensky\",\"fakeusernameremembered\":\"\",\"fakepasswordremembered\":\"\",\"donor_id\":\"17166\"},\"donation\":{\"designations\":\"Wilna Dervil @ 32 (Every Month)\",\"total_amount\":32,\"method\":\"Credit Card\",\"date\":\"May 2, 2024\"}},\"subject\":\"Donation Receipt\",\"body\":\"<p>Thank you for your donation Wilna Dervil @ 32 (Every Month) for 32. This email serves as your donation receipt.<\\/p>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<table style=\\\"\\\" border-color:#666;width:80%;margin:20px=\\\"\\\" auto;\\\"\\\"=\\\"\\\" cellpadding=\\\"\\\" 10\\\"\\\"=\\\"\\\">\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tbody>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tDonor Name\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t[donor_name]\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tDesignation\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t[designation_name]\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tAmount\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t$[amount]\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tMethod\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tCredit Card\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tFrequency\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t[frequency]<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tbody>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/table><p>May 2, 2024<\\/p>\",\"done_by\":\"System\"}",
          "created_at": "2024-05-02T09:42:13.000000Z",
          "updated_at": "2024-05-02T09:42:13.000000Z",
          "description": "A commitment donation receipt email for <strong>Estilien Claudensky</strong> has been sent to <a href=\"/app/view_donor/17166\"><strong>John, Katie & Clara Richter CC Monthly</strong></a>"
        },
        {
          "id": 269,
          "client_id": 207,
          "admin_id": null,
          "donor_id": 17166,
          "table_name": "donations",
          "record_id": 379515,
          "action": "commitment_donation_email",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"John, Katie & Clara Richter CC Monthly\",\"details\":{\"donor\":{\"id\":\"17166\",\"client_id\":\"207\",\"hysform_id\":\"639\",\"do_not_email\":\"0\",\"wait_time\":\"\",\"who_added\":\"{\\\"type\\\":\\\"donor\\\",\\\"method\\\":\\\"individual\\\",\\\"id\\\":\\\"\\\"}\",\"stripe_cust_id\":\"\",\"authorize_profile\":\"\",\"json_fields\":\"{\\\"dn_donor_name\\\":\\\"John, Katie & Clara Richter\\\",\\\"dn_address\\\":\\\"dev+6@helpyousponsor.com\\\",\\\"dn_home_address\\\":\\\"405 Hackberry Ln Box 363\\\",\\\"dn_payment_type\\\":\\\"CC Monthly\\\",\\\"dn_child_sponsored\\\":\\\"Estilien Claudensky\\\",\\\"fakeusernameremembered\\\":\\\"\\\",\\\"fakepasswordremembered\\\":\\\"\\\",\\\"password\\\":\\\"\\\"}\",\"deleted_at\":\"\",\"created_at\":\"2018-11-04T22:27:57.000000Z\",\"updated_at\":\"2020-09-09T00:34:40.000000Z\",\"last_login\":\"2020-09-09 00:34:20\",\"__hevo__database_name\":\"apphys_new\",\"__hevo__ingested_at\":\"1679725257574\",\"__hevo__marked_deleted\":\"0\",\"__hevo__source_modified_at\":\"\",\"stripe_card_id\":\"\",\"paypal_email\":\"\",\"dn_donor_name\":\"John, Katie & Clara Richter\",\"dn_address\":\"dev+6@helpyousponsor.com\",\"dn_home_address\":\"405 Hackberry Ln Box 363\",\"dn_payment_type\":\"CC Monthly\",\"dn_child_sponsored\":\"Estilien Claudensky\",\"fakeusernameremembered\":\"\",\"fakepasswordremembered\":\"\",\"donor_id\":\"17166\"},\"donation\":{\"designations\":\"Wilna Dervil @ 32 (Every Month)\",\"total_amount\":32,\"method\":\"Credit Card\",\"date\":\"May 2, 2024\"}},\"subject\":\"Donation Receipt\",\"body\":\"<p>Thank you for your donation Wilna Dervil @ 32 (Every Month) for 32. This email serves as your donation receipt.<\\/p>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<table style=\\\"\\\" border-color:#666;width:80%;margin:20px=\\\"\\\" auto;\\\"\\\"=\\\"\\\" cellpadding=\\\"\\\" 10\\\"\\\"=\\\"\\\">\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tbody>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tDonor Name\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t[donor_name]\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tDesignation\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t[designation_name]\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tAmount\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t$[amount]\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tMethod\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tCredit Card\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tFrequency\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t[frequency]<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tbody>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/table><p>May 2, 2024<\\/p>\",\"done_by\":\"System\"}",
          "created_at": "2024-05-02T09:42:13.000000Z",
          "updated_at": "2024-05-02T09:42:13.000000Z",
          "description": "A commitment donation receipt email for <strong>Estilien Claudensky</strong> has been sent to <a href=\"/app/view_donor/17166\"><strong>John, Katie & Clara Richter CC Monthly</strong></a>"
        },
        {
          "id": 255,
          "client_id": 207,
          "admin_id": null,
          "donor_id": 17166,
          "table_name": "donations",
          "record_id": 379514,
          "action": "commitment_donation_email",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"John, Katie & Clara Richter CC Monthly\",\"details\":{\"donor\":{\"id\":\"17166\",\"client_id\":\"207\",\"hysform_id\":\"639\",\"do_not_email\":\"0\",\"wait_time\":\"\",\"who_added\":\"{\\\"type\\\":\\\"donor\\\",\\\"method\\\":\\\"individual\\\",\\\"id\\\":\\\"\\\"}\",\"stripe_cust_id\":\"\",\"authorize_profile\":\"\",\"json_fields\":\"{\\\"dn_donor_name\\\":\\\"John, Katie & Clara Richter\\\",\\\"dn_address\\\":\\\"dev+6@helpyousponsor.com\\\",\\\"dn_home_address\\\":\\\"405 Hackberry Ln Box 363\\\",\\\"dn_payment_type\\\":\\\"CC Monthly\\\",\\\"dn_child_sponsored\\\":\\\"Estilien Claudensky\\\",\\\"fakeusernameremembered\\\":\\\"\\\",\\\"fakepasswordremembered\\\":\\\"\\\",\\\"password\\\":\\\"\\\"}\",\"deleted_at\":\"\",\"created_at\":\"2018-11-04T22:27:57.000000Z\",\"updated_at\":\"2020-09-09T00:34:40.000000Z\",\"last_login\":\"2020-09-09 00:34:20\",\"__hevo__database_name\":\"apphys_new\",\"__hevo__ingested_at\":\"1679725257574\",\"__hevo__marked_deleted\":\"0\",\"__hevo__source_modified_at\":\"\",\"stripe_card_id\":\"\",\"paypal_email\":\"\",\"dn_donor_name\":\"John, Katie & Clara Richter\",\"dn_address\":\"dev+6@helpyousponsor.com\",\"dn_home_address\":\"405 Hackberry Ln Box 363\",\"dn_payment_type\":\"CC Monthly\",\"dn_child_sponsored\":\"Estilien Claudensky\",\"fakeusernameremembered\":\"\",\"fakepasswordremembered\":\"\",\"donor_id\":\"17166\"},\"donation\":{\"designations\":\"Wilna Dervil @ 32 (Every Month)\",\"total_amount\":32,\"method\":\"Credit Card\",\"date\":\"May 4, 2024\"}},\"subject\":\"Donation Receipt\",\"body\":\"<p>Thank you for your donation Wilna Dervil @ 32 (Every Month) for 32. This email serves as your donation receipt.<\\/p>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<table style=\\\"\\\" border-color:#666;width:80%;margin:20px=\\\"\\\" auto;\\\"\\\"=\\\"\\\" cellpadding=\\\"\\\" 10\\\"\\\"=\\\"\\\">\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tbody>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tDonor Name\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t[donor_name]\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tDesignation\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t[designation_name]\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tAmount\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t$[amount]\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tMethod\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tCredit Card\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tFrequency\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t[frequency]<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tbody>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/table><p>May 4, 2024<\\/p>\",\"done_by\":\"System\"}",
          "created_at": "2024-05-02T09:41:55.000000Z",
          "updated_at": "2024-05-02T09:41:55.000000Z",
          "description": "A commitment donation receipt email for <strong>Estilien Claudensky</strong> has been sent to <a href=\"/app/view_donor/17166\"><strong>John, Katie & Clara Richter CC Monthly</strong></a>"
        },
        {
          "id": 268,
          "client_id": 207,
          "admin_id": null,
          "donor_id": 17166,
          "table_name": "donations",
          "record_id": 379514,
          "action": "commitment_donation_email",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"John, Katie & Clara Richter CC Monthly\",\"details\":{\"donor\":{\"id\":\"17166\",\"client_id\":\"207\",\"hysform_id\":\"639\",\"do_not_email\":\"0\",\"wait_time\":\"\",\"who_added\":\"{\\\"type\\\":\\\"donor\\\",\\\"method\\\":\\\"individual\\\",\\\"id\\\":\\\"\\\"}\",\"stripe_cust_id\":\"\",\"authorize_profile\":\"\",\"json_fields\":\"{\\\"dn_donor_name\\\":\\\"John, Katie & Clara Richter\\\",\\\"dn_address\\\":\\\"dev+6@helpyousponsor.com\\\",\\\"dn_home_address\\\":\\\"405 Hackberry Ln Box 363\\\",\\\"dn_payment_type\\\":\\\"CC Monthly\\\",\\\"dn_child_sponsored\\\":\\\"Estilien Claudensky\\\",\\\"fakeusernameremembered\\\":\\\"\\\",\\\"fakepasswordremembered\\\":\\\"\\\",\\\"password\\\":\\\"\\\"}\",\"deleted_at\":\"\",\"created_at\":\"2018-11-04T22:27:57.000000Z\",\"updated_at\":\"2020-09-09T00:34:40.000000Z\",\"last_login\":\"2020-09-09 00:34:20\",\"__hevo__database_name\":\"apphys_new\",\"__hevo__ingested_at\":\"1679725257574\",\"__hevo__marked_deleted\":\"0\",\"__hevo__source_modified_at\":\"\",\"stripe_card_id\":\"\",\"paypal_email\":\"\",\"dn_donor_name\":\"John, Katie & Clara Richter\",\"dn_address\":\"dev+6@helpyousponsor.com\",\"dn_home_address\":\"405 Hackberry Ln Box 363\",\"dn_payment_type\":\"CC Monthly\",\"dn_child_sponsored\":\"Estilien Claudensky\",\"fakeusernameremembered\":\"\",\"fakepasswordremembered\":\"\",\"donor_id\":\"17166\"},\"donation\":{\"designations\":\"Wilna Dervil @ 32 (Every Month)\",\"total_amount\":32,\"method\":\"Credit Card\",\"date\":\"May 4, 2024\"}},\"subject\":\"Donation Receipt\",\"body\":\"<p>Thank you for your donation Wilna Dervil @ 32 (Every Month) for 32. This email serves as your donation receipt.<\\/p>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<table style=\\\"\\\" border-color:#666;width:80%;margin:20px=\\\"\\\" auto;\\\"\\\"=\\\"\\\" cellpadding=\\\"\\\" 10\\\"\\\"=\\\"\\\">\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tbody>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tDonor Name\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t[donor_name]\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tDesignation\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t[designation_name]\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tAmount\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t$[amount]\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tMethod\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tCredit Card\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tFrequency\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t[frequency]<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tbody>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/table><p>May 4, 2024<\\/p>\",\"done_by\":\"System\"}",
          "created_at": "2024-05-02T09:41:55.000000Z",
          "updated_at": "2024-05-02T09:41:55.000000Z",
          "description": "A commitment donation receipt email for <strong>Estilien Claudensky</strong> has been sent to <a href=\"/app/view_donor/17166\"><strong>John, Katie & Clara Richter CC Monthly</strong></a>"
        },
        {
          "id": 27,
          "client_id": 207,
          "admin_id": 542,
          "donor_id": null,
          "table_name": "donors",
          "record_id": 16043,
          "action": "restore_donor",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"alsong\",\"done_by\":\"Leslie Jobs\"}",
          "created_at": "2024-05-02T08:53:30.000000Z",
          "updated_at": "2024-05-02T08:53:30.000000Z",
          "description": "Donor <a href=\"/app/view_donor/16043\"><strong>alsong</strong></a> has been restored"
        },
        {
          "id": 26,
          "client_id": 207,
          "admin_id": 542,
          "donor_id": null,
          "table_name": "donors",
          "record_id": 16043,
          "action": "archive_donor",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"alsong\",\"done_by\":\"Leslie Jobs\"}",
          "created_at": "2024-05-02T08:52:59.000000Z",
          "updated_at": "2024-05-02T08:52:59.000000Z",
          "description": "Donor <a href=\"/app/view_donor/16043\"><strong>alsong</strong></a> has been archived"
        },
        {
          "id": 25,
          "client_id": 207,
          "admin_id": 542,
          "donor_id": null,
          "table_name": "donors",
          "record_id": 24641,
          "action": "restore_donor",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"TestDonor5\",\"done_by\":\"Leslie Jobs\"}",
          "created_at": "2024-05-02T08:52:36.000000Z",
          "updated_at": "2024-05-02T08:52:36.000000Z",
          "description": "Donor <a href=\"/app/view_donor/24641\"><strong>TestDonor5</strong></a> has been restored"
        },
        {
          "id": 24,
          "client_id": 207,
          "admin_id": null,
          "donor_id": null,
          "table_name": "clients",
          "record_id": 207,
          "action": "export_donations_email",
          "deleted_at": null,
          "additional_data": "{\"client_name\":\"Giving Hands Ministry\",\"done_by\":\"System\"}",
          "created_at": "2024-05-02T06:04:22.000000Z",
          "updated_at": "2024-05-02T06:04:22.000000Z",
          "description": "Action performed"
        },
        {
          "id": 22,
          "client_id": 207,
          "admin_id": 542,
          "donor_id": 26106,
          "table_name": "donations",
          "record_id": 379449,
          "action": "add_donation",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"Brown Jr Cash\",\"amount\":\"12\",\"method\":\"Wire Transfer\",\"designation\":\"Bag of Beans\",\"done_by\":\"Leslie Jobs\"}",
          "created_at": "2024-05-02T04:58:19.000000Z",
          "updated_at": "2024-05-02T04:58:19.000000Z",
          "description": "<a href=\"/app/view_donor/26106\"><strong>Brown Jr Cash</strong></a> has donated <strong>12</strong> by <strong>Wire Transfer</strong> for <strong>Bag of Beans</strong>"
        },
        {
          "id": 21,
          "client_id": 207,
          "admin_id": 542,
          "donor_id": 26106,
          "table_name": "commitments",
          "record_id": 23257,
          "action": "add_sponsorship",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"Brown Jr Cash\",\"amount\":\"32\",\"method\":\"Cash\",\"designation\":\"Berline Fran\\u00e7ois\",\"done_by\":\"Leslie Jobs\"}",
          "created_at": "2024-05-02T04:57:19.000000Z",
          "updated_at": "2024-05-02T04:57:19.000000Z",
          "description": "<a href=\"/app/view_donor/26106\"><strong>Brown Jr Cash</strong></a> has sponsored <strong>Berline Fran\u00e7ois</strong> with <strong>32</strong> by <strong>Cash</strong>"
        },
        {
          "id": 20,
          "client_id": 207,
          "admin_id": 542,
          "donor_id": 17017,
          "table_name": "donors",
          "record_id": 17017,
          "action": "account_setup_email",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"Test Donor Shaban Paypal, monthly\",\"done_by\":\"Leslie Jobs\"}",
          "created_at": "2024-05-01T09:54:07.000000Z",
          "updated_at": "2024-05-01T09:54:07.000000Z",
          "description": "An account setup notification email for <a href=\"/app/view_donor/17017\"><strong>Test Donor Shaban Paypal, monthly</strong></a> has been sent"
        },
        {
          "id": 19,
          "client_id": 207,
          "admin_id": 542,
          "donor_id": null,
          "table_name": "donors",
          "record_id": 24591,
          "action": "restore_donor",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"alsongtest\",\"done_by\":\"Leslie Jobs\"}",
          "created_at": "2024-05-01T09:53:33.000000Z",
          "updated_at": "2024-05-01T09:53:33.000000Z",
          "description": "Donor <a href=\"/app/view_donor/24591\"><strong>alsongtest</strong></a> has been restored"
        },
        {
          "id": 18,
          "client_id": 207,
          "admin_id": 542,
          "donor_id": null,
          "table_name": "donors",
          "record_id": 17274,
          "action": "restore_donor",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"dev8\",\"done_by\":\"Leslie Jobs\"}",
          "created_at": "2024-05-01T09:53:08.000000Z",
          "updated_at": "2024-05-01T09:53:08.000000Z",
          "description": "Donor <a href=\"/app/view_donor/17274\"><strong>dev8</strong></a> has been restored"
        },
        {
          "id": 17,
          "client_id": 207,
          "admin_id": null,
          "donor_id": null,
          "table_name": "clients",
          "record_id": 207,
          "action": "export_donations_email",
          "deleted_at": null,
          "additional_data": "{\"client_name\":\"Giving Hands Ministry\",\"done_by\":\"System\"}",
          "created_at": "2024-04-30T07:04:06.000000Z",
          "updated_at": "2024-04-30T07:04:06.000000Z",
          "description": "Action performed"
        },
        {
          "id": 16,
          "client_id": 207,
          "admin_id": null,
          "donor_id": null,
          "table_name": "clients",
          "record_id": 207,
          "action": "export_donations_email",
          "deleted_at": null,
          "additional_data": "{\"client_name\":\"Giving Hands Ministry\",\"done_by\":\"System\"}",
          "created_at": "2024-04-29T09:26:04.000000Z",
          "updated_at": "2024-04-29T09:26:04.000000Z",
          "description": "Action performed"
        },
        {
          "id": 254,
          "client_id": 207,
          "admin_id": null,
          "donor_id": 17166,
          "table_name": "donations",
          "record_id": 379498,
          "action": "commitment_donation_email",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"John, Katie & Clara Richter CC Monthly\",\"details\":{\"donor\":{\"id\":\"17166\",\"client_id\":\"207\",\"hysform_id\":\"639\",\"do_not_email\":\"0\",\"wait_time\":\"\",\"who_added\":\"{\\\"type\\\":\\\"donor\\\",\\\"method\\\":\\\"individual\\\",\\\"id\\\":\\\"\\\"}\",\"stripe_cust_id\":\"\",\"authorize_profile\":\"\",\"json_fields\":\"{\\\"dn_donor_name\\\":\\\"John, Katie & Clara Richter\\\",\\\"dn_address\\\":\\\"dev+6@helpyousponsor.com\\\",\\\"dn_home_address\\\":\\\"405 Hackberry Ln Box 363\\\",\\\"dn_payment_type\\\":\\\"CC Monthly\\\",\\\"dn_child_sponsored\\\":\\\"Estilien Claudensky\\\",\\\"fakeusernameremembered\\\":\\\"\\\",\\\"fakepasswordremembered\\\":\\\"\\\",\\\"password\\\":\\\"\\\"}\",\"deleted_at\":\"\",\"created_at\":\"2018-11-04T22:27:57.000000Z\",\"updated_at\":\"2020-09-09T00:34:40.000000Z\",\"last_login\":\"2020-09-09 00:34:20\",\"__hevo__database_name\":\"apphys_new\",\"__hevo__ingested_at\":\"1679725257574\",\"__hevo__marked_deleted\":\"0\",\"__hevo__source_modified_at\":\"\",\"stripe_card_id\":\"\",\"paypal_email\":\"\",\"dn_donor_name\":\"John, Katie & Clara Richter\",\"dn_address\":\"dev+6@helpyousponsor.com\",\"dn_home_address\":\"405 Hackberry Ln Box 363\",\"dn_payment_type\":\"CC Monthly\",\"dn_child_sponsored\":\"Estilien Claudensky\",\"fakeusernameremembered\":\"\",\"fakepasswordremembered\":\"\",\"donor_id\":\"17166\"},\"donation\":{\"designations\":\"Wilna Dervil @ 40.00 (Every Month)\",\"total_amount\":\"40.00\",\"method\":\"Credit Card\",\"date\":\"Apr 24, 2024\"}},\"subject\":\"Donation Receipt\",\"body\":\"<p>Thank you for your donation Wilna Dervil @ 40.00 (Every Month) for 40.00. This email serves as your donation receipt.<\\/p>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<table style=\\\"\\\" border-color:#666;width:80%;margin:20px=\\\"\\\" auto;\\\"\\\"=\\\"\\\" cellpadding=\\\"\\\" 10\\\"\\\"=\\\"\\\">\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tbody>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tDonor Name\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t[donor_name]\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tDesignation\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t[designation_name]\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tAmount\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t$[amount]\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tMethod\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tCredit Card\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tFrequency\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t[frequency]<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tbody>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/table><p>Apr 24, 2024<\\/p>\",\"done_by\":\"System\"}",
          "created_at": "2024-04-25T07:45:53.000000Z",
          "updated_at": "2024-04-25T07:45:53.000000Z",
          "description": "A commitment donation receipt email for <strong>Estilien Claudensky</strong> has been sent to <a href=\"/app/view_donor/17166\"><strong>John, Katie & Clara Richter CC Monthly</strong></a>"
        },
        {
          "id": 267,
          "client_id": 207,
          "admin_id": null,
          "donor_id": 17166,
          "table_name": "donations",
          "record_id": 379498,
          "action": "commitment_donation_email",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"John, Katie & Clara Richter CC Monthly\",\"details\":{\"donor\":{\"id\":\"17166\",\"client_id\":\"207\",\"hysform_id\":\"639\",\"do_not_email\":\"0\",\"wait_time\":\"\",\"who_added\":\"{\\\"type\\\":\\\"donor\\\",\\\"method\\\":\\\"individual\\\",\\\"id\\\":\\\"\\\"}\",\"stripe_cust_id\":\"\",\"authorize_profile\":\"\",\"json_fields\":\"{\\\"dn_donor_name\\\":\\\"John, Katie & Clara Richter\\\",\\\"dn_address\\\":\\\"dev+6@helpyousponsor.com\\\",\\\"dn_home_address\\\":\\\"405 Hackberry Ln Box 363\\\",\\\"dn_payment_type\\\":\\\"CC Monthly\\\",\\\"dn_child_sponsored\\\":\\\"Estilien Claudensky\\\",\\\"fakeusernameremembered\\\":\\\"\\\",\\\"fakepasswordremembered\\\":\\\"\\\",\\\"password\\\":\\\"\\\"}\",\"deleted_at\":\"\",\"created_at\":\"2018-11-04T22:27:57.000000Z\",\"updated_at\":\"2020-09-09T00:34:40.000000Z\",\"last_login\":\"2020-09-09 00:34:20\",\"__hevo__database_name\":\"apphys_new\",\"__hevo__ingested_at\":\"1679725257574\",\"__hevo__marked_deleted\":\"0\",\"__hevo__source_modified_at\":\"\",\"stripe_card_id\":\"\",\"paypal_email\":\"\",\"dn_donor_name\":\"John, Katie & Clara Richter\",\"dn_address\":\"dev+6@helpyousponsor.com\",\"dn_home_address\":\"405 Hackberry Ln Box 363\",\"dn_payment_type\":\"CC Monthly\",\"dn_child_sponsored\":\"Estilien Claudensky\",\"fakeusernameremembered\":\"\",\"fakepasswordremembered\":\"\",\"donor_id\":\"17166\"},\"donation\":{\"designations\":\"Wilna Dervil @ 40.00 (Every Month)\",\"total_amount\":\"40.00\",\"method\":\"Credit Card\",\"date\":\"Apr 24, 2024\"}},\"subject\":\"Donation Receipt\",\"body\":\"<p>Thank you for your donation Wilna Dervil @ 40.00 (Every Month) for 40.00. This email serves as your donation receipt.<\\/p>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<table style=\\\"\\\" border-color:#666;width:80%;margin:20px=\\\"\\\" auto;\\\"\\\"=\\\"\\\" cellpadding=\\\"\\\" 10\\\"\\\"=\\\"\\\">\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tbody>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tDonor Name\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t[donor_name]\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tDesignation\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t[designation_name]\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tAmount\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t$[amount]\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tMethod\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tCredit Card\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tFrequency\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t[frequency]<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tbody>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/table><p>Apr 24, 2024<\\/p>\",\"done_by\":\"System\"}",
          "created_at": "2024-04-25T07:45:53.000000Z",
          "updated_at": "2024-04-25T07:45:53.000000Z",
          "description": "A commitment donation receipt email for <strong>Estilien Claudensky</strong> has been sent to <a href=\"/app/view_donor/17166\"><strong>John, Katie & Clara Richter CC Monthly</strong></a>"
        },
        {
          "id": 15,
          "client_id": 207,
          "admin_id": null,
          "donor_id": 26103,
          "table_name": "donoremails",
          "record_id": 17530,
          "action": "donor_message_send",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"Test Leo 10\",\"entity_name\":\"Djeff Pierre\",\"subject\":\"selectedTab\",\"message\":\"<p>selectedTab<\\/p>\",\"done_by\":\"Test Leo 10\"}",
          "created_at": "2024-04-19T06:55:33.000000Z",
          "updated_at": "2024-04-19T06:55:33.000000Z",
          "description": "An email from <strong>Test Leo 10</strong> to <strong>Djeff Pierre</strong> has been sent"
        },
        {
          "id": 14,
          "client_id": 207,
          "admin_id": null,
          "donor_id": 26103,
          "table_name": "donoremails",
          "record_id": 17529,
          "action": "donor_message_send",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"Test Leo 10\",\"entity_name\":\"Djeff Pierre\",\"subject\":\"Re: Test\",\"message\":\"<p>test reply<\\/p>\",\"done_by\":\"Test Leo 10\"}",
          "created_at": "2024-04-19T06:52:36.000000Z",
          "updated_at": "2024-04-19T06:52:36.000000Z",
          "description": "An email from <strong>Test Leo 10</strong> to <strong>Djeff Pierre</strong> has been sent"
        },
        {
          "id": 13,
          "client_id": 207,
          "admin_id": null,
          "donor_id": 26103,
          "table_name": "donoremails",
          "record_id": 17528,
          "action": "donor_message_send",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"Test Leo 10\",\"entity_name\":\"Djeff Pierre\",\"subject\":\"Test\",\"message\":\"<p>Test<\\/p>\",\"done_by\":\"Test Leo 10\"}",
          "created_at": "2024-04-19T06:52:25.000000Z",
          "updated_at": "2024-04-19T06:52:25.000000Z",
          "description": "An email from <strong>Test Leo 10</strong> to <strong>Djeff Pierre</strong> has been sent"
        },
        {
          "id": 12,
          "client_id": 207,
          "admin_id": null,
          "donor_id": 26101,
          "table_name": "donoremails",
          "record_id": 17527,
          "action": "donor_message_send",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"Leo Test 9\",\"entity_name\":\"Flormida\\u00efna Dor\\u00e9lus\",\"subject\":\"Re: Hello\",\"message\":\"<p>You good<\\/p>\",\"done_by\":\"Leo Test 9\"}",
          "created_at": "2024-04-17T10:54:27.000000Z",
          "updated_at": "2024-04-17T10:54:27.000000Z",
          "description": "An email from <strong>Leo Test 9</strong> to <strong>Flormida\u00efna Dor\u00e9lus</strong> has been sent"
        },
        {
          "id": 11,
          "client_id": 207,
          "admin_id": null,
          "donor_id": 26101,
          "table_name": "donoremails",
          "record_id": 17526,
          "action": "donor_message_send",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"Leo Test 9\",\"entity_name\":\"Flormida\\u00efna Dor\\u00e9lus\",\"subject\":\"Hello\",\"message\":\"<p>Hello<\\/p>\",\"done_by\":\"Leo Test 9\"}",
          "created_at": "2024-04-17T10:54:10.000000Z",
          "updated_at": "2024-04-17T10:54:10.000000Z",
          "description": "An email from <strong>Leo Test 9</strong> to <strong>Flormida\u00efna Dor\u00e9lus</strong> has been sent"
        },
        {
          "id": 253,
          "client_id": 207,
          "admin_id": null,
          "donor_id": 17166,
          "table_name": "donations",
          "record_id": 379481,
          "action": "commitment_donation_email",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"John, Katie & Clara Richter CC Monthly\",\"details\":{\"donor\":{\"id\":\"17166\",\"client_id\":\"207\",\"hysform_id\":\"639\",\"do_not_email\":\"0\",\"wait_time\":\"\",\"who_added\":\"{\\\"type\\\":\\\"donor\\\",\\\"method\\\":\\\"individual\\\",\\\"id\\\":\\\"\\\"}\",\"stripe_cust_id\":\"\",\"authorize_profile\":\"\",\"json_fields\":\"{\\\"dn_donor_name\\\":\\\"John, Katie & Clara Richter\\\",\\\"dn_address\\\":\\\"dev+6@helpyousponsor.com\\\",\\\"dn_home_address\\\":\\\"405 Hackberry Ln Box 363\\\",\\\"dn_payment_type\\\":\\\"CC Monthly\\\",\\\"dn_child_sponsored\\\":\\\"Estilien Claudensky\\\",\\\"fakeusernameremembered\\\":\\\"\\\",\\\"fakepasswordremembered\\\":\\\"\\\",\\\"password\\\":\\\"\\\"}\",\"deleted_at\":\"\",\"created_at\":\"2018-11-04T22:27:57.000000Z\",\"updated_at\":\"2020-09-09T00:34:40.000000Z\",\"last_login\":\"2020-09-09 00:34:20\",\"__hevo__database_name\":\"apphys_new\",\"__hevo__ingested_at\":\"1679725257574\",\"__hevo__marked_deleted\":\"0\",\"__hevo__source_modified_at\":\"\",\"stripe_card_id\":\"\",\"paypal_email\":\"\",\"dn_donor_name\":\"John, Katie & Clara Richter\",\"dn_address\":\"dev+6@helpyousponsor.com\",\"dn_home_address\":\"405 Hackberry Ln Box 363\",\"dn_payment_type\":\"CC Monthly\",\"dn_child_sponsored\":\"Estilien Claudensky\",\"fakeusernameremembered\":\"\",\"fakepasswordremembered\":\"\",\"donor_id\":\"17166\"},\"donation\":{\"designations\":\"Estilien Claudensky @ 32 (Every 3 Months)\",\"total_amount\":32,\"method\":\"Credit Card\",\"date\":\"Apr 16, 2024\"}},\"subject\":\"Donation Receipt\",\"body\":\"<p>Thank you for your donation Estilien Claudensky @ 32 (Every 3 Months) for 32. This email serves as your donation receipt.<\\/p>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<table style=\\\"\\\" border-color:#666;width:80%;margin:20px=\\\"\\\" auto;\\\"\\\"=\\\"\\\" cellpadding=\\\"\\\" 10\\\"\\\"=\\\"\\\">\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tbody>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tDonor Name\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t[donor_name]\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tDesignation\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t[designation_name]\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tAmount\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t$[amount]\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tMethod\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tCredit Card\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tFrequency\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t[frequency]<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tbody>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/table><p>Apr 16, 2024<\\/p>\",\"done_by\":\"System\"}",
          "created_at": "2024-04-16T10:19:18.000000Z",
          "updated_at": "2024-04-16T10:19:18.000000Z",
          "description": "A commitment donation receipt email for <strong>Estilien Claudensky</strong> has been sent to <a href=\"/app/view_donor/17166\"><strong>John, Katie & Clara Richter CC Monthly</strong></a>"
        },
        {
          "id": 266,
          "client_id": 207,
          "admin_id": null,
          "donor_id": 17166,
          "table_name": "donations",
          "record_id": 379481,
          "action": "commitment_donation_email",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"John, Katie & Clara Richter CC Monthly\",\"details\":{\"donor\":{\"id\":\"17166\",\"client_id\":\"207\",\"hysform_id\":\"639\",\"do_not_email\":\"0\",\"wait_time\":\"\",\"who_added\":\"{\\\"type\\\":\\\"donor\\\",\\\"method\\\":\\\"individual\\\",\\\"id\\\":\\\"\\\"}\",\"stripe_cust_id\":\"\",\"authorize_profile\":\"\",\"json_fields\":\"{\\\"dn_donor_name\\\":\\\"John, Katie & Clara Richter\\\",\\\"dn_address\\\":\\\"dev+6@helpyousponsor.com\\\",\\\"dn_home_address\\\":\\\"405 Hackberry Ln Box 363\\\",\\\"dn_payment_type\\\":\\\"CC Monthly\\\",\\\"dn_child_sponsored\\\":\\\"Estilien Claudensky\\\",\\\"fakeusernameremembered\\\":\\\"\\\",\\\"fakepasswordremembered\\\":\\\"\\\",\\\"password\\\":\\\"\\\"}\",\"deleted_at\":\"\",\"created_at\":\"2018-11-04T22:27:57.000000Z\",\"updated_at\":\"2020-09-09T00:34:40.000000Z\",\"last_login\":\"2020-09-09 00:34:20\",\"__hevo__database_name\":\"apphys_new\",\"__hevo__ingested_at\":\"1679725257574\",\"__hevo__marked_deleted\":\"0\",\"__hevo__source_modified_at\":\"\",\"stripe_card_id\":\"\",\"paypal_email\":\"\",\"dn_donor_name\":\"John, Katie & Clara Richter\",\"dn_address\":\"dev+6@helpyousponsor.com\",\"dn_home_address\":\"405 Hackberry Ln Box 363\",\"dn_payment_type\":\"CC Monthly\",\"dn_child_sponsored\":\"Estilien Claudensky\",\"fakeusernameremembered\":\"\",\"fakepasswordremembered\":\"\",\"donor_id\":\"17166\"},\"donation\":{\"designations\":\"Estilien Claudensky @ 32 (Every 3 Months)\",\"total_amount\":32,\"method\":\"Credit Card\",\"date\":\"Apr 16, 2024\"}},\"subject\":\"Donation Receipt\",\"body\":\"<p>Thank you for your donation Estilien Claudensky @ 32 (Every 3 Months) for 32. This email serves as your donation receipt.<\\/p>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<table style=\\\"\\\" border-color:#666;width:80%;margin:20px=\\\"\\\" auto;\\\"\\\"=\\\"\\\" cellpadding=\\\"\\\" 10\\\"\\\"=\\\"\\\">\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tbody>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tDonor Name\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t[donor_name]\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tDesignation\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t[designation_name]\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tAmount\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t$[amount]\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tMethod\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tCredit Card\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tFrequency\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t[frequency]<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tbody>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/table><p>Apr 16, 2024<\\/p>\",\"done_by\":\"System\"}",
          "created_at": "2024-04-16T10:19:18.000000Z",
          "updated_at": "2024-04-16T10:19:18.000000Z",
          "description": "A commitment donation receipt email for <strong>Estilien Claudensky</strong> has been sent to <a href=\"/app/view_donor/17166\"><strong>John, Katie & Clara Richter CC Monthly</strong></a>"
        },
        {
          "id": 252,
          "client_id": 207,
          "admin_id": null,
          "donor_id": 17166,
          "table_name": "donations",
          "record_id": 379480,
          "action": "commitment_donation_email",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"John, Katie & Clara Richter CC Monthly\",\"details\":{\"donor\":{\"id\":\"17166\",\"client_id\":\"207\",\"hysform_id\":\"639\",\"do_not_email\":\"0\",\"wait_time\":\"\",\"who_added\":\"{\\\"type\\\":\\\"donor\\\",\\\"method\\\":\\\"individual\\\",\\\"id\\\":\\\"\\\"}\",\"stripe_cust_id\":\"\",\"authorize_profile\":\"\",\"json_fields\":\"{\\\"dn_donor_name\\\":\\\"John, Katie & Clara Richter\\\",\\\"dn_address\\\":\\\"dev+6@helpyousponsor.com\\\",\\\"dn_home_address\\\":\\\"405 Hackberry Ln Box 363\\\",\\\"dn_payment_type\\\":\\\"CC Monthly\\\",\\\"dn_child_sponsored\\\":\\\"Estilien Claudensky\\\",\\\"fakeusernameremembered\\\":\\\"\\\",\\\"fakepasswordremembered\\\":\\\"\\\",\\\"password\\\":\\\"\\\"}\",\"deleted_at\":\"\",\"created_at\":\"2018-11-04T22:27:57.000000Z\",\"updated_at\":\"2020-09-09T00:34:40.000000Z\",\"last_login\":\"2020-09-09 00:34:20\",\"__hevo__database_name\":\"apphys_new\",\"__hevo__ingested_at\":\"1679725257574\",\"__hevo__marked_deleted\":\"0\",\"__hevo__source_modified_at\":\"\",\"stripe_card_id\":\"\",\"paypal_email\":\"\",\"dn_donor_name\":\"John, Katie & Clara Richter\",\"dn_address\":\"dev+6@helpyousponsor.com\",\"dn_home_address\":\"405 Hackberry Ln Box 363\",\"dn_payment_type\":\"CC Monthly\",\"dn_child_sponsored\":\"Estilien Claudensky\",\"fakeusernameremembered\":\"\",\"fakepasswordremembered\":\"\",\"donor_id\":\"17166\"},\"donation\":{\"designations\":\"Wilna Dervil @ 32 (Every Month)\",\"total_amount\":32,\"method\":\"Credit Card\",\"date\":\"Apr 16, 2024\"}},\"subject\":\"Donation Receipt\",\"body\":\"<p>Thank you for your donation Wilna Dervil @ 32 (Every Month) for 32. This email serves as your donation receipt.<\\/p>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<table style=\\\"\\\" border-color:#666;width:80%;margin:20px=\\\"\\\" auto;\\\"\\\"=\\\"\\\" cellpadding=\\\"\\\" 10\\\"\\\"=\\\"\\\">\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tbody>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tDonor Name\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t[donor_name]\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tDesignation\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t[designation_name]\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tAmount\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t$[amount]\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tMethod\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tCredit Card\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tFrequency\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t[frequency]<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tbody>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/table><p>Apr 16, 2024<\\/p>\",\"done_by\":\"System\"}",
          "created_at": "2024-04-16T10:18:43.000000Z",
          "updated_at": "2024-04-16T10:18:43.000000Z",
          "description": "A commitment donation receipt email for <strong>Estilien Claudensky</strong> has been sent to <a href=\"/app/view_donor/17166\"><strong>John, Katie & Clara Richter CC Monthly</strong></a>"
        },
        {
          "id": 265,
          "client_id": 207,
          "admin_id": null,
          "donor_id": 17166,
          "table_name": "donations",
          "record_id": 379480,
          "action": "commitment_donation_email",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"John, Katie & Clara Richter CC Monthly\",\"details\":{\"donor\":{\"id\":\"17166\",\"client_id\":\"207\",\"hysform_id\":\"639\",\"do_not_email\":\"0\",\"wait_time\":\"\",\"who_added\":\"{\\\"type\\\":\\\"donor\\\",\\\"method\\\":\\\"individual\\\",\\\"id\\\":\\\"\\\"}\",\"stripe_cust_id\":\"\",\"authorize_profile\":\"\",\"json_fields\":\"{\\\"dn_donor_name\\\":\\\"John, Katie & Clara Richter\\\",\\\"dn_address\\\":\\\"dev+6@helpyousponsor.com\\\",\\\"dn_home_address\\\":\\\"405 Hackberry Ln Box 363\\\",\\\"dn_payment_type\\\":\\\"CC Monthly\\\",\\\"dn_child_sponsored\\\":\\\"Estilien Claudensky\\\",\\\"fakeusernameremembered\\\":\\\"\\\",\\\"fakepasswordremembered\\\":\\\"\\\",\\\"password\\\":\\\"\\\"}\",\"deleted_at\":\"\",\"created_at\":\"2018-11-04T22:27:57.000000Z\",\"updated_at\":\"2020-09-09T00:34:40.000000Z\",\"last_login\":\"2020-09-09 00:34:20\",\"__hevo__database_name\":\"apphys_new\",\"__hevo__ingested_at\":\"1679725257574\",\"__hevo__marked_deleted\":\"0\",\"__hevo__source_modified_at\":\"\",\"stripe_card_id\":\"\",\"paypal_email\":\"\",\"dn_donor_name\":\"John, Katie & Clara Richter\",\"dn_address\":\"dev+6@helpyousponsor.com\",\"dn_home_address\":\"405 Hackberry Ln Box 363\",\"dn_payment_type\":\"CC Monthly\",\"dn_child_sponsored\":\"Estilien Claudensky\",\"fakeusernameremembered\":\"\",\"fakepasswordremembered\":\"\",\"donor_id\":\"17166\"},\"donation\":{\"designations\":\"Wilna Dervil @ 32 (Every Month)\",\"total_amount\":32,\"method\":\"Credit Card\",\"date\":\"Apr 16, 2024\"}},\"subject\":\"Donation Receipt\",\"body\":\"<p>Thank you for your donation Wilna Dervil @ 32 (Every Month) for 32. This email serves as your donation receipt.<\\/p>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<table style=\\\"\\\" border-color:#666;width:80%;margin:20px=\\\"\\\" auto;\\\"\\\"=\\\"\\\" cellpadding=\\\"\\\" 10\\\"\\\"=\\\"\\\">\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tbody>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tDonor Name\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t[donor_name]\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tDesignation\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t[designation_name]\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tAmount\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t$[amount]\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tMethod\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tCredit Card\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tFrequency\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t[frequency]<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tbody>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/table><p>Apr 16, 2024<\\/p>\",\"done_by\":\"System\"}",
          "created_at": "2024-04-16T10:18:43.000000Z",
          "updated_at": "2024-04-16T10:18:43.000000Z",
          "description": "A commitment donation receipt email for <strong>Estilien Claudensky</strong> has been sent to <a href=\"/app/view_donor/17166\"><strong>John, Katie & Clara Richter CC Monthly</strong></a>"
        },
        {
          "id": 251,
          "client_id": 207,
          "admin_id": null,
          "donor_id": 17166,
          "table_name": "donations",
          "record_id": 379479,
          "action": "commitment_donation_email",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"John, Katie & Clara Richter CC Monthly\",\"details\":{\"donor\":{\"id\":\"17166\",\"client_id\":\"207\",\"hysform_id\":\"639\",\"do_not_email\":\"0\",\"wait_time\":\"\",\"who_added\":\"{\\\"type\\\":\\\"donor\\\",\\\"method\\\":\\\"individual\\\",\\\"id\\\":\\\"\\\"}\",\"stripe_cust_id\":\"\",\"authorize_profile\":\"\",\"json_fields\":\"{\\\"dn_donor_name\\\":\\\"John, Katie & Clara Richter\\\",\\\"dn_address\\\":\\\"dev+6@helpyousponsor.com\\\",\\\"dn_home_address\\\":\\\"405 Hackberry Ln Box 363\\\",\\\"dn_payment_type\\\":\\\"CC Monthly\\\",\\\"dn_child_sponsored\\\":\\\"Estilien Claudensky\\\",\\\"fakeusernameremembered\\\":\\\"\\\",\\\"fakepasswordremembered\\\":\\\"\\\",\\\"password\\\":\\\"\\\"}\",\"deleted_at\":\"\",\"created_at\":\"2018-11-04T22:27:57.000000Z\",\"updated_at\":\"2020-09-09T00:34:40.000000Z\",\"last_login\":\"2020-09-09 00:34:20\",\"__hevo__database_name\":\"apphys_new\",\"__hevo__ingested_at\":\"1679725257574\",\"__hevo__marked_deleted\":\"0\",\"__hevo__source_modified_at\":\"\",\"stripe_card_id\":\"\",\"paypal_email\":\"\",\"dn_donor_name\":\"John, Katie & Clara Richter\",\"dn_address\":\"dev+6@helpyousponsor.com\",\"dn_home_address\":\"405 Hackberry Ln Box 363\",\"dn_payment_type\":\"CC Monthly\",\"dn_child_sponsored\":\"Estilien Claudensky\",\"fakeusernameremembered\":\"\",\"fakepasswordremembered\":\"\",\"donor_id\":\"17166\"},\"donation\":{\"designations\":\"Wilna Dervil @ 32 (Every Month)\",\"total_amount\":32,\"method\":\"Credit Card\",\"date\":\"Apr 16, 2024\"}},\"subject\":\"Donation Receipt\",\"body\":\"<p>Thank you for your donation Wilna Dervil @ 32 (Every Month) for 32. This email serves as your donation receipt.<\\/p>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<table style=\\\"\\\" border-color:#666;width:80%;margin:20px=\\\"\\\" auto;\\\"\\\"=\\\"\\\" cellpadding=\\\"\\\" 10\\\"\\\"=\\\"\\\">\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tbody>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tDonor Name\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t[donor_name]\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tDesignation\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t[designation_name]\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tAmount\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t$[amount]\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tMethod\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tCredit Card\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tFrequency\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t[frequency]<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tbody>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/table><p>Apr 16, 2024<\\/p>\",\"done_by\":\"System\"}",
          "created_at": "2024-04-16T10:18:22.000000Z",
          "updated_at": "2024-04-16T10:18:22.000000Z",
          "description": "A commitment donation receipt email for <strong>Estilien Claudensky</strong> has been sent to <a href=\"/app/view_donor/17166\"><strong>John, Katie & Clara Richter CC Monthly</strong></a>"
        },
        {
          "id": 264,
          "client_id": 207,
          "admin_id": null,
          "donor_id": 17166,
          "table_name": "donations",
          "record_id": 379479,
          "action": "commitment_donation_email",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"John, Katie & Clara Richter CC Monthly\",\"details\":{\"donor\":{\"id\":\"17166\",\"client_id\":\"207\",\"hysform_id\":\"639\",\"do_not_email\":\"0\",\"wait_time\":\"\",\"who_added\":\"{\\\"type\\\":\\\"donor\\\",\\\"method\\\":\\\"individual\\\",\\\"id\\\":\\\"\\\"}\",\"stripe_cust_id\":\"\",\"authorize_profile\":\"\",\"json_fields\":\"{\\\"dn_donor_name\\\":\\\"John, Katie & Clara Richter\\\",\\\"dn_address\\\":\\\"dev+6@helpyousponsor.com\\\",\\\"dn_home_address\\\":\\\"405 Hackberry Ln Box 363\\\",\\\"dn_payment_type\\\":\\\"CC Monthly\\\",\\\"dn_child_sponsored\\\":\\\"Estilien Claudensky\\\",\\\"fakeusernameremembered\\\":\\\"\\\",\\\"fakepasswordremembered\\\":\\\"\\\",\\\"password\\\":\\\"\\\"}\",\"deleted_at\":\"\",\"created_at\":\"2018-11-04T22:27:57.000000Z\",\"updated_at\":\"2020-09-09T00:34:40.000000Z\",\"last_login\":\"2020-09-09 00:34:20\",\"__hevo__database_name\":\"apphys_new\",\"__hevo__ingested_at\":\"1679725257574\",\"__hevo__marked_deleted\":\"0\",\"__hevo__source_modified_at\":\"\",\"stripe_card_id\":\"\",\"paypal_email\":\"\",\"dn_donor_name\":\"John, Katie & Clara Richter\",\"dn_address\":\"dev+6@helpyousponsor.com\",\"dn_home_address\":\"405 Hackberry Ln Box 363\",\"dn_payment_type\":\"CC Monthly\",\"dn_child_sponsored\":\"Estilien Claudensky\",\"fakeusernameremembered\":\"\",\"fakepasswordremembered\":\"\",\"donor_id\":\"17166\"},\"donation\":{\"designations\":\"Wilna Dervil @ 32 (Every Month)\",\"total_amount\":32,\"method\":\"Credit Card\",\"date\":\"Apr 16, 2024\"}},\"subject\":\"Donation Receipt\",\"body\":\"<p>Thank you for your donation Wilna Dervil @ 32 (Every Month) for 32. This email serves as your donation receipt.<\\/p>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<table style=\\\"\\\" border-color:#666;width:80%;margin:20px=\\\"\\\" auto;\\\"\\\"=\\\"\\\" cellpadding=\\\"\\\" 10\\\"\\\"=\\\"\\\">\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tbody>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tDonor Name\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t[donor_name]\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tDesignation\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t[designation_name]\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tAmount\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t$[amount]\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tMethod\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tCredit Card\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tFrequency\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t[frequency]<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tbody>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/table><p>Apr 16, 2024<\\/p>\",\"done_by\":\"System\"}",
          "created_at": "2024-04-16T10:18:22.000000Z",
          "updated_at": "2024-04-16T10:18:22.000000Z",
          "description": "A commitment donation receipt email for <strong>Estilien Claudensky</strong> has been sent to <a href=\"/app/view_donor/17166\"><strong>John, Katie & Clara Richter CC Monthly</strong></a>"
        },
        {
          "id": 250,
          "client_id": 207,
          "admin_id": null,
          "donor_id": 17166,
          "table_name": "donations",
          "record_id": 379478,
          "action": "commitment_donation_email",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"John, Katie & Clara Richter CC Monthly\",\"details\":{\"donor\":{\"id\":\"17166\",\"client_id\":\"207\",\"hysform_id\":\"639\",\"do_not_email\":\"0\",\"wait_time\":\"\",\"who_added\":\"{\\\"type\\\":\\\"donor\\\",\\\"method\\\":\\\"individual\\\",\\\"id\\\":\\\"\\\"}\",\"stripe_cust_id\":\"\",\"authorize_profile\":\"\",\"json_fields\":\"{\\\"dn_donor_name\\\":\\\"John, Katie & Clara Richter\\\",\\\"dn_address\\\":\\\"dev+6@helpyousponsor.com\\\",\\\"dn_home_address\\\":\\\"405 Hackberry Ln Box 363\\\",\\\"dn_payment_type\\\":\\\"CC Monthly\\\",\\\"dn_child_sponsored\\\":\\\"Estilien Claudensky\\\",\\\"fakeusernameremembered\\\":\\\"\\\",\\\"fakepasswordremembered\\\":\\\"\\\",\\\"password\\\":\\\"\\\"}\",\"deleted_at\":\"\",\"created_at\":\"2018-11-04T22:27:57.000000Z\",\"updated_at\":\"2020-09-09T00:34:40.000000Z\",\"last_login\":\"2020-09-09 00:34:20\",\"__hevo__database_name\":\"apphys_new\",\"__hevo__ingested_at\":\"1679725257574\",\"__hevo__marked_deleted\":\"0\",\"__hevo__source_modified_at\":\"\",\"stripe_card_id\":\"\",\"paypal_email\":\"\",\"dn_donor_name\":\"John, Katie & Clara Richter\",\"dn_address\":\"dev+6@helpyousponsor.com\",\"dn_home_address\":\"405 Hackberry Ln Box 363\",\"dn_payment_type\":\"CC Monthly\",\"dn_child_sponsored\":\"Estilien Claudensky\",\"fakeusernameremembered\":\"\",\"fakepasswordremembered\":\"\",\"donor_id\":\"17166\"},\"donation\":{\"designations\":\"Wilna Dervil @ 32 (Every Month)\",\"total_amount\":32,\"method\":\"Credit Card\",\"date\":\"Apr 16, 2024\"}},\"subject\":\"Donation Receipt\",\"body\":\"<p>Thank you for your donation Wilna Dervil @ 32 (Every Month) for 32. This email serves as your donation receipt.<\\/p>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<table style=\\\"\\\" border-color:#666;width:80%;margin:20px=\\\"\\\" auto;\\\"\\\"=\\\"\\\" cellpadding=\\\"\\\" 10\\\"\\\"=\\\"\\\">\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tbody>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tDonor Name\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t[donor_name]\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tDesignation\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t[designation_name]\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tAmount\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t$[amount]\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tMethod\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tCredit Card\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tFrequency\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t[frequency]<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tbody>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/table><p>Apr 16, 2024<\\/p>\",\"done_by\":\"System\"}",
          "created_at": "2024-04-16T10:16:54.000000Z",
          "updated_at": "2024-04-16T10:16:54.000000Z",
          "description": "A commitment donation receipt email for <strong>Estilien Claudensky</strong> has been sent to <a href=\"/app/view_donor/17166\"><strong>John, Katie & Clara Richter CC Monthly</strong></a>"
        },
        {
          "id": 263,
          "client_id": 207,
          "admin_id": null,
          "donor_id": 17166,
          "table_name": "donations",
          "record_id": 379478,
          "action": "commitment_donation_email",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"John, Katie & Clara Richter CC Monthly\",\"details\":{\"donor\":{\"id\":\"17166\",\"client_id\":\"207\",\"hysform_id\":\"639\",\"do_not_email\":\"0\",\"wait_time\":\"\",\"who_added\":\"{\\\"type\\\":\\\"donor\\\",\\\"method\\\":\\\"individual\\\",\\\"id\\\":\\\"\\\"}\",\"stripe_cust_id\":\"\",\"authorize_profile\":\"\",\"json_fields\":\"{\\\"dn_donor_name\\\":\\\"John, Katie & Clara Richter\\\",\\\"dn_address\\\":\\\"dev+6@helpyousponsor.com\\\",\\\"dn_home_address\\\":\\\"405 Hackberry Ln Box 363\\\",\\\"dn_payment_type\\\":\\\"CC Monthly\\\",\\\"dn_child_sponsored\\\":\\\"Estilien Claudensky\\\",\\\"fakeusernameremembered\\\":\\\"\\\",\\\"fakepasswordremembered\\\":\\\"\\\",\\\"password\\\":\\\"\\\"}\",\"deleted_at\":\"\",\"created_at\":\"2018-11-04T22:27:57.000000Z\",\"updated_at\":\"2020-09-09T00:34:40.000000Z\",\"last_login\":\"2020-09-09 00:34:20\",\"__hevo__database_name\":\"apphys_new\",\"__hevo__ingested_at\":\"1679725257574\",\"__hevo__marked_deleted\":\"0\",\"__hevo__source_modified_at\":\"\",\"stripe_card_id\":\"\",\"paypal_email\":\"\",\"dn_donor_name\":\"John, Katie & Clara Richter\",\"dn_address\":\"dev+6@helpyousponsor.com\",\"dn_home_address\":\"405 Hackberry Ln Box 363\",\"dn_payment_type\":\"CC Monthly\",\"dn_child_sponsored\":\"Estilien Claudensky\",\"fakeusernameremembered\":\"\",\"fakepasswordremembered\":\"\",\"donor_id\":\"17166\"},\"donation\":{\"designations\":\"Wilna Dervil @ 32 (Every Month)\",\"total_amount\":32,\"method\":\"Credit Card\",\"date\":\"Apr 16, 2024\"}},\"subject\":\"Donation Receipt\",\"body\":\"<p>Thank you for your donation Wilna Dervil @ 32 (Every Month) for 32. This email serves as your donation receipt.<\\/p>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<table style=\\\"\\\" border-color:#666;width:80%;margin:20px=\\\"\\\" auto;\\\"\\\"=\\\"\\\" cellpadding=\\\"\\\" 10\\\"\\\"=\\\"\\\">\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tbody>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tDonor Name\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t[donor_name]\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tDesignation\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t[designation_name]\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tAmount\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t$[amount]\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tMethod\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tCredit Card\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tFrequency\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t[frequency]<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tbody>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/table><p>Apr 16, 2024<\\/p>\",\"done_by\":\"System\"}",
          "created_at": "2024-04-16T10:16:54.000000Z",
          "updated_at": "2024-04-16T10:16:54.000000Z",
          "description": "A commitment donation receipt email for <strong>Estilien Claudensky</strong> has been sent to <a href=\"/app/view_donor/17166\"><strong>John, Katie & Clara Richter CC Monthly</strong></a>"
        },
        {
          "id": 249,
          "client_id": 207,
          "admin_id": null,
          "donor_id": 17166,
          "table_name": "donations",
          "record_id": 379477,
          "action": "commitment_donation_email",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"John, Katie & Clara Richter CC Monthly\",\"details\":{\"donor\":{\"id\":\"17166\",\"client_id\":\"207\",\"hysform_id\":\"639\",\"do_not_email\":\"0\",\"wait_time\":\"\",\"who_added\":\"{\\\"type\\\":\\\"donor\\\",\\\"method\\\":\\\"individual\\\",\\\"id\\\":\\\"\\\"}\",\"stripe_cust_id\":\"\",\"authorize_profile\":\"\",\"json_fields\":\"{\\\"dn_donor_name\\\":\\\"John, Katie & Clara Richter\\\",\\\"dn_address\\\":\\\"dev+6@helpyousponsor.com\\\",\\\"dn_home_address\\\":\\\"405 Hackberry Ln Box 363\\\",\\\"dn_payment_type\\\":\\\"CC Monthly\\\",\\\"dn_child_sponsored\\\":\\\"Estilien Claudensky\\\",\\\"fakeusernameremembered\\\":\\\"\\\",\\\"fakepasswordremembered\\\":\\\"\\\",\\\"password\\\":\\\"\\\"}\",\"deleted_at\":\"\",\"created_at\":\"2018-11-04T22:27:57.000000Z\",\"updated_at\":\"2020-09-09T00:34:40.000000Z\",\"last_login\":\"2020-09-09 00:34:20\",\"__hevo__database_name\":\"apphys_new\",\"__hevo__ingested_at\":\"1679725257574\",\"__hevo__marked_deleted\":\"0\",\"__hevo__source_modified_at\":\"\",\"stripe_card_id\":\"\",\"paypal_email\":\"\",\"dn_donor_name\":\"John, Katie & Clara Richter\",\"dn_address\":\"dev+6@helpyousponsor.com\",\"dn_home_address\":\"405 Hackberry Ln Box 363\",\"dn_payment_type\":\"CC Monthly\",\"dn_child_sponsored\":\"Estilien Claudensky\",\"fakeusernameremembered\":\"\",\"fakepasswordremembered\":\"\",\"donor_id\":\"17166\"},\"donation\":{\"designations\":\"Wilna Dervil @ 32 (Every Month)\",\"total_amount\":32,\"method\":\"Credit Card\",\"date\":\"Apr 16, 2024\"}},\"subject\":\"Donation Receipt\",\"body\":\"<p>Thank you for your donation Wilna Dervil @ 32 (Every Month) for 32. This email serves as your donation receipt.<\\/p>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<table style=\\\"\\\" border-color:#666;width:80%;margin:20px=\\\"\\\" auto;\\\"\\\"=\\\"\\\" cellpadding=\\\"\\\" 10\\\"\\\"=\\\"\\\">\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tbody>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tDonor Name\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t[donor_name]\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tDesignation\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t[designation_name]\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tAmount\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t$[amount]\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tMethod\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tCredit Card\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tFrequency\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t[frequency]<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tbody>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/table><p>Apr 16, 2024<\\/p>\",\"done_by\":\"System\"}",
          "created_at": "2024-04-16T10:16:32.000000Z",
          "updated_at": "2024-04-16T10:16:32.000000Z",
          "description": "A commitment donation receipt email for <strong>Estilien Claudensky</strong> has been sent to <a href=\"/app/view_donor/17166\"><strong>John, Katie & Clara Richter CC Monthly</strong></a>"
        },
        {
          "id": 262,
          "client_id": 207,
          "admin_id": null,
          "donor_id": 17166,
          "table_name": "donations",
          "record_id": 379477,
          "action": "commitment_donation_email",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"John, Katie & Clara Richter CC Monthly\",\"details\":{\"donor\":{\"id\":\"17166\",\"client_id\":\"207\",\"hysform_id\":\"639\",\"do_not_email\":\"0\",\"wait_time\":\"\",\"who_added\":\"{\\\"type\\\":\\\"donor\\\",\\\"method\\\":\\\"individual\\\",\\\"id\\\":\\\"\\\"}\",\"stripe_cust_id\":\"\",\"authorize_profile\":\"\",\"json_fields\":\"{\\\"dn_donor_name\\\":\\\"John, Katie & Clara Richter\\\",\\\"dn_address\\\":\\\"dev+6@helpyousponsor.com\\\",\\\"dn_home_address\\\":\\\"405 Hackberry Ln Box 363\\\",\\\"dn_payment_type\\\":\\\"CC Monthly\\\",\\\"dn_child_sponsored\\\":\\\"Estilien Claudensky\\\",\\\"fakeusernameremembered\\\":\\\"\\\",\\\"fakepasswordremembered\\\":\\\"\\\",\\\"password\\\":\\\"\\\"}\",\"deleted_at\":\"\",\"created_at\":\"2018-11-04T22:27:57.000000Z\",\"updated_at\":\"2020-09-09T00:34:40.000000Z\",\"last_login\":\"2020-09-09 00:34:20\",\"__hevo__database_name\":\"apphys_new\",\"__hevo__ingested_at\":\"1679725257574\",\"__hevo__marked_deleted\":\"0\",\"__hevo__source_modified_at\":\"\",\"stripe_card_id\":\"\",\"paypal_email\":\"\",\"dn_donor_name\":\"John, Katie & Clara Richter\",\"dn_address\":\"dev+6@helpyousponsor.com\",\"dn_home_address\":\"405 Hackberry Ln Box 363\",\"dn_payment_type\":\"CC Monthly\",\"dn_child_sponsored\":\"Estilien Claudensky\",\"fakeusernameremembered\":\"\",\"fakepasswordremembered\":\"\",\"donor_id\":\"17166\"},\"donation\":{\"designations\":\"Wilna Dervil @ 32 (Every Month)\",\"total_amount\":32,\"method\":\"Credit Card\",\"date\":\"Apr 16, 2024\"}},\"subject\":\"Donation Receipt\",\"body\":\"<p>Thank you for your donation Wilna Dervil @ 32 (Every Month) for 32. This email serves as your donation receipt.<\\/p>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<table style=\\\"\\\" border-color:#666;width:80%;margin:20px=\\\"\\\" auto;\\\"\\\"=\\\"\\\" cellpadding=\\\"\\\" 10\\\"\\\"=\\\"\\\">\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tbody>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tDonor Name\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t[donor_name]\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tDesignation\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t[designation_name]\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tAmount\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t$[amount]\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tMethod\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tCredit Card\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tFrequency\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t[frequency]<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tbody>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/table><p>Apr 16, 2024<\\/p>\",\"done_by\":\"System\"}",
          "created_at": "2024-04-16T10:16:32.000000Z",
          "updated_at": "2024-04-16T10:16:32.000000Z",
          "description": "A commitment donation receipt email for <strong>Estilien Claudensky</strong> has been sent to <a href=\"/app/view_donor/17166\"><strong>John, Katie & Clara Richter CC Monthly</strong></a>"
        },
        {
          "id": 248,
          "client_id": 207,
          "admin_id": null,
          "donor_id": 17166,
          "table_name": "donations",
          "record_id": 379476,
          "action": "commitment_donation_email",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"John, Katie & Clara Richter CC Monthly\",\"details\":{\"donor\":{\"id\":\"17166\",\"client_id\":\"207\",\"hysform_id\":\"639\",\"do_not_email\":\"0\",\"wait_time\":\"\",\"who_added\":\"{\\\"type\\\":\\\"donor\\\",\\\"method\\\":\\\"individual\\\",\\\"id\\\":\\\"\\\"}\",\"stripe_cust_id\":\"\",\"authorize_profile\":\"\",\"json_fields\":\"{\\\"dn_donor_name\\\":\\\"John, Katie & Clara Richter\\\",\\\"dn_address\\\":\\\"dev+6@helpyousponsor.com\\\",\\\"dn_home_address\\\":\\\"405 Hackberry Ln Box 363\\\",\\\"dn_payment_type\\\":\\\"CC Monthly\\\",\\\"dn_child_sponsored\\\":\\\"Estilien Claudensky\\\",\\\"fakeusernameremembered\\\":\\\"\\\",\\\"fakepasswordremembered\\\":\\\"\\\",\\\"password\\\":\\\"\\\"}\",\"deleted_at\":\"\",\"created_at\":\"2018-11-04T22:27:57.000000Z\",\"updated_at\":\"2020-09-09T00:34:40.000000Z\",\"last_login\":\"2020-09-09 00:34:20\",\"__hevo__database_name\":\"apphys_new\",\"__hevo__ingested_at\":\"1679725257574\",\"__hevo__marked_deleted\":\"0\",\"__hevo__source_modified_at\":\"\",\"stripe_card_id\":\"\",\"paypal_email\":\"\",\"dn_donor_name\":\"John, Katie & Clara Richter\",\"dn_address\":\"dev+6@helpyousponsor.com\",\"dn_home_address\":\"405 Hackberry Ln Box 363\",\"dn_payment_type\":\"CC Monthly\",\"dn_child_sponsored\":\"Estilien Claudensky\",\"fakeusernameremembered\":\"\",\"fakepasswordremembered\":\"\",\"donor_id\":\"17166\"},\"donation\":{\"designations\":\"Wilna Dervil @ 32 (Every Month)\",\"total_amount\":32,\"method\":\"Credit Card\",\"date\":\"Apr 16, 2024\"}},\"subject\":\"Donation Receipt\",\"body\":\"<p>Thank you for your donation Wilna Dervil @ 32 (Every Month) for 32. This email serves as your donation receipt.<\\/p>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<table style=\\\"\\\" border-color:#666;width:80%;margin:20px=\\\"\\\" auto;\\\"\\\"=\\\"\\\" cellpadding=\\\"\\\" 10\\\"\\\"=\\\"\\\">\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tbody>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tDonor Name\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t[donor_name]\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tDesignation\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t[designation_name]\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tAmount\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t$[amount]\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tMethod\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tCredit Card\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tFrequency\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t[frequency]<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tbody>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/table><p>Apr 16, 2024<\\/p>\",\"done_by\":\"System\"}",
          "created_at": "2024-04-16T10:16:13.000000Z",
          "updated_at": "2024-04-16T10:16:13.000000Z",
          "description": "A commitment donation receipt email for <strong>Estilien Claudensky</strong> has been sent to <a href=\"/app/view_donor/17166\"><strong>John, Katie & Clara Richter CC Monthly</strong></a>"
        },
        {
          "id": 261,
          "client_id": 207,
          "admin_id": null,
          "donor_id": 17166,
          "table_name": "donations",
          "record_id": 379476,
          "action": "commitment_donation_email",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"John, Katie & Clara Richter CC Monthly\",\"details\":{\"donor\":{\"id\":\"17166\",\"client_id\":\"207\",\"hysform_id\":\"639\",\"do_not_email\":\"0\",\"wait_time\":\"\",\"who_added\":\"{\\\"type\\\":\\\"donor\\\",\\\"method\\\":\\\"individual\\\",\\\"id\\\":\\\"\\\"}\",\"stripe_cust_id\":\"\",\"authorize_profile\":\"\",\"json_fields\":\"{\\\"dn_donor_name\\\":\\\"John, Katie & Clara Richter\\\",\\\"dn_address\\\":\\\"dev+6@helpyousponsor.com\\\",\\\"dn_home_address\\\":\\\"405 Hackberry Ln Box 363\\\",\\\"dn_payment_type\\\":\\\"CC Monthly\\\",\\\"dn_child_sponsored\\\":\\\"Estilien Claudensky\\\",\\\"fakeusernameremembered\\\":\\\"\\\",\\\"fakepasswordremembered\\\":\\\"\\\",\\\"password\\\":\\\"\\\"}\",\"deleted_at\":\"\",\"created_at\":\"2018-11-04T22:27:57.000000Z\",\"updated_at\":\"2020-09-09T00:34:40.000000Z\",\"last_login\":\"2020-09-09 00:34:20\",\"__hevo__database_name\":\"apphys_new\",\"__hevo__ingested_at\":\"1679725257574\",\"__hevo__marked_deleted\":\"0\",\"__hevo__source_modified_at\":\"\",\"stripe_card_id\":\"\",\"paypal_email\":\"\",\"dn_donor_name\":\"John, Katie & Clara Richter\",\"dn_address\":\"dev+6@helpyousponsor.com\",\"dn_home_address\":\"405 Hackberry Ln Box 363\",\"dn_payment_type\":\"CC Monthly\",\"dn_child_sponsored\":\"Estilien Claudensky\",\"fakeusernameremembered\":\"\",\"fakepasswordremembered\":\"\",\"donor_id\":\"17166\"},\"donation\":{\"designations\":\"Wilna Dervil @ 32 (Every Month)\",\"total_amount\":32,\"method\":\"Credit Card\",\"date\":\"Apr 16, 2024\"}},\"subject\":\"Donation Receipt\",\"body\":\"<p>Thank you for your donation Wilna Dervil @ 32 (Every Month) for 32. This email serves as your donation receipt.<\\/p>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<table style=\\\"\\\" border-color:#666;width:80%;margin:20px=\\\"\\\" auto;\\\"\\\"=\\\"\\\" cellpadding=\\\"\\\" 10\\\"\\\"=\\\"\\\">\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tbody>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tDonor Name\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t[donor_name]\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tDesignation\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t[designation_name]\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tAmount\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t$[amount]\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tMethod\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tCredit Card\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tFrequency\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t[frequency]<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tbody>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/table><p>Apr 16, 2024<\\/p>\",\"done_by\":\"System\"}",
          "created_at": "2024-04-16T10:16:13.000000Z",
          "updated_at": "2024-04-16T10:16:13.000000Z",
          "description": "A commitment donation receipt email for <strong>Estilien Claudensky</strong> has been sent to <a href=\"/app/view_donor/17166\"><strong>John, Katie & Clara Richter CC Monthly</strong></a>"
        },
        {
          "id": 247,
          "client_id": 207,
          "admin_id": null,
          "donor_id": 17166,
          "table_name": "donations",
          "record_id": 379475,
          "action": "commitment_donation_email",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"John, Katie & Clara Richter CC Monthly\",\"details\":{\"donor\":{\"id\":\"17166\",\"client_id\":\"207\",\"hysform_id\":\"639\",\"do_not_email\":\"0\",\"wait_time\":\"\",\"who_added\":\"{\\\"type\\\":\\\"donor\\\",\\\"method\\\":\\\"individual\\\",\\\"id\\\":\\\"\\\"}\",\"stripe_cust_id\":\"\",\"authorize_profile\":\"\",\"json_fields\":\"{\\\"dn_donor_name\\\":\\\"John, Katie & Clara Richter\\\",\\\"dn_address\\\":\\\"dev+6@helpyousponsor.com\\\",\\\"dn_home_address\\\":\\\"405 Hackberry Ln Box 363\\\",\\\"dn_payment_type\\\":\\\"CC Monthly\\\",\\\"dn_child_sponsored\\\":\\\"Estilien Claudensky\\\",\\\"fakeusernameremembered\\\":\\\"\\\",\\\"fakepasswordremembered\\\":\\\"\\\",\\\"password\\\":\\\"\\\"}\",\"deleted_at\":\"\",\"created_at\":\"2018-11-04T22:27:57.000000Z\",\"updated_at\":\"2020-09-09T00:34:40.000000Z\",\"last_login\":\"2020-09-09 00:34:20\",\"__hevo__database_name\":\"apphys_new\",\"__hevo__ingested_at\":\"1679725257574\",\"__hevo__marked_deleted\":\"0\",\"__hevo__source_modified_at\":\"\",\"stripe_card_id\":\"\",\"paypal_email\":\"\",\"dn_donor_name\":\"John, Katie & Clara Richter\",\"dn_address\":\"dev+6@helpyousponsor.com\",\"dn_home_address\":\"405 Hackberry Ln Box 363\",\"dn_payment_type\":\"CC Monthly\",\"dn_child_sponsored\":\"Estilien Claudensky\",\"fakeusernameremembered\":\"\",\"fakepasswordremembered\":\"\",\"donor_id\":\"17166\"},\"donation\":{\"designations\":\"Wilna Dervil @ 32 (Every Month)\",\"total_amount\":32,\"method\":\"Credit Card\",\"date\":\"Apr 16, 2024\"}},\"subject\":\"Donation Receipt\",\"body\":\"<p>Thank you for your donation Wilna Dervil @ 32 (Every Month) for 32. This email serves as your donation receipt.<\\/p>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<table style=\\\"\\\" border-color:#666;width:80%;margin:20px=\\\"\\\" auto;\\\"\\\"=\\\"\\\" cellpadding=\\\"\\\" 10\\\"\\\"=\\\"\\\">\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tbody>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tDonor Name\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t[donor_name]\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tDesignation\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t[designation_name]\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tAmount\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t$[amount]\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tMethod\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tCredit Card\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tFrequency\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t[frequency]<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tbody>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/table><p>Apr 16, 2024<\\/p>\",\"done_by\":\"System\"}",
          "created_at": "2024-04-16T10:12:46.000000Z",
          "updated_at": "2024-04-16T10:12:46.000000Z",
          "description": "A commitment donation receipt email for <strong>Estilien Claudensky</strong> has been sent to <a href=\"/app/view_donor/17166\"><strong>John, Katie & Clara Richter CC Monthly</strong></a>"
        },
        {
          "id": 260,
          "client_id": 207,
          "admin_id": null,
          "donor_id": 17166,
          "table_name": "donations",
          "record_id": 379475,
          "action": "commitment_donation_email",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"John, Katie & Clara Richter CC Monthly\",\"details\":{\"donor\":{\"id\":\"17166\",\"client_id\":\"207\",\"hysform_id\":\"639\",\"do_not_email\":\"0\",\"wait_time\":\"\",\"who_added\":\"{\\\"type\\\":\\\"donor\\\",\\\"method\\\":\\\"individual\\\",\\\"id\\\":\\\"\\\"}\",\"stripe_cust_id\":\"\",\"authorize_profile\":\"\",\"json_fields\":\"{\\\"dn_donor_name\\\":\\\"John, Katie & Clara Richter\\\",\\\"dn_address\\\":\\\"dev+6@helpyousponsor.com\\\",\\\"dn_home_address\\\":\\\"405 Hackberry Ln Box 363\\\",\\\"dn_payment_type\\\":\\\"CC Monthly\\\",\\\"dn_child_sponsored\\\":\\\"Estilien Claudensky\\\",\\\"fakeusernameremembered\\\":\\\"\\\",\\\"fakepasswordremembered\\\":\\\"\\\",\\\"password\\\":\\\"\\\"}\",\"deleted_at\":\"\",\"created_at\":\"2018-11-04T22:27:57.000000Z\",\"updated_at\":\"2020-09-09T00:34:40.000000Z\",\"last_login\":\"2020-09-09 00:34:20\",\"__hevo__database_name\":\"apphys_new\",\"__hevo__ingested_at\":\"1679725257574\",\"__hevo__marked_deleted\":\"0\",\"__hevo__source_modified_at\":\"\",\"stripe_card_id\":\"\",\"paypal_email\":\"\",\"dn_donor_name\":\"John, Katie & Clara Richter\",\"dn_address\":\"dev+6@helpyousponsor.com\",\"dn_home_address\":\"405 Hackberry Ln Box 363\",\"dn_payment_type\":\"CC Monthly\",\"dn_child_sponsored\":\"Estilien Claudensky\",\"fakeusernameremembered\":\"\",\"fakepasswordremembered\":\"\",\"donor_id\":\"17166\"},\"donation\":{\"designations\":\"Wilna Dervil @ 32 (Every Month)\",\"total_amount\":32,\"method\":\"Credit Card\",\"date\":\"Apr 16, 2024\"}},\"subject\":\"Donation Receipt\",\"body\":\"<p>Thank you for your donation Wilna Dervil @ 32 (Every Month) for 32. This email serves as your donation receipt.<\\/p>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<table style=\\\"\\\" border-color:#666;width:80%;margin:20px=\\\"\\\" auto;\\\"\\\"=\\\"\\\" cellpadding=\\\"\\\" 10\\\"\\\"=\\\"\\\">\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tbody>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tDonor Name\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t[donor_name]\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tDesignation\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t[designation_name]\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tAmount\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t$[amount]\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tMethod\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tCredit Card\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tFrequency\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t[frequency]<\\/td>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tr>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/tbody>\\r\\n\\t\\t\\t\\t\\t\\t\\t\\t<\\/table><p>Apr 16, 2024<\\/p>\",\"done_by\":\"System\"}",
          "created_at": "2024-04-16T10:12:46.000000Z",
          "updated_at": "2024-04-16T10:12:46.000000Z",
          "description": "A commitment donation receipt email for <strong>Estilien Claudensky</strong> has been sent to <a href=\"/app/view_donor/17166\"><strong>John, Katie & Clara Richter CC Monthly</strong></a>"
        },
        {
          "id": 10,
          "client_id": 207,
          "admin_id": 542,
          "donor_id": 17017,
          "table_name": "commitments",
          "record_id": 23226,
          "action": "add_sponsorship",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"Test Donor Shaban Paypal, monthly\",\"amount\":\"32\",\"method\":\"External Payments\",\"designation\":\"Malache Basquin\",\"done_by\":\"Leslie Jobs\"}",
          "created_at": "2024-04-15T08:59:24.000000Z",
          "updated_at": "2024-04-15T08:59:24.000000Z",
          "description": "<a href=\"/app/view_donor/17017\"><strong>Test Donor Shaban Paypal, monthly</strong></a> has sponsored <strong>Malache Basquin</strong> with <strong>32</strong> by <strong>External Payments</strong>"
        },
        {
          "id": 9,
          "client_id": 207,
          "admin_id": 542,
          "donor_id": 17017,
          "table_name": "donations",
          "record_id": 379422,
          "action": "add_donation",
          "deleted_at": null,
          "additional_data": "{\"donor_name\":\"Test Donor Shaban Paypal, monthly\",\"amount\":\"50\",\"method\":\"External Payments\",\"designation\":\"Test Gift\",\"done_by\":\"Leslie Jobs\"}",
          "created_at": "2024-04-15T08:58:24.000000Z",
          "updated_at": "2024-04-15T08:58:24.000000Z",
          "description": "<a href=\"/app/view_donor/17017\"><strong>Test Donor Shaban Paypal, monthly</strong></a> has donated <strong>50</strong> by <strong>External Payments</strong> for <strong>Test Gift</strong>"
        }
    ],
}

export const groupdata = {
  "data": {
        "programs": [
            {
                "id": 3528,
                "client_id": 207,
                "hysform_id": null,
                "donor_hysform_id": null,
                "setting_id": null,
                "emailset_id": null,
                "entity_submit": null,
                "donor_submit": null,
                "link_id": null,
                "name": "Testing Attachment Prog",
                "prefix": "TAP",
                "counter": null,
                "lft": 2,
                "rgt": 3,
                "tree": 207,
                "box_folder_id": null,
                "deleted_at": null,
                "created_at": "2024-07-26T05:43:51.000000Z",
                "updated_at": "2024-07-26T05:43:51.000000Z",
                "__hevo__database_name": null,
                "__hevo__ingested_at": null,
                "__hevo__marked_deleted": null,
                "__hevo__source_modified_at": null,
                "children": []
            },
            {
                "id": 3521,
                "client_id": 207,
                "hysform_id": 3051,
                "donor_hysform_id": 3030,
                "setting_id": 1652,
                "emailset_id": null,
                "entity_submit": null,
                "donor_submit": null,
                "link_id": null,
                "name": "Sustainable Living Expo",
                "prefix": "DC",
                "counter": 1,
                "lft": 4,
                "rgt": 5,
                "tree": 207,
                "box_folder_id": null,
                "deleted_at": null,
                "created_at": "2024-06-13T08:35:10.000000Z",
                "updated_at": "2024-08-06T12:03:55.000000Z",
                "__hevo__database_name": null,
                "__hevo__ingested_at": null,
                "__hevo__marked_deleted": null,
                "__hevo__source_modified_at": null,
                "children": []
            },
            {
                "id": 3518,
                "client_id": 207,
                "hysform_id": 3048,
                "donor_hysform_id": 639,
                "setting_id": 1650,
                "emailset_id": null,
                "entity_submit": null,
                "donor_submit": null,
                "link_id": null,
                "name": "Masaka BoreHole",
                "prefix": "MBH",
                "counter": 1,
                "lft": 6,
                "rgt": 7,
                "tree": 207,
                "box_folder_id": null,
                "deleted_at": null,
                "created_at": "2023-10-17T06:26:48.000000Z",
                "updated_at": "2024-06-17T12:10:38.000000Z",
                "__hevo__database_name": null,
                "__hevo__ingested_at": null,
                "__hevo__marked_deleted": null,
                "__hevo__source_modified_at": null,
                "children": []
            },
            {
                "id": 3510,
                "client_id": 207,
                "hysform_id": 3043,
                "donor_hysform_id": null,
                "setting_id": 410,
                "emailset_id": null,
                "entity_submit": null,
                "donor_submit": null,
                "link_id": null,
                "name": "us2uganda",
                "prefix": "usa",
                "counter": null,
                "lft": 8,
                "rgt": 9,
                "tree": 207,
                "box_folder_id": null,
                "deleted_at": null,
                "created_at": "2023-06-02T09:24:28.000000Z",
                "updated_at": "2023-06-02T09:36:45.000000Z",
                "__hevo__database_name": null,
                "__hevo__ingested_at": null,
                "__hevo__marked_deleted": null,
                "__hevo__source_modified_at": null,
                "children": []
            },
            {
                "id": 3507,
                "client_id": 207,
                "hysform_id": 3019,
                "donor_hysform_id": 3040,
                "setting_id": 1646,
                "emailset_id": null,
                "entity_submit": null,
                "donor_submit": null,
                "link_id": null,
                "name": "Kupe",
                "prefix": "KUP",
                "counter": null,
                "lft": 10,
                "rgt": 11,
                "tree": 207,
                "box_folder_id": null,
                "deleted_at": null,
                "created_at": "2023-05-03T06:41:45.000000Z",
                "updated_at": "2024-07-25T08:23:28.000000Z",
                "__hevo__database_name": null,
                "__hevo__ingested_at": null,
                "__hevo__marked_deleted": null,
                "__hevo__source_modified_at": null,
                "children": []
            },
            {
                "id": 3506,
                "client_id": 207,
                "hysform_id": 3019,
                "donor_hysform_id": 3030,
                "setting_id": 410,
                "emailset_id": 1557,
                "entity_submit": "3058",
                "donor_submit": "",
                "link_id": null,
                "name": "Kupenda",
                "prefix": "KP",
                "counter": 200,
                "lft": 12,
                "rgt": 13,
                "tree": 207,
                "box_folder_id": null,
                "deleted_at": null,
                "created_at": "2023-04-29T15:08:37.000000Z",
                "updated_at": "2024-07-29T09:01:30.000000Z",
                "__hevo__database_name": null,
                "__hevo__ingested_at": null,
                "__hevo__marked_deleted": null,
                "__hevo__source_modified_at": null,
                "children": []
            },
            {
                "id": 3438,
                "client_id": 207,
                "hysform_id": 3019,
                "donor_hysform_id": 639,
                "setting_id": 1641,
                "emailset_id": 0,
                "entity_submit": "",
                "donor_submit": "",
                "link_id": 0,
                "name": "Marathon for the Disabled",
                "prefix": "C1",
                "counter": 5,
                "lft": 14,
                "rgt": 15,
                "tree": 207,
                "box_folder_id": "",
                "deleted_at": null,
                "created_at": "2022-12-21T16:50:33.000000Z",
                "updated_at": "2024-08-06T12:02:58.000000Z",
                "__hevo__database_name": "apphys_new",
                "__hevo__ingested_at": 1679910350683,
                "__hevo__marked_deleted": 0,
                "__hevo__source_modified_at": 1679909849000,
                "children": []
            },
            {
                "id": 3437,
                "client_id": 207,
                "hysform_id": 638,
                "donor_hysform_id": 0,
                "setting_id": 410,
                "emailset_id": 0,
                "entity_submit": "",
                "donor_submit": "",
                "link_id": 0,
                "name": "Medical",
                "prefix": "",
                "counter": 0,
                "lft": 16,
                "rgt": 17,
                "tree": 207,
                "box_folder_id": "",
                "deleted_at": null,
                "created_at": "2022-12-14T20:13:03.000000Z",
                "updated_at": "2023-03-28T18:44:07.000000Z",
                "__hevo__database_name": "apphys_new",
                "__hevo__ingested_at": 1680004248746,
                "__hevo__marked_deleted": 0,
                "__hevo__source_modified_at": 1680003847000,
                "children": []
            },
            {
                "id": 1221,
                "client_id": 207,
                "hysform_id": 3019,
                "donor_hysform_id": 639,
                "setting_id": 410,
                "emailset_id": 0,
                "entity_submit": "",
                "donor_submit": "",
                "link_id": 0,
                "name": "Sponsored",
                "prefix": "",
                "counter": 54,
                "lft": 18,
                "rgt": 19,
                "tree": 207,
                "box_folder_id": "",
                "deleted_at": null,
                "created_at": "2019-01-22T01:50:21.000000Z",
                "updated_at": "2024-07-26T09:58:46.000000Z",
                "__hevo__database_name": "apphys_new",
                "__hevo__ingested_at": 1679910350681,
                "__hevo__marked_deleted": 0,
                "__hevo__source_modified_at": 1679909849000,
                "children": []
            },
            {
                "id": 929,
                "client_id": 207,
                "hysform_id": 638,
                "donor_hysform_id": 639,
                "setting_id": 410,
                "emailset_id": 337,
                "entity_submit": "3058",
                "donor_submit": "",
                "link_id": 0,
                "name": "Education",
                "prefix": "",
                "counter": 429,
                "lft": 20,
                "rgt": 21,
                "tree": 207,
                "box_folder_id": "",
                "deleted_at": null,
                "created_at": "2017-02-23T01:40:22.000000Z",
                "updated_at": "2024-08-06T12:02:54.000000Z",
                "__hevo__database_name": "apphys_new",
                "__hevo__ingested_at": 1680004248741,
                "__hevo__marked_deleted": 0,
                "__hevo__source_modified_at": 1680003822000,
                "children": []
            },
            {
                "id": 3494,
                "client_id": 207,
                "hysform_id": 3019,
                "donor_hysform_id": 639,
                "setting_id": 410,
                "emailset_id": 1542,
                "entity_submit": "3058",
                "donor_submit": null,
                "link_id": 929,
                "name": "Youth Mentorship Program",
                "prefix": "",
                "counter": 5,
                "lft": 21,
                "rgt": 22,
                "tree": 207,
                "box_folder_id": null,
                "deleted_at": null,
                "created_at": "2023-03-25T09:14:29.000000Z",
                "updated_at": "2024-08-06T12:51:47.000000Z",
                "__hevo__database_name": null,
                "__hevo__ingested_at": null,
                "__hevo__marked_deleted": null,
                "__hevo__source_modified_at": null,
                "children": []
            }
        ],
        "donors": [
            {
                "id": 639,
                "client_id": 207,
                "default_emailset_id": 337,
                "type": "donor",
                "name": "Sponsor Profiles",
                "prefix": "",
                "counter": 253,
                "box_folder_id": "",
                "can_donor_modify_amount": "",
                "mailchimp_list_id": "",
                "forgive_missed_payments": 0,
                "notify": null,
                "deleted_at": null,
                "created_at": "2017-02-23T01:40:21.000000Z",
                "updated_at": "2024-08-06T10:18:45.000000Z",
                "hide_payment": "",
                "__hevo__database_name": "apphys_new",
                "__hevo__ingested_at": 1680093778944,
                "__hevo__marked_deleted": 0,
                "__hevo__source_modified_at": 1680093318000
            },
            {
                "id": 3030,
                "client_id": 207,
                "default_emailset_id": 0,
                "type": "donor",
                "name": "new test form",
                "prefix": "",
                "counter": 0,
                "box_folder_id": "",
                "can_donor_modify_amount": "",
                "mailchimp_list_id": "",
                "forgive_missed_payments": 0,
                "notify": null,
                "deleted_at": null,
                "created_at": "2023-04-04T08:39:19.000000Z",
                "updated_at": "2023-04-04T08:39:19.000000Z",
                "hide_payment": "",
                "__hevo__database_name": null,
                "__hevo__ingested_at": null,
                "__hevo__marked_deleted": null,
                "__hevo__source_modified_at": null
            },
            {
                "id": 3040,
                "client_id": 207,
                "default_emailset_id": 0,
                "type": "donor",
                "name": "Kupenda Donors",
                "prefix": "",
                "counter": 0,
                "box_folder_id": "",
                "can_donor_modify_amount": "",
                "mailchimp_list_id": "",
                "forgive_missed_payments": 0,
                "notify": null,
                "deleted_at": null,
                "created_at": "2023-05-09T14:53:42.000000Z",
                "updated_at": "2023-05-09T14:53:42.000000Z",
                "hide_payment": "",
                "__hevo__database_name": null,
                "__hevo__ingested_at": null,
                "__hevo__marked_deleted": null,
                "__hevo__source_modified_at": null
            }
        ],
        "group": {
            "id": 1472,
            "name": "Uganda Permissions",
            "deleted_at": null,
            "created_at": "2022-12-16T08:34:34.000000Z",
            "updated_at": "2023-02-13T13:15:59.000000Z",
            "client_id": "207",
            "__hevo__ingested_at": 1679725257548,
            "__hevo__marked_deleted": 0,
            "__hevo__source_modified_at": null,
            "__hevo__database_name": "apphys_new",
            "groups": "1",
            "group-301": "1",
            "admins": "1",
            "forms": "1",
            "new_form": "1",
            "manage_programs": "1",
            "manage_settings": "1",
            "manage_designations": "1",
            "manage_email": "1",
            "email_manager": "1",
            "donations": "1",
            "disable_entity_archive": "1",
            "disable_entity_restore": "1",
            "disable_entity_delete": "1",
            "program-3437": "1",
            "program-1221": "1",
            "program-929": "1",
            "disable_donor_archive": "1",
            "disable_donor_restore": "1",
            "disable_donor_delete": "1",
            "donor-639": "1",
            "donor-all": "1",
            "account": null,
            "send_status": null,
            "form_report": null,
            "group_all": null,
            "disable_message_send_without_approval": null,
            "group_id": 1472
        },
        "all_groups": [
            {
                "id": 301,
                "name": "HYS Demo",
                "permissions": "{\"id\":301,\"deleted_at\":null,\"created_at\":\"2017-02-22T20:40:21.000000Z\",\"updated_at\":\"2023-05-03T09:41:45.000000Z\",\"client_id\":\"207\",\"__hevo__ingested_at\":1679725257548,\"__hevo__marked_deleted\":0,\"__hevo__source_modified_at\":null,\"__hevo__database_name\":\"apphys_new\",\"group_all\":\"1\",\"account\":\"1\",\"groups\":\"1\",\"group-301\":\"1\",\"admins\":\"1\",\"forms\":\"1\",\"new_form\":\"1\",\"manage_programs\":\"1\",\"manage_settings\":\"1\",\"manage_designations\":\"1\",\"manage_email\":\"1\",\"email_manager\":\"1\",\"donations\":\"1\",\"form_report\":\"1\",\"program-1221\":\"1\",\"program-929\":\"1\",\"donor-639\":\"1\",\"program-all\":\"1\",\"donor-all\":\"1\",\"program-3437\":\"1\",\"program-3438\":\"1\",\"program-3439\":\"1\",\"program-3440\":\"1\",\"program-3441\":\"1\",\"program-3442\":\"1\",\"program-3443\":\"1\",\"program-3494\":\"1\",\"program-3495\":\"1\",\"program-3506\":\"1\",\"program-3507\":\"1\",\"disable_entity_archive\":null,\"disable_donor_archive\":null,\"disable_donor_delete\":null,\"disable_donor_restore\":null,\"disable_entity_delete\":null,\"disable_entity_restore\":null,\"group_id\":301,\"program-3510\":\"1\",\"program-3515\":\"1\",\"program-3516\":\"1\",\"program-3517\":\"1\",\"program-3518\":\"1\",\"disable_message_send_without_approval\":null,\"send_status\":\"1\",\"program-3521\":\"1\",\"program-3528\":\"1\"}",
                "deleted_at": null,
                "created_at": "2017-02-22T17:40:21.000000Z",
                "updated_at": "2024-07-26T05:43:51.000000Z",
                "client_id": "207",
                "__hevo__ingested_at": 1679725257548,
                "__hevo__marked_deleted": 0,
                "__hevo__source_modified_at": null,
                "__hevo__database_name": "apphys_new"
            },
            {
                "id": 1472,
                "name": "Uganda Permissions",
                "permissions": "{\"id\":1472,\"deleted_at\":null,\"created_at\":\"2022-12-16T08:34:34.000000Z\",\"updated_at\":\"2023-02-13T13:15:59.000000Z\",\"client_id\":\"207\",\"__hevo__ingested_at\":1679725257548,\"__hevo__marked_deleted\":0,\"__hevo__source_modified_at\":null,\"__hevo__database_name\":\"apphys_new\",\"groups\":\"1\",\"group-301\":\"1\",\"admins\":\"1\",\"forms\":\"1\",\"new_form\":\"1\",\"manage_programs\":\"1\",\"manage_settings\":\"1\",\"manage_designations\":\"1\",\"manage_email\":\"1\",\"email_manager\":\"1\",\"donations\":\"1\",\"disable_entity_archive\":\"1\",\"disable_entity_restore\":\"1\",\"disable_entity_delete\":\"1\",\"program-3437\":\"1\",\"program-1221\":\"1\",\"program-929\":\"1\",\"disable_donor_archive\":\"1\",\"disable_donor_restore\":\"1\",\"disable_donor_delete\":\"1\",\"donor-639\":\"1\",\"donor-all\":\"1\",\"account\":null,\"send_status\":null,\"form_report\":null,\"group_all\":null,\"disable_message_send_without_approval\":null,\"group_id\":1472}",
                "deleted_at": null,
                "created_at": "2022-12-16T08:34:34.000000Z",
                "updated_at": "2024-08-09T10:15:36.000000Z",
                "client_id": "207",
                "__hevo__ingested_at": 1679725257548,
                "__hevo__marked_deleted": 0,
                "__hevo__source_modified_at": null,
                "__hevo__database_name": "apphys_new"
            },
            {
                "id": 1473,
                "name": "Congo Permissions",
                "permissions": "{\"id\":1473,\"deleted_at\":null,\"created_at\":\"2023-02-13T13:07:07.000000Z\",\"updated_at\":\"2023-02-13T13:07:07.000000Z\",\"client_id\":\"207\",\"__hevo__ingested_at\":1679725257548,\"__hevo__marked_deleted\":0,\"__hevo__source_modified_at\":null,\"__hevo__database_name\":\"apphys_new\",\"account\":null,\"admins\":null,\"donations\":null,\"email_manager\":null,\"send_status\":null,\"form_report\":null,\"forms\":null,\"disable_entity_archive\":null,\"manage_designations\":null,\"manage_email\":null,\"manage_programs\":null,\"manage_settings\":null,\"new_form\":null,\"group_all\":null,\"groups\":null,\"disable_donor_archive\":null,\"disable_donor_delete\":null,\"disable_donor_restore\":null,\"disable_entity_delete\":null,\"disable_entity_restore\":null,\"disable_message_send_without_approval\":null,\"group_id\":1473}",
                "deleted_at": null,
                "created_at": "2023-02-13T13:07:07.000000Z",
                "updated_at": "2024-08-09T09:25:19.000000Z",
                "client_id": "207",
                "__hevo__ingested_at": 1679725257548,
                "__hevo__marked_deleted": 0,
                "__hevo__source_modified_at": null,
                "__hevo__database_name": "apphys_new"
            },
            {
                "id": 1474,
                "name": "India Permissions",
                "permissions": "{\"id\":1474,\"deleted_at\":null,\"created_at\":\"2023-02-15T09:15:44.000000Z\",\"updated_at\":\"2023-02-15T09:15:44.000000Z\",\"client_id\":\"207\",\"__hevo__ingested_at\":1679725257548,\"__hevo__marked_deleted\":0,\"__hevo__source_modified_at\":null,\"__hevo__database_name\":\"apphys_new\",\"program-3437\":\"1\",\"program-1221\":\"1\",\"program-929\":\"1\",\"account\":null,\"admins\":null,\"donations\":null,\"email_manager\":null,\"send_status\":null,\"form_report\":null,\"forms\":null,\"disable_entity_archive\":null,\"manage_designations\":null,\"manage_email\":null,\"manage_programs\":null,\"manage_settings\":null,\"new_form\":null,\"group_all\":null,\"groups\":null,\"disable_donor_archive\":null,\"disable_donor_delete\":null,\"disable_donor_restore\":null,\"disable_entity_delete\":null,\"disable_entity_restore\":null,\"disable_message_send_without_approval\":null,\"group_id\":1474}",
                "deleted_at": null,
                "created_at": "2023-02-15T09:15:44.000000Z",
                "updated_at": "2024-08-09T09:25:40.000000Z",
                "client_id": "207",
                "__hevo__ingested_at": 1679725257548,
                "__hevo__marked_deleted": 0,
                "__hevo__source_modified_at": null,
                "__hevo__database_name": "apphys_new"
            }
        ]
    },
    "message": "Group data retrieved successfully"
}

export const createGroup = {
  "programs": [
        {
            "id": 3528,
            "client_id": 207,
            "hysform_id": null,
            "donor_hysform_id": null,
            "setting_id": null,
            "emailset_id": null,
            "entity_submit": null,
            "donor_submit": null,
            "link_id": null,
            "name": "Testing Attachment Prog",
            "prefix": "TAP",
            "counter": null,
            "lft": 2,
            "rgt": 3,
            "tree": 207,
            "box_folder_id": null,
            "deleted_at": null,
            "created_at": "2024-07-26T05:43:51.000000Z",
            "updated_at": "2024-07-26T05:43:51.000000Z",
            "__hevo__database_name": null,
            "__hevo__ingested_at": null,
            "__hevo__marked_deleted": null,
            "__hevo__source_modified_at": null,
            "children": []
        },
        {
            "id": 3521,
            "client_id": 207,
            "hysform_id": 3051,
            "donor_hysform_id": 3030,
            "setting_id": 1652,
            "emailset_id": null,
            "entity_submit": null,
            "donor_submit": null,
            "link_id": null,
            "name": "Sustainable Living Expo",
            "prefix": "DC",
            "counter": 1,
            "lft": 4,
            "rgt": 5,
            "tree": 207,
            "box_folder_id": null,
            "deleted_at": null,
            "created_at": "2024-06-13T08:35:10.000000Z",
            "updated_at": "2024-08-06T12:03:55.000000Z",
            "__hevo__database_name": null,
            "__hevo__ingested_at": null,
            "__hevo__marked_deleted": null,
            "__hevo__source_modified_at": null,
            "children": []
        },
        {
            "id": 3518,
            "client_id": 207,
            "hysform_id": 3048,
            "donor_hysform_id": 639,
            "setting_id": 1650,
            "emailset_id": null,
            "entity_submit": null,
            "donor_submit": null,
            "link_id": null,
            "name": "Masaka BoreHole",
            "prefix": "MBH",
            "counter": 1,
            "lft": 6,
            "rgt": 7,
            "tree": 207,
            "box_folder_id": null,
            "deleted_at": null,
            "created_at": "2023-10-17T06:26:48.000000Z",
            "updated_at": "2024-06-17T12:10:38.000000Z",
            "__hevo__database_name": null,
            "__hevo__ingested_at": null,
            "__hevo__marked_deleted": null,
            "__hevo__source_modified_at": null,
            "children": []
        },
        {
            "id": 3510,
            "client_id": 207,
            "hysform_id": 3043,
            "donor_hysform_id": null,
            "setting_id": 410,
            "emailset_id": null,
            "entity_submit": null,
            "donor_submit": null,
            "link_id": null,
            "name": "us2uganda",
            "prefix": "usa",
            "counter": null,
            "lft": 8,
            "rgt": 9,
            "tree": 207,
            "box_folder_id": null,
            "deleted_at": null,
            "created_at": "2023-06-02T09:24:28.000000Z",
            "updated_at": "2023-06-02T09:36:45.000000Z",
            "__hevo__database_name": null,
            "__hevo__ingested_at": null,
            "__hevo__marked_deleted": null,
            "__hevo__source_modified_at": null,
            "children": []
        },
        {
            "id": 3507,
            "client_id": 207,
            "hysform_id": 3019,
            "donor_hysform_id": 3040,
            "setting_id": 1646,
            "emailset_id": null,
            "entity_submit": null,
            "donor_submit": null,
            "link_id": null,
            "name": "Kupe",
            "prefix": "KUP",
            "counter": null,
            "lft": 10,
            "rgt": 11,
            "tree": 207,
            "box_folder_id": null,
            "deleted_at": null,
            "created_at": "2023-05-03T06:41:45.000000Z",
            "updated_at": "2024-07-25T08:23:28.000000Z",
            "__hevo__database_name": null,
            "__hevo__ingested_at": null,
            "__hevo__marked_deleted": null,
            "__hevo__source_modified_at": null,
            "children": []
        },
        {
            "id": 3506,
            "client_id": 207,
            "hysform_id": 3019,
            "donor_hysform_id": 3030,
            "setting_id": 410,
            "emailset_id": 1557,
            "entity_submit": "3058",
            "donor_submit": "",
            "link_id": null,
            "name": "Kupenda",
            "prefix": "KP",
            "counter": 200,
            "lft": 12,
            "rgt": 13,
            "tree": 207,
            "box_folder_id": null,
            "deleted_at": null,
            "created_at": "2023-04-29T15:08:37.000000Z",
            "updated_at": "2024-07-29T09:01:30.000000Z",
            "__hevo__database_name": null,
            "__hevo__ingested_at": null,
            "__hevo__marked_deleted": null,
            "__hevo__source_modified_at": null,
            "children": []
        },
        {
            "id": 3438,
            "client_id": 207,
            "hysform_id": 3019,
            "donor_hysform_id": 639,
            "setting_id": 1641,
            "emailset_id": 0,
            "entity_submit": "",
            "donor_submit": "",
            "link_id": 0,
            "name": "Marathon for the Disabled",
            "prefix": "C1",
            "counter": 5,
            "lft": 14,
            "rgt": 15,
            "tree": 207,
            "box_folder_id": "",
            "deleted_at": null,
            "created_at": "2022-12-21T16:50:33.000000Z",
            "updated_at": "2024-08-06T12:02:58.000000Z",
            "__hevo__database_name": "apphys_new",
            "__hevo__ingested_at": 1679910350683,
            "__hevo__marked_deleted": 0,
            "__hevo__source_modified_at": 1679909849000,
            "children": []
        },
        {
            "id": 3437,
            "client_id": 207,
            "hysform_id": 638,
            "donor_hysform_id": 0,
            "setting_id": 410,
            "emailset_id": 0,
            "entity_submit": "",
            "donor_submit": "",
            "link_id": 0,
            "name": "Medical",
            "prefix": "",
            "counter": 0,
            "lft": 16,
            "rgt": 17,
            "tree": 207,
            "box_folder_id": "",
            "deleted_at": null,
            "created_at": "2022-12-14T20:13:03.000000Z",
            "updated_at": "2023-03-28T18:44:07.000000Z",
            "__hevo__database_name": "apphys_new",
            "__hevo__ingested_at": 1680004248746,
            "__hevo__marked_deleted": 0,
            "__hevo__source_modified_at": 1680003847000,
            "children": []
        },
        {
            "id": 1221,
            "client_id": 207,
            "hysform_id": 3019,
            "donor_hysform_id": 639,
            "setting_id": 410,
            "emailset_id": 0,
            "entity_submit": "",
            "donor_submit": "",
            "link_id": 0,
            "name": "Sponsored",
            "prefix": "",
            "counter": 54,
            "lft": 18,
            "rgt": 19,
            "tree": 207,
            "box_folder_id": "",
            "deleted_at": null,
            "created_at": "2019-01-22T01:50:21.000000Z",
            "updated_at": "2024-07-26T09:58:46.000000Z",
            "__hevo__database_name": "apphys_new",
            "__hevo__ingested_at": 1679910350681,
            "__hevo__marked_deleted": 0,
            "__hevo__source_modified_at": 1679909849000,
            "children": []
        },
        {
            "id": 929,
            "client_id": 207,
            "hysform_id": 638,
            "donor_hysform_id": 639,
            "setting_id": 410,
            "emailset_id": 337,
            "entity_submit": "3058",
            "donor_submit": "",
            "link_id": 0,
            "name": "Education",
            "prefix": "",
            "counter": 429,
            "lft": 20,
            "rgt": 21,
            "tree": 207,
            "box_folder_id": "",
            "deleted_at": null,
            "created_at": "2017-02-23T01:40:22.000000Z",
            "updated_at": "2024-08-06T12:02:54.000000Z",
            "__hevo__database_name": "apphys_new",
            "__hevo__ingested_at": 1680004248741,
            "__hevo__marked_deleted": 0,
            "__hevo__source_modified_at": 1680003822000,
            "children": []
        },
        {
            "id": 3494,
            "client_id": 207,
            "hysform_id": 3019,
            "donor_hysform_id": 639,
            "setting_id": 410,
            "emailset_id": 1542,
            "entity_submit": "3058",
            "donor_submit": null,
            "link_id": 929,
            "name": "Youth Mentorship Program",
            "prefix": "",
            "counter": 5,
            "lft": 21,
            "rgt": 22,
            "tree": 207,
            "box_folder_id": null,
            "deleted_at": null,
            "created_at": "2023-03-25T09:14:29.000000Z",
            "updated_at": "2024-08-06T12:51:47.000000Z",
            "__hevo__database_name": null,
            "__hevo__ingested_at": null,
            "__hevo__marked_deleted": null,
            "__hevo__source_modified_at": null,
            "children": []
        }
    ],
    "donors": [
        {
            "id": 639,
            "client_id": 207,
            "default_emailset_id": 337,
            "type": "donor",
            "name": "Sponsor Profiles",
            "prefix": "",
            "counter": 253,
            "box_folder_id": "",
            "can_donor_modify_amount": "",
            "mailchimp_list_id": "",
            "forgive_missed_payments": 0,
            "notify": null,
            "deleted_at": null,
            "created_at": "2017-02-23T01:40:21.000000Z",
            "updated_at": "2024-08-06T10:18:45.000000Z",
            "hide_payment": "",
            "__hevo__database_name": "apphys_new",
            "__hevo__ingested_at": 1680093778944,
            "__hevo__marked_deleted": 0,
            "__hevo__source_modified_at": 1680093318000
        },
        {
            "id": 3030,
            "client_id": 207,
            "default_emailset_id": 0,
            "type": "donor",
            "name": "new test form",
            "prefix": "",
            "counter": 0,
            "box_folder_id": "",
            "can_donor_modify_amount": "",
            "mailchimp_list_id": "",
            "forgive_missed_payments": 0,
            "notify": null,
            "deleted_at": null,
            "created_at": "2023-04-04T08:39:19.000000Z",
            "updated_at": "2023-04-04T08:39:19.000000Z",
            "hide_payment": "",
            "__hevo__database_name": null,
            "__hevo__ingested_at": null,
            "__hevo__marked_deleted": null,
            "__hevo__source_modified_at": null
        },
        {
            "id": 3040,
            "client_id": 207,
            "default_emailset_id": 0,
            "type": "donor",
            "name": "Kupenda Donors",
            "prefix": "",
            "counter": 0,
            "box_folder_id": "",
            "can_donor_modify_amount": "",
            "mailchimp_list_id": "",
            "forgive_missed_payments": 0,
            "notify": null,
            "deleted_at": null,
            "created_at": "2023-05-09T14:53:42.000000Z",
            "updated_at": "2023-05-09T14:53:42.000000Z",
            "hide_payment": "",
            "__hevo__database_name": null,
            "__hevo__ingested_at": null,
            "__hevo__marked_deleted": null,
            "__hevo__source_modified_at": null
        }
    ],
    "all_groups": [
        {
            "id": 301,
            "name": "HYS Demo",
            "permissions": "{\"id\":301,\"deleted_at\":null,\"created_at\":\"2017-02-22T20:40:21.000000Z\",\"updated_at\":\"2023-05-03T09:41:45.000000Z\",\"client_id\":\"207\",\"__hevo__ingested_at\":1679725257548,\"__hevo__marked_deleted\":0,\"__hevo__source_modified_at\":null,\"__hevo__database_name\":\"apphys_new\",\"group_all\":\"1\",\"account\":\"1\",\"groups\":\"1\",\"group-301\":\"1\",\"admins\":\"1\",\"forms\":\"1\",\"new_form\":\"1\",\"manage_programs\":\"1\",\"manage_settings\":\"1\",\"manage_designations\":\"1\",\"manage_email\":\"1\",\"email_manager\":\"1\",\"donations\":\"1\",\"form_report\":\"1\",\"program-1221\":\"1\",\"program-929\":\"1\",\"donor-639\":\"1\",\"program-all\":\"1\",\"donor-all\":\"1\",\"program-3437\":\"1\",\"program-3438\":\"1\",\"program-3439\":\"1\",\"program-3440\":\"1\",\"program-3441\":\"1\",\"program-3442\":\"1\",\"program-3443\":\"1\",\"program-3494\":\"1\",\"program-3495\":\"1\",\"program-3506\":\"1\",\"program-3507\":\"1\",\"disable_entity_archive\":null,\"disable_donor_archive\":null,\"disable_donor_delete\":null,\"disable_donor_restore\":null,\"disable_entity_delete\":null,\"disable_entity_restore\":null,\"group_id\":301,\"program-3510\":\"1\",\"program-3515\":\"1\",\"program-3516\":\"1\",\"program-3517\":\"1\",\"program-3518\":\"1\",\"disable_message_send_without_approval\":null,\"send_status\":\"1\",\"program-3521\":\"1\",\"program-3528\":\"1\"}",
            "deleted_at": null,
            "created_at": "2017-02-22T17:40:21.000000Z",
            "updated_at": "2024-07-26T05:43:51.000000Z",
            "client_id": "207",
            "__hevo__ingested_at": 1679725257548,
            "__hevo__marked_deleted": 0,
            "__hevo__source_modified_at": null,
            "__hevo__database_name": "apphys_new"
        },
        {
            "id": 1472,
            "name": "Uganda Permissions",
            "permissions": "{\"id\":1472,\"deleted_at\":null,\"created_at\":\"2022-12-16T08:34:34.000000Z\",\"updated_at\":\"2023-02-13T13:15:59.000000Z\",\"client_id\":\"207\",\"__hevo__ingested_at\":1679725257548,\"__hevo__marked_deleted\":0,\"__hevo__source_modified_at\":null,\"__hevo__database_name\":\"apphys_new\",\"groups\":\"1\",\"group-301\":\"1\",\"admins\":\"1\",\"forms\":\"1\",\"new_form\":\"1\",\"manage_programs\":\"1\",\"manage_settings\":\"1\",\"manage_designations\":\"1\",\"manage_email\":\"1\",\"email_manager\":\"1\",\"donations\":\"1\",\"disable_entity_archive\":\"1\",\"disable_entity_restore\":\"1\",\"disable_entity_delete\":\"1\",\"program-3437\":\"1\",\"program-1221\":\"1\",\"program-929\":\"1\",\"disable_donor_archive\":\"1\",\"disable_donor_restore\":\"1\",\"disable_donor_delete\":\"1\",\"donor-639\":\"1\",\"donor-all\":\"1\",\"account\":null,\"send_status\":null,\"form_report\":null,\"group_all\":null,\"disable_message_send_without_approval\":null,\"group_id\":1472}",
            "deleted_at": null,
            "created_at": "2022-12-16T08:34:34.000000Z",
            "updated_at": "2024-08-09T09:25:05.000000Z",
            "client_id": "207",
            "__hevo__ingested_at": 1679725257548,
            "__hevo__marked_deleted": 0,
            "__hevo__source_modified_at": null,
            "__hevo__database_name": "apphys_new"
        },
        {
            "id": 1473,
            "name": "Congo Permissions",
            "permissions": "{\"id\":1473,\"deleted_at\":null,\"created_at\":\"2023-02-13T13:07:07.000000Z\",\"updated_at\":\"2023-02-13T13:07:07.000000Z\",\"client_id\":\"207\",\"__hevo__ingested_at\":1679725257548,\"__hevo__marked_deleted\":0,\"__hevo__source_modified_at\":null,\"__hevo__database_name\":\"apphys_new\",\"account\":null,\"admins\":null,\"donations\":null,\"email_manager\":null,\"send_status\":null,\"form_report\":null,\"forms\":null,\"disable_entity_archive\":null,\"manage_designations\":null,\"manage_email\":null,\"manage_programs\":null,\"manage_settings\":null,\"new_form\":null,\"group_all\":null,\"groups\":null,\"disable_donor_archive\":null,\"disable_donor_delete\":null,\"disable_donor_restore\":null,\"disable_entity_delete\":null,\"disable_entity_restore\":null,\"disable_message_send_without_approval\":null,\"group_id\":1473}",
            "deleted_at": null,
            "created_at": "2023-02-13T13:07:07.000000Z",
            "updated_at": "2024-08-09T09:25:19.000000Z",
            "client_id": "207",
            "__hevo__ingested_at": 1679725257548,
            "__hevo__marked_deleted": 0,
            "__hevo__source_modified_at": null,
            "__hevo__database_name": "apphys_new"
        },
        {
            "id": 1474,
            "name": "India Permissions",
            "permissions": "{\"id\":1474,\"deleted_at\":null,\"created_at\":\"2023-02-15T09:15:44.000000Z\",\"updated_at\":\"2023-02-15T09:15:44.000000Z\",\"client_id\":\"207\",\"__hevo__ingested_at\":1679725257548,\"__hevo__marked_deleted\":0,\"__hevo__source_modified_at\":null,\"__hevo__database_name\":\"apphys_new\",\"program-3437\":\"1\",\"program-1221\":\"1\",\"program-929\":\"1\",\"account\":null,\"admins\":null,\"donations\":null,\"email_manager\":null,\"send_status\":null,\"form_report\":null,\"forms\":null,\"disable_entity_archive\":null,\"manage_designations\":null,\"manage_email\":null,\"manage_programs\":null,\"manage_settings\":null,\"new_form\":null,\"group_all\":null,\"groups\":null,\"disable_donor_archive\":null,\"disable_donor_delete\":null,\"disable_donor_restore\":null,\"disable_entity_delete\":null,\"disable_entity_restore\":null,\"disable_message_send_without_approval\":null,\"group_id\":1474}",
            "deleted_at": null,
            "created_at": "2023-02-15T09:15:44.000000Z",
            "updated_at": "2024-08-09T09:25:40.000000Z",
            "client_id": "207",
            "__hevo__ingested_at": 1679725257548,
            "__hevo__marked_deleted": 0,
            "__hevo__source_modified_at": null,
            "__hevo__database_name": "apphys_new"
        }
    ]
}

export const groups = [
  {
    "id": 301,
    "name": "HYS Demo",
    "permissions": "{\"id\":301,\"deleted_at\":null,\"created_at\":\"2017-02-22T20:40:21.000000Z\",\"updated_at\":\"2023-05-03T09:41:45.000000Z\",\"client_id\":\"207\",\"__hevo__ingested_at\":1679725257548,\"__hevo__marked_deleted\":0,\"__hevo__source_modified_at\":null,\"__hevo__database_name\":\"apphys_new\",\"group_all\":\"1\",\"account\":\"1\",\"groups\":\"1\",\"group-301\":\"1\",\"admins\":\"1\",\"forms\":\"1\",\"new_form\":\"1\",\"manage_programs\":\"1\",\"manage_settings\":\"1\",\"manage_designations\":\"1\",\"manage_email\":\"1\",\"email_manager\":\"1\",\"donations\":\"1\",\"form_report\":\"1\",\"program-1221\":\"1\",\"program-929\":\"1\",\"donor-639\":\"1\",\"program-all\":\"1\",\"donor-all\":\"1\",\"program-3437\":\"1\",\"program-3438\":\"1\",\"program-3439\":\"1\",\"program-3440\":\"1\",\"program-3441\":\"1\",\"program-3442\":\"1\",\"program-3443\":\"1\",\"program-3494\":\"1\",\"program-3495\":\"1\",\"program-3506\":\"1\",\"program-3507\":\"1\",\"disable_entity_archive\":null,\"disable_donor_archive\":null,\"disable_donor_delete\":null,\"disable_donor_restore\":null,\"disable_entity_delete\":null,\"disable_entity_restore\":null,\"group_id\":301,\"program-3510\":\"1\",\"program-3515\":\"1\",\"program-3516\":\"1\",\"program-3517\":\"1\",\"program-3518\":\"1\",\"disable_message_send_without_approval\":null,\"send_status\":\"1\",\"program-3521\":\"1\",\"program-3528\":\"1\"}",
    "deleted_at": null,
    "created_at": "2017-02-22T17:40:21.000000Z",
    "updated_at": "2024-07-26T05:43:51.000000Z",
    "client_id": "207",
    "__hevo__ingested_at": 1679725257548,
    "__hevo__marked_deleted": 0,
    "__hevo__source_modified_at": null,
    "__hevo__database_name": "apphys_new"
},
{
    "id": 1472,
    "name": "Uganda Permissions",
    "permissions": "{\"id\":1472,\"deleted_at\":null,\"created_at\":\"2022-12-16T08:34:34.000000Z\",\"updated_at\":\"2023-02-13T13:15:59.000000Z\",\"client_id\":\"207\",\"__hevo__ingested_at\":1679725257548,\"__hevo__marked_deleted\":0,\"__hevo__source_modified_at\":null,\"__hevo__database_name\":\"apphys_new\",\"groups\":\"1\",\"group-301\":\"1\",\"admins\":\"1\",\"forms\":\"1\",\"new_form\":\"1\",\"manage_programs\":\"1\",\"manage_settings\":\"1\",\"manage_designations\":\"1\",\"manage_email\":\"1\",\"email_manager\":\"1\",\"donations\":\"1\",\"disable_entity_archive\":\"1\",\"disable_entity_restore\":\"1\",\"disable_entity_delete\":\"1\",\"program-3437\":\"1\",\"program-1221\":\"1\",\"program-929\":\"1\",\"disable_donor_archive\":\"1\",\"disable_donor_restore\":\"1\",\"disable_donor_delete\":\"1\",\"donor-639\":\"1\",\"donor-all\":\"1\",\"account\":null,\"send_status\":null,\"form_report\":null,\"group_all\":null,\"disable_message_send_without_approval\":null,\"group_id\":1472}",
    "deleted_at": null,
    "created_at": "2022-12-16T08:34:34.000000Z",
    "updated_at": "2024-08-09T09:25:05.000000Z",
    "client_id": "207",
    "__hevo__ingested_at": 1679725257548,
    "__hevo__marked_deleted": 0,
    "__hevo__source_modified_at": null,
    "__hevo__database_name": "apphys_new"
},
{
    "id": 1473,
    "name": "Congo Permissions",
    "permissions": "{\"id\":1473,\"deleted_at\":null,\"created_at\":\"2023-02-13T13:07:07.000000Z\",\"updated_at\":\"2023-02-13T13:07:07.000000Z\",\"client_id\":\"207\",\"__hevo__ingested_at\":1679725257548,\"__hevo__marked_deleted\":0,\"__hevo__source_modified_at\":null,\"__hevo__database_name\":\"apphys_new\",\"account\":null,\"admins\":null,\"donations\":null,\"email_manager\":null,\"send_status\":null,\"form_report\":null,\"forms\":null,\"disable_entity_archive\":null,\"manage_designations\":null,\"manage_email\":null,\"manage_programs\":null,\"manage_settings\":null,\"new_form\":null,\"group_all\":null,\"groups\":null,\"disable_donor_archive\":null,\"disable_donor_delete\":null,\"disable_donor_restore\":null,\"disable_entity_delete\":null,\"disable_entity_restore\":null,\"disable_message_send_without_approval\":null,\"group_id\":1473}",
    "deleted_at": null,
    "created_at": "2023-02-13T13:07:07.000000Z",
    "updated_at": "2024-08-09T09:25:19.000000Z",
    "client_id": "207",
    "__hevo__ingested_at": 1679725257548,
    "__hevo__marked_deleted": 0,
    "__hevo__source_modified_at": null,
    "__hevo__database_name": "apphys_new"
},
{
    "id": 1474,
    "name": "India Permissions",
    "permissions": "{\"id\":1474,\"deleted_at\":null,\"created_at\":\"2023-02-15T09:15:44.000000Z\",\"updated_at\":\"2023-02-15T09:15:44.000000Z\",\"client_id\":\"207\",\"__hevo__ingested_at\":1679725257548,\"__hevo__marked_deleted\":0,\"__hevo__source_modified_at\":null,\"__hevo__database_name\":\"apphys_new\",\"program-3437\":\"1\",\"program-1221\":\"1\",\"program-929\":\"1\",\"account\":null,\"admins\":null,\"donations\":null,\"email_manager\":null,\"send_status\":null,\"form_report\":null,\"forms\":null,\"disable_entity_archive\":null,\"manage_designations\":null,\"manage_email\":null,\"manage_programs\":null,\"manage_settings\":null,\"new_form\":null,\"group_all\":null,\"groups\":null,\"disable_donor_archive\":null,\"disable_donor_delete\":null,\"disable_donor_restore\":null,\"disable_entity_delete\":null,\"disable_entity_restore\":null,\"disable_message_send_without_approval\":null,\"group_id\":1474}",
    "deleted_at": null,
    "created_at": "2023-02-15T09:15:44.000000Z",
    "updated_at": "2024-08-09T09:25:40.000000Z",
    "client_id": "207",
    "__hevo__ingested_at": 1679725257548,
    "__hevo__marked_deleted": 0,
    "__hevo__source_modified_at": null,
    "__hevo__database_name": "apphys_new"
}
]

export const administrators = [
  {
    "id": 542,
    "email": "dev@helpyousponsor.com",
    "permissions": null,
    "activated": 1,
    "activation_code": null,
    "activated_at": "2017-02-23 01:41:10",
    "last_login": "2024-08-08 15:22:28",
    "reset_password_code": null,
    "first_name": "Leslie",
    "last_name": "Jobs",
    "created_at": "2017-02-23T01:40:21.000000Z",
    "updated_at": "2024-08-08T15:22:28.000000Z",
    "client_id": "207",
    "group_id": 301,
    "email_verified_at": null,
    "__hevo__database_name": "apphys_new",
    "__hevo__ingested_at": 1678920545435,
    "__hevo__marked_deleted": 0,
    "__hevo__source_modified_at": 1678920204000,
    "onboarding_status": null,
    "phone": null,
    "group": {
        "id": 301,
        "name": "HYS Demo",
        "permissions": "{\"id\":301,\"deleted_at\":null,\"created_at\":\"2017-02-22T20:40:21.000000Z\",\"updated_at\":\"2023-05-03T09:41:45.000000Z\",\"client_id\":\"207\",\"__hevo__ingested_at\":1679725257548,\"__hevo__marked_deleted\":0,\"__hevo__source_modified_at\":null,\"__hevo__database_name\":\"apphys_new\",\"group_all\":\"1\",\"account\":\"1\",\"groups\":\"1\",\"group-301\":\"1\",\"admins\":\"1\",\"forms\":\"1\",\"new_form\":\"1\",\"manage_programs\":\"1\",\"manage_settings\":\"1\",\"manage_designations\":\"1\",\"manage_email\":\"1\",\"email_manager\":\"1\",\"donations\":\"1\",\"form_report\":\"1\",\"program-1221\":\"1\",\"program-929\":\"1\",\"donor-639\":\"1\",\"program-all\":\"1\",\"donor-all\":\"1\",\"program-3437\":\"1\",\"program-3438\":\"1\",\"program-3439\":\"1\",\"program-3440\":\"1\",\"program-3441\":\"1\",\"program-3442\":\"1\",\"program-3443\":\"1\",\"program-3494\":\"1\",\"program-3495\":\"1\",\"program-3506\":\"1\",\"program-3507\":\"1\",\"disable_entity_archive\":null,\"disable_donor_archive\":null,\"disable_donor_delete\":null,\"disable_donor_restore\":null,\"disable_entity_delete\":null,\"disable_entity_restore\":null,\"group_id\":301,\"program-3510\":\"1\",\"program-3515\":\"1\",\"program-3516\":\"1\",\"program-3517\":\"1\",\"program-3518\":\"1\",\"disable_message_send_without_approval\":null,\"send_status\":\"1\",\"program-3521\":\"1\",\"program-3528\":\"1\"}",
        "deleted_at": null,
        "created_at": "2017-02-22T17:40:21.000000Z",
        "updated_at": "2024-07-26T05:43:51.000000Z",
        "client_id": "207",
        "__hevo__ingested_at": 1679725257548,
        "__hevo__marked_deleted": 0,
        "__hevo__source_modified_at": null,
        "__hevo__database_name": "apphys_new"
    }
},
{
    "id": 714,
    "email": "dev+1@helpyousponsor.com",
    "permissions": null,
    "activated": 1,
    "activation_code": null,
    "activated_at": "2018-08-20 10:19:25",
    "last_login": "2024-06-06 09:26:02",
    "reset_password_code": null,
    "first_name": "Mathew",
    "last_name": "James",
    "created_at": "2018-08-20T10:19:15.000000Z",
    "updated_at": "2024-06-06T09:26:02.000000Z",
    "client_id": "207",
    "group_id": 301,
    "email_verified_at": null,
    "__hevo__database_name": "apphys_new",
    "__hevo__ingested_at": 1678980320629,
    "__hevo__marked_deleted": 0,
    "__hevo__source_modified_at": 1678980082000,
    "onboarding_status": null,
    "phone": null,
    "group": {
        "id": 301,
        "name": "HYS Demo",
        "permissions": "{\"id\":301,\"deleted_at\":null,\"created_at\":\"2017-02-22T20:40:21.000000Z\",\"updated_at\":\"2023-05-03T09:41:45.000000Z\",\"client_id\":\"207\",\"__hevo__ingested_at\":1679725257548,\"__hevo__marked_deleted\":0,\"__hevo__source_modified_at\":null,\"__hevo__database_name\":\"apphys_new\",\"group_all\":\"1\",\"account\":\"1\",\"groups\":\"1\",\"group-301\":\"1\",\"admins\":\"1\",\"forms\":\"1\",\"new_form\":\"1\",\"manage_programs\":\"1\",\"manage_settings\":\"1\",\"manage_designations\":\"1\",\"manage_email\":\"1\",\"email_manager\":\"1\",\"donations\":\"1\",\"form_report\":\"1\",\"program-1221\":\"1\",\"program-929\":\"1\",\"donor-639\":\"1\",\"program-all\":\"1\",\"donor-all\":\"1\",\"program-3437\":\"1\",\"program-3438\":\"1\",\"program-3439\":\"1\",\"program-3440\":\"1\",\"program-3441\":\"1\",\"program-3442\":\"1\",\"program-3443\":\"1\",\"program-3494\":\"1\",\"program-3495\":\"1\",\"program-3506\":\"1\",\"program-3507\":\"1\",\"disable_entity_archive\":null,\"disable_donor_archive\":null,\"disable_donor_delete\":null,\"disable_donor_restore\":null,\"disable_entity_delete\":null,\"disable_entity_restore\":null,\"group_id\":301,\"program-3510\":\"1\",\"program-3515\":\"1\",\"program-3516\":\"1\",\"program-3517\":\"1\",\"program-3518\":\"1\",\"disable_message_send_without_approval\":null,\"send_status\":\"1\",\"program-3521\":\"1\",\"program-3528\":\"1\"}",
        "deleted_at": null,
        "created_at": "2017-02-22T17:40:21.000000Z",
        "updated_at": "2024-07-26T05:43:51.000000Z",
        "client_id": "207",
        "__hevo__ingested_at": 1679725257548,
        "__hevo__marked_deleted": 0,
        "__hevo__source_modified_at": null,
        "__hevo__database_name": "apphys_new"
    }
},
{
    "id": 1951,
    "email": "dev+2@helpyousponsor.com",
    "permissions": null,
    "activated": 1,
    "activation_code": null,
    "activated_at": "2023-02-13 13:08:15",
    "last_login": "2023-02-13 13:08:27",
    "reset_password_code": null,
    "first_name": "Peter",
    "last_name": "Test",
    "created_at": "2023-02-13T13:07:55.000000Z",
    "updated_at": "2023-02-13T13:08:27.000000Z",
    "client_id": "207",
    "group_id": 1473,
    "email_verified_at": null,
    "__hevo__database_name": "apphys_new",
    "__hevo__ingested_at": 1678720146685,
    "__hevo__marked_deleted": 0,
    "__hevo__source_modified_at": null,
    "onboarding_status": null,
    "phone": null,
    "group": {
        "id": 1473,
        "name": "Congo Permissions",
        "permissions": "{\"id\":1473,\"deleted_at\":null,\"created_at\":\"2023-02-13T13:07:07.000000Z\",\"updated_at\":\"2023-02-13T13:07:07.000000Z\",\"client_id\":\"207\",\"__hevo__ingested_at\":1679725257548,\"__hevo__marked_deleted\":0,\"__hevo__source_modified_at\":null,\"__hevo__database_name\":\"apphys_new\",\"account\":null,\"admins\":null,\"donations\":null,\"email_manager\":null,\"send_status\":null,\"form_report\":null,\"forms\":null,\"disable_entity_archive\":null,\"manage_designations\":null,\"manage_email\":null,\"manage_programs\":null,\"manage_settings\":null,\"new_form\":null,\"group_all\":null,\"groups\":null,\"disable_donor_archive\":null,\"disable_donor_delete\":null,\"disable_donor_restore\":null,\"disable_entity_delete\":null,\"disable_entity_restore\":null,\"disable_message_send_without_approval\":null,\"group_id\":1473}",
        "deleted_at": null,
        "created_at": "2023-02-13T13:07:07.000000Z",
        "updated_at": "2024-08-09T09:25:19.000000Z",
        "client_id": "207",
        "__hevo__ingested_at": 1679725257548,
        "__hevo__marked_deleted": 0,
        "__hevo__source_modified_at": null,
        "__hevo__database_name": "apphys_new"
    }
},
{
    "id": 1957,
    "email": "test@gmail.com",
    "permissions": null,
    "activated": 0,
    "activation_code": null,
    "activated_at": null,
    "last_login": null,
    "reset_password_code": null,
    "first_name": "Mary",
    "last_name": "Admin",
    "created_at": "2023-03-15T10:30:37.000000Z",
    "updated_at": "2023-03-26T23:47:28.000000Z",
    "client_id": "207",
    "group_id": 1472,
    "email_verified_at": null,
    "__hevo__database_name": null,
    "__hevo__ingested_at": null,
    "__hevo__marked_deleted": null,
    "__hevo__source_modified_at": null,
    "onboarding_status": null,
    "phone": null,
    "group": {
        "id": 1472,
        "name": "Uganda Permissions",
        "permissions": "{\"id\":1472,\"deleted_at\":null,\"created_at\":\"2022-12-16T08:34:34.000000Z\",\"updated_at\":\"2023-02-13T13:15:59.000000Z\",\"client_id\":\"207\",\"__hevo__ingested_at\":1679725257548,\"__hevo__marked_deleted\":0,\"__hevo__source_modified_at\":null,\"__hevo__database_name\":\"apphys_new\",\"groups\":\"1\",\"group-301\":\"1\",\"admins\":\"1\",\"forms\":\"1\",\"new_form\":\"1\",\"manage_programs\":\"1\",\"manage_settings\":\"1\",\"manage_designations\":\"1\",\"manage_email\":\"1\",\"email_manager\":\"1\",\"donations\":\"1\",\"disable_entity_archive\":\"1\",\"disable_entity_restore\":\"1\",\"disable_entity_delete\":\"1\",\"program-3437\":\"1\",\"program-1221\":\"1\",\"program-929\":\"1\",\"disable_donor_archive\":\"1\",\"disable_donor_restore\":\"1\",\"disable_donor_delete\":\"1\",\"donor-639\":\"1\",\"donor-all\":\"1\",\"account\":null,\"send_status\":null,\"form_report\":null,\"group_all\":null,\"disable_message_send_without_approval\":null,\"group_id\":1472}",
        "deleted_at": null,
        "created_at": "2022-12-16T08:34:34.000000Z",
        "updated_at": "2024-08-09T09:25:05.000000Z",
        "client_id": "207",
        "__hevo__ingested_at": 1679725257548,
        "__hevo__marked_deleted": 0,
        "__hevo__source_modified_at": null,
        "__hevo__database_name": "apphys_new"
    }
},
]